import React, { useState, useEffect, useCallback, createContext, useContext, useMemo, useRef } from 'react';
import { initializeApp, getApp, deleteApp } from 'firebase/app';
import {
    getAuth,
    signInWithEmailAndPassword,
    signOut,
    onAuthStateChanged,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    sendEmailVerification,
    signInAnonymously,
    RecaptchaVerifier,
    signInWithPhoneNumber,
    signInWithCustomToken
} from 'firebase/auth';
import {
    getFirestore,
    collection,
    addDoc,
    getDocs,
    doc,
    updateDoc,
    deleteDoc,
    arrayUnion,
    query,
    where,
    Timestamp,
    onSnapshot,
    setDoc,
    orderBy,
    limit,
    getDoc,
    writeBatch,
    startAfter, // <-- TAMBAHKAN INI
    GeoPoint // <-- TAMBAHKAN INI
} from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import { getFunctions, httpsCallable } from "firebase/functions";

import { QRCodeSVG, QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';
import { BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
// import { Capacitor } from '@capacitor/core';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import {
    getStorage,
    ref,
    uploadBytesResumable,
    getDownloadURL,
    deleteObject
} from 'firebase/storage';
import { Drawer } from "vaul";
import { UpdatePrompt } from './updatePrompt';
import { Toaster } from 'react-hot-toast';
import toast from 'react-hot-toast';

// ---------------------------------------------------------------- //
// ----- BAGIAN INI DITAMBAHKAN UNTUK PWA INSTALL PROMPT
// ---------------------------------------------------------------- //

const PWAInstallButton = ({ onInstallClick }) => {
    return (
        <div className="fixed bottom-0 left-0 right-0 p-4 z-50">
            <div className="bg-white rounded-xl shadow-xl border border-gray-200 p-4">
                <div className="flex justify-between items-center mb-2">
                    <div className="flex items-center">
                        <img src="https://placehold.co/48x48/F43F5E/FFFFFF?text=SW" alt="Logo Aplikasi" className="w-12 h-12 rounded-lg" />
                        <div className="ml-3">
                            <h3 className="text-lg font-semibold text-gray-800">SATUWARGA App</h3>
                            <p className="text-sm text-gray-500">Install aplikasi untuk pengalaman terbaik.</p>
                        </div>
                    </div>
                </div>
                <div className="flex space-x-2">
                    <button
                        onClick={onInstallClick}
                        className="flex-1 px-4 py-2 text-sm font-medium rounded-lg text-white bg-sky-500 hover:bg-sky-600 transition-colors shadow-md"
                    >
                        Install
                    </button>
                    <button className="flex-1 px-4 py-2 text-sm font-medium rounded-lg text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors">
                        Tidak Sekarang
                    </button>
                </div>
            </div>
        </div>
    );
};

// ---------------------------------------------------------------- //
// ----- BAGIAN INI DITAMBAHKAN UNTUK PWA INSTALL PROMPT
// ---------------------------------------------------------------- //

// --- Firebase Configuration ---
const firebaseConfig = {
    apiKey: "AIzaSyAD1jyntqS1JO-yoFKU_Bw43vEB6BWFVeI",
    authDomain: "elok-rt-09.firebaseapp.com",
    projectId: "elok-rt-09",
    storageBucket: "elok-rt-09.firebasestorage.app",
    messagingSenderId: "475976044630",
    appId: "1:475976044630:web:02749bcad09858ed8b2bf7"
};

const API_KEY = "54tu09jdgshbctRGxdhsahb54tu09jdgshbctRGxdhsahb";

const appIdForPaths = `data-${firebaseConfig.projectId}`;

// --- Initialize Firebase ---
const app = initializeApp(firebaseConfig);
const authGlobal = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// --- Firestore Collection Paths --- 
const getHouseholdsCollectionPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/households`;
const getHouseholdDocPath = (rtProfileId, docId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/households/${docId}`;
const getPaymentsCollectionPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/payments`;
const getPaymentDocPath = (rtProfileId, docId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/payments/${docId}`;
const getExpensesCollectionPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/expenses`;
const getExpenseDocPath = (rtProfileId, docId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/expenses/${docId}`;

const getAdminUsersCollectionPath = () => `/artifacts/${appIdForPaths}/public/data/adminUsers`;
const getAdminUserDocPath = (uid) => `/artifacts/${appIdForPaths}/public/data/adminUsers/${uid}`;

const getAppConfigDocPath = () => `/artifacts/${appIdForPaths}/public/data/appConfig/main`;
const getAccessCodeDocPath = () => `/artifacts/${appIdForPaths}/public/data/accessControl/currentOtp`;

const getRtProfilesCollectionPath = () => `/artifacts/${appIdForPaths}/public/data/rtProfiles`;
const getRtProfileDocPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}`;
const getRtSpecificConfigDocPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/config/main`;
const getRtSpecificAccessCodeDocPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/accessControl/currentOtp`;
const getBankAccountsCollectionPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/bankAccounts`;

// --- Discord Webhook URLs ---
const PAYMENT_STATUS_WEBHOOK_URL = "https://discord.com/api/webhooks/1377660583859454042/UCrJbhYhCTALY2-HmWzde8jVEdMowKlWJqsOV_H9BYetvtg_H8QMVxZzJGTB8X6GuPWf";
const EXPENSE_RECORD_WEBHOOK_URL = "https://discord.com/api/webhooks/1377660975192477829/bxJeeDvJKPQoz4ewbocmlpEtP2XeC4vwcK4O83s6mPEvbTVSC3poj6ve6IHavhtdXFv8";
const OTP_NOTIFICATION_WEBHOOK_URL = "https://discord.com/api/webhooks/1377661409566920755/sVTEEdo8kuwKr2oqjVvTYdqS2JJV7xaB7bPJlaHE5CXLw2U-6DJLEkb4d_tZvbBJdL_s";
// --- Custom Hook yang baru dibuat ---

const XENDIT_BANK_LIST = [
    { name: "BCA (Bank Central Asia)", code: "BCA" },
    { name: "Bank Mandiri", code: "MANDIRI" },
    { name: "BNI (Bank Negara Indonesia)", code: "BNI" },
    { name: "BRI (Bank Rakyat Indonesia)", code: "BRI" },
    { name: "BSI (Bank Syariah Indonesia)", code: "BSI" },
    { name: "CIMB Niaga", code: "CIMB" },
    { name: "Bank Danamon", code: "DANAMON" },
    { name: "Bank Permata", code: "PERMATA" },
    { name: "Bank Jago", code: "JAGO" },
    { name: "BCA Digital (BluBCA)", code: "BCA_DIGITAL" },
    { name: "Bank Neo Commerce", code: "BNC" },
    { name: "Seabank", code: "SEABANK" },
    { name: "GoPay", code: "GOPAY" },
    { name: "OVO", code: "OVO" },
    { name: "Dana", code: "DANA" },
    { name: "ShopeePay", code: "SHOPEEPAY" },
    { name: "LinkAja", code: "LINKAJA" }
    // Anda bisa menambahkan bank lain dari daftar Xendit jika diperlukan
].sort((a, b) => a.name.localeCompare(b.name)); // Diurutkan otomatis A-Z

// --- Helper: Send Discord Notification ---
// Di atas definisi AuthProvider
const sendDiscordNotification = async (notificationType, rtConfig, embedMessage, globalConstants) => {
    // 1. Cek apakah fitur integrasi aktif untuk RT ini
    if (rtConfig?.isDiscordIntegrationEnabled !== true) {
        // console.log(`[Discord] Notifikasi dibatalkan karena integrasi tidak aktif untuk RT: ${rtConfig?.id || 'Global'}`);
        return false; // <-- KEMBALIKAN false jika dibatalkan
    }

    // 2. Tentukan URL webhook yang benar
    let webhookUrl = '';
    switch (notificationType) {
        case 'payment':
            webhookUrl = rtConfig.paymentWebhookUrl || globalConstants.PAYMENT_STATUS_WEBHOOK_URL;
            break;
        case 'expense':
            webhookUrl = rtConfig.expenseWebhookUrl || globalConstants.EXPENSE_RECORD_WEBHOOK_URL;
            break;
        case 'otp':
            webhookUrl = rtConfig.otpWebhookUrl || globalConstants.OTP_NOTIFICATION_WEBHOOK_URL;
            break;
        default:
            console.warn(`[Discord] Tipe notifikasi tidak dikenal: ${notificationType}`);
            return false;
    }

    // 3. Cek jika URL valid
    if (!webhookUrl || !webhookUrl.startsWith('https://discord.com/api/webhooks/')) {
        console.warn(`[Discord] URL Webhook tidak valid atau kosong untuk tipe '${notificationType}'. Skipping notification.`);
        return false; // <-- KEMBALIKAN false jika URL tidak valid
    }

    // 4. Kirim notifikasi
    // console.log(`[Discord] Mengirim notifikasi tipe '${notificationType}' ke URL: ${webhookUrl}`);
    const payload = { embeds: embedMessage ? [embedMessage] : [] };
    try {
        const response = await fetch(webhookUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        if (!response.ok) {
            console.error(`Error sending Discord notification to ${webhookUrl}: ${response.status}`);
            return false; // <-- KEMBALIKAN false jika ada error dari Discord
        }
        return true; // <-- KEMBALIKAN true jika berhasil dikirim
    } catch (error) {
        console.error("Error sending Discord notification:", error);
        return false; // <-- KEMBALIKAN false jika ada error fetch
    }
};

// --- Authentication Context ---
const AuthContext = createContext();

// --- GANTI SELURUH KOMPONEN AuthProvider DENGAN VERSI FINAL INI ---

// --- GANTI SELURUH KOMPONEN INI DI App.js ---

// --- AuthProvider (FINAL v5 - Paling Stabil dan Anti Race Condition) ---
const AuthProvider = ({ children }) => {
    // State untuk otentikasi
    const [currentUser, setCurrentUser] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [rtProfileId, setRtProfileId] = useState(null);
    const [loadingAuth, setLoadingAuth] = useState(true);
    const [userId, setUserId] = useState(null);

    // State untuk konfigurasi
    const [appConfig, setAppConfig] = useState(null);
    const [loadingAppConfig, setLoadingAppConfig] = useState(true);

    // State internal untuk menampung data mentah
    const [rawPlans, setRawPlans] = useState(null);
    const [rawProfiles, setRawProfiles] = useState(null);
    const [rawGlobalConfig, setRawGlobalConfig] = useState(null);
    const [rawRtConfigs, setRawRtConfigs] = useState(null);

    // const SUPER_ADMIN_EMAIL = "waringinelok09@gmail.com";

    // Listener untuk data dasar (plans, profiles, global config)
    useEffect(() => {
        const unsubPlans = onSnapshot(doc(db, '/feature_plans/main'), snap => setRawPlans(snap.exists() ? snap.data() : {}));
        const unsubGlobalConfig = onSnapshot(doc(db, getAppConfigDocPath()), snap => setRawGlobalConfig(snap.exists() ? snap.data() : {}));
        const unsubProfiles = onSnapshot(query(collection(db, getRtProfilesCollectionPath())), snap => {
            const profiles = {};
            snap.forEach(doc => { profiles[doc.id] = { id: doc.id, ...doc.data() }; });
            setRawProfiles(profiles);
        });
        return () => { unsubPlans(); unsubGlobalConfig(); unsubProfiles(); };
    }, []);

    // Listener untuk semua config spesifik RT
    useEffect(() => {
        if (rawProfiles === null) return;
        const profileIds = Object.keys(rawProfiles);
        if (profileIds.length === 0) { setRawRtConfigs({}); return; }
        const unsubscribers = profileIds.map(id =>
            onSnapshot(doc(db, getRtSpecificConfigDocPath(id)), (snap) => {
                setRawRtConfigs(prev => ({ ...prev, [id]: snap.exists() ? snap.data() : {} }));
            })
        );
        return () => unsubscribers.forEach(unsub => unsub());
    }, [rawProfiles]);

    // useEffect UTAMA: Menggabungkan semua data & menerapkan logika "Fitur Efektif"
    useEffect(() => {
        // Jangan berjalan jika salah satu data mentah belum siap
        if (rawPlans === null || rawProfiles === null || rawGlobalConfig === null || rawRtConfigs === null) {
            return;
        }

        // console.log("AuthProvider: Semua data mentah siap, membangun appConfig final...");
        const rtProfilesConfig = {};
        Object.keys(rawProfiles).forEach(id => {
            const profileData = rawProfiles[id];
            const configData = rawRtConfigs[id] || {};
            const assignedPlanName = profileData.plan || 'gratis';
            const featuresForAssignedPlan = rawPlans[assignedPlanName] || rawPlans['gratis'];
            const featuresForFreePlan = rawPlans['gratis'];

            const isSubscribedAndActive =
                profileData.subscriptionStatus === 'ACTIVE' &&
                profileData.subscriptionValidUntil &&
                profileData.subscriptionValidUntil.toDate() > new Date();

            const effectiveFeatures = (assignedPlanName !== 'gratis' && isSubscribedAndActive)
                ? featuresForAssignedPlan
                : featuresForFreePlan;

            rtProfilesConfig[id] = { ...profileData, ...configData, ...effectiveFeatures };
        });

        const finalAppConfig = { ...rawGlobalConfig, plans: rawPlans, rtProfiles: rtProfilesConfig };
        setAppConfig(finalAppConfig);
        setLoadingAppConfig(false); // Loading selesai HANYA setelah semua siap

    }, [rawPlans, rawProfiles, rawGlobalConfig, rawRtConfigs]);

    const SUPER_ADMIN_EMAIL = "waringinelok09@gmail.com";

    // useEffect untuk otentikasi (dengan perbaikan logika anonim)
    useEffect(() => {
        const unsubscribeAuth = onAuthStateChanged(authGlobal, (user) => {
            if (user) {
                // Pengguna terdeteksi (baik anonim maupun login)
                setCurrentUser(user);
                setUserId(user.uid);
                if (user.isAnonymous) {
                    setUserRole(null);
                    setRtProfileId(null);
                } else if (user.email === SUPER_ADMIN_EMAIL) {
                    setUserRole("superAdmin");
                    setRtProfileId(null);
                } else {
                    // Ambil data peran untuk admin RT
                    getDoc(doc(db, getAdminUserDocPath(user.uid))).then(userDocSnap => {
                        if (userDocSnap.exists()) {
                            const userData = userDocSnap.data();
                            setUserRole(userData.role);
                            setRtProfileId(userData.rtProfileId || null);
                        } else {
                            setUserRole(null);
                            setRtProfileId(null);
                        }
                    });
                }
                setLoadingAuth(false);
            } else {
                // Tidak ada pengguna SAMA SEKALI, lakukan sign in anonim
                signInAnonymously(authGlobal).catch(err => {
                    console.error("Gagal melakukan login anonim:", err);
                    setLoadingAuth(false); // Tetap selesaikan loading meskipun gagal
                });
            }
        });
        return () => unsubscribeAuth();
    }, [SUPER_ADMIN_EMAIL]);

    const updateSpecificRtConfig = useCallback((rtId, newConfigData) => {
        setAppConfig(prevConfig => {
            if (!prevConfig?.rtProfiles?.[rtId]) return prevConfig;

            const oldProfile = prevConfig.rtProfiles[rtId];
            const updatedProfile = { ...oldProfile, ...newConfigData };

            const assignedPlanName = updatedProfile.plan || 'gratis';
            const featuresForAssignedPlan = prevConfig.plans[assignedPlanName] || prevConfig.plans['gratis'];
            const featuresForFreePlan = prevConfig.plans['gratis'];
            const isSubscribedAndActive = updatedProfile.subscriptionStatus === 'ACTIVE' && updatedProfile.subscriptionValidUntil?.toDate() > new Date();
            const effectiveFeatures = (assignedPlanName !== 'gratis' && isSubscribedAndActive) ? featuresForAssignedPlan : featuresForFreePlan;

            const finalUpdatedProfile = { ...updatedProfile, ...effectiveFeatures };

            return {
                ...prevConfig,
                rtProfiles: {
                    ...prevConfig.rtProfiles,
                    [rtId]: finalUpdatedProfile
                }
            };
        });
    }, []);

    const value = useMemo(() => ({
        currentUser, userRole, userId, rtProfileId, loadingAuth, appConfig, loadingAppConfig,
        login: (email, password) => signInWithEmailAndPassword(authGlobal, email, password),
        logout: () => signOut(authGlobal),
        updateSpecificRtConfig
    }), [currentUser, userRole, userId, rtProfileId, loadingAuth, appConfig, loadingAppConfig]);

    return (
        <AuthContext.Provider value={value}>
            {/* Tampilkan loading global sampai SEMUA siap */}
            {(loadingAuth || loadingAppConfig) ? (
                <div className="min-h-screen flex items-center justify-center bg-slate-100">
                    <LoadingSpinner /><p className="ml-4 text-slate-600">Mempersiapkan sesi Anda...</p>
                </div>
            ) : children}
        </AuthContext.Provider>
    );
};

const useAuth = () => useContext(AuthContext);

// --- Helper Functions & Constants ---
const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
const QUARTERS = [
    { label: "Triwulan 1 (Jan-Mar)", value: 0 },
    { label: "Triwulan 2 (Apr-Jun)", value: 3 },
    { label: "Triwulan 3 (Jul-Sep)", value: 6 },
    { label: "Triwulan 4 (Okt-Des)", value: 9 }
];

const SEMESTERS = [
    { label: "Semester 1 (Jan-Jun)", value: 0 },
    { label: "Semester 2 (Jul-Des)", value: 6 }
];
const CURRENT_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: 10 }, (_, i) => CURRENT_YEAR - 5 + i);
const EXPENSE_TYPES = ["Pembangunan Lingkungan", "Pembayaran Keamanan", "Pembayaran Sampah", "Operasional RT/RW", "Kegiatan Sosial", "Lain-lain"];
const LOGO_URL = process.env.PUBLIC_URL + '/logo-satuwarga.png';
const USER_ROLES = ["admin_rt", "bendahara", "superAdmin"];
const DUES_TYPES = ["Iuran Rutin", "Iuran Pembangunan Aspal", "Iuran Keamanan Tambahan", "Sumbangan Sukarela", "Lain-lain"];
const PIN_STORAGE_PREFIX = "app_pin_";

// --- UI Components ---
const commonInputStyle = "mt-1 block w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-sm shadow-sm placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none";
const commonButtonStyle = "px-4 py-2 rounded-md font-semibold text-white shadow-md focus:outline-none focus:ring-2 focus:ring-opacity-75";
const primaryButtonStyle = `${commonButtonStyle} bg-sky-500 hover:bg-sky-600 focus:ring-sky-500`;
const secondaryButtonStyle = `${commonButtonStyle} bg-slate-500 hover:bg-slate-600 focus:ring-slate-500`;
const dangerButtonStyle = `${commonButtonStyle} bg-red-500 hover:bg-red-600 focus:ring-red-500`;
const cardStyle = "bg-white shadow-lg rounded-lg p-6 mb-6";
const tabButtonStyle = (isActive) => `px-4 py-2 rounded-t-md font-medium text-sm ${isActive ? 'bg-sky-500 text-white' : 'bg-slate-200 text-slate-700 hover:bg-slate-300'}`;
const BackButton = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            className="p-2 rounded-full hover:bg-slate-200 active:bg-slate-300"
            style={{
                // Menambah display block dan pointer-events none pada SVG
                // Ini memastikan area klik meluas ke seluruh area tombol
                // bukan hanya path SVG-nya
                display: 'flex', // Gunakan flex untuk memastikan svg terpusat
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer', // Menambahkan kursor pointer untuk UX yang lebih baik
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-slate-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
                // Atribut pointer-events: none memastikan mouse event melewati SVG
                // dan langsung ditangkap oleh elemen parent <button>
                style={{ pointerEvents: 'none' }}
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
        </button>
    );
};

const PinInputDisplay = ({ value }) => (
    // Kita ganti 'space-x-2' menjadi 'gap-2' untuk spasi yang lebih simetris
    <div className="flex justify-center gap-2 my-4">
        {[...Array(6)].map((_, i) => (
            <div
                key={i}
                className={`w-8 h-8 sm:w-10 sm:h-10 border-2 rounded-full flex items-center justify-center transition-all ${value.length > i ? 'bg-white border-white' : 'bg-transparent border-orange-200'
                    }`}
            >
                {value.length > i && <span className="text-orange-500 text-xl">•</span>}
            </div>
        ))}
    </div>
);
const LoadingSpinner = () => <div className="flex justify-center items-center h-20"><div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-sky-500"></div></div>;
const MessageBox = ({ message, type, onClose }) => { if (!message) return null; const bgColor = type === 'error' ? 'bg-red-100 border-red-400 text-red-700' : (type === 'success' ? 'bg-green-100 border-green-400 text-green-700' : 'bg-orange-100 border-orange-400 text-orange-700'); return (<div className={`border px-4 py-3 rounded relative ${bgColor} my-4`} role="alert"><span className="block sm:inline">{message}</span>{onClose && (<button onClick={onClose} className="absolute top-0 bottom-0 right-0 px-4 py-3"><svg className="fill-current h-6 w-6" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" /></svg></button>)}</div>); };

const MapDisplay = ({ location }) => {
    const mapRef = useRef(null);

    useEffect(() => {
        // Pastikan Google Maps script sudah dimuat dan ada data lokasi
        if (!window.google || !location || !mapRef.current) return;

        // Tentukan titik tengah peta dari data GeoPoint
        const center = { lat: location.latitude, lng: location.longitude };

        // Buat peta baru
        const gMap = new window.google.maps.Map(mapRef.current, {
            center: center,
            zoom: 16, // Tingkat zoom
            // Nonaktifkan kontrol yang tidak perlu untuk mode display
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
        });

        // Tambahkan penanda (marker) di lokasi agenda
        new window.google.maps.Marker({
            position: center,
            map: gMap,
        });
    }, [location]); // useEffect akan berjalan lagi jika properti 'location' berubah

    // Render sebuah div yang akan menjadi kontainer peta
    return (
        <div ref={mapRef} style={{ height: '150px', width: '100%', borderRadius: '0.75rem' }}></div>
    );
};

const RTContext = createContext();
export const useRT = () => useContext(RTContext);

// --- Di dekat definisi useAuth & useRT ---

// function usePrevious(value) {
//     const ref = useRef();
//     useEffect(() => {
//         ref.current = value;
//     }, [value]);
//     return ref.current;
// }

// GANTI SELURUH FUNGSI INI DENGAN VERSI BARU
const loadRtProfileFromStorage = async () => {
    const rtCode = localStorage.getItem('rtCode');
    if (!rtCode) return null;

    try {
        // 1. Ambil definisi plan dari Firestore terlebih dahulu
        const plansDocRef = doc(db, '/feature_plans/main');
        const plansSnap = await getDoc(plansDocRef);
        const plansData = plansSnap.exists() ? plansSnap.data() : {};

        // 2. Ambil data profil RT
        const profileRef = doc(db, getRtProfileDocPath(rtCode));
        const profileSnap = await getDoc(profileRef);

        if (profileSnap.exists()) {
            let profileData = { id: profileSnap.id, ...profileSnap.data() };

            // 3. Tentukan plan yang digunakan RT ini dan ambil fitur-fiturnya
            const assignedPlanName = profileData.plan || 'gratis';
            const featuresFromPlan = plansData[assignedPlanName] || plansData['gratis'];

            // 4. Ambil data config spesifik (seperti judul, logo, dll.)
            const configRef = doc(db, getRtSpecificConfigDocPath(rtCode));
            const configSnap = await getDoc(configRef);
            const specificConfigData = configSnap.exists() ? configSnap.data() : {};

            // 5. Gabungkan semua data menjadi satu objek yang utuh
            // Urutan ini penting: fitur dari plan akan menimpa data konfigurasi lama
            const finalProfileData = {
                ...profileData,
                ...specificConfigData,
                ...featuresFromPlan
            };

            // console.log(`[RTProvider] Profil RT ${rtCode} dimuat dengan fitur dari plan '${assignedPlanName}'.`);
            return finalProfileData;
        }
    } catch (e) {
        console.error(`[RTProvider] Gagal memuat profil RT (${rtCode}) atau konfigurasinya:`, e);
    }
    return null;
};

// Ganti seluruh komponen RTProvider Anda dengan ini
const RTProvider = ({ children }) => {
    const { appConfig, loadingAppConfig } = useAuth();
    const [rtProfile, setRtProfile] = useState(null);
    const [loadingRt, setLoadingRt] = useState(true);

    useEffect(() => {
        // Jangan lakukan apa-apa sampai appConfig benar-benar siap
        if (loadingAppConfig || !appConfig) {
            return;
        }

        const rtCode = localStorage.getItem('rtCode');

        // Ambil data profil yang sudah matang dari appConfig
        if (rtCode && appConfig.rtProfiles?.[rtCode]) {
            setRtProfile(appConfig.rtProfiles[rtCode]);
        } else {
            setRtProfile(null);
        }
        setLoadingRt(false);

    }, [appConfig, loadingAppConfig]); // Hanya bergantung pada appConfig

    const value = useMemo(() => ({ rtProfile, setRtProfile, loadingRt }), [rtProfile, loadingRt]);

    // Gunakan loadingAppConfig sebagai gerbang utama
    return (
        <RTContext.Provider value={value}>
            {!loadingAppConfig && children}
        </RTContext.Provider>
    );
};

const ForcedLogoutModal = ({ isOpen, onTimeout }) => {
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        if (!isOpen) {
            setCountdown(5);
            return;
        }
        if (countdown === 0) {
            onTimeout();
            return;
        }
        const intervalId = setInterval(() => {
            setCountdown(c => c - 1);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [isOpen, countdown, onTimeout]);

    if (!isOpen) return null;

    return (
        // --- Perubahan ada di sini, pada z-[99999] ---
        <div className="fixed inset-0 z-[99999] bg-black bg-opacity-60 flex items-center justify-center backdrop-blur-sm p-4">
            <div className="bg-white p-8 rounded-2xl shadow-xl text-center max-w-sm mx-auto">
                <h3 className="text-xl font-bold text-slate-800">Pembaruan Layanan</h3>
                <p className="text-slate-600 my-4">
                    Peran atau paket layanan untuk RT Anda telah diperbarui. Anda akan dikeluarkan secara otomatis untuk menerapkan perubahan dalam:
                </p>
                <div className="text-6xl font-bold text-sky-500 my-6">
                    {countdown}
                </div>
            </div>
        </div>
    );
};

// --- GlobalOtpInputComponent (FINAL - DENGAN DRAGGABLE BOTTOM SHEET) ---
const GlobalOtpInputComponent = ({ onRtVerifiedAndSelected }) => {
    const [rtCode, setRtCode] = useState('');
    const [otp, setOtp] = useState('');
    const [loadingOtp, setLoadingOtp] = useState(false);
    const [otpMessage, setOtpMessage] = useState({ text: '', type: '' });

    const [snap, setSnap] = useState(0.38);

    // Fungsi handleOtpSubmit tidak berubah
    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        if (rtCode.trim() === '' || otp.length !== 6) {
            setOtpMessage({ text: "Kode RT dan OTP (6 karakter) harus diisi dengan benar.", type: "error" });
            return;
        }
        setLoadingOtp(true);
        setOtpMessage({ text: '', type: '' });
        const normalizedRtCode = rtCode.toUpperCase().trim();
        try {
            const otpDocPath = getRtSpecificAccessCodeDocPath(normalizedRtCode);
            const otpDocRef = doc(db, otpDocPath);
            const docSnap = await getDoc(otpDocRef);
            if (docSnap.exists() && docSnap.data().code === otp.toUpperCase() && docSnap.data().isActive === true) {
                if (typeof onRtVerifiedAndSelected === 'function') {
                    onRtVerifiedAndSelected(normalizedRtCode);
                }
            } else {
                let errorMessage = "Kode RT atau OTP tidak valid.";
                if (docSnap.exists() && docSnap.data().isActive === false) {
                    errorMessage = "Kode OTP ini sudah tidak aktif atau kedaluwarsa.";
                }
                setOtpMessage({ text: errorMessage, type: "error" });
            }
        } catch (error) {
            setOtpMessage({ text: "Gagal memverifikasi OTP.", type: "error" });
        } finally {
            setLoadingOtp(false);
        }
    };
    let displayLogoUrl = LOGO_URL, displayRtTitle = "SATUWARGA";
    displayLogoUrl = LOGO_URL;
    displayRtTitle = "SATUWARGA";
    return (
        <div className="w-full min-h-screen bg-slate-100">
            <div className="w-full h-[65vh] flex flex-col justify-center items-center p-6 space-y-4">

                {/* --- SVG DENGAN PALET WARNA ORANYE BARU --- */}
                <img src={displayLogoUrl} alt="Logo" className="mx-auto mb-4 h-30 w-auto" />
                {/* <svg width="240" viewBox="0 0 235 152" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M41.7501 151.5C28.4168 151.5 17.7501 140.833 17.7501 127.5V89.6083C17.7501 87.275 19.6668 85.3583 22.0001 85.3583H26.3334C28.6668 85.3583 30.5834 87.275 30.5834 89.6083V127.5C30.5834 134.4 35.5418 139.358 41.7501 139.358H53.5834C55.9168 139.358 57.8334 141.275 57.8334 143.608V147.167C57.8334 149.5 55.9168 151.5 53.5834 151.5H41.7501Z" fill="#9A3412" />
                    <path d="M193.25 151.5H181.417C179.083 151.5 177.167 149.5 177.167 147.167V143.608C177.167 141.275 179.083 139.358 181.417 139.358H193.25C199.458 139.358 204.417 134.4 204.417 127.5V89.6083C204.417 87.275 206.333 85.3583 208.667 85.3583H213C215.333 85.3583 217.25 87.275 217.25 89.6083V127.5C217.25 140.833 206.583 151.5 193.25 151.5Z" fill="#9A3412" />
                    <path d="M117.5 76C129.088 76 138.5 66.5883 138.5 55C138.5 43.4117 129.088 34 117.5 34C105.912 34 96.5 43.4117 96.5 55C96.5 66.5883 105.912 76 117.5 76Z" fill="#FB923C" />
                    <path d="M69.5 52C79.165 52 87 44.165 87 34.5C87 24.835 79.165 17 69.5 17C59.835 17 52 24.835 52 34.5C52 44.165 59.835 52 69.5 52Z" fill="#F97316" />
                    <path d="M165.5 52C175.165 52 183 44.165 183 34.5C183 24.835 175.165 17 165.5 17C155.835 17 148 24.835 148 34.5C148 44.165 155.835 52 165.5 52Z" fill="#F97316" />
                    <rect x="0.5" y="103.5" width="234" height="48" rx="24" fill="#F97316" />
                    <path d="M153 104H82C74.2533 104 68 97.7467 68 90V85.674C68 80.3344 71.9444 75.6324 77.0556 74.453L117.5 65L157.944 74.453C163.056 75.6324 167 80.3344 167 85.674V90C167 97.7467 160.747 104 153 104Z" fill="#FB923C" />
                    <path d="M117.5 65L100.333 60.6667L109 43.5H126L134.667 60.6667L117.5 65Z" fill="#FFEDD5" />
                    <path d="M117.5 42C121.366 42 124.5 38.866 124.5 35C124.5 31.134 121.366 28 117.5 28C113.634 28 110.5 31.134 110.5 35C110.5 38.866 113.634 42 117.5 42Z" fill="#FB923C" />
                    <path d="M117.5 65L109 43.5H126L117.5 65Z" fill="#FED7AA" />
                    <path d="M117.5 42C121.366 42 124.5 38.866 124.5 35C124.5 31.134 121.366 28 117.5 28C113.634 28 110.5 31.134 110.5 35C110.5 38.866 113.634 42 117.5 42Z" fill="#F97316" />
                    <path d="M84 100L59.5 83.5L46 92.5L59.5 117.5L84 100Z" fill="#FB923C" />
                    <path d="M69.5 59C73.366 59 76.5 55.866 76.5 52C76.5 48.134 73.366 45 69.5 45C65.634 45 62.5 48.134 62.5 52C62.5 55.866 65.634 59 69.5 59Z" fill="#EA580C" />
                    <path d="M151 100L175.5 83.5L189 92.5L175.5 117.5L151 100Z" fill="#FB923C" />
                    <path d="M165.5 59C169.366 59 172.5 55.866 172.5 52C172.5 48.134 169.366 45 165.5 45C161.634 45 158.5 48.134 158.5 52C158.5 55.866 161.634 59 165.5 59Z" fill="#EA580C" />
                    <path d="M128.5 10.5C128.5 13.5376 126.038 16 123 16C119.962 16 117.5 13.5376 117.5 10.5C117.5 7.46243 119.962 5 123 5C126.038 5 128.5 7.46243 128.5 10.5Z" fill="#FBBF24" />
                    <path d="M137.5 24.5C137.5 26.9853 135.485 29 133 29C130.515 29 128.5 26.9853 128.5 24.5C128.5 22.0147 130.515 20 133 20C135.485 20 137.5 22.0147 137.5 24.5Z" fill="#FBBF24" />
                    <path d="M107.5 24.5C107.5 26.9853 105.485 29 103 29C100.515 29 98.5 26.9853 98.5 24.5C98.5 22.0147 100.515 20 103 20C105.485 20 107.5 22.0147 107.5 24.5Z" fill="#FBBF24" />
                </svg> */}
                {/* <h1 className="text-4xl font-bold text-slate-800">{displayRtTitle}</h1> */}
            </div>

            <Drawer.Root
                open={true}
                snapPoints={[0.38, 0.75]}
                activeSnapPoint={snap}
                setActiveSnapPoint={setSnap}
            >
                <Drawer.Portal>
                    <Drawer.Content className="bg-white flex flex-col rounded-t-3xl h-full fixed bottom-0 left-0 right-0 z-50">
                        <div className="p-4 flex-1">
                            <div className="mx-auto w-12 h-1.5 flex-shrink-0 rounded-full bg-slate-300 mb-4" />
                            <div className="max-w-md mx-auto">
                                <div className="text-center">
                                    <Drawer.Title asChild>
                                        <h1 className="text-3xl font-bold text-slate-800">Selamat Datang</h1>
                                    </Drawer.Title>
                                    <p className="text-slate-500 mt-1">Kolaborasi & transparansi dalam genggaman Anda.</p>
                                </div>
                                <div className="mt-8">
                                    <MessageBox message={otpMessage.text} type={otpMessage.type} onClose={() => setOtpMessage({ text: '', type: '' })} />
                                    <form onSubmit={handleOtpSubmit} className="space-y-4">
                                        <input type="text" value={rtCode} onChange={(e) => setRtCode(e.target.value.toUpperCase())} placeholder="Kode Komunitas (misal: RT009)" className={commonInputStyle} required />
                                        <input type="text" value={otp} onChange={(e) => setOtp(e.target.value.toUpperCase())} placeholder="Kode Akses 6 Karakter (OTP)" className={commonInputStyle} maxLength={6} required />

                                        {/* --- TOMBOL DENGAN GRADIENT ORANYE --- */}
                                        <button
                                            type="submit"
                                            className="w-full !py-3 !text-base !font-bold text-white rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 transition-all"
                                            disabled={loadingOtp}
                                        >
                                            {loadingOtp ? <LoadingSpinner /> : 'Masuk & Verifikasi'}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </Drawer.Content>
                </Drawer.Portal>
            </Drawer.Root>
        </div>
    );
};

// --- Komponen Kartu Iuran Display (FINAL v2 - Logika Cerdas & Dinamis) ---
// --- Komponen Kartu Iuran Display (FINAL v3 - Cerdas & Dinamis) ---
const KartuIuranDisplay = ({ houseData, year, allBillsForYear, duesTemplate }) => {
    const kartuRef = React.useRef();

    if (!houseData || !duesTemplate) {
        return <div className="p-4 text-center bg-slate-100 rounded-lg text-slate-500">Pilih jenis iuran untuk melihat kartu.</div>;
    }

    const moveInDate = houseData.moveInDate ? houseData.moveInDate.toDate() : null;
    const { period, amount: templateAmount, name: templateName, startMonth = 1, endMonth = 12 } = duesTemplate;

    const generateRows = () => {
        const rows = [];
        const getPeriodDetails = (periodStartMonth) => {
            const periodStartDate = new Date(year, periodStartMonth - 1, 1);

            // Pengecekan moveInDate untuk iuran periodik (bulanan, triwulan, dll.)
            // if (period !== 'sekali bayar' && period !== 'tahunan') {
            //     if (moveInDate && periodStartDate < new Date(moveInDate.getFullYear(), moveInDate.getMonth(), 1)) {
            //         return { text: "Belum Menghuni", class: "text-slate-400 italic", amount: 0 };
            //     }
            // }
            // --- AWAL PERBAIKAN LOGIKA moveInDate ---
            let periodDurationMonths = 1;
            if (period === 'triwulan') periodDurationMonths = 3;
            else if (period === 'semester') periodDurationMonths = 6;
            else if (period === 'tahunan') periodDurationMonths = 12;

            // Tentukan tanggal akhir dari periode yang sedang diperiksa
            const periodEndDate = new Date(year, periodStartMonth - 1 + periodDurationMonths, 0);
            periodEndDate.setHours(23, 59, 59, 999);

            // Cek baru: Apakah warga masuk SETELAH periode ini berakhir?
            if (moveInDate && moveInDate > periodEndDate) {
                return { text: "Belum Menghuni", class: "text-slate-400 italic", amount: 0 };
            }
            // --- AKHIR PERBAIKAN LOGIKA ---

            /* --- BLOK LOGIKA KEBIJAKAN (Dinonaktifkan sesuai permintaan, bisa diaktifkan kembali) ---
            // Pengecekan ini akan membuat iuran sekali bayar/tahunan menjadi tidak berlaku jika dibuat sebelum warga masuk.
            if ((period === 'sekali bayar' || period === 'tahunan') && moveInDate) {
                if (duesTemplate.createdAt && duesTemplate.createdAt.toDate() < moveInDate) {
                    return { text: "Tidak Berlaku", class: "text-slate-400 italic", amount: 0 };
                }
            }
            --- AKHIR BLOK LOGIKA KEBIJAKAN --- */

            // Logika untuk mencari tagihan yang sesuai dan menentukan status (tidak berubah)
            const billForPeriod = allBillsForYear.find(b =>
                b.duesTemplateId === duesTemplate.id &&
                b.billPeriodMonth === periodStartMonth &&
                b.billPeriodYear === year
            );

            if (billForPeriod) {
                // Jika tagihan DITEMUKAN, cek statusnya
                const status = billForPeriod.status;
                if (status === 'PAID' || status === 'approved') {
                    return { text: `LUNAS`, class: "text-green-600 font-semibold", amount: billForPeriod.amount };
                }
                if (status === 'PENDING_QRIS' || status === 'pending' || status === 'PENDING_BULK') {
                    return { text: `Sedang Diproses`, class: "text-yellow-600 font-semibold", amount: billForPeriod.amount };
                }
                // Jika statusnya UNPAID atau lainnya
                return { text: "Belum Bayar", class: "text-red-600", amount: billForPeriod.amount };
            } else {
                // --- PERBAIKAN DI SINI ---
                // Jika tagihan TIDAK DITEMUKAN (belum di-generate)
                return { text: "Tagihan Belum Terbit", class: "text-slate-500", amount: templateAmount };
            }
        };

        switch (period) {
            case 'bulanan':
                for (let i = startMonth - 1; i < endMonth; i++) {
                    rows.push({ label: MONTHS[i].toUpperCase(), details: getPeriodDetails(i + 1) });
                }
                break;
            case 'triwulan':
                for (let i = 0; i < 4; i++) {
                    const periodStartMonth = i * 3 + 1;
                    if (periodStartMonth >= startMonth && periodStartMonth < endMonth) {
                        rows.push({ label: `TRIWULAN ${i + 1}`, details: getPeriodDetails(periodStartMonth) });
                    }
                }
                break;
            case 'semester':
                for (let i = 0; i < 2; i++) {
                    const periodStartMonth = i * 6 + 1;
                    if (periodStartMonth >= startMonth && periodStartMonth < endMonth) {
                        rows.push({ label: `SEMESTER ${i + 1}`, details: getPeriodDetails(periodStartMonth) });
                    }
                }
                break;
            case 'tahunan':
            case 'sekali bayar':
                rows.push({ label: `TAHUN ${year}`, details: getPeriodDetails(startMonth) });
                break;
            default: break;
        }

        return rows;
    };

    const tableRows = generateRows();

    const handlePrint = () => {
        if (!kartuRef.current) return;

        // Ambil judul dan subjudul langsung dari state/props saat ini
        const title = `KARTU IURAN - ${templateName.toUpperCase()} ${year}`;
        const subtitle = `No. Rumah: <strong>${houseData.houseIdentifier}</strong><br />Penghuni: ${houseData.occupantName || "N/A"}`;

        // Generate baris tabel HTML dari data `tableRows` yang sudah kita proses
        const tableBodyHtml = tableRows.map(row => `
            <tr>
                <td style="border: 1px solid #ddd; padding: 8px;">${row.label}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">${row.details.amount.toLocaleString('id-ID')}</td>
                <td style="border: 1px solid #ddd; padding: 8px;">${row.details.text}</td>
            </tr>
        `).join('');

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Cetak Kartu Iuran - ${houseData.houseIdentifier} - ${templateName}</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                        .card-container { border: 1px solid #ccc; padding: 20px; }
                        h1 { font-size: 1.25rem; text-align: center; margin: 0; }
                        h2 { font-size: 0.9rem; text-align: center; font-weight: normal; margin-top: 5px; margin-bottom: 20px; }
                        table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        th { background-color: #f2f2f2; }
                        .footer { margin-top: 20px; font-size: 0.75rem; text-align: right; }
                        @media print {
                            body { margin: 0; }
                            .card-container { border: none; }
                        }
                    </style>
                </head>
                <body>
                    <div class="card-container">
                        <h1>${title}</h1>
                        <h2>${subtitle}</h2>
                        <table>
                            <thead>
                                <tr>
                                    <th>PERIODE</th>
                                    <th>IURAN RP</th>
                                    <th>STATUS / KETERANGAN</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${tableBodyHtml}
                            </tbody>
                        </table>
                        <div class="footer">
                            Dicetak pada ${new Date().toLocaleString('id-ID')}
                        </div>
                    </div>
                    <script>
                        setTimeout(() => { 
                            window.print(); 
                            window.close(); 
                        }, 250);
                    </script>
                </body>
            </html>
        `);
        printWindow.document.close();
    };

    return (
        <div className="mt-6 animate-fade-in">
            <div ref={kartuRef} className="print-card-container bg-yellow-50 border border-yellow-300 p-6 rounded-lg shadow-md">
                <div className="print-header-title">KARTU IURAN - {templateName.toUpperCase()} {year}</div>
                <div className="print-header-subtitle">
                    No. Rumah: <strong>{houseData.houseIdentifier}</strong><br />
                    Penghuni: {houseData.occupantName || "N/A"}
                </div>
                <table className="w-full border-collapse text-sm mt-4">
                    <thead>
                        <tr className="bg-yellow-200">
                            <th className="border border-yellow-400 px-3 py-2 w-1/3">PERIODE</th>
                            <th className="border border-yellow-400 px-3 py-2 text-right">IURAN RP</th>
                            <th className="border border-yellow-400 px-3 py-2">STATUS / KETERANGAN</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRows.map(({ label, details }) => (
                            <tr key={label} className="bg-white even:bg-yellow-50">
                                <td className="border border-yellow-300 px-3 py-2 font-semibold">{label}</td>
                                <td className="border border-yellow-300 px-3 py-2 text-right">{details.amount.toLocaleString('id-ID')}</td>
                                <td className="border border-yellow-300 px-3 py-2"><span className={details.class}>{details.text}</span></td>
                            </tr>
                        ))}
                        {tableRows.length === 0 && (
                            <tr><td colSpan="3" className="text-center p-4 text-slate-500">Tidak ada periode tagihan yang berlaku untuk jenis iuran ini.</td></tr>
                        )}
                    </tbody>
                </table>
                <div className="footer-notes-print"><strong>Keterangan:</strong> Pembayaran iuran dapat dilakukan sesuai kebijakan RT.</div>
            </div>
            <button onClick={handlePrint} className={`${primaryButtonStyle} mt-4 w-full md:w-auto`}>Cetak Kartu Iuran</button>
        </div>
    );
};

// --- Searchable House Select Component ---
const SearchableHouseSelect = ({ households, selectedHouseId, onHouseSelect, label = "Nomor Rumah Anda *", idPrefix = "public", disabled = false }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        // console.log('households:', households);
        if (selectedHouseId) {
            const house = households.find(h => h.id === selectedHouseId);
            if (house) {
                setInputValue(`${house.houseIdentifier} (${house.occupantName || 'N/A'})`);
            } else {
                setInputValue('');
            }
        } else {
            setInputValue(searchTerm);
        }
    }, [selectedHouseId, households, searchTerm]);


    useEffect(() => {
        if (searchTerm.trim().length > 0 && !disabled) {
            const filtered = households
                .filter(h =>
                    (h.houseIdentifier && h.houseIdentifier.toLowerCase().includes(searchTerm.trim().toLowerCase())) ||
                    (h.occupantName && h.occupantName.toLowerCase().includes(searchTerm.trim().toLowerCase()))
                )
                .slice(0, 5);
            setSuggestions(filtered);
        } else {
            setSuggestions([]);
        }
    }, [searchTerm, households, disabled]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    const handleInputChange = (e) => {
        if (disabled) return;
        const currentTypedValue = e.target.value;
        setInputValue(currentTypedValue);
        setSearchTerm(currentTypedValue);
        onHouseSelect("");
        if (currentTypedValue.trim().length > 0) {
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSuggestionClick = (house) => {
        if (disabled) return;
        onHouseSelect(house.id);
        setInputValue(`${house.houseIdentifier} (${house.occupantName || 'N/A'})`);
        setSearchTerm('');
        setShowSuggestions(false);
    };

    return (
        <div className="relative" ref={wrapperRef}>
            <label htmlFor={`houseSearch-${idPrefix}`} className="block text-sm font-medium text-slate-700">
                {label}
            </label>
            <input
                type="text"
                id={`houseSearch-${idPrefix}`}
                placeholder={disabled ? "Rumah sudah dipilih" : "Ketik Nomor Rumah / Penghuni..."}
                value={inputValue}
                onChange={handleInputChange}
                onFocus={() => {
                    if (!disabled && (inputValue.trim().length > 0 || households.length > 0)) {
                        setShowSuggestions(true);
                    }
                }}
                className={commonInputStyle}
                autoComplete="off"
                disabled={disabled}
            />
            {!disabled && showSuggestions && suggestions.length > 0 && (
                <ul className="absolute z-10 w-full bg-white border border-slate-300 rounded-md mt-1 max-h-60 overflow-y-auto shadow-lg">
                    {suggestions.map(house => (
                        <li
                            key={house.id}
                            onClick={() => handleSuggestionClick(house)}
                            className="px-3 py-2 text-sm hover:bg-sky-100 cursor-pointer"
                        >
                            {house.houseIdentifier} (Penghuni: {house.occupantName || 'N/A'})
                        </li>
                    ))}
                </ul>
            )}
            {!disabled && showSuggestions && searchTerm.trim().length > 0 && suggestions.length === 0 && !selectedHouseId && (
                <div className="absolute z-10 w-full bg-white border border-slate-300 rounded-md mt-1 p-3 text-sm text-slate-500 shadow-lg">
                    Tidak ada rumah yang cocok dengan "{searchTerm}".
                </div>
            )}
        </div>
    );
};

// --- Searchable Family Select Component (BARU) ---
// --- Searchable Family Select Component ---
const SearchableFamilySelect = ({ families, selectedFamilyId, onFamilySelect, disabled = false }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        if (selectedFamilyId) {
            const family = families.find(f => f.id === selectedFamilyId);
            if (family) {
                setInputValue(`KK: ${family.headOfFamilyName} (No.KK: ${family.familyCardNumber || 'N/A'})`);
            } else {
                setInputValue('');
            }
        } else {
            setInputValue(searchTerm);
        }
    }, [selectedFamilyId, families, searchTerm]);

    useEffect(() => {
        if (searchTerm.trim().length > 0 && !disabled) {
            const filtered = families
                .filter(f =>
                    (f.headOfFamilyName && f.headOfFamilyName.toLowerCase().includes(searchTerm.trim().toLowerCase())) ||
                    (f.familyCardNumber && f.familyCardNumber.includes(searchTerm.trim()))
                )
                .slice(0, 5);
            setSuggestions(filtered);
        } else {
            setSuggestions([]);
        }
    }, [searchTerm, families, disabled]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [wrapperRef]);

    const handleInputChange = (e) => {
        if (disabled) return;
        const currentTypedValue = e.target.value;
        setInputValue(currentTypedValue);
        setSearchTerm(currentTypedValue);
        onFamilySelect("");
        setShowSuggestions(currentTypedValue.trim().length > 0);
    };

    const handleSuggestionClick = (family) => {
        if (disabled) return;
        onFamilySelect(family.id);
        setInputValue(`KK: ${family.headOfFamilyName} (No.KK: ${family.familyCardNumber || 'N/A'})`);
        setSearchTerm('');
        setShowSuggestions(false);
    };

    return (
        <div className="relative" ref={wrapperRef}>
            <label htmlFor="familySearch" className="block text-sm font-medium text-slate-700">
                Cari Keluarga Terdaftar*
            </label>
            <input
                type="text"
                id="familySearch"
                placeholder="Ketik Nama Kepala Keluarga / No. KK..."
                value={inputValue}
                onChange={handleInputChange}
                onFocus={() => { if (!disabled) setShowSuggestions(true); }}
                className={commonInputStyle}
                autoComplete="off"
                disabled={disabled}
            />
            {!disabled && showSuggestions && suggestions.length > 0 && (
                <ul className="absolute z-10 w-full bg-white border border-slate-300 rounded-md mt-1 max-h-60 overflow-y-auto shadow-lg">
                    {suggestions.map(family => (
                        <li
                            key={family.id}
                            onClick={() => handleSuggestionClick(family)}
                            className="px-3 py-2 text-sm hover:bg-sky-100 cursor-pointer"
                        >
                            KK: {family.headOfFamilyName} (No: {family.familyCardNumber || 'N/A'})
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

const PublicPaymentForm = ({ paymentContext, onBack, onNavigate }) => {
    // --- STATE MANAGEMENT ---
    const { currentUser, appConfig } = useAuth();
    const [description, setDescription] = useState('');
    const [proofImage, setProofImage] = useState(null);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [bankAccounts, setBankAccounts] = useState([]);
    const [loadingAccounts, setLoadingAccounts] = useState(true);
    const [selectedMethod, setSelectedMethod] = useState(null);
    const [manualStep, setManualStep] = useState(1);
    const [qrisData, setQrisData] = useState(null);
    const [isGeneratingQr, setIsGeneratingQr] = useState(false);
    const [countdown, setCountdown] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);

    // --- STATE BARU UNTUK BIAYA LAYANAN ---
    const [serviceFee, setServiceFee] = useState(0);
    const [finalAmount, setFinalAmount] = useState(0);
    const [showFeeDetails, setShowFeeDetails] = useState(false);

    const qrisListenerUnsubscribe = useRef(null);
    const fileInputRef = React.useRef(null);

    // --- DATA DERIVATION ---
    const isBulkPayment = paymentContext?.isBulkPayment === true;
    const singleBillData = !isBulkPayment ? paymentContext?.billData : null;
    const bulkBillsData = isBulkPayment ? paymentContext.billsData : [];
    const totalAmount = isBulkPayment ? paymentContext.totalAmount : singleBillData?.amount;
    const sessionData = paymentContext?.sessionData;
    const allTemplates = paymentContext?.allTemplates || {};
    const rtProfileId = sessionData?.rtProfileId;
    const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId] || appConfig;
    const qrisRef = useRef(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [error, setError] = useState('');

    // --- HELPER FUNCTION ---
    const formatBillPeriodForDisplay = (bill) => {
        if (!bill || !allTemplates) return "Memuat...";
        const template = allTemplates[bill.duesTemplateId];
        if (!template) return `${MONTHS[(bill.billPeriodMonth || bill.paymentMonth) - 1]} ${bill.billPeriodYear || bill.paymentYear}`;
        const periodType = template.period;
        const monthIndex = (bill.billPeriodMonth || bill.paymentMonth) - 1;
        const year = bill.billPeriodYear || bill.paymentYear;
        switch (periodType) {
            case 'triwulan':
                if (monthIndex === 0) return `Triwulan 1 (${year})`;
                if (monthIndex === 3) return `Triwulan 2 (${year})`;
                if (monthIndex === 6) return `Triwulan 3 (${year})`;
                if (monthIndex === 9) return `Triwulan 4 (${year})`;
                return `Triwulan Tdk Valid`;
            case 'semester':
                if (monthIndex === 0) return `Semester 1 (${year})`;
                if (monthIndex === 6) return `Semester 2 (${year})`;
                return `Semester Tdk Valid`;
            case 'tahunan': case 'sekali bayar': return `Tahun ${year}`;
            default: return `${MONTHS[monthIndex]} ${year}`;
        }
    };

    useEffect(() => {
        if (!rtProfileId) { setLoadingAccounts(false); return; }
        const fetchBankAccounts = async () => {
            setLoadingAccounts(true);
            try {
                const accountsPath = getBankAccountsCollectionPath(rtProfileId);
                const q = query(collection(db, accountsPath), orderBy("bankName"));
                const snapshot = await getDocs(q);
                setBankAccounts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            } catch (err) { setMessage({ text: "Gagal memuat data rekening tujuan.", type: "error" }); }
            finally { setLoadingAccounts(false); }
        };
        fetchBankAccounts();
    }, [rtProfileId]);

    // --- HANDLER FUNCTIONS ---
    const listenForPayment = useCallback((billIdToListen) => {
        if (qrisListenerUnsubscribe.current) qrisListenerUnsubscribe.current();
        if (!rtProfileId || !billIdToListen) return;
        const billRef = doc(db, getBillsCollectionPath(rtProfileId), billIdToListen);
        setMessage({ text: "Menunggu pembayaran Anda...", type: "info" });
        qrisListenerUnsubscribe.current = onSnapshot(billRef, (docSnap) => {
            if (docSnap.exists() && (docSnap.data().status === 'PAID' || docSnap.data().status === 'approved')) {
                if (qrisListenerUnsubscribe.current) qrisListenerUnsubscribe.current();
                setMessage({ text: "Pembayaran berhasil! Anda akan diarahkan kembali.", type: "success" });
                setTimeout(() => onBack(true), 2000);
            }
        });
    }, [rtProfileId, onBack]);

    const handleDownloadQris = async () => {
        // Langkah 1: Tangkap elemen DOM terlebih dahulu.
        const qrisElement = qrisRef.current;

        // Langkah 2: Jika elemen tidak ada, jangan lakukan apa-apa.
        if (!qrisElement) {
            console.error("Referensi ke elemen qris tidak ditemukan.");
            setError("Gagal mengunduh, elemen tidak ditemukan.");
            return;
        }

        // Langkah 3: BARU setelah elemen ditangkap, set status loading.
        // Ini tidak akan lagi mengganggu referensi yang sudah kita simpan.
        setIsDownloading(true);
        setError(''); // Bersihkan error lama

        try {
            // Langkah 4: Lakukan proses 'screenshot' pada elemen yang sudah ditangkap.
            const canvas = await html2canvas(qrisElement, {
                scale: 2,
                backgroundColor: null,
                useCORS: true // Tambahkan ini untuk memastikan gambar eksternal (jika ada) ikut ter-render
            });

            const dataUrl = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = `qris-satuwarga-SW/BILL/${qrisData.reference_id.substring(0, 12).toUpperCase()}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            console.error("Gagal membuat gambar qris:", err);
            setError("Gagal mengunduh qris.");
        } finally {
            // Langkah 5: Selalu set loading kembali ke false.
            setIsDownloading(false);
        }
    };

    // --- handleGenerateQris (LOGIKA UTAMA DIMODIFIKASI DI SINI) ---
    const handleGenerateQris = () => {
        if (!sessionData || !rtProfileId || !totalAmount || !currentRtConfig) {
            setMessage({ text: "Data tidak lengkap untuk membuat QRIS.", type: "error" });
            return;
        }

        let fee = 0;
        let finalAmountToPay = totalAmount;

        // --- INI ADALAH LOGIKA YANG DIPERBAIKI ---
        // Cek langsung ke benefit plan-nya. Biaya dikenakan jika benefit "bebas biaya" bernilai false.
        // console.log("currentRtConfig.isTransactionFeeWaived:", currentRtConfig.isTransactionFeeWaived);
        const shouldChargeFee = currentRtConfig.isTransactionFeeWaived === false;

        if (shouldChargeFee) {
            const percentage = appConfig.qrisFeePercentage || 0;
            const fixed = appConfig.qrisFeeFixed || 0;

            if (percentage > 0 || fixed > 0) {
                const percentageFee = Math.ceil(totalAmount * (percentage / 100));
                fee = percentageFee + fixed;
                finalAmountToPay = totalAmount + fee;
            }
        }
        // --- AKHIR DARI LOGIKA YANG DIPERBAIKI ---

        // Simpan ke state agar bisa ditampilkan di UI
        setServiceFee(fee);
        setFinalAmount(finalAmountToPay);
        setShowFeeDetails(true); // Perintah untuk UI agar menampilkan rincian
        // proceedToGenerateQr(finalAmountToPay);

    }

    // Fungsi baru untuk melanjutkan pembuatan QR setelah konfirmasi
    const proceedToGenerateQr = async (amountToCharge) => {
        setIsProcessing(true);
        setIsGeneratingQr(true);
        setMessage({ text: "Membuat QR Code...", type: "info" });
        setShowFeeDetails(false); // Sembunyikan detail fee saat QR sedang dibuat

        try {
            const payload = {
                rtId: rtProfileId,
                amount: amountToCharge, // Gunakan jumlah akhir yang sudah dihitung
                isBulk: isBulkPayment,
                billIds: isBulkPayment ? bulkBillsData.map(b => b.id) : [singleBillData.id],
                billsData: isBulkPayment ? bulkBillsData : (singleBillData ? [singleBillData] : []),
                existingParentBillId: paymentContext?.existingParentBillId || null,
            };

            const response = await fetch("https://us-central1-elok-rt-09.cloudfunctions.net/createPayment", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY },
                body: JSON.stringify(payload)
            });

            if (!response.ok) { throw new Error(`Server merespons: ${await response.text()}`); }

            const result = await response.json();
            const qrisResultWithTimestamp = { ...result, expires_at: Timestamp.fromDate(new Date(result.expires_at)) };
            setQrisData(qrisResultWithTimestamp);
            setMessage({ text: "QR Code berhasil dibuat. Silakan pindai.", type: "success" });
            listenForPayment(result.reference_id);

        } catch (err) {
            setMessage({ text: `Gagal membuat QR Code: ${err.message}`, type: "error" });
        } finally {
            setIsGeneratingQr(false);
            // setIsProcessing(false) akan di-handle oleh listener atau timeout
        }
    };

    const handleQrisClick = () => {
        if (isProcessing) return;
        if (currentRtConfig?.isQrisPaymentEnabled) {
            setSelectedMethod('QRIS');
        } else {
            onNavigate('show_feature_gate', { featureName: 'Pembayaran QRIS' });
        }
    };

    const handleSubmitManual = async (e) => {
        e.preventDefault();
        if (!proofImage || !rtProfileId || !sessionData) { /* ... validasi ... */
            setMessage({ text: "Data tidak lengkap untuk membuat pembayaran manual.", type: "error" });
            return;
        }
        setIsProcessing(true);
        setLoadingSubmit(true);
        const currentMode = currentRtConfig?.isTestingMode ? "testing" : "live";
        try {
            const imageName = `${appIdForPaths}_payment_${sessionData.id}_${Date.now()}_${proofImage.name}`;
            const storageRefPath = `payment_proofs/${rtProfileId}/${imageName}`;
            const fileStorageRef = ref(storage, storageRefPath);
            const uploadTask = uploadBytesResumable(fileStorageRef, proofImage);
            await uploadTask;
            const storagePath = uploadTask.snapshot.ref.fullPath;

            const batch = writeBatch(db);
            const newPaymentRef = doc(collection(db, getPaymentsCollectionPath(rtProfileId)));

            if (isBulkPayment) {
                const billIds = bulkBillsData.map(b => b.id);
                billIds.forEach(id => {
                    const billRef = doc(db, getBillsCollectionPath(rtProfileId), id);
                    batch.update(billRef, { status: 'pending', paymentId: newPaymentRef.id });
                });
                batch.set(newPaymentRef, {
                    houseId: sessionData.id, familyId: sessionData.familyId,
                    amount: totalAmount, submissionTimestamp: Timestamp.now(),
                    status: 'pending', paymentMethod: 'MANUAL_BULK', description: description,
                    proofStoragePath: storagePath, relatedBillIds: billIds,
                    submittedByUserId: currentUser?.uid || 'public_user', mode: currentMode, rtProfileId: rtProfileId,
                });
            } else {
                const billRef = doc(db, getBillsCollectionPath(rtProfileId), singleBillData.id);
                batch.update(billRef, { status: 'pending', paymentId: newPaymentRef.id });
                batch.set(newPaymentRef, {
                    houseId: sessionData.id, familyId: sessionData.familyId,
                    paymentMonth: singleBillData.billPeriodMonth, paymentYear: singleBillData.billPeriodYear,
                    amount: singleBillData.amount, duesType: singleBillData.duesType,
                    billId: singleBillData.id, duesTemplateId: singleBillData.duesTemplateId,
                    proofStoragePath: storagePath, submissionTimestamp: Timestamp.now(),
                    status: 'pending', paymentMethod: 'MANUAL', description: description,
                    submittedByUserId: currentUser?.uid || 'public_user', mode: currentMode, rtProfileId: rtProfileId,
                });
            }
            await batch.commit();
            setMessage({ text: "Bukti pembayaran berhasil dikirim.", type: 'success' });
            setTimeout(() => onBack(true), 2500);
        } catch (error) { setMessage({ text: `Terjadi kesalahan: ${error.message}`, type: 'error' }); }
        finally { setLoadingSubmit(false); }
    };

    // --- SIDE EFFECTS ---
    useEffect(() => {
        if (isBulkPayment) {
            setDescription(`Pembayaran gabungan untuk ${bulkBillsData.length} tagihan.`);
        } else if (singleBillData) {
            const periodText = formatBillPeriodForDisplay(singleBillData);
            setDescription(`Pembayaran untuk ${singleBillData.duesType} periode ${periodText}`);
        }
    }, [paymentContext]);

    useEffect(() => {
        if (!rtProfileId) { setLoadingAccounts(false); return; }
        const fetchBankAccounts = async () => { /* ... */ };
        fetchBankAccounts();
    }, [rtProfileId]);

    // useEffect untuk alur "Lanjutkan Pembayaran QRIS"
    useEffect(() => {
        if (paymentContext?.method === 'QRIS') {
            setSelectedMethod('QRIS');
        }
    }, [paymentContext]);

    // useEffect untuk Countdown Timer
    useEffect(() => {
        if (!qrisData?.expires_at) { setCountdown(''); return; }
        const intervalId = setInterval(() => {
            const expiryDate = qrisData.expires_at.toDate();
            const diff = expiryDate.getTime() - new Date().getTime();
            if (diff <= 0) {
                clearInterval(intervalId);
                setCountdown("Kedaluwarsa");
                setQrisData(null);
                setMessage({ text: "Kode QR sudah kedaluwarsa, silakan buat yang baru.", type: "error" });
                return;
            }
            const minutes = Math.floor((diff / 1000) / 60);
            const seconds = Math.floor((diff / 1000) % 60);
            setCountdown(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [qrisData]);

    // --- useEffect BARU UNTUK MENGHITUNG FEE SECARA OTOMATIS ---
    useEffect(() => {
        // Hanya jalankan jika metode QRIS dipilih
        if (selectedMethod === 'QRIS') {
            if (!sessionData || !rtProfileId || !totalAmount || !currentRtConfig) {
                setMessage({ text: "Data tidak lengkap untuk memproses pembayaran.", type: "error" });
                return;
            }

            let fee = 0;
            let finalAmountToPay = totalAmount;

            const shouldChargeFee = currentRtConfig.isTransactionFeeWaived === false;

            if (shouldChargeFee) {
                const percentage = appConfig.qrisFeePercentage || 0;
                const fixed = appConfig.qrisFeeFixed || 0;

                if (percentage > 0 || fixed > 0) {
                    const percentageFee = Math.ceil(totalAmount * (percentage / 100));
                    fee = percentageFee + fixed;
                    finalAmountToPay = totalAmount + fee;
                }
            }

            setServiceFee(fee);
            setFinalAmount(finalAmountToPay);
            setShowFeeDetails(true); // Langsung set true untuk menampilkan rincian
        } else {
            // Reset jika pengguna memilih metode lain
            setShowFeeDetails(false);
        }
    }, [selectedMethod, totalAmount, currentRtConfig, appConfig, sessionData, rtProfileId]);

    // --- UI RENDERING ---
    if (!paymentContext || (!singleBillData && !isBulkPayment) || !sessionData) {
        return (
            <div className={cardStyle}>
                <MessageBox message="Data tagihan tidak ditemukan. Mungkin sesi Anda telah berakhir." type="error" />
                <button onClick={() => onBack(false)} className={`${secondaryButtonStyle} w-full mt-4`}>
                    Kembali
                </button>
            </div>
        );
    }

    return (
        <div className={`${cardStyle} max-w-lg mx-auto animate-fade-in`}>
            <div className="flex items-center mb-6">
                <button onClick={() => onBack(false)} className="p-2 mr-2 -ml-2 rounded-full hover:bg-slate-200">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                </button>
                <h2 className="text-2xl font-semibold text-slate-700">Metode Pembayaran</h2>
            </div>
            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />
            {selectedMethod === null && (
                <div className="mb-6">
                    <h3 className="text-base font-semibold text-slate-800 mb-3">Pilih Metode Pembayaran</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <button type="button" onClick={() => { setSelectedMethod('MANUAL'); setManualStep(1); }} disabled={isProcessing} className={`p-4 rounded-xl border-2 text-left ...`}>
                            <p className="font-bold">🏦 Transfer Manual</p>
                            <p className="text-xs text-slate-500 mt-1">Unggah bukti setelah transfer.</p>
                        </button>
                        <button type="button" onClick={handleQrisClick} disabled={isProcessing} className={`p-4 rounded-xl border-2 text-left ...`}>
                            <div className="flex items-center justify-between">
                                <p className="font-bold">📱 Bayar dengan QRIS</p>
                                {!currentRtConfig?.isQrisPaymentEnabled && (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-amber-500" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a4 4 0 100 8 4 4 0 000-8z" clipRule="evenodd" /></svg>
                                )}
                            </div>
                            <p className="text-xs text-slate-500 mt-1">Pindai QR code dengan m-Banking/e-wallet.</p>
                        </button>
                    </div>
                </div>
            )}
            {selectedMethod === 'MANUAL' && (
                <div className="animate-fade-in space-y-4">
                    {/* LANGKAH 1: Tampilkan Info Transfer */}
                    <div className={`p-4 border rounded-lg bg-slate-50 ${manualStep === 2 ? 'opacity-50' : ''}`}>
                        <h3 className="text-base font-semibold ...">Langkah 1: Lakukan Transfer</h3>
                        <p className="text-sm text-slate-600 mb-3">Silakan transfer sejumlah <strong className="text-red-500">Rp {totalAmount.toLocaleString('id-ID')}</strong> ke salah satu rekening berikut:</p>
                        {loadingAccounts ? <LoadingSpinner /> : (
                            <div className="space-y-3">
                                {bankAccounts.map(acc => (
                                    <div key={acc.id} className="text-sm p-3 bg-white rounded-lg border">
                                        <p className="font-bold text-sky-700">{acc.bankName}</p>
                                        <div className="flex items-center justify-between mt-1">
                                            <p className="font-mono text-lg tracking-wider">{acc.accountNumber}</p>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    navigator.clipboard.writeText(acc.accountNumber);
                                                    setMessage({ text: `Nomor rekening ${acc.bankName} tersalin!`, type: "success" });
                                                }}
                                                className="text-xs font-semibold text-slate-500 hover:text-sky-600 border border-slate-300 rounded-md px-2 py-1"
                                                title="Salin Nomor Rekening"
                                            >
                                                SALIN
                                            </button>
                                        </div>
                                        <p className="text-xs text-slate-500">a/n {acc.accountHolderName}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                        {manualStep === 1 && (<button type="button" onClick={() => setManualStep(2)} className={`${primaryButtonStyle} w-full mt-4`}> Saya Sudah Transfer, Lanjutkan </button>)}
                    </div>

                    {/* LANGKAH 2: Form Upload */}
                    {manualStep === 2 && (
                        <form onSubmit={handleSubmitManual} className="space-y-4 p-4 border rounded-lg bg-slate-50 animate-fade-in">
                            <h3 className="text-base font-semibold ...">Langkah 2: Kirim Bukti Pembayaran</h3>
                            <div className="p-3 bg-white rounded-md border text-sm space-y-1">
                                {/* --- PERBAIKAN: Gunakan `isBulkPayment` untuk tampilan kondisional --- */}
                                {isBulkPayment ? (
                                    <>
                                        <p><strong>Jenis:</strong> Pembayaran Gabungan ({bulkBillsData.length} item)</p>
                                        <ul className="list-disc list-inside ..."><p><strong>Jenis:</strong> Pembayaran Gabungan ({bulkBillsData.length} item)</p>
                                            {bulkBillsData.map(b => <li key={b.id}>{b.duesType} - {formatBillPeriodForDisplay(b)}</li>)}
                                        </ul>
                                        <p><strong>Total Jumlah:</strong> <span className="font-bold text-lg">Rp {totalAmount.toLocaleString('id-ID')}</span></p>
                                    </>
                                ) : (
                                    <>
                                        <p><strong>Jenis:</strong> {singleBillData.duesType}</p>
                                        <p><strong>:</strong> {formatBillPeriodForDisplay(singleBillData)}</p>
                                        <p><strong>Jumlah:</strong> <span className="font-bold text-lg">Rp {totalAmount.toLocaleString('id-ID')}</span></p>
                                    </>
                                )}
                            </div>
                            <div className="mb-6">
                                <label htmlFor="proofImageFilePublic" className="block text-sm font-medium text-slate-700">Unggah Bukti Transfer (Gambar) *</label>
                                <input type="file" id="proofImageFilePublic" ref={fileInputRef} onChange={(e) => setProofImage(e.target.files[0])} accept="image/*" className={`${commonInputStyle} file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-sky-50 file:text-sky-700 hover:file:bg-sky-100`} required />
                                {proofImage && <p className="text-xs text-slate-500 mt-1">File terpilih: {proofImage.name}</p>}
                            </div>
                            <button type="submit" className={`${primaryButtonStyle} w-full`} disabled={loadingSubmit}>
                                {loadingSubmit ? <LoadingSpinner /> : 'Kirim Bukti Pembayaran'}
                            </button>
                        </form>
                    )}
                </div>
            )}

            {selectedMethod === 'QRIS' && (
                <div className="animate-fade-in text-center">
                    {isGeneratingQr && <div className="py-10"><LoadingSpinner /></div>}

                    {!isGeneratingQr && qrisData?.qr_string ? (
                        // --- TAMPILAN INVOICE SETELAH QR DIBUAT ---
                        <div className="p-4 sm:p-6 rounded-2xl relative overflow-hidden">

                            {/* Stempel UNPAID */}
                            <div className="absolute top-0 right-0 text-center transform origin-top-right rotate-45 translate-x-1/2 -translate-y-1/4">
                                <div className="px-10 py-2 bg-orange-500 text-white font-bold uppercase tracking-wider shadow-lg">Belum Lunas</div>
                            </div>

                            {/* Header Invoice */}
                            <div className="flex justify-between items-start mb-4 pb-4 border-b">
                                <div>
                                    <img src={`${process.env.PUBLIC_URL}/icon/logo-satuwarga-text.png`} alt="Logo Satuwarga" className="h-7" />
                                    <p className="text-xs text-slate-400 mt-1">INVOICE TAGIHAN</p>
                                </div>
                            </div>

                            {/* Detail Tagihan */}
                            <div className="text-left text-sm space-y-2 mb-4">
                                <div>
                                    <p className="text-xs text-slate-500">Tagihan untuk:</p>
                                    <p className="font-semibold text-slate-800">{sessionData.payerName}</p>
                                    <p className="text-xs text-slate-500">Rumah {sessionData.houseIdentifier}</p>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-slate-500">Invoice #</span>
                                    {/* Menggunakan reference_id dari QRIS sebagai nomor referensi */}
                                    <span className="font-mono text-xs">{`SW/BILL/${qrisData.reference_id.substring(0, 12).toUpperCase()}`}</span>
                                </div>
                            </div>

                            {/* Rincian Item Tagihan */}
                            <div className="my-4 pt-4 border-t text-left">
                                {isBulkPayment ? (
                                    bulkBillsData.map(b =>
                                        <div key={b.id} className="flex justify-between items-center text-sm py-1">
                                            <span>{b.duesType} <span className="text-xs text-slate-500">({formatBillPeriodForDisplay(b)})</span></span>
                                            <span className="font-semibold">Rp {b.amount.toLocaleString('id-ID')}</span>
                                        </div>
                                    )
                                ) : (
                                    <div className="flex justify-between items-center text-sm py-1">
                                        <span>{singleBillData.duesType} <span className="text-xs text-slate-500">({formatBillPeriodForDisplay(singleBillData)})</span></span>
                                        <span className="font-semibold">Rp {singleBillData.amount.toLocaleString('id-ID')}</span>
                                    </div>
                                )}
                                {/* Rincian Biaya Layanan */}
                                {serviceFee > 0 && (
                                    <div className="flex justify-between items-center text-sm py-1 mt-2">
                                        <span className="text-slate-500">Biaya Layanan</span>
                                        <span className="font-semibold">Rp {serviceFee.toLocaleString('id-ID')}</span>
                                    </div>
                                )}
                            </div>

                            {/* Total Pembayaran */}
                            <div className="flex justify-between items-center text-lg font-bold border-t pt-4">
                                <span className="uppercase">Total</span>
                                <span>Rp {finalAmount.toLocaleString('id-ID')}</span>
                            </div>

                            {/* Tampilan QR Code */}
                            <div className="flex justify-between items-center text-lg font-bold border-t pt-4">
                                <button onClick={handleDownloadQris} disabled={isDownloading} className={`bg-orange-500 text-white hover:bg-orange-600 w-full`}>
                                    {isDownloading ? 'Memproses...' : 'Unduh QRIS'}
                                </button>
                            </div>
                            <div className="flex flex-col items-center mt-6">
                                {countdown && <p className={`text-sm font-semibold mt-2 ${countdown === 'Kedaluwarsa' ? 'text-red-500 animate-pulse' : 'text-slate-500'}`}>Kedaluwarsa dalam: {countdown}</p>}
                                <div ref={qrisRef} className="bg-white p-2 inline-block rounded-lg shadow-md">
                                    <QRCodeCanvas value={qrisData.qr_string} size={256} />
                                </div>
                                <img src={`${process.env.PUBLIC_URL}/icon/logo-qris.png`} alt="Logo QRIS" className="h-10 w-auto mt-3" />
                                <div className="mt-4 flex items-center justify-center gap-2 text-sky-700">
                                    {/* <LoadingSpinner /> */}
                                    <p className="font-semibold text-sm">Menunggu pembayaran...</p>
                                </div>
                            </div>
                        </div>

                    ) : (
                        // --- TAMPILAN SEBELUM QR DIBUAT ---
                        <div className="p-4">
                            <h3 className="text-base font-semibold text-slate-700">Konfirmasi Pembayaran</h3>
                            <div className="text-left text-sm bg-white p-4 my-4 rounded-lg border space-y-2">
                                <div className="flex justify-between">
                                    <span className="text-slate-500">Total Tagihan</span>
                                    <span className="font-medium">Rp {totalAmount.toLocaleString('id-ID')}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-slate-500">Biaya Layanan</span>
                                    <span className="font-medium">Rp {serviceFee.toLocaleString('id-ID')}</span>
                                </div>
                                <hr className="my-1" />
                                <div className="flex justify-between font-bold text-base">
                                    <span>Total Pembayaran</span>
                                    <span>Rp {finalAmount.toLocaleString('id-ID')}</span>
                                </div>
                            </div>
                            <button type="button" onClick={() => proceedToGenerateQr(finalAmount)} className={`${primaryButtonStyle} w-full`}>
                                Lanjutkan & Buat Kode QR
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// --- LANGKAH 1: DEFINISIKAN AuthForm SEBAGAI KOMPONEN MANDIRI DI LUAR AdminLoginPage ---
const AuthForm = ({
    formMode,
    email, setEmail,
    password, setPassword,
    error, setError,
    message, setMessage,
    loading,
    handleLogin,
    handleForgotPassword,
    setFormMode
}) => (
    <div className="w-full bg-white p-8 md:p-10 rounded-2xl shadow-xl">
        {formMode === 'login' ? (
            // --- TAMPILAN FORM LOGIN ---
            <>
                <h2 className="text-3xl font-bold text-slate-800 text-center">Login Pengurus</h2>
                <p className="text-center text-slate-500 text-sm mt-2 mb-6">Selamat datang kembali.</p>
                {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}
                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label className="text-sm font-medium text-slate-600">Email</label>
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={commonInputStyle} required autoComplete="email" />
                    </div>
                    <div>
                        <label className="text-sm font-medium text-slate-600">Password</label>
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={commonInputStyle} required autoComplete="current-password" />
                    </div>
                    <div className="text-right">
                        <button type="button" onClick={() => { setFormMode('forgot'); setError(''); setMessage(''); }} className="text-sm font-medium text-sky-600 hover:underline">
                            Lupa Password?
                        </button>
                    </div>
                    <button type="submit" className={`${primaryButtonStyle} w-full !py-3 !font-bold`} disabled={loading}>
                        {loading ? <LoadingSpinner /> : 'Login'}
                    </button>
                </form>
            </>
        ) : (
            // --- TAMPILAN FORM LUPA PASSWORD ---
            <>
                <h2 className="text-2xl font-bold text-slate-800 text-center">Lupa Password</h2>
                <p className="text-center text-slate-500 text-sm mt-2 mb-6">Masukkan email Anda untuk menerima link reset.</p>
                {message && <MessageBox message={message} type="success" onClose={() => setMessage('')} />}
                {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}
                <form onSubmit={handleForgotPassword} className="space-y-4">
                    <div>
                        <label className="text-sm font-medium text-slate-600">Email Terdaftar</label>
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={commonInputStyle} required />
                    </div>
                    <button type="submit" className={`${primaryButtonStyle} w-full !py-3 !font-bold`} disabled={loading}>
                        {loading ? <LoadingSpinner /> : 'Kirim Link Reset'}
                    </button>
                    <div className="text-center pt-2">
                        <button type="button" onClick={() => { setFormMode('login'); setError(''); setMessage(''); }} className="text-sm font-medium text-sky-600 hover:underline">
                            &larr; Kembali ke Login
                        </button>
                    </div>
                </form>
            </>
        )}
    </div>
);


// --- LANGKAH 2: GANTI AdminLoginPage DENGAN VERSI YANG LEBIH SEDERHANA INI ---
const AdminLoginPage = () => {
    const { login } = useAuth();

    // Semua state dan handler tetap di sini
    const [formMode, setFormMode] = useState('login');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(''); setMessage(''); setLoading(true);
        try {
            await login(email, password);
        } catch (err) {
            setError("Login gagal. Periksa kembali email dan password Anda.");
        } finally {
            setLoading(false);
        }
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        if (!email) {
            setError("Silakan masukkan alamat email Anda terlebih dahulu.");
            return;
        }
        setError(''); setMessage(''); setLoading(true);
        try {
            await sendPasswordResetEmail(authGlobal, email);
            setMessage("Email untuk reset password telah berhasil dikirim! Silakan periksa kotak masuk Anda.");
            setFormMode('login');
        } catch (err) {
            setError("Gagal mengirim email reset. Pastikan email sudah terdaftar.");
        } finally {
            setLoading(false);
        }
    };

    // JSX return sekarang hanya merender layout dan memanggil AuthForm
    return (
        <div className="min-h-screen w-full lg:grid lg:grid-cols-2">
            {/* Kolom Kiri: Branding */}
            <div className="hidden lg:flex flex-col items-center justify-center p-12 bg-slate-50 text-center">
                <img src={`${process.env.PUBLIC_URL}/icon/logo-satuwarga-text.png`} alt="Logo Satuwarga" className="w-auto h-16 mb-6" />
                <h1 className="text-4xl font-bold text-slate-800">Manajemen RT Modern</h1>
                <p className="text-lg text-slate-600 mt-4 max-w-md">
                    Kolaborasi, transparansi, dan efisiensi dalam satu platform terpadu untuk pengurus dan warga.
                </p>
            </div>

            {/* Kolom Kanan: Form Login */}
            <div className="flex flex-col items-center justify-center p-4 w-full min-h-screen bg-gradient-to-br from-orange-300 to-orange-600 lg:bg-orange-400 lg:bg-slate-50">
                <div className="w-full max-w-md">
                    {/* Logo khusus mobile */}
                    <div className="lg:hidden text-center mb-8">
                        <img src={`${process.env.PUBLIC_URL}/icon/logo-512.png`} alt="Logo Satuwarga" className="w-[120px] h-auto mx-auto bg-white p-2 rounded-full" />
                    </div>
                    {/* Memanggil AuthForm dan mengirim semua state & handler sebagai props */}
                    <AuthForm
                        formMode={formMode}
                        email={email}
                        setEmail={setEmail}
                        password={password}
                        setPassword={setPassword}
                        error={error}
                        setError={setError}
                        message={message}
                        setMessage={setMessage}
                        loading={loading}
                        handleLogin={handleLogin}
                        handleForgotPassword={handleForgotPassword}
                        setFormMode={setFormMode}
                    />
                </div>
            </div>
        </div>
    );
};

// Tambahkan komponen baru ini di App.js
const StatCardDashboard = ({ title, value, icon, description }) => (
    <div className="bg-white p-6 rounded-xl shadow-lg flex items-start space-x-4">
        <div className="bg-sky-100 text-sky-600 p-3 rounded-lg">
            <span className="text-2xl">{icon}</span>
        </div>
        <div>
            <p className="text-sm font-medium text-slate-500">{title}</p>
            <p className="text-2xl font-bold text-slate-800">{value}</p>
            {description && <p className="text-xs text-slate-400">{description}</p>}
        </div>
    </div>
);

// Tambahkan komponen baru ini di App.js

const SuperAdminDashboard = () => {
    // State untuk data dan UI
    const [dashboardData, setDashboardData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    // State untuk modal penarikan
    const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);
    const [withdrawalAmount, setWithdrawalAmount] = useState('');
    const [withdrawalFee, setWithdrawalFee] = useState('');
    const [withdrawalNote, setWithdrawalNote] = useState('');
    const [isProcessingWithdrawal, setIsProcessingWithdrawal] = useState(false);

    // State untuk Modal Pengeluaran
    const [isExpenseModalOpen, setIsExpenseModalOpen] = useState(false);
    const [expenseAmount, setExpenseAmount] = useState('');
    const [expenseDesc, setExpenseDesc] = useState('');
    const [expenseDate, setExpenseDate] = useState(new Date().toISOString().split('T')[0]);
    const [isProcessingExpense, setIsProcessingExpense] = useState(false);
    const functions = getFunctions(app, 'us-central1');
    // Fungsi untuk mengambil data dasbor
    const fetchDashboardData = useCallback(async () => {
        setIsLoading(true);
        setError('');
        try {
            const getDashboardData = httpsCallable(functions, 'getSuperAdminDashboardData');
            const result = await getDashboardData();
            setDashboardData(result.data);
        } catch (err) {
            setError(`Gagal memuat data dasbor: ${err.message}`);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchDashboardData();
    }, [fetchDashboardData]);

    // Fungsi untuk mencatat penarikan
    const handleRecordWithdrawal = async () => {
        const amount = parseFloat(withdrawalAmount);
        const fee = parseFloat(withdrawalFee);

        if (isNaN(amount) || amount <= 0 || isNaN(fee) || fee < 0) {
            toast.error("Masukkan jumlah dan biaya yang valid.");
            return;
        }

        setIsProcessingWithdrawal(true);
        try {
            const recordCompanyWithdrawal = httpsCallable(functions, 'recordCompanyWithdrawal');
            const result = await recordCompanyWithdrawal({ grossAmount: amount, withdrawalFee: fee, note: withdrawalNote });

            toast.success(result.data.message);

            setIsWithdrawModalOpen(false);
            setWithdrawalAmount('');
            setWithdrawalFee('');
            setWithdrawalNote('');

            // Panggil ulang data dasbor untuk memperbarui angka secara real-time
            fetchDashboardData();

        } catch (err) {
            toast.error(`Gagal: ${err.message}`);
        } finally {
            setIsProcessingWithdrawal(false);
        }
    };

    // --- FUNGSI BARU UNTUK MENCATAT PENGELUARAN ---
    const handleRecordExpense = async () => {
        const amount = parseFloat(expenseAmount);
        if (isNaN(amount) || amount <= 0 || !expenseDesc.trim()) {
            toast.error("Masukkan jumlah dan deskripsi pengeluaran yang valid.");
            return;
        }

        setIsProcessingExpense(true);
        try {
            const recordCompanyExpense = httpsCallable(functions, 'recordCompanyExpense');
            const result = await recordCompanyExpense({ amount, description: expenseDesc, expenseDate });

            toast.success(result.data.message);

            setIsExpenseModalOpen(false);
            setExpenseAmount('');
            setExpenseDesc('');

            fetchDashboardData(); // Refresh data dasbor

        } catch (err) {
            toast.error(`Gagal: ${err.message}`);
        } finally {
            setIsProcessingExpense(false);
        }
    };

    const formatCurrency = (amount) => `Rp ${amount != null ? Math.round(amount).toLocaleString('id-ID') : '0'}`;

    if (isLoading) return <div className={cardStyle}><LoadingSpinner /><p>Memuat data dasbor...</p></div>;
    if (error) return <div className={cardStyle}><MessageBox message={error} type="error" /></div>;
    if (!dashboardData) return <div className={cardStyle}><p>Tidak ada data untuk ditampilkan.</p></div>;

    return (
        <>
            <div className="space-y-8">
                <h2 className="text-3xl font-bold text-slate-800">Dasbor Keuangan & Operasional</h2>

                {/* LAPORAN LABA RUGI */}
                <h3 className="text-lg font-semibold text-slate-600 border-b pb-2">Laporan Laba Rugi (Akumulasi)</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {/* TAMBAHKAN STATCARD BARU DI SINI */}
                    <StatCard
                        title="Total Nilai Transaksi"
                        value={formatCurrency(dashboardData.totalTransactionValue)}
                        icon="📈"
                        description="Total uang kotor yang masuk dari QRIS (Sebelum potongan xendit)."
                    />
                    <StatCard title="Total Pendapatan" value={formatCurrency(dashboardData.totalGrossRevenue)} icon="💵" />
                    <div className="bg-white p-6 rounded-xl shadow-lg">
                        <div className="flex justify-between items-start">
                            <div>
                                <p className="text-sm font-semibold text-slate-500 uppercase">💸 Total Pengeluaran</p>
                                <p className="text-3xl font-bold text-slate-800 mt-1">{formatCurrency(dashboardData.totalOperationalCosts)}</p>
                            </div>
                            <button onClick={() => setIsExpenseModalOpen(true)} className="text-xs py-1 px-3 bg-red-500 text-white font-semibold rounded-lg shadow-md hover:bg-red-600">+ Catat</button>
                        </div>
                    </div>
                    <StatCard title="Laba / Rugi" value={formatCurrency(dashboardData.netProfitLoss)} icon="💰" color={dashboardData.netProfitLoss >= 0 ? 'text-green-600' : 'text-red-600'} />
                </div>

                {/* POSISI KAS & SALDO SAAT INI */}
                <h3 className="text-lg font-semibold text-slate-600 border-b pb-2 mt-10">Posisi Kas & Saldo</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <StatCard title="Kas Perusahaan di Xendit" value={formatCurrency(dashboardData.companyCashInXendit)} icon="💳" description="Siap ditarik ke rekening perusahaan." />
                    <StatCard title="Dana Titipan Milik RT" value={formatCurrency(dashboardData.rtEscrowFunds)} icon="🏦" description="Iuran QRIS yang belum ditarik oleh RT." />
                    <div className="bg-white p-6 rounded-xl shadow-lg">
                        <div className="flex justify-between items-start">
                            <div>
                                <p className="text-sm font-semibold text-slate-500 uppercase">💳 Total Saldo di Xendit</p>
                                <p className="text-3xl font-bold text-slate-800 mt-1">{formatCurrency(dashboardData.totalXenditBalance)}</p>
                                <p className="text-xs text-slate-400">Kas Perusahaan + Dana Titipan RT.</p>
                            </div>
                            <button onClick={() => setIsWithdrawModalOpen(true)} className="text-sm py-2 px-4 bg-sky-500 text-white font-semibold rounded-lg shadow-md hover:bg-sky-600 transition-colors flex-shrink-0" title="Catat Penarikan Dana Perusahaan">+ Catat Penarikan</button>
                        </div>
                    </div>
                </div>

                {/* OPERASIONAL & PERTUMBUHAN */}
                <h3 className="text-lg font-semibold text-slate-600 border-b pb-2 mt-10">Operasional & Pertumbuhan</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <StatCard title="Total Profil RT" value={dashboardData.totalRts} icon="🏢" />
                    <StatCard title="Total Warga Terdaftar" value={dashboardData.totalResidents} icon="👥" />
                    <StatCard title="Pendapatan Bulan Ini" value={formatCurrency(dashboardData.netRevenueThisMonth)} icon="📈" description="Dari langganan & biaya layanan bulan ini." />
                    <div className="bg-white p-6 rounded-xl shadow-lg">
                        <h4 className="text-sm font-semibold text-slate-500 uppercase">Distribusi Paket</h4>
                        <div className="text-sm space-y-1 mt-2">
                            <p>Gratis: <span className="font-bold">{dashboardData.planDistribution.gratis}</span></p>
                            <p>Premium: <span className="font-bold">{dashboardData.planDistribution.premium}</span></p>
                            <p>Maksimum: <span className="font-bold">{dashboardData.planDistribution.maksimum}</span></p>
                        </div>
                    </div>
                </div>

                {/* ANALISIS */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="bg-white p-6 rounded-xl shadow-lg">
                        <h3 className="font-semibold text-slate-800 mb-4">Pertumbuhan Pendapatan Bersih (12 Bulan Terakhir)</h3>
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={dashboardData.revenueGrowthChartData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" fontSize={12} />
                                <YAxis tickFormatter={(value) => new Intl.NumberFormat('id-ID', { notation: 'compact', compactDisplay: 'short' }).format(value)} />
                                <Tooltip formatter={(value) => formatCurrency(value)} />
                                <Legend />
                                <Bar dataKey="Pendapatan Bersih" fill="#0ea5e9" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                    <div className="bg-white p-6 rounded-xl shadow-lg">
                        <h3 className="font-semibold text-slate-800 mb-4">RT Pengguna QRIS Teraktif</h3>
                        {dashboardData.top5MostActiveRt && dashboardData.top5MostActiveRt.length > 0 ? (
                            <div className="overflow-x-auto">
                                <table className="min-w-full">
                                    <thead className="bg-slate-50">
                                        <tr>
                                            <th className="px-4 py-2 text-left text-xs font-medium text-slate-500 uppercase">Nama RT</th>
                                            <th className="px-4 py-2 text-right text-xs font-medium text-slate-500 uppercase">Jml. Transaksi</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-200">
                                        {dashboardData.top5MostActiveRt.map(rt => (
                                            <tr key={rt.rtId}>
                                                <td className="px-4 py-2 text-sm font-medium text-slate-800">{rt.rtTitle}</td>
                                                <td className="px-4 py-2 text-right text-sm font-semibold text-slate-600">{rt.count}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="flex items-center justify-center h-full">
                                <p className="text-slate-400 text-center">Belum ada data transaksi QRIS.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Modal untuk mencatat penarikan */}
            {isWithdrawModalOpen && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center p-4">
                    <div className="bg-white p-6 rounded-2xl shadow-xl w-full max-w-md">
                        <h3 className="text-xl font-bold text-slate-800">Catat Penarikan Dana Perusahaan</h3>
                        <p className="text-sm text-slate-500 mt-1">Catat dana yang sudah Anda tarik dari Xendit ke rekening perusahaan.</p>
                        <div className="space-y-4 mt-6">
                            <div>
                                <label className="block text-sm font-medium text-slate-700">Jumlah Ditarik dari Saldo Xendit (Rp)*</label>
                                <input type="number" value={withdrawalAmount} onChange={(e) => setWithdrawalAmount(e.target.value)} className={commonInputStyle} placeholder="Jumlah kotor sebelum dipotong biaya" required />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700">Biaya Layanan Penarikan (Rp)*</label>
                                <input type="number" value={withdrawalFee} onChange={(e) => setWithdrawalFee(e.target.value)} className={commonInputStyle} placeholder="Contoh: 5000" required />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700">Catatan (Opsional)</label>
                                <input type="text" value={withdrawalNote} onChange={(e) => setWithdrawalNote(e.target.value)} className={commonInputStyle} placeholder="Contoh: Operasional Juli 2025" />
                            </div>
                        </div>
                        <div className="flex justify-end gap-3 mt-6">
                            <button onClick={() => setIsWithdrawModalOpen(false)} className={secondaryButtonStyle} disabled={isProcessingWithdrawal}>Batal</button>
                            <button onClick={handleRecordWithdrawal} className={primaryButtonStyle} disabled={isProcessingWithdrawal}>
                                {isProcessingWithdrawal ? <LoadingSpinner /> : 'Simpan Catatan'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- MODAL BARU UNTUK CATAT PENGELUARAN --- */}
            {isExpenseModalOpen && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center p-4">
                    <div className="bg-white p-6 rounded-2xl shadow-xl w-full max-w-md">
                        <h3 className="text-xl font-bold text-slate-800">Catat Pengeluaran Operasional</h3>
                        <p className="text-sm text-slate-500 mt-1">Catat pengeluaran yang dibayar dari kas perusahaan.</p>
                        <div className="space-y-4 mt-6">
                            <div>
                                <label className="block text-sm font-medium text-slate-700">Jumlah Pengeluaran (Rp)*</label>
                                <input type="number" value={expenseAmount} onChange={(e) => setExpenseAmount(e.target.value)} className={commonInputStyle} required />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700">Deskripsi*</label>
                                <input type="text" value={expenseDesc} onChange={(e) => setExpenseDesc(e.target.value)} className={commonInputStyle} placeholder="Contoh: Biaya Server AWS Juli" required />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700">Tanggal Pengeluaran*</label>
                                <input type="date" value={expenseDate} onChange={(e) => setExpenseDate(e.target.value)} className={commonInputStyle} required />
                            </div>
                        </div>
                        <div className="flex justify-end gap-3 mt-6">
                            <button onClick={() => setIsExpenseModalOpen(false)} className={secondaryButtonStyle} disabled={isProcessingExpense}>Batal</button>
                            <button onClick={handleRecordExpense} className={`${dangerButtonStyle} bg-red-500`} disabled={isProcessingExpense}>
                                {isProcessingExpense ? <LoadingSpinner /> : 'Simpan Pengeluaran'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};


// --- GANTI SELURUH KOMPONEN AdminDashboardPage ANDA DENGAN VERSI FINAL INI ---

const AdminDashboardPage = () => {
    const { rtProfileId, appConfig } = useAuth();

    // State untuk data mentah dari Firestore
    const [allBills, setAllBills] = useState([]);
    const [allPayments, setAllPayments] = useState([]);
    const [allExpenses, setAllExpenses] = useState([]);
    const [allResidents, setAllResidents] = useState([]);
    const [households, setHouseholds] = useState([]);
    const [occupancies, setOccupancies] = useState([]);
    const [duesTemplates, setDuesTemplates] = useState([]);

    // State untuk UI
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    // State untuk filter
    const [filterYear, setFilterYear] = useState(new Date().getFullYear());
    const [filterTemplateId, setFilterTemplateId] = useState('ALL');

    // Mengambil semua data yang diperlukan
    useEffect(() => {
        if (!rtProfileId) { setIsLoading(false); return; }

        setIsLoading(true);
        setError('');
        const currentRtConfig = appConfig.rtProfiles?.[rtProfileId] || {};
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";

        const unsubscribers = [];

        // Definisikan koleksi dan apakah mereka menggunakan filter 'mode'
        const collectionsToFetch = [
            { path: getBillsCollectionPath(rtProfileId), setter: setAllBills, useModeFilter: true },
            { path: getPaymentsCollectionPath(rtProfileId), setter: setAllPayments, useModeFilter: true },
            { path: getExpensesCollectionPath(rtProfileId), setter: setAllExpenses, useModeFilter: true },
            { path: getResidentsCollectionPath(rtProfileId), setter: setAllResidents, useModeFilter: false },
            { path: getHouseholdsCollectionPath(rtProfileId), setter: setHouseholds, useModeFilter: false },
            { path: getOccupanciesCollectionPath(rtProfileId), setter: setOccupancies, useModeFilter: false },
            { path: getDuesTemplatesCollectionPath(rtProfileId), setter: setDuesTemplates, useModeFilter: false }
        ];

        let loadedCount = 0;
        collectionsToFetch.forEach(c => {
            let q;
            // --- PERBAIKAN UTAMA: Buat query berdasarkan kebutuhan ---
            if (c.useModeFilter) {
                q = query(collection(db, c.path), where("mode", "==", currentMode));
            } else {
                q = query(collection(db, c.path));
            }

            const unsub = onSnapshot(q,
                (snapshot) => {
                    c.setter(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                    loadedCount++;
                    if (loadedCount === collectionsToFetch.length) {
                        setIsLoading(false);
                    }
                },
                (err) => {
                    console.error(`Gagal memuat ${c.path}`, err);
                    setError(`Gagal memuat data penting. Periksa Security Rules.`);
                    setIsLoading(false);
                }
            );
            unsubscribers.push(unsub);
        });

        return () => unsubscribers.forEach(unsub => unsub());
    }, [rtProfileId, appConfig]);


    // "Otak" kalkulasi dasbor
    const dashboardData = useMemo(() => {
        if (isLoading || allResidents.length === 0 || households.length === 0) {
            return null;
        }

        // Kalkulasi Keuangan
        const paymentsForCalcs = allPayments.filter(p => p.paymentYear === filterYear && (filterTemplateId === 'ALL' || p.duesTemplateId === filterTemplateId));
        const billsForCalcs = allBills.filter(b => b.billPeriodYear === filterYear && (filterTemplateId === 'ALL' || b.duesTemplateId === filterTemplateId));
        const totalPaidInPeriod = paymentsForCalcs.filter(p => p.status === 'approved').reduce((acc, p) => acc + p.amount, 0);
        const totalReceivables = billsForCalcs.filter(b => b.status === 'UNPAID').reduce((acc, b) => acc + b.amount, 0);
        const totalCash = allPayments.filter(p => p.status === 'approved' && (filterTemplateId === 'ALL' || p.duesTemplateId === filterTemplateId)).reduce((acc, p) => acc + p.amount, 0) - allExpenses.reduce((acc, e) => acc + e.jumlah, 0);

        // Kalkulasi Kependudukan
        const residentCount = allResidents.length;
        const familyCount = new Set(allResidents.map(r => r.familyId)).size;
        const occupiedHouseIds = new Set(occupancies.filter(o => o.status === 'ACTIVE').map(o => o.householdId));
        const emptyHouses = households.filter(h => !occupiedHouseIds.has(h.id));

        // Data untuk Grafik
        const residencyChartData = Object.entries(allResidents.reduce((acc, r) => {
            const status = r.residencyStatus || 'Tidak Diketahui';
            acc[status] = (acc[status] || 0) + 1;
            return acc;
        }, {})).map(([name, jumlah]) => ({ name, jumlah }));

        const religionChartData = Object.entries(allResidents.reduce((acc, r) => {
            const religion = r.religion || 'Lainnya';
            acc[religion] = (acc[religion] || 0) + 1;
            return acc;
        }, {})).map(([name, jumlah]) => ({ name, jumlah }));

        return {
            totalCash,
            totalReceivables,
            totalPaid: totalPaidInPeriod,
            residentCount,
            familyCount,
            emptyHousesCount: emptyHouses.length,
            emptyHousesList: emptyHouses.map(h => h.houseIdentifier).slice(0, 5),
            residencyChartData,
            religionChartData
        };

    }, [allBills, allPayments, allExpenses, allResidents, households, occupancies, filterYear, filterTemplateId, isLoading]);

    const COLORS = ['#0ea5e9', '#f97316', '#10b981', '#ef4444', '#8b5cf6', '#f59e0b'];

    if (isLoading) {
        return <div className="flex justify-center items-center h-64"><LoadingSpinner /><p>Memuat Data Dasbor...</p></div>;
    }

    if (error) return <MessageBox message={error} type="error" />;
    if (!dashboardData) return <MessageBox message="Data belum cukup untuk menampilkan dasbor. Harap isi data kependudukan terlebih dahulu." type="info" />;

    return (
        <div className="space-y-8">
            <div>
                <h2 className="text-3xl font-bold text-slate-800">Dasbor RT {rtProfileId}</h2>
                <p className="text-slate-600">Ringkasan kondisi RT Anda saat ini.</p>
            </div>

            {/* Filter */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border rounded-lg bg-slate-50">
                <div>
                    <label htmlFor="filterYear" className="block text-sm font-medium text-slate-700">Tahun Laporan</label>
                    <select id="filterYear" value={filterYear} onChange={e => setFilterYear(Number(e.target.value))} className={commonInputStyle}>
                        {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                </div>
                <div>
                    <label htmlFor="filterTemplateId" className="block text-sm font-medium text-slate-700">Jenis Iuran</label>
                    <select id="filterTemplateId" value={filterTemplateId} onChange={e => setFilterTemplateId(e.target.value)} className={commonInputStyle}>
                        <option value="ALL">Semua Jenis Iuran</option>
                        {duesTemplates.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                    </select>
                </div>
            </div>

            {/* Baris Metrik Keuangan */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <StatCard title="Total Kas RT Saat Ini" value={`Rp ${dashboardData.totalCash.toLocaleString('id-ID')}`} icon="💰" />
                <StatCard title="Total Piutang" value={`Rp ${dashboardData.totalReceivables.toLocaleString('id-ID')}`} icon="🧾" description={`Pada filter yang dipilih`} />
                <StatCard title="Total Terbayar" value={`Rp ${dashboardData.totalPaid.toLocaleString('id-ID')}`} icon="✅" description={`Pada filter yang dipilih`} />
            </div>

            {/* Baris Metrik Kependudukan */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <StatCard title="Jumlah Warga" value={dashboardData.residentCount} icon="👥" />
                <StatCard title="Jumlah Kartu Keluarga" value={dashboardData.familyCount} icon="👨‍👩‍👧‍👦" />
                <StatCard title="Rumah Kosong" value={dashboardData.emptyHousesCount} icon="🏠" />
            </div>

            {/* Area Detail & Grafik */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-1 bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="font-semibold text-slate-800 mb-4">Daftar Rumah Kosong</h3>
                    {dashboardData.emptyHousesList.length > 0 ? (
                        <ul className="space-y-2 text-sm">
                            {dashboardData.emptyHousesList.map(house => (
                                <li key={house} className="p-2 bg-slate-50 rounded-md font-mono">{house}</li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-sm text-slate-500 text-center py-4">✓ Semua rumah terhuni.</p>
                    )}
                </div>
                <div className="lg:col-span-2 bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="font-semibold text-slate-800 mb-4">Warga Berdasarkan Status KTP</h3>
                    {dashboardData.residencyChartData.length > 0 ? (
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={dashboardData.residencyChartData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" fontSize={12} />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="jumlah" name="Jumlah Warga" fill="#0ea5e9" />
                            </BarChart>
                        </ResponsiveContainer>
                    ) : <p className="text-center text-slate-400 py-10">Data kependudukan tidak tersedia.</p>}
                </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg">
                <h3 className="font-semibold text-slate-800 mb-4">Warga Berdasarkan Agama</h3>
                {dashboardData.religionChartData.length > 0 ? (
                    <ResponsiveContainer width="100%" height={300}>
                        <PieChart>
                            <Pie data={dashboardData.religionChartData} dataKey="jumlah" nameKey="name" cx="50%" cy="50%" outerRadius={100} labelLine={false} label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}>
                                {dashboardData.religionChartData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                ) : <p className="text-center text-slate-400 py-10">Data kependudukan tidak tersedia.</p>}
            </div>
        </div>
    );
};

// --- Komponen AdminRtManagementPage (Placeholder) ---
// --- Ganti seluruh komponen AdminRtManagementPage dengan ini ---
const AdminRtManagementPage = () => {
    const { userRole, DEFAULT_GLOBAL_APP_CONFIG, appConfig: globalAppConfig, refreshAppConfig, updateSpecificRtConfig } = useAuth();
    const [rtProfiles, setRtProfiles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });
    const [showForm, setShowForm] = useState(false);
    const [editingProfile, setEditingProfile] = useState(null);

    // --- Form states ---
    const [rtId, setRtId] = useState('');
    const [rtTitle, setRtTitle] = useState('');
    const [rtDescription, setRtDescription] = useState('');
    const [rtAddress, setRtAddress] = useState('');
    const [adminEmail, setAdminEmail] = useState('');
    const [adminPassword, setAdminPassword] = useState('');
    const [logoImage, setLogoImage] = useState(null);
    const [logoPreview, setLogoPreview] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // --- STATE BARU UNTUK MANAJEMEN LANGGANAN ---
    const [plan, setPlan] = useState('gratis');
    const [subscriptionStatus, setSubscriptionStatus] = useState('INACTIVE');
    const [subscriptionValidUntil, setSubscriptionValidUntil] = useState('');
    // --- STATE BARU UNTUK SIKLUS PENAGIHAN ---
    const [billingCycle, setBillingCycle] = useState('yearly'); // Default ke tahunan


    const fileInputRef = useRef(null);

    useEffect(() => {
        if (userRole !== 'superAdmin') { setIsLoading(false); return; }
        // Listener untuk mengambil data RT profiles
        const unsubscribe = onSnapshot(collection(db, getRtProfilesCollectionPath()), (snapshot) => {
            const profiles = snapshot.docs.map(doc => {
                const data = doc.data();
                // Konversi timestamp Firestore ke format YYYY-MM-DD untuk input date
                const validUntilDate = data.subscriptionValidUntil?.toDate();
                const formattedValidUntil = validUntilDate
                    ? new Date(validUntilDate.getTime() - (validUntilDate.getTimezoneOffset() * 60000)).toISOString().split('T')[0]
                    : '';
                return { id: doc.id, ...data, formattedValidUntil };
            });
            setRtProfiles(profiles);
            setIsLoading(false);
        }, (err) => {
            console.error("Error fetching RT profiles:", err);
            setMessage({ text: "Gagal memuat profil RT.", type: "error" });
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, [userRole]);

    const handleLogoChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setLogoImage(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    const resetForm = () => {
        setRtId('');
        setRtTitle('');
        setRtDescription('');
        setRtAddress('');
        setAdminEmail('');
        setAdminPassword('');
        setLogoImage(null);
        setLogoPreview('');
        setEditingProfile(null);
        setShowForm(false);
        setPlan('gratis'); // Reset plan ke default
        setSubscriptionStatus('INACTIVE');
        setSubscriptionValidUntil('');
        setBillingCycle('yearly'); // <-- Tambahkan reset
    };

    const handleEdit = async (profile) => {
        setEditingProfile(profile);
        setRtId(profile.id);
        setRtTitle(profile.rtTitle);
        setRtDescription(profile.rtDescription || '');
        setRtAddress(profile.rtAddress || '');
        setAdminEmail(profile.adminEmail || '');
        setAdminPassword('');
        setLogoPreview(profile.logoUrl || '');
        setLogoImage(null);
        setPlan(profile.plan || 'gratis'); // Atur plan sesuai data yang ada

        // --- ISI FORM LANGGANAN DENGAN DATA YANG ADA ---
        setPlan(profile.plan || 'gratis');
        setSubscriptionStatus(profile.subscriptionStatus || 'INACTIVE');
        setSubscriptionValidUntil(profile.formattedValidUntil || '');
        setBillingCycle(profile.billingCycle || 'yearly');

        setShowForm(true);
        setError('');
        setMessage({ text: '', type: '' });
        window.scrollTo(0, 0);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!rtId.trim() || !rtTitle.trim() || !adminEmail.trim() || (!editingProfile && !adminPassword.trim())) {
            setError("ID RT, Judul RT, Email Admin, dan Password Admin (saat membuat baru) wajib diisi.");
            return;
        }

        setIsSubmitting(true);
        setError('');
        setMessage({ text: '', type: '' });
        let secondaryAppInstance = null;

        try {
            let logoUrlToSave = editingProfile?.logoUrl || '';
            if (logoImage) {
                const logoStorageRef = ref(storage, `rt_logos/${rtId}/${Date.now()}_${logoImage.name}`);
                await uploadBytesResumable(logoStorageRef, logoImage);
                logoUrlToSave = await getDownloadURL(logoStorageRef);
            }

            // Data yang disimpan sekarang termasuk 'plan'
            const rtProfileData = {
                rtTitle,
                rtDescription,
                rtAddress,
                logoUrl: logoUrlToSave,
                adminEmail,
                plan: plan,
                subscriptionStatus: subscriptionStatus,
                // Konversi tanggal dari input kembali ke Firestore Timestamp
                subscriptionValidUntil: subscriptionValidUntil ? Timestamp.fromDate(new Date(subscriptionValidUntil)) : null,
                billingCycle: billingCycle, // <-- Field baru
                updatedAt: Timestamp.now()
            };

            // Kita tidak lagi menyimpan config fitur di sini, karena sudah diatur oleh plan
            const configDataToSave = { rtTitle, rtAddress, logoUrl: logoUrlToSave };

            if (editingProfile) {
                await updateDoc(doc(db, getRtProfileDocPath(editingProfile.id)), rtProfileData);
                // --- PANGGIL FUNGSI UPDATE INSTAN DI SINI ---
                // Ini akan langsung memperbarui state di aplikasi tanpa menunggu listener
                updateSpecificRtConfig(editingProfile.id, rtProfileData);
                await setDoc(doc(db, getRtSpecificConfigDocPath(editingProfile.id)), configDataToSave, { merge: true });
                setMessage({ text: `Profil RT ${editingProfile.id} berhasil diperbarui.`, type: "success" });
            } else {
                rtProfileData.createdAt = Timestamp.now();
                secondaryAppInstance = initializeApp(firebaseConfig, `rtAdminCreationApp_${Date.now()}`);
                const userCreationAuth = getAuth(secondaryAppInstance);
                const userCredential = await createUserWithEmailAndPassword(userCreationAuth, adminEmail, adminPassword);
                const newAdminRtUid = userCredential.user.uid;
                await setDoc(doc(db, getAdminUserDocPath(newAdminRtUid)), { email: adminEmail, role: 'admin_rt', rtProfileId: rtId, createdAt: Timestamp.now(), createdBy: authGlobal.currentUser.uid });
                await signOut(userCreationAuth);
                await deleteApp(secondaryAppInstance);
                secondaryAppInstance = null;
                await setDoc(doc(db, getRtProfileDocPath(rtId)), rtProfileData);
                const initialRtConfig = { ...DEFAULT_GLOBAL_APP_CONFIG, ...configDataToSave };
                await setDoc(doc(db, getRtSpecificConfigDocPath(rtId)), initialRtConfig);
                setMessage({ text: `Profil RT ${rtId} dan Admin RT ${adminEmail} berhasil dibuat.`, type: "success" });
            }
            // if (refreshAppConfig) await refreshAppConfig();
            // Panggil refreshAppConfig untuk memperbarui data di seluruh aplikasi secara real-time
            // Kita tidak perlu lagi update state lokal karena AuthProvider akan menangani semuanya
            if (refreshAppConfig) {
                // console.log("Memanggil refreshAppConfig dari AdminRtManagementPage...");
                await refreshAppConfig();
            }
            resetForm();
        } catch (err) {
            console.error("Error saving RT profile:", err);
            setError("Gagal menyimpan Profil RT: " + (err.message || "Error tidak diketahui"));
            if (secondaryAppInstance) {
                try { await deleteApp(secondaryAppInstance); } catch (e) { console.error("Error deleting secondary app on failure:", e); }
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDeleteProfile = async (profileIdToDelete, profileTitle) => {
        // ... (logika handleDeleteProfile tidak perlu diubah)
    };

    if (userRole !== 'superAdmin') {
        return <div className={cardStyle}><MessageBox message="Akses ditolak. Hanya Super Admin." type="error" /></div>;
    }
    if (isLoading) return <div className={cardStyle}><LoadingSpinner /><p className="text-center">Memuat Profil RT...</p></div>;

    return (
        <div className={cardStyle}>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold text-slate-700">Manajemen Profil RT</h2>
                <button onClick={() => { resetForm(); setShowForm(true); }} className={primaryButtonStyle}>
                    {showForm ? 'Batal' : 'Tambah Profil RT Baru'}
                </button>
            </div>
            {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}
            {message.text && <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />}

            {showForm && (
                <form onSubmit={handleFormSubmit} className="mb-8 p-6 border rounded-lg bg-slate-50 space-y-4">
                    <h3 className="text-xl font-medium mb-3">{editingProfile ? `Edit Profil RT: ${editingProfile.id}` : 'Buat Profil RT Baru'}</h3>

                    {/* Input untuk data RT */}
                    <div><label>ID RT*</label><input type="text" value={rtId} onChange={(e) => setRtId(e.target.value.toUpperCase())} className={commonInputStyle} required disabled={!!editingProfile} /></div>
                    <div><label>Judul/Nama RT*</label><input type="text" value={rtTitle} onChange={(e) => setRtTitle(e.target.value)} className={commonInputStyle} required /></div>
                    <div><label>Deskripsi</label><textarea value={rtDescription} onChange={(e) => setRtDescription(e.target.value)} rows="2" className={commonInputStyle}></textarea></div>
                    <div><label>Alamat</label><textarea value={rtAddress} onChange={(e) => setRtAddress(e.target.value)} rows="3" className={commonInputStyle}></textarea></div>
                    <div><label>Logo</label><input type="file" ref={fileInputRef} onChange={handleLogoChange} accept="image/*" className={`${commonInputStyle} file:mr-4 ...`} />{logoPreview && <img src={logoPreview} alt="Preview" className="mt-2 h-20 w-auto rounded" />}</div>

                    {/* --- BAGIAN BARU: FORM MANAJEMEN LANGGANAN --- */}
                    <hr className="my-4" />
                    <h4 className="text-md font-semibold text-slate-700">Pengaturan Langganan</h4>

                    <div>
                        <label htmlFor="billingCycle" className="block text-sm font-medium text-slate-700">Siklus Penagihan</label>
                        <select id="billingCycle" value={billingCycle} onChange={(e) => setBillingCycle(e.target.value)} className={commonInputStyle}>
                            <option value="monthly">Bulanan</option>
                            <option value="yearly">Tahunan</option>
                        </select>
                    </div>

                    <div>
                        <label htmlFor="planSelect" className="block text-sm font-medium text-slate-700">Paket (Plan)</label>
                        <select id="planSelect" value={plan} onChange={(e) => setPlan(e.target.value)} className={commonInputStyle}>
                            <option value="gratis">Gratis</option>
                            <option value="premium">Premium</option>
                            <option value="maksimum">Maksimum</option>
                        </select>
                    </div>

                    <div>
                        <label htmlFor="subStatus" className="block text-sm font-medium text-slate-700">Status Langganan</label>
                        <select id="subStatus" value={subscriptionStatus} onChange={(e) => setSubscriptionStatus(e.target.value)} className={commonInputStyle}>
                            <option value="INACTIVE">Tidak Aktif / Kedaluwarsa</option>
                            <option value="ACTIVE">Aktif</option>
                        </select>
                    </div>

                    <div>
                        <label htmlFor="subValidUntil" className="block text-sm font-medium text-slate-700">Langganan Aktif Hingga</label>
                        <input type="date" id="subValidUntil" value={subscriptionValidUntil} onChange={(e) => setSubscriptionValidUntil(e.target.value)} className={commonInputStyle} />
                        <p className="text-xs text-slate-500 mt-1">Kosongkan jika tidak ada langganan aktif.</p>
                    </div>
                    {/* --- AKHIR BAGIAN BARU --- */}

                    <hr />
                    <h4 className="text-md font-medium text-slate-600 pt-2">Akun Admin untuk RT ini:</h4>
                    <div><label>Email Admin RT*</label><input type="email" value={adminEmail} onChange={(e) => setAdminEmail(e.target.value)} className={commonInputStyle} required disabled={!!editingProfile} /></div>
                    {!editingProfile && (
                        <div><label>Password Admin RT (min. 6 karakter)*</label><input type="password" value={adminPassword} onChange={(e) => setAdminPassword(e.target.value)} className={commonInputStyle} required minLength="6" /></div>
                    )}

                    <div className="flex gap-4 pt-3">
                        <button type="submit" className={primaryButtonStyle} disabled={isSubmitting}>{isSubmitting ? <LoadingSpinner /> : (editingProfile ? 'Update Profil RT' : 'Simpan Profil RT & Admin')}</button>
                        <button type="button" onClick={resetForm} className={secondaryButtonStyle}>Batal</button>
                    </div>
                </form>
            )}

            <h3 className="text-lg font-semibold text-slate-600 mb-3">Daftar Profil RT</h3>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-slate-200">
                    <thead className="bg-slate-50">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase">Profil RT</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase">Plan</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase">Status Langganan</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase">Aktif Hingga</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase">Aksi</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-200">
                        {rtProfiles.map(profile => {
                            let statusBadge;
                            if (profile.plan === 'gratis') {
                                statusBadge = <span className="px-2 py-1 text-xs font-semibold rounded-full bg-slate-200 text-slate-800">GRATIS</span>;
                            } else {
                                const isActive = profile.subscriptionStatus === 'ACTIVE' && profile.subscriptionValidUntil?.toDate() > new Date();
                                if (isActive) {
                                    statusBadge = <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">AKTIF</span>;
                                } else {
                                    statusBadge = <span className="px-2 py-1 text-xs font-semibold rounded-full bg-orange-100 text-orange-800">KEDALUWARSA</span>;
                                }
                            }
                            // --- AKHIR DARI LOGIKA TAMPILAN STATUS YANG BARU ---

                            return (
                                <tr key={profile.id}>
                                    <td className="px-4 py-4"><div className="font-semibold text-sky-700">{profile.rtTitle}</div><div className="text-xs text-slate-500">{profile.id}</div></td>
                                    <td className="px-4 py-4"><span className="font-medium capitalize">{profile.plan || 'gratis'}</span></td>
                                    <td className="px-4 py-4">{statusBadge}</td>
                                    <td className="px-4 py-4 text-sm text-slate-600">{profile.subscriptionValidUntil?.toDate().toLocaleDateString('id-ID') || '-'}</td>
                                    <td className="px-4 py-4"><button onClick={() => handleEdit(profile)} className="text-sm font-semibold text-sky-600 hover:underline">Kelola</button></td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};


// Helper untuk path koleksi duesTemplates
const getDuesTemplatesCollectionPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/duesTemplates`;
// helper path huian lainnya
const getResidentsCollectionPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/residents`;
const getOccupanciesCollectionPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/occupancies`;
const getFamiliesCollectionPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/families`;
const getBillsCollectionPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/bills`;


// Helper untuk mengambil templat dengan logika fallback/mewarisi
// const getEffectiveDuesTemplates = async (rtProfileId, year, maxFallbackYears = 5) => {
//     for (let i = 0; i < maxFallbackYears; i++) {
//         const targetYear = year - i;
//         const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
//         const q = query(collection(db, templatesPath), where("year", "==", targetYear));

//         const snapshot = await getDocs(q);
//         if (!snapshot.empty) {
//             console.log(`Menemukan templat untuk tahun ${targetYear}, digunakan untuk tahun ${year}.`);
//             const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//             return { templates: data, effectiveYear: targetYear };
//         }
//     }
//     console.log(`Tidak ditemukan templat untuk tahun ${year} atau ${maxFallbackYears} tahun sebelumnya.`);
//     return { templates: [], effectiveYear: year };
// };

// GANTI SELURUH KOMPONEN INI DI App.js

const ManageDuesTemplatesPage = () => {
    const { rtProfileId, appConfig } = useAuth();

    // Ambil konfigurasi spesifik untuk RT yang sedang login
    const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId];

    // State untuk menampung data mentah dari listener dan yang akan ditampilkan
    const [allTemplates, setAllTemplates] = useState([]);
    const [displayedTemplates, setDisplayedTemplates] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });

    // State untuk form
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [currentTemplate, setCurrentTemplate] = useState(null);
    const [name, setName] = useState('');
    const [amount, setAmount] = useState('');
    const [period, setPeriod] = useState('bulanan');
    const [isActive, setIsActive] = useState(true);
    const [isPrimary, setIsPrimary] = useState(true);
    const [startMonth, setStartMonth] = useState(1);
    const [endMonth, setEndMonth] = useState(12);

    // State untuk UI
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [effectiveYear, setEffectiveYear] = useState(null);
    const [billingType, setBillingType] = useState('RULE_BASED');

    const canCustomizePeriod = currentRtConfig?.canCreateCustomDuesPeriods === true;
    const canUseTargetedBilling = currentRtConfig?.canUseTargetedBilling === true;

    // Helper data untuk dropdowns
    const monthOptions = useMemo(() => Array.from({ length: 12 }, (_, i) => ({ value: i + 1, label: new Date(2000, i).toLocaleString('id-ID', { month: 'long' }) })), []);
    const periodOptions = useMemo(() => [
        { value: 'sekali bayar', label: 'Sekali Bayar', duration: 1 }, { value: 'bulanan', label: 'Bulanan', duration: 1 },
        { value: 'triwulan', label: 'Triwulan', duration: 3 }, { value: 'semester', label: 'Semester', duration: 6 },
        { value: 'tahunan', label: 'Tahunan', duration: 12 },
    ], []);

    const filteredPeriodOptions = useMemo(() => {
        const duration = isPrimary ? 12 : endMonth - startMonth + 1;
        if (duration <= 0) return [];
        return periodOptions.filter(opt => opt.duration <= duration);
    }, [startMonth, endMonth, isPrimary, periodOptions]);

    // useEffect untuk mendengarkan perubahan data dari Firestore secara REAL-TIME
    useEffect(() => {
        if (!rtProfileId) {
            setIsLoading(false);
            setError("Profil RT tidak valid untuk mengakses fitur ini.");
            return;
        }

        setIsLoading(true);
        const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
        const q = query(collection(db, templatesPath), orderBy('createdAt', 'desc'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const allData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setAllTemplates(allData); // Simpan semua data mentah dari listener
            setIsLoading(false);
            // console.log("Data templat iuran berhasil dimuat/diperbarui secara real-time.");
        }, (err) => {
            console.error("Error fetching dues templates:", err);
            setError("Gagal memuat data templat iuran.");
            setIsLoading(false);
        });

        return () => unsubscribe(); // Cleanup listener saat komponen dibongkar
    }, [rtProfileId]);

    // useEffect untuk memfilter dan menerapkan logika "mewarisi"
    useEffect(() => {
        let yearFound = selectedYear;
        let templatesForDisplay = allTemplates.filter(t => t.year === selectedYear);

        if (templatesForDisplay.length === 0 && allTemplates.length > 0) {
            for (let i = 1; i <= 5; i++) {
                const fallbackYear = selectedYear - i;
                const fallbackTemplates = allTemplates.filter(t => t.year === fallbackYear);
                if (fallbackTemplates.length > 0) {
                    templatesForDisplay = fallbackTemplates;
                    yearFound = fallbackYear;
                    break;
                }
            }
        }
        setDisplayedTemplates(templatesForDisplay);
        setEffectiveYear(yearFound);

    }, [allTemplates, selectedYear]);

    // useEffect untuk mengelola state form
    useEffect(() => {
        if (!canCustomizePeriod) setIsPrimary(true);
        if (isPrimary) { setStartMonth(1); setEndMonth(12); }
    }, [isPrimary, canCustomizePeriod]);

    useEffect(() => {
        if (!filteredPeriodOptions.find(p => p.value === period)) {
            if (filteredPeriodOptions.length > 0) setPeriod(filteredPeriodOptions[0].value);
        }
    }, [filteredPeriodOptions, period]);

    const resetForm = () => { setCurrentTemplate(null); setName(''); setAmount(''); setPeriod('bulanan'); setIsActive(true); setIsPrimary(true); };
    const handleEdit = (template) => { setCurrentTemplate(template); setName(template.name); setAmount(template.amount.toString()); setPeriod(template.period); setIsActive(template.isActive); setIsPrimary(template.isPrimary !== undefined ? template.isPrimary : true); setStartMonth(template.startMonth || 1); setEndMonth(template.endMonth || 12); setBillingType(template.billingType || 'RULE_BASED'); window.scrollTo(0, 0); };
    const handleDelete = async (templateId, templateName) => { if (!rtProfileId) return; if (window.confirm(`Yakin hapus templat "${templateName}"?`)) { setIsSubmitting(true); try { await deleteDoc(doc(db, getDuesTemplatesCollectionPath(rtProfileId), templateId)); setMessage({ text: "Templat berhasil dihapus.", type: "success" }); } catch (err) { setError("Gagal menghapus templat."); } finally { setIsSubmitting(false); } } };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!rtProfileId) { setError("Profil RT tidak valid."); return; }
        if (!name || !amount || Number(amount) <= 0) { setError("Nama dan Jumlah Iuran (harus positif) tidak boleh kosong."); return; }

        setIsSubmitting(true);
        setError('');

        const finalIsPrimary = canCustomizePeriod ? isPrimary : true;
        const dataToSave = {
            name: name.trim(), amount: Number(amount), period, isActive,
            isPrimary: finalIsPrimary, startMonth: finalIsPrimary ? 1 : startMonth,
            endMonth: finalIsPrimary ? 12 : endMonth, year: selectedYear, rtProfileId,
            billingType: billingType,
            updatedAt: Timestamp.now() // Selalu perbarui timestamp
        };

        try {
            const batch = writeBatch(db);
            const templatesCollectionRef = collection(db, getDuesTemplatesCollectionPath(rtProfileId));

            // --- LOGIKA BARU UNTUK MEMASTIKAN HANYA ADA SATU IURAN UTAMA ---
            if (finalIsPrimary) {
                // Cari iuran utama lain yang mungkin masih aktif
                const q = query(templatesCollectionRef, where("isPrimary", "==", true));
                const existingPrimarySnap = await getDocs(q);

                existingPrimarySnap.forEach(docSnap => {
                    // Jika ditemukan iuran utama lain (dan itu bukan dokumen yang sedang kita edit),
                    // set isPrimary-nya menjadi false.
                    if (currentTemplate?.id !== docSnap.id) {
                        const oldPrimaryRef = doc(db, getDuesTemplatesCollectionPath(rtProfileId), docSnap.id);
                        batch.update(oldPrimaryRef, { isPrimary: false });
                    }
                });
            }
            // --- AKHIR LOGIKA BARU ---

            if (currentTemplate) {
                // Update dokumen yang ada
                const templateRef = doc(db, getDuesTemplatesCollectionPath(rtProfileId), currentTemplate.id);
                batch.update(templateRef, dataToSave);
                setMessage({ text: "Templat berhasil diperbarui.", type: "success" });
            } else {
                // Tambah dokumen baru
                dataToSave.createdAt = Timestamp.now();
                const newTemplateRef = doc(templatesCollectionRef);
                batch.set(newTemplateRef, dataToSave);
                setMessage({ text: "Templat baru berhasil ditambahkan.", type: "success" });
            }

            await batch.commit(); // Jalankan semua operasi (update + add/update)
            resetForm();

        } catch (err) {
            console.error("Error saving template:", err);
            setError("Gagal menyimpan templat.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-4">Manajemen Jenis Iuran</h2>

            <div className="mb-6 p-4 border rounded-lg bg-slate-50">
                <label htmlFor="year-select" className="block text-sm font-medium text-slate-700">Kelola Templat untuk Tahun</label>
                <select id="year-select" value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))} className={commonInputStyle}>
                    {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() + 2 - i).map(year => (<option key={year} value={year}>{year}</option>))}
                </select>
            </div>

            <form onSubmit={handleSubmit} className="mb-8 p-4 border rounded-lg bg-slate-50">
                <h3 className="text-lg font-semibold mb-3">{currentTemplate ? `Edit Templat` : `Tambah Templat Baru untuk Tahun ${selectedYear}`}</h3>
                {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}
                {message.text && <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />}
                <div className="space-y-4">
                    <input type="text" placeholder="Nama Iuran (e.g., Iuran Keamanan)" value={name} onChange={(e) => setName(e.target.value)} className={commonInputStyle} required />
                    {/* --- BLOK KONDISIONAL BARU UNTUK MENGUNCI SELURUH FITUR --- */}
                    {currentRtConfig?.canUseTargetedBilling === true && (
                        <div>
                            <label className="block text-sm font-medium text-slate-700">Tipe Penagihan*</label>
                            <select value={billingType} onChange={(e) => setBillingType(e.target.value)} className={commonInputStyle}>
                                <option value="RULE_BASED">Berbasis Aturan (Otomatis untuk semua)</option>
                                <option value="TARGETED">Bertarget (Dipilih Manual oleh Admin)</option>
                            </select>
                            <p className="text-xs text-slate-500 mt-1">
                                Pilih 'Berbasis Aturan' untuk iuran rutin. Pilih 'Bertarget' untuk iuran insidental yang ditujukan ke rumah tertentu.
                            </p>
                        </div>
                    )}
                    <input type="number" placeholder="Jumlah (e.g., 50000)" value={amount} onChange={(e) => setAmount(e.target.value)} className={commonInputStyle} required min="0" />
                    {canCustomizePeriod && (<div className="pt-2"><label className="flex items-center space-x-2 cursor-pointer"><input type="checkbox" checked={isPrimary} onChange={(e) => setIsPrimary(e.target.checked)} className="h-5 w-5 rounded text-sky-600 focus:ring-sky-500" /><span>Iuran Utama (berlaku sepanjang tahun)</span></label></div>)}
                    {canCustomizePeriod && !isPrimary && (<div className="mt-4 p-3 bg-sky-50 border border-sky-100 rounded-md"><p className="text-sm font-semibold mb-2 text-slate-600">Periode Aktif Kustom:</p><div className="flex items-center space-x-2"><select value={startMonth} onChange={(e) => setStartMonth(Number(e.target.value))} className={commonInputStyle}>{monthOptions.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}</select><span className="text-slate-500">s/d</span><select value={endMonth} onChange={(e) => setEndMonth(Number(e.target.value))} className={commonInputStyle}>{monthOptions.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}</select></div></div>)}
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">Periode Penagihan</label>
                        <select value={period} onChange={(e) => setPeriod(e.target.value)} className={commonInputStyle} disabled={filteredPeriodOptions.length === 0}>
                            {filteredPeriodOptions.map(opt => (<option key={opt.value} value={opt.value}>{opt.label}</option>))}
                        </select>
                        {filteredPeriodOptions.length === 0 && <p className="text-xs text-red-500 mt-1">Rentang bulan tidak valid.</p>}
                    </div>
                    <div className="pt-2"><label className="flex items-center space-x-2 cursor-pointer"><input type="checkbox" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} className="h-5 w-5 rounded text-sky-600 focus:ring-sky-500" /><span>Aktif (bisa digunakan untuk membuat tagihan)</span></label></div>
                </div>
                <div className="mt-4 flex items-center space-x-2">
                    <button type="submit" className={primaryButtonStyle} disabled={isSubmitting}>{isSubmitting ? <LoadingSpinner /> : (currentTemplate ? 'Simpan Perubahan' : 'Tambah Templat')}</button>
                    {currentTemplate && (<button type="button" onClick={resetForm} className="px-4 py-2 rounded-md font-semibold text-slate-700 bg-slate-200 hover:bg-slate-300">Batal Edit</button>)}
                </div>
            </form>

            <h3 className="text-lg font-semibold mb-3">Daftar Templat Iuran untuk Tahun {selectedYear}</h3>
            {effectiveYear && selectedYear !== effectiveYear && (<MessageBox message={`Tidak ada templat untuk tahun ${selectedYear}. Menampilkan data yang diwarisi dari tahun ${effectiveYear}.`} type="info" />)}
            {isLoading ? <LoadingSpinner /> : (
                <div className="space-y-3">
                    {displayedTemplates.length === 0 ? <p className="text-center text-slate-500 py-4">Belum ada templat iuran yang dibuat.</p> : displayedTemplates.map(template => (
                        <div key={template.id} className="p-4 border rounded-lg flex justify-between items-center bg-white shadow-sm">
                            <div>
                                <p className="font-semibold flex items-center gap-2">
                                    {template.name}

                                    {/* --- LABEL BARU DITAMBAHKAN DI SINI --- */}
                                    {template.isPrimary && (
                                        <span className="text-xs font-bold text-white bg-green-600 px-2.5 py-1 rounded-full">
                                            UTAMA
                                        </span>
                                    )}
                                </p>

                                <p className="text-sm text-slate-600">Rp {template.amount.toLocaleString('id-ID')} / {template.period}</p>
                                <p className="text-xs text-slate-500">Periode Aktif: {template.isPrimary ? 'Setahun Penuh' : `${monthOptions.find(m => m.value === template.startMonth)?.label} - ${monthOptions.find(m => m.value === template.endMonth)?.label}`}</p>
                            </div>
                            {/* <div>
                                <p className="font-semibold">{template.name}</p>
                                <p className="text-sm text-slate-600">Rp {template.amount.toLocaleString('id-ID')} / {template.period}</p>
                                <p className="text-xs text-slate-500">Periode Aktif: {template.isPrimary ? 'Setahun Penuh' : `${monthOptions.find(m => m.value === template.startMonth)?.label} - ${monthOptions.find(m => m.value === template.endMonth)?.label}`}</p>
                            </div> */}
                            <div className="flex flex-col items-end space-y-2">
                                <p className={`text-xs font-bold ${template.isActive ? 'text-green-600' : 'text-red-600'}`}>{template.isActive ? 'Aktif' : 'Non-Aktif'}</p>
                                <div className="space-x-2">
                                    <button onClick={() => handleEdit(template)} className="text-sm font-semibold text-sky-600 hover:text-sky-800">Edit</button>
                                    <button onClick={() => handleDelete(template.id, template.name)} className="text-sm font-semibold text-red-600 hover:text-red-800" disabled={isSubmitting}>Hapus</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const ManageFamilyPage = () => {
    const { rtProfileId, appConfig } = useAuth();
    const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId];

    // States untuk data dari Firestore
    const [families, setFamilies] = useState([]);
    const [residents, setResidents] = useState([]);
    const [occupancies, setOccupancies] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // States untuk UI
    const [error, setError] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    // States untuk form keluarga
    const [editingFamily, setEditingFamily] = useState(null);
    const [familyCardNumber, setFamilyCardNumber] = useState('');
    const [headOfFamilyName, setHeadOfFamilyName] = useState('');

    // States untuk form anggota keluarga
    const [showMemberForm, setShowMemberForm] = useState(false);
    const [editingMember, setEditingMember] = useState(null);
    const [memberFormData, setMemberFormData] = useState({ fullName: '', nik: '', statusInFamily: 'Anak' });

    const canUseOcr = currentRtConfig?.isOcrEnabled === true;

    // Mengambil semua data yang diperlukan secara real-time
    useEffect(() => {
        if (!rtProfileId) { setIsLoading(false); return; }
        const unsubFamilies = onSnapshot(query(collection(db, getFamiliesCollectionPath(rtProfileId)), orderBy("createdAt", "desc")), (s) => setFamilies(s.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubResidents = onSnapshot(query(collection(db, getResidentsCollectionPath(rtProfileId))), (s) => setResidents(s.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubOccupancies = onSnapshot(query(collection(db, getOccupanciesCollectionPath(rtProfileId))), (s) => {
            setOccupancies(s.docs.map(d => ({ id: d.id, ...d.data() })));
            setIsLoading(false);
        });
        return () => { unsubFamilies(); unsubResidents(); unsubOccupancies(); };
    }, [rtProfileId]);

    // Menggabungkan data untuk ditampilkan
    const familiesWithMembers = useMemo(() => {
        return families.map(family => ({
            ...family,
            members: residents.filter(res => res.familyId === family.id).sort((a, b) => a.createdAt?.toDate() - b.createdAt?.toDate())
        }));
    }, [families, residents]);

    const handleStartAddFamily = () => { setEditingFamily({ id: 'new' }); setHeadOfFamilyName(''); setFamilyCardNumber(''); };
    const handleEditFamily = (family) => { setEditingFamily(family); setHeadOfFamilyName(family.headOfFamilyName); setFamilyCardNumber(family.familyCardNumber || ''); setShowMemberForm(false); };
    const handleCancelEdit = () => { setEditingFamily(null); setError(''); };

    const handleSaveFamily = async (e) => {
        e.preventDefault();
        if (!headOfFamilyName) { setError("Nama Kepala Keluarga wajib diisi."); return; }
        setIsSubmitting(true);

        const limits = { maxFamilyCards: currentRtConfig?.maxFamilyCards || Infinity };
        if (editingFamily?.id === 'new' && families.length >= limits.maxFamilyCards) {
            setError(`Gagal: Jumlah KK sudah mencapai batas maksimal (${limits.maxFamilyCards}) untuk plan ini.`);
            setIsSubmitting(false);
            return;
        }

        const familyData = { headOfFamilyName, familyCardNumber, rtProfileId };
        try {
            if (editingFamily?.id === 'new') {
                familyData.createdAt = Timestamp.now();
                const newFamilyRef = await addDoc(collection(db, getFamiliesCollectionPath(rtProfileId)), familyData);
                await addDoc(collection(db, getResidentsCollectionPath(rtProfileId)), {
                    fullName: headOfFamilyName, nik: '', statusInFamily: 'Kepala Keluarga',
                    familyId: newFamilyRef.id, familyCardNumber, createdAt: Timestamp.now(), rtProfileId
                });
                setMessage({ text: 'Keluarga baru berhasil dibuat.', type: 'success' });
            } else {
                await updateDoc(doc(db, getFamiliesCollectionPath(rtProfileId), editingFamily.id), familyData);
                setMessage({ text: 'Data keluarga berhasil diperbarui.', type: 'success' });
            }
            handleCancelEdit();
        } catch (err) { setError("Gagal menyimpan data keluarga."); }
        finally { setIsSubmitting(false); }
    };

    const handleStartAddMember = () => { setShowMemberForm(true); setEditingMember(null); setMemberFormData({ fullName: '', nik: '', statusInFamily: 'Anak' }); };
    const handleStartEditMember = (member) => {
        setShowMemberForm(true);
        setEditingMember(member);
        setMemberFormData({
            // Data yang sudah ada sebelumnya
            fullName: member.fullName,
            nik: member.nik || '',
            statusInFamily: member.statusInFamily,

            // Data baru yang kita tambahkan untuk ditarik dari Firestore
            gender: member.gender || '',
            religion: member.religion || '',
            occupation: member.occupation || '',
            education: member.education || '',
            bloodType: member.bloodType || '',
            residencyStatus: member.residencyStatus || '',
            phoneNumber: member.phoneNumber || '' // <-- TAMBAHKAN BARIS INI
        });
    };
    const handleCancelMemberForm = () => { setShowMemberForm(false); setEditingMember(null); };

    const handleMemberFormChange = (field, value) => setMemberFormData(prev => ({ ...prev, [field]: value }));

    const handleSaveMember = async (e) => {
        e.preventDefault();
        if (!memberFormData.fullName) { setError("Nama anggota keluarga tidak boleh kosong."); return; }

        // --- VALIDASI BARU DIMULAI DI SINI ---
        if (memberFormData.statusInFamily === 'Kepala Keluarga') {
            // Cek apakah sudah ada kepala keluarga lain di keluarga ini
            const membersInFamily = residents.filter(r => r.familyId === editingFamily.id);
            // Saat mengedit, pastikan kita tidak membandingkan dengan diri sendiri
            const otherMembers = editingMember ? membersInFamily.filter(m => m.id !== editingMember.id) : membersInFamily;
            const headAlreadyExists = otherMembers.some(m => m.statusInFamily === 'Kepala Keluarga');

            if (headAlreadyExists) {
                setError("Gagal: Keluarga ini sudah memiliki Kepala Keluarga. Hanya boleh ada satu.");
                return;
            }
        }
        // --- AKHIR VALIDASI ---

        const limits = { maxResidents: currentRtConfig?.maxResidents || Infinity };
        if (!editingMember && residents.length >= limits.maxResidents) {
            setError(`Gagal: Jumlah warga akan melebihi batas maksimal (${limits.maxResidents}) untuk plan ini.`);
            return;
        }
        setIsSubmitting(true);
        const dataToSave = {
            fullName: memberFormData.fullName,
            nik: memberFormData.nik || '',
            statusInFamily: memberFormData.statusInFamily,
            gender: memberFormData.gender || '',
            religion: memberFormData.religion || '',
            occupation: memberFormData.occupation || '',
            education: memberFormData.education || '',
            bloodType: memberFormData.bloodType || '',
            phoneNumber: memberFormData.phoneNumber || '', // <-- TAMBAHKAN INI
            residencyStatus: memberFormData.residencyStatus || '',
            rtProfileId
        };
        try {
            if (editingMember) {
                const residentRef = doc(db, getResidentsCollectionPath(rtProfileId), editingMember.id);
                await updateDoc(residentRef, dataToSave);
                setMessage({ text: 'Data anggota keluarga berhasil diperbarui.', type: 'success' });
            } else {
                dataToSave.familyId = editingFamily.id;
                dataToSave.familyCardNumber = editingFamily.familyCardNumber;
                dataToSave.status = 'ACTIVE';
                dataToSave.createdAt = Timestamp.now();
                await addDoc(collection(db, getResidentsCollectionPath(rtProfileId)), dataToSave);
                setMessage({ text: 'Anggota keluarga baru berhasil ditambahkan.', type: 'success' });
            }
            handleCancelMemberForm();
        } catch (err) { setError("Gagal menyimpan data anggota."); }
        finally { setIsSubmitting(false); }
    };

    const handleDeleteResident = async (residentToDelete) => {
        const family = families.find(f => f.id === residentToDelete.familyId);
        const membersInFamily = residents.filter(r => r.familyId === residentToDelete.familyId);
        if (membersInFamily.length === 1 && occupancies.some(o => o.familyId === residentToDelete.familyId && o.status === 'ACTIVE')) {
            alert("Gagal Hapus: Tidak bisa menghapus satu-satunya anggota keluarga dari hunian yang masih aktif. Proses pindah hunian terlebih dahulu atau tambahkan anggota lain sebelum menghapus.");
            return;
        }
        if (window.confirm(`Yakin ingin menghapus warga "${residentToDelete.fullName}" dari keluarga ${family.headOfFamilyName}?`)) {
            setIsSubmitting(true);
            try {
                await deleteDoc(doc(db, getResidentsCollectionPath(rtProfileId), residentToDelete.id));
                setMessage({ text: "Data warga berhasil dihapus.", type: "success" });
            } catch (err) { setError("Gagal menghapus data warga."); }
            finally { setIsSubmitting(false); }
        }
    };

    if (isLoading) return <div className={cardStyle}><LoadingSpinner /></div>;

    return (
        <div className={cardStyle}>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold text-slate-700">Manajemen Keluarga & Warga</h2>
                {!editingFamily && <button onClick={handleStartAddFamily} className={primaryButtonStyle}>+ Tambah Keluarga</button>}
            </div>
            {message.text && <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '' })} />}
            {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}

            {editingFamily && (
                <div className="p-4 border rounded-lg bg-slate-50 mb-6">
                    <h3 className="text-xl font-semibold mb-3">{editingFamily.id === 'new' ? 'Tambah Keluarga Baru' : `Kelola Keluarga: ${editingFamily.headOfFamilyName}`}</h3>
                    {canUseOcr && <button type="button" className="w-full text-sm p-2 mb-3 bg-gray-200 text-gray-600 rounded-md hover:bg-gray-300">(Segera Hadir) Upload & Scan KK</button>}
                    <form onSubmit={handleSaveFamily} className="space-y-4 mb-4">
                        <input type="text" placeholder="Nama Kepala Keluarga*" value={headOfFamilyName} onChange={e => setHeadOfFamilyName(e.target.value)} className={commonInputStyle} required />
                        <input type="text" placeholder="No. Kartu Keluarga (Opsional)" value={familyCardNumber} onChange={e => setFamilyCardNumber(e.target.value)} className={commonInputStyle} />
                        <div className="flex space-x-2"><button type="submit" className={primaryButtonStyle} disabled={isSubmitting}>{isSubmitting ? 'Menyimpan...' : 'Simpan Keluarga'}</button><button type="button" onClick={handleCancelEdit} className={secondaryButtonStyle}>Tutup</button></div>
                    </form>

                    {editingFamily.id !== 'new' && (
                        <div className="mt-4 pt-4 border-t">
                            <div className="flex justify-between items-center">
                                <h4 className="text-lg font-semibold text-slate-700">Anggota Keluarga</h4>
                                {!showMemberForm && <button onClick={handleStartAddMember} className="text-sm font-semibold text-sky-600 hover:underline">+ Tambah Anggota</button>}
                            </div>

                            {showMemberForm && (
                                <form onSubmit={handleSaveMember} className="space-y-3 mt-2 bg-white p-3 rounded-md border">
                                    <h5 className="font-semibold">{editingMember ? `Edit: ${editingMember.fullName}` : 'Anggota Baru'}</h5>
                                    <input type="text" placeholder="Nama Lengkap*" value={memberFormData.fullName} onChange={e => handleMemberFormChange('fullName', e.target.value)} className={commonInputStyle} required />
                                    <input type="text" placeholder="NIK (Opsional)" value={memberFormData.nik} onChange={e => handleMemberFormChange('nik', e.target.value)} className={commonInputStyle} />
                                    <div>
                                        <label className="block text-xs font-medium text-slate-600">Nomor HP (untuk Login OTP)</label>
                                        <input
                                            type="tel"
                                            placeholder="+6281234567890"
                                            value={memberFormData.phoneNumber || ''}
                                            onChange={e => handleMemberFormChange('phoneNumber', e.target.value)}
                                            className={commonInputStyle}
                                        />
                                    </div>
                                    <select value={memberFormData.statusInFamily} onChange={e => handleMemberFormChange('statusInFamily', e.target.value)} className={commonInputStyle}>
                                        <option>Kepala Keluarga</option><option>Istri</option><option>Anak</option><option>Lainnya</option>
                                    </select>
                                    {/* --- INPUT-INPUT BARU (OPSIONAL) --- */}
                                    <div className="grid grid-cols-2 gap-3 mt-2">
                                        <div>
                                            <label className="block text-xs font-medium text-slate-600">Jenis Kelamin</label>
                                            <select value={memberFormData.gender || ''} onChange={e => handleMemberFormChange('gender', e.target.value)} className={commonInputStyle}>
                                                <option value="">-- Pilih --</option>
                                                <option value="Laki-laki">Laki-laki</option>
                                                <option value="Perempuan">Perempuan</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-slate-600">Agama</label>
                                            <select value={memberFormData.religion || ''} onChange={e => handleMemberFormChange('religion', e.target.value)} className={commonInputStyle}>
                                                <option value="">-- Pilih Agama --</option>
                                                <option value="Islam">Islam</option>
                                                <option value="Kristen Protestan">Kristen Protestan</option>
                                                <option value="Kristen Katolik">Kristen Katolik</option>
                                                <option value="Hindu">Hindu</option>
                                                <option value="Buddha">Buddha</option>
                                                <option value="Konghucu">Konghucu</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-slate-600">Pekerjaan</label>
                                            <input type="text" placeholder="Contoh: Karyawan Swasta" value={memberFormData.occupation || ''} onChange={e => handleMemberFormChange('occupation', e.target.value)} className={commonInputStyle} />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-slate-600">Pendidikan</label>
                                            <input type="text" placeholder="Contoh: S1" value={memberFormData.education || ''} onChange={e => handleMemberFormChange('education', e.target.value)} className={commonInputStyle} />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-slate-600">Gol. Darah</label>
                                            <select value={memberFormData.bloodType || ''} onChange={e => handleMemberFormChange('bloodType', e.target.value)} className={commonInputStyle}>
                                                <option value="">-- Pilih --</option>
                                                <option>A</option><option>B</option><option>AB</option><option>O</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-slate-600">Status Kependudukan</label>
                                            <select value={memberFormData.residencyStatus || ''} onChange={e => handleMemberFormChange('residencyStatus', e.target.value)} className={commonInputStyle}>
                                                <option value="">-- Pilih --</option>
                                                <option value="Warga Lokal (KTP Setempat)">Warga Lokal (KTP Setempat)</option>
                                                <option value="Warga Pendatang (KTP Luar)">Warga Pendatang (KTP Luar)</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="flex space-x-2"><button type="submit" className="text-xs py-1 px-3 bg-green-500 hover:bg-green-600 text-white rounded-md" disabled={isSubmitting}>{isSubmitting ? '...' : 'Simpan Anggota'}</button><button type="button" onClick={handleCancelMemberForm} className={secondaryButtonStyle}>Batal</button></div>
                                </form>
                            )}
                            <ul className="list-disc list-inside text-sm text-slate-700 mt-2 space-y-2">
                                {familiesWithMembers.find(f => f.id === editingFamily.id)?.members.map(member => (
                                    <li key={member.id} className="flex justify-between items-center py-1 border-b">
                                        <span>
                                            {member.fullName} ({member.statusInFamily})
                                            {/* Logika untuk menampilkan label TIDAK AKTIF */}
                                            {member.status === 'INACTIVE' && (
                                                <span className="ml-2 text-xs font-semibold text-white bg-slate-500 px-2 py-0.5 rounded-full">
                                                    TIDAK AKTIF
                                                </span>
                                            )}
                                        </span>
                                        <div className="space-x-2"><button onClick={() => handleStartEditMember(member)} className="text-xs hover:underline text-blue-600">Edit</button><button onClick={() => handleDeleteResident(member)} className="text-xs hover:underline text-red-600" disabled={isSubmitting}>Hapus</button></div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}

            <h3 className="text-lg font-semibold text-slate-600 mb-3">Daftar Keluarga Terdaftar ({familiesWithMembers.length})</h3>
            <div className="space-y-3">
                {familiesWithMembers.map(family => {
                    // Cek apakah semua anggota dalam keluarga ini statusnya 'INACTIVE'
                    const isFamilyInactive = family.members.length > 0 && family.members.every(member => member.status === 'INACTIVE');

                    return (
                        <div
                            key={family.id}
                            className={`p-4 border rounded-lg flex justify-between items-center shadow-sm transition-colors ${isFamilyInactive ? 'bg-slate-100 opacity-70' : 'bg-white'
                                }`}
                        >
                            <div>
                                <h4 className="font-bold text-lg text-sky-700">
                                    {family.headOfFamilyName}
                                    {isFamilyInactive && (
                                        <span className="ml-3 text-sm font-bold text-white bg-red-600 px-2.5 py-1 rounded-full align-middle">
                                            PINDAH
                                        </span>
                                    )}
                                </h4>
                                <p className="text-sm text-slate-500">No. KK: {family.familyCardNumber || 'Belum diisi'}</p>
                                <p className="text-xs text-slate-400">Jumlah Anggota: {family.members.length}</p>
                            </div>
                            <button
                                onClick={() => handleEditFamily(family)}
                                className="text-sm font-semibold text-sky-600 hover:text-sky-800"
                            >
                                Kelola
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const ManageOccupancyPage = () => {
    const { rtProfileId, appConfig } = useAuth();
    const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId];

    // States untuk data dari Firestore
    const [households, setHouseholds] = useState([]);
    const [occupancies, setOccupancies] = useState([]);
    const [residents, setResidents] = useState([]);
    const [families, setFamilies] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // States untuk UI
    const [error, setError] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showFormForHouse, setShowFormForHouse] = useState(null);

    // States untuk form (termasuk mode)
    const [formMode, setFormMode] = useState('new'); // 'new' atau 'existing'
    const [selectedFamilyId, setSelectedFamilyId] = useState('');
    const [familyCardNumber, setFamilyCardNumber] = useState('');
    const [moveInDate, setMoveInDate] = useState(new Date().toISOString().split('T')[0]);
    const [isPayer, setIsPayer] = useState(true);
    const [familyMembers, setFamilyMembers] = useState([{ fullName: '', nik: '', statusInFamily: 'Kepala Keluarga' }]);
    const [isMoveModalOpen, setIsMoveModalOpen] = useState(false);
    const [occupancyToMove, setOccupancyToMove] = useState(null);

    const canUseOcr = currentRtConfig?.isOcrEnabled === true;

    // Mengambil semua data yang diperlukan secara real-time
    useEffect(() => {
        if (!rtProfileId) {
            setIsLoading(false);
            return;
        }
        const unsubHouseholds = onSnapshot(query(collection(db, getHouseholdsCollectionPath(rtProfileId)), orderBy("houseIdentifier")), (s) => setHouseholds(s.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubOccupancies = onSnapshot(query(collection(db, getOccupanciesCollectionPath(rtProfileId)), orderBy("moveInDate", "desc")), (s) => setOccupancies(s.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubResidents = onSnapshot(query(collection(db, getResidentsCollectionPath(rtProfileId))), (s) => setResidents(s.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubFamilies = onSnapshot(query(collection(db, getFamiliesCollectionPath(rtProfileId))), (s) => {
            setFamilies(s.docs.map(d => ({ id: d.id, ...d.data() })));
            setIsLoading(false);
        });
        return () => {
            unsubHouseholds();
            unsubOccupancies();
            unsubResidents();
            unsubFamilies();
        };
    }, [rtProfileId]);

    const housesWithDetails = useMemo(() => {
        return households.map(house => ({
            ...house,
            activeOccupants: occupancies.filter(occ => occ.householdId === house.id && occ.status === 'ACTIVE')
        }));
    }, [households, occupancies]);

    const resetForm = () => {
        setFamilyCardNumber('');
        setMoveInDate(new Date().toISOString().split('T')[0]);
        setIsPayer(true);
        setFamilyMembers([{ fullName: '', nik: '', statusInFamily: 'Kepala Keluarga' }]);
        setFormMode('new');
        setSelectedFamilyId('');
    };

    // DENGAN VERSI LENGKAP INI:
    const handleSetAsPayer = async (newPayerOccupancy) => {
        // Mencegah klik ganda jika proses sedang berjalan
        if (isSubmitting) return;

        const confirmation = window.confirm(
            `Jadikan keluarga ${newPayerOccupancy.headOfFamilyName} sebagai penanggung jawab iuran untuk rumah ini?`
        );
        if (!confirmation) return;

        setIsSubmitting(true);
        setError('');

        const houseId = newPayerOccupancy.householdId;
        // Ambil data rumah dari state yang sudah digabung
        const house = housesWithDetails.find(h => h.id === houseId);
        const currentPayer = house?.activeOccupants.find(o => o.isPayer);

        const batch = writeBatch(db);

        try {
            // 1. Set penanggung jawab iuran yang lama (jika ada) menjadi false
            if (currentPayer) {
                const oldPayerRef = doc(db, getOccupanciesCollectionPath(rtProfileId), currentPayer.id);
                batch.update(oldPayerRef, { isPayer: false });
            }

            // 2. Set hunian yang baru dipilih menjadi penanggung jawab iuran (isPayer: true)
            const newPayerRef = doc(db, getOccupanciesCollectionPath(rtProfileId), newPayerOccupancy.id);
            batch.update(newPayerRef, { isPayer: true });

            // Lakukan kedua operasi di atas secara bersamaan
            await batch.commit();
            setMessage({ text: `Penanggung jawab iuran berhasil diperbarui.`, type: 'success' });

        } catch (err) {
            console.error("Error setting new payer:", err);
            setError("Gagal memperbarui penanggung jawab iuran.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleAddNewOccupantClick = (houseId) => {
        setShowFormForHouse(houseId);
        resetForm();
    };

    const handleMemberChange = (index, field, value) => {
        const updatedMembers = [...familyMembers];
        updatedMembers[index][field] = value;
        setFamilyMembers(updatedMembers);
    };

    const handleAddMemberField = () => setFamilyMembers([...familyMembers, { fullName: '', nik: '', statusInFamily: 'Anak' }]);
    const handleRemoveMemberField = (index) => { if (familyMembers.length > 1) setFamilyMembers(familyMembers.filter((_, i) => i !== index)); };

    // GANTI FUNGSI INI
    const handleMoveOut = (occupancy) => {
        setOccupancyToMove(occupancy);
        setIsMoveModalOpen(true);
    };

    // GANTI FUNGSI LAMA DENGAN VERSI BARU INI
    const handleDeactivateOccupancy = async (occupancy) => {
        if (isSubmitting) return;

        const confirmation = window.confirm(
            `Yakin ingin menonaktifkan hunian untuk keluarga ${occupancy.headOfFamilyName}? Ini akan menandai seluruh anggota keluarga sebagai 'Tidak Aktif' dan tidak bisa dibatalkan.`
        );
        if (!confirmation) return;

        setIsSubmitting(true);
        setError('');

        const batch = writeBatch(db);

        try {
            // 1. Dapatkan semua dokumen warga dari keluarga yang bersangkutan
            const residentsQuery = query(
                collection(db, getResidentsCollectionPath(rtProfileId)),
                where("familyId", "==", occupancy.familyId)
            );
            const residentsSnap = await getDocs(residentsQuery);

            // 2. Update dokumen hunian (sama seperti sebelumnya)
            const occupancyRef = doc(db, getOccupanciesCollectionPath(rtProfileId), occupancy.id);
            batch.update(occupancyRef, {
                status: 'MOVED_OUT_RT',
                moveOutDate: Timestamp.now()
            });

            // 3. Loop dan update setiap dokumen warga untuk menambahkan status 'INACTIVE'
            residentsSnap.forEach(residentDoc => {
                const residentRef = doc(db, getResidentsCollectionPath(rtProfileId), residentDoc.id);
                batch.update(residentRef, {
                    status: 'INACTIVE' // Atau 'MOVED_OUT' sesuai preferensi Anda
                });
            });

            // 4. Jalankan semua operasi update secara bersamaan
            await batch.commit();

            setMessage({ text: `Hunian untuk keluarga ${occupancy.headOfFamilyName} dan status warganya telah berhasil dinonaktifkan.`, type: 'success' });
        } catch (err) {
            console.error("Error deactivating occupancy and residents:", err);
            setError("Gagal menonaktifkan hunian dan status warganya.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError('');

        const houseData = housesWithDetails.find(h => h.id === showFormForHouse);
        const batch = writeBatch(db);

        if (formMode === 'existing') {
            if (!selectedFamilyId || !moveInDate) {
                setError("Pilih keluarga dan tentukan tanggal masuk terlebih dahulu.");
                setIsSubmitting(false);
                return;
            }
            const selectedFamilyData = families.find(f => f.id === selectedFamilyId);
            if (!selectedFamilyData) {
                setError("Data keluarga yang dipilih tidak valid.");
                setIsSubmitting(false);
                return;
            }

            try {
                const existingOccupancyQuery = query(
                    collection(db, getOccupanciesCollectionPath(rtProfileId)),
                    where("familyId", "==", selectedFamilyId),
                    where("status", "==", "ACTIVE"),
                    limit(1)
                );
                const existingOccupancySnap = await getDocs(existingOccupancyQuery);

                if (!existingOccupancySnap.empty) {
                    const existingOccupancy = existingOccupancySnap.docs[0].data();
                    const existingHouse = households.find(h => h.id === existingOccupancy.householdId);
                    setError(`Keluarga ${selectedFamilyData.headOfFamilyName} sudah aktif menempati ${existingHouse?.houseIdentifier || 'rumah lain'}. Harap proses pindah hunian lama terlebih dahulu.`);
                    setIsSubmitting(false);
                    return;
                }

                if (isPayer && houseData?.activeOccupants.length > 0) {
                    const currentPayer = houseData.activeOccupants.find(o => o.isPayer);
                    if (currentPayer) {
                        const oldPayerRef = doc(db, getOccupanciesCollectionPath(rtProfileId), currentPayer.id);
                        batch.update(oldPayerRef, { isPayer: false });
                    }
                }

                const newOccupancyRef = doc(collection(db, getOccupanciesCollectionPath(rtProfileId)));
                batch.set(newOccupancyRef, {
                    householdId: showFormForHouse,
                    familyId: selectedFamilyId,
                    headOfFamilyName: selectedFamilyData.headOfFamilyName,
                    isPayer,
                    moveInDate: Timestamp.fromDate(new Date(moveInDate)),
                    moveOutDate: null,
                    status: 'ACTIVE',
                    createdAt: Timestamp.now(),
                    rtProfileId
                });

                await batch.commit();
                setMessage({ text: `Keluarga ${selectedFamilyData.headOfFamilyName} berhasil ditempatkan di hunian baru.`, type: 'success' });
                setShowFormForHouse(null);
            } catch (validationError) {
                console.error("Error during existing family validation/commit:", validationError);
                setError("Gagal melakukan validasi hunian. Coba lagi.");
            } finally {
                setIsSubmitting(false);
            }
        } else { // formMode === 'new'
            const headOfFamily = familyMembers.find(m => m.statusInFamily === 'Kepala Keluarga');

            // --- VALIDASI BARU DIMULAI DI SINI ---
            const headCount = familyMembers.filter(m => m.statusInFamily === 'Kepala Keluarga').length;
            if (headCount === 0) {
                setError("Gagal: Harus ada satu anggota yang ditetapkan sebagai 'Kepala Keluarga'.");
                setIsSubmitting(false);
                return;
            }
            if (headCount > 1) {
                setError("Gagal: Hanya boleh ada satu 'Kepala Keluarga' dalam satu pendaftaran keluarga baru.");
                setIsSubmitting(false);
                return;
            }
            // --- AKHIR VALIDASI ---

            if (!headOfFamily || !headOfFamily.fullName.trim() || !moveInDate) {
                setError("Data Kepala Keluarga (Nama & Status) dan Tanggal Masuk wajib diisi.");
                setIsSubmitting(false);
                return;
            }
            const limits = { maxFamilyCards: currentRtConfig?.maxFamilyCards || Infinity, maxResidents: currentRtConfig?.maxResidents || Infinity };
            if (families.length >= limits.maxFamilyCards) {
                setError(`Gagal: Jumlah keluarga sudah mencapai batas maksimal (${limits.maxFamilyCards}) untuk plan ini.`);
                setIsSubmitting(false); return;
            }
            if ((residents.length + familyMembers.length) > limits.maxResidents) {
                setError(`Gagal: Jumlah warga akan melebihi batas maksimal (${limits.maxResidents}) untuk plan ini.`);
                setIsSubmitting(false); return;
            }

            try {
                if (isPayer && houseData?.activeOccupants.length > 0) {
                    const currentPayer = houseData.activeOccupants.find(o => o.isPayer);
                    if (currentPayer) {
                        const oldPayerRef = doc(db, getOccupanciesCollectionPath(rtProfileId), currentPayer.id);
                        batch.update(oldPayerRef, { isPayer: false });
                    }
                }
                const newFamilyRef = doc(collection(db, getFamiliesCollectionPath(rtProfileId)));
                batch.set(newFamilyRef, {
                    headOfFamilyName: headOfFamily.fullName,
                    familyCardNumber: familyCardNumber || '',
                    createdAt: Timestamp.now(),
                    rtProfileId: rtProfileId
                });
                // KODE BARU UNTUK DITEMPELKAN DI handleSubmit -> else -> forEach
                familyMembers.forEach(member => {
                    if (member.fullName.trim()) {
                        const newResidentRef = doc(collection(db, getResidentsCollectionPath(rtProfileId)));
                        batch.set(newResidentRef, {
                            // Data lama
                            fullName: member.fullName,
                            nik: member.nik || '',
                            statusInFamily: member.statusInFamily,
                            familyId: newFamilyRef.id,
                            createdAt: Timestamp.now(),
                            rtProfileId,
                            status: 'ACTIVE', // Pastikan warga baru selalu aktif

                            // Data baru (opsional)
                            gender: member.gender || '',
                            religion: member.religion || '',
                            occupation: member.occupation || '',
                            education: member.education || '',
                            bloodType: member.bloodType || '',
                            residencyStatus: member.residencyStatus || '',
                            phoneNumber: member.phoneNumber || ''
                        });
                    }
                });
                const newOccupancyRef = doc(collection(db, getOccupanciesCollectionPath(rtProfileId)));
                batch.set(newOccupancyRef, {
                    householdId: showFormForHouse,
                    familyId: newFamilyRef.id,
                    headOfFamilyName: headOfFamily.fullName,
                    isPayer,
                    moveInDate: Timestamp.fromDate(new Date(moveInDate)),
                    moveOutDate: null,
                    status: 'ACTIVE',
                    createdAt: Timestamp.now(),
                    rtProfileId
                });
                await batch.commit();
                setMessage({ text: `Hunian baru untuk keluarga ${headOfFamily.fullName} berhasil ditambahkan.`, type: 'success' });
                setShowFormForHouse(null);
            } catch (err) {
                console.error("Error saving new occupancy:", err);
                setError("Gagal menyimpan data hunian baru.");
            } finally {
                setIsSubmitting(false);
            }
        }
    };

    if (isLoading) return <div className={cardStyle}><LoadingSpinner /></div>;

    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-4">Manajemen Riwayat Hunian</h2>
            {message.text && <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '' })} />}
            {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}
            <div className="space-y-4">
                {housesWithDetails.map(house => (
                    <div key={house.id} className="p-4 border rounded-lg bg-slate-50 shadow-sm">
                        <div className="flex justify-between items-start gap-2">
                            <h3 className="text-lg font-semibold text-sky-700">{house.houseIdentifier}</h3>
                            <button onClick={() => handleAddNewOccupantClick(house.id)} className="text-xs py-1 px-3 bg-sky-500 text-white rounded-md hover:bg-sky-600 flex-shrink-0">+ Tambah Hunian</button>
                        </div>
                        {showFormForHouse === house.id && (
                            <form onSubmit={handleSubmit} className="mt-4 pt-4 border-t space-y-4">
                                <h4 className="font-semibold text-slate-800">Masukkan Data Hunian Baru</h4>
                                <div className="flex w-full bg-slate-200 p-1 rounded-lg mb-4">
                                    <button type="button" onClick={() => setFormMode('new')} className={`w-1/2 p-2 rounded-md text-sm font-semibold transition-colors ${formMode === 'new' ? 'bg-white text-sky-600 shadow' : 'text-slate-600'}`}>Buat Keluarga Baru</button>
                                    <button type="button" onClick={() => setFormMode('existing')} className={`w-1/2 p-2 rounded-md text-sm font-semibold transition-colors ${formMode === 'existing' ? 'bg-white text-sky-600 shadow' : 'text-slate-600'}`}>Pilih Keluarga Terdaftar</button>
                                </div>
                                {formMode === 'new' ? (
                                    <>
                                        {canUseOcr && <button type="button" className="w-full text-sm p-2 mb-3 bg-gray-200 text-gray-600 rounded-md hover:bg-gray-300">(Segera Hadir) Upload & Scan KK</button>}
                                        <div className="grid grid-cols-1">
                                            <div><label className="block text-sm font-medium">No. Kartu Keluarga (Opsional)</label><input type="text" value={familyCardNumber} onChange={e => setFamilyCardNumber(e.target.value)} className={commonInputStyle} /></div>
                                        </div>
                                        <div className="mt-4"><label className="block text-sm font-medium">Tanggal Masuk*</label><input type="date" value={moveInDate} onChange={e => setMoveInDate(e.target.value)} className={commonInputStyle} required /></div>
                                        <div className="pt-2"><label className="flex items-center space-x-2"><input type="checkbox" checked={isPayer} onChange={e => setIsPayer(e.target.checked)} className="h-4 w-4" /><span>Jadikan sebagai Penanggung Jawab Iuran?</span></label></div>
                                        <hr />
                                        <h5 className="font-semibold text-slate-700">Anggota Keluarga</h5>
                                        {familyMembers.map((member, index) => (
                                            <div key={index} className="p-3 border rounded-lg bg-white space-y-2 relative">
                                                {familyMembers.length > 1 && <button type="button" onClick={() => handleRemoveMemberField(index)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full h-5 w-5 text-xs flex items-center justify-center">X</button>}

                                                {/* Input yang sudah ada */}
                                                <input type="text" placeholder="Nama Lengkap*" value={member.fullName} onChange={e => handleMemberChange(index, 'fullName', e.target.value)} className={commonInputStyle} required />
                                                <input type="text" placeholder="NIK (Opsional)" value={member.nik || ''} onChange={e => handleMemberChange(index, 'nik', e.target.value)} className={commonInputStyle} />
                                                {/* --- TAMBAHKAN BLOK INPUT BARU INI --- */}
                                                <div>
                                                    <label className="block text-xs font-medium text-slate-600">Nomor HP (untuk Login OTP)</label>
                                                    <input
                                                        type="tel"
                                                        placeholder="+6281234567890"
                                                        value={member.phoneNumber || ''}
                                                        onChange={e => handleMemberChange(index, 'phoneNumber', e.target.value)}
                                                        className={commonInputStyle}
                                                    />
                                                </div>
                                                <select value={member.statusInFamily} onChange={e => handleMemberChange(index, 'statusInFamily', e.target.value)} className={commonInputStyle}>
                                                    <option>Kepala Keluarga</option><option>Istri</option><option>Anak</option><option>Lainnya</option>
                                                </select>

                                                {/* --- INPUT-INPUT BARU (OPSIONAL) --- */}
                                                <div className="grid grid-cols-2 gap-3 pt-2">
                                                    <div>
                                                        <label className="block text-xs font-medium text-slate-600">Jenis Kelamin</label>
                                                        <select value={member.gender || ''} onChange={e => handleMemberChange(index, 'gender', e.target.value)} className={commonInputStyle}>
                                                            <option value="">-- Pilih --</option>
                                                            <option value="Laki-laki">Laki-laki</option>
                                                            <option value="Perempuan">Perempuan</option>
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-slate-600">Agama</label>
                                                        <select value={member.religion || ''} onChange={e => handleMemberChange(index, 'religion', e.target.value)} className={commonInputStyle}>
                                                            <option value="">-- Pilih Agama --</option>
                                                            <option value="Islam">Islam</option>
                                                            <option value="Kristen Protestan">Kristen Protestan</option>
                                                            <option value="Kristen Katolik">Kristen Katolik</option>
                                                            <option value="Hindu">Hindu</option>
                                                            <option value="Buddha">Buddha</option>
                                                            <option value="Konghucu">Konghucu</option>
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-slate-600">Pekerjaan</label>
                                                        <input type="text" placeholder="Contoh: Karyawan" value={member.occupation || ''} onChange={e => handleMemberChange(index, 'occupation', e.target.value)} className={commonInputStyle} />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-slate-600">Pendidikan</label>
                                                        <input type="text" placeholder="Contoh: S1" value={member.education || ''} onChange={e => handleMemberChange(index, 'education', e.target.value)} className={commonInputStyle} />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-slate-600">Gol. Darah</label>
                                                        <select value={member.bloodType || ''} onChange={e => handleMemberChange(index, 'bloodType', e.target.value)} className={commonInputStyle}>
                                                            <option value="">--</option>
                                                            <option>A</option><option>B</option><option>AB</option><option>O</option>
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-slate-600">Status Kependudukan</label>
                                                        <select value={member.residencyStatus || ''} onChange={e => handleMemberChange(index, 'residencyStatus', e.target.value)} className={commonInputStyle}>
                                                            <option value="">-- Pilih --</option>
                                                            <option value="Warga Lokal (KTP Setempat)">Warga Lokal (KTP Setempat)</option>
                                                            <option value="Warga Pendatang (KTP Luar)">Warga Pendatang (KTP Luar)</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        <button type="button" onClick={handleAddMemberField} className="text-sm text-sky-600 hover:underline">+ Tambah Anggota</button>
                                    </>
                                ) : (
                                    <>
                                        <SearchableFamilySelect families={families} selectedFamilyId={selectedFamilyId} onFamilySelect={setSelectedFamilyId} />
                                        <div className="mt-4"><label className="block text-sm font-medium">Tanggal Masuk*</label><input type="date" value={moveInDate} onChange={e => setMoveInDate(e.target.value)} className={commonInputStyle} required /></div>
                                        <div className="pt-2"><label className="flex items-center space-x-2"><input type="checkbox" checked={isPayer} onChange={e => setIsPayer(e.target.checked)} className="h-4 w-4" /><span>Jadikan sebagai Penanggung Jawab Iuran?</span></label></div>
                                    </>
                                )}
                                <div className="flex space-x-2 pt-2"><button type="submit" className={primaryButtonStyle} disabled={isSubmitting}>{isSubmitting ? 'Menyimpan...' : 'Simpan Hunian'}</button><button type="button" onClick={() => setShowFormForHouse(null)} className="px-4 py-2 rounded-md font-semibold text-slate-700 bg-slate-200 hover:bg-slate-300">Batal</button></div>
                            </form>
                        )}
                        <div className="mt-3">
                            <p className="text-sm font-semibold text-slate-600">Penghuni Aktif:</p>
                            {house.activeOccupants.length > 0 ? (
                                // Di dalam ManageOccupancyPage, cari return statement dan ganti bagian ul ini
                                <ul className="space-y-2 mt-1">
                                    {house.activeOccupants.map(occ => (
                                        <li key={occ.id} className="text-sm p-2 bg-white border rounded-md flex justify-between items-center flex-wrap gap-2">
                                            <div>
                                                <span>{occ.headOfFamilyName}</span>
                                                {occ.isPayer && <span className="ml-2 text-xs font-bold text-green-600 bg-green-100 px-2 py-0.5 rounded-full">PEMBAYAR</span>}
                                            </div>
                                            <div className="space-x-2 flex-shrink-0">
                                                {!occ.isPayer && <button onClick={() => handleSetAsPayer(occ)} className="text-xs hover:underline text-sky-600" disabled={isSubmitting}>Jadikan Pembayar</button>}
                                                <button onClick={() => handleMoveOut(occ)} className="text-xs hover:underline text-amber-600" disabled={isSubmitting}>Proses Pindah</button>
                                                {/* --- TOMBOL BARU --- */}
                                                <button onClick={() => handleDeactivateOccupancy(occ)} className="text-xs hover:underline text-red-600" disabled={isSubmitting}>Nonaktifkan</button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            ) : <p className="text-sm text-slate-500 italic mt-1">Rumah ini sedang kosong.</p>}
                        </div>
                    </div>
                ))}
            </div>
            {/* --- RENDER MODAL DI SINI --- */}
            <MoveOccupantModal
                isOpen={isMoveModalOpen}
                onClose={() => setIsMoveModalOpen(false)}
                occupancyData={occupancyToMove}
                households={households}
                rtProfileId={rtProfileId}
                onSuccess={(successMsg) => {
                    setMessage({ text: successMsg, type: 'success' });
                }}
            />
        </div>
    );
};

// --- Halaman Generate Tagihan Massal (BARU) ---
// const GenerateBillsPage = () => {
//     const { rtProfileId } = useAuth();

//     // State untuk data & UI
//     const [duesTemplates, setDuesTemplates] = useState([]);
//     const [isLoadingTemplates, setIsLoadingTemplates] = useState(true);
//     const [isGenerating, setIsGenerating] = useState(false);
//     const [message, setMessage] = useState({ text: '', type: '' });

//     // State untuk pilihan form
//     const [selectedTemplateId, setSelectedTemplateId] = useState('');
//     const [billMonth, setBillMonth] = useState(new Date().getMonth());
//     const [billYear, setBillYear] = useState(new Date().getFullYear());

//     // Mengambil data templat iuran yang aktif
//     useEffect(() => {
//         if (!rtProfileId) return;
//         const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
//         const q = query(collection(db, templatesPath), where("isActive", "==", true));

//         const unsubscribe = onSnapshot(q, (snapshot) => {
//             const templatesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//             setDuesTemplates(templatesData);
//             if (templatesData.length > 0) {
//                 setSelectedTemplateId(templatesData[0].id);
//             }
//             setIsLoadingTemplates(false);
//         }, (err) => {
//             console.error("Error fetching dues templates:", err);
//             setMessage({ text: "Gagal memuat jenis iuran.", type: "error" });
//             setIsLoadingTemplates(false);
//         });
//         return () => unsubscribe();
//     }, [rtProfileId]);

//     const handleGenerateBills = async () => {
//         if (!selectedTemplateId) {
//             setMessage({ text: "Silakan pilih jenis iuran terlebih dahulu.", type: "error" });
//             return;
//         }
//         if (!window.confirm(`Yakin ingin membuat tagihan massal untuk periode ${MONTHS[billMonth]} ${billYear}? Proses ini tidak bisa dibatalkan.`)) {
//             return;
//         }

//         setIsGenerating(true);
//         setMessage({ text: '', type: '' });

//         try {
//             // 1. Dapatkan detail dari templat iuran yang dipilih
//             const selectedTemplate = duesTemplates.find(t => t.id === selectedTemplateId);
//             if (!selectedTemplate) {
//                 throw new Error("Jenis iuran tidak ditemukan.");
//             }

//             // 2. Cek apakah tagihan untuk periode & jenis ini sudah pernah dibuat
//             const billsPath = getBillsCollectionPath(rtProfileId);
//             const checkQuery = query(billsPath,
//                 where("duesTemplateId", "==", selectedTemplateId),
//                 where("billPeriodMonth", "==", billMonth + 1),
//                 where("billPeriodYear", "==", billYear)
//             );
//             const existingBillsSnap = await getDocs(checkQuery);
//             if (!existingBillsSnap.empty) {
//                 throw new Error(`Tagihan untuk "${selectedTemplate.name}" periode ${MONTHS[billMonth]} ${billYear} sudah pernah dibuat sebelumnya.`);
//             }

//             // 3. Dapatkan semua hunian yang aktif dan memiliki penanggung jawab iuran
//             const occupanciesPath = getOccupanciesCollectionPath(rtProfileId);
//             const payersQuery = query(occupanciesPath,
//                 where("status", "==", "ACTIVE"),
//                 where("isPayer", "==", true)
//             );
//             const payersSnap = await getDocs(payersQuery);
//             const targetOccupancies = payersSnap.docs.map(d => d.data());

//             if (targetOccupancies.length === 0) {
//                 throw new Error("Tidak ditemukan penanggung jawab iuran yang aktif untuk dibuatkan tagihan.");
//             }

//             // 4. Gunakan batch write untuk membuat semua dokumen tagihan
//             const batch = writeBatch(db);
//             let billsCreatedCount = 0;

//             targetOccupancies.forEach(occ => {
//                 const newBillRef = doc(collection(db, billsPath));
//                 const billData = {
//                     householdId: occ.householdId,
//                     familyId: occ.familyId,
//                     payerName: occ.headOfFamilyName,
//                     billPeriodMonth: billMonth + 1,
//                     billPeriodYear: billYear,
//                     duesTemplateId: selectedTemplateId,
//                     duesType: selectedTemplate.name,
//                     amount: selectedTemplate.amount,
//                     status: 'UNPAID',
//                     createdAt: Timestamp.now(),
//                     rtProfileId: rtProfileId,
//                 };
//                 batch.set(newBillRef, billData);
//                 billsCreatedCount++;
//             });

//             await batch.commit();
//             setMessage({ text: `Berhasil! Sebanyak ${billsCreatedCount} tagihan baru telah dibuat.`, type: 'success' });

//         } catch (error) {
//             console.error("Error generating bills:", error);
//             setMessage({ text: `Gagal: ${error.message}`, type: "error" });
//         } finally {
//             setIsGenerating(false);
//         }
//     };

//     if (isLoadingTemplates) return <div className={cardStyle}><LoadingSpinner /></div>;

//     return (
//         <div className={cardStyle}>
//             <h2 className="text-2xl font-semibold text-slate-700 mb-4">Buat Tagihan Iuran Massal</h2>
//             <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '' })} />

//             {duesTemplates.length === 0 ? (
//                 <p className="text-center text-slate-500 p-4">Tidak ada jenis iuran yang aktif. Silakan tambahkan di menu "Jenis Iuran".</p>
//             ) : (
//                 <div className="space-y-4 p-4 border rounded-lg bg-slate-50">
//                     <div>
//                         <label htmlFor="duesTypeSelect" className="block text-sm font-medium text-slate-700">Jenis Iuran*</label>
//                         <select id="duesTypeSelect" value={selectedTemplateId} onChange={e => setSelectedTemplateId(e.target.value)} className={commonInputStyle}>
//                             {duesTemplates.map(template => (
//                                 <option key={template.id} value={template.id}>{template.name} (Rp {template.amount.toLocaleString('id-ID')})</option>
//                             ))}
//                         </select>
//                     </div>
//                     <div className="grid grid-cols-2 gap-4">
//                         <div>
//                             <label htmlFor="billMonth" className="block text-sm font-medium text-slate-700">Untuk Bulan*</label>
//                             <select id="billMonth" value={billMonth} onChange={e => setBillMonth(parseInt(e.target.value))} className={commonInputStyle}>
//                                 {MONTHS.map((m, i) => <option key={i} value={i}>{m}</option>)}
//                             </select>
//                         </div>
//                         <div>
//                             <label htmlFor="billYear" className="block text-sm font-medium text-slate-700">Tahun*</label>
//                             <select id="billYear" value={billYear} onChange={e => setBillYear(parseInt(e.target.value))} className={commonInputStyle}>
//                                 {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
//                             </select>
//                         </div>
//                     </div>
//                     <div className="pt-4">
//                         <button onClick={handleGenerateBills} className={`${primaryButtonStyle} w-full`} disabled={isGenerating}>
//                             {isGenerating ? <LoadingSpinner /> : `Buat Tagihan untuk ${MONTHS[billMonth]} ${billYear}`}
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// --- Custom hook useWhatsappNotifier dipindahkan ke sini ---
const useWhatsappNotifier = () => {
    const { rtProfileId, appConfig } = useAuth();
    const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId];

    const sendNotifications = async (householdsToNotify, template, billMonth, billYear) => {
        // console.log('hehehehe', currentRtConfig);
        const isWhatsAppEnabled = currentRtConfig?.isWhatsappIntegrationEnabled;
        if (!isWhatsAppEnabled) {
            return;
        }
        // console.log('householdsToNotify:', householdsToNotify);
        if (!householdsToNotify || householdsToNotify.length === 0) {
            return;
        }

        const functions = getFunctions();
        // console.log('mengirim notifikasi ke wa');
        const sendWhatsappNotification = httpsCallable(functions, 'sendWhatsappNotification');

        let notificationsSent = 0;
        let notificationsFailed = 0;
        let failedData = [];
        for (const house of householdsToNotify) {
            // console.log('phone:', house.phoneNumber);
            if (house.phoneNumber) {
                const messageText = `Halo ${house.payerName}, tagihan iuran ${template.name} sebesar Rp ${template.amount.toLocaleString('id-ID')} untuk periode ${MONTHS[billMonth]} ${billYear} telah dibuat. Silakan cek aplikasi Anda untuk detail lebih lanjut di https://app.satuwarga.com.`;
                const target = `${house.phoneNumber}|a`;

                try {
                    await sendWhatsappNotification({ target, message: messageText });
                    notificationsSent++;
                } catch (err) {
                    console.error(`Gagal mengirim notifikasi ke ${house.payerName}:`, err);
                }
            } else {
                // console.log('hehehehe');
                notificationsFailed++;
                failedData.push(house.payerName);
            }
        }
        // console.log('apakah terkirim?');

        if (notificationsSent > 0) {
            // console.log(`Berhasil mengirim ${notificationsSent} notifikasi WhatsApp.`);
            toast.success(`Berhasil mengirim ${notificationsSent} notifikasi WhatsApp.`);
        }
        if (notificationsFailed > 0) {
            const stringFailedData = failedData.join(', ');
            // console.log(`Gagal mengirim ${notificationsFailed} notifikasi WhatsApp: ${stringFailedData}`);
            toast.error(`Gagal mengirim ${notificationsFailed} notifikasi WhatsApp: ${stringFailedData}`, {
                duration: 5000,
            });
        }
    };

    return sendNotifications;
};

const useWhatsappMetaNotifier = () => {
    // Asumsi: useAuth() sudah menyediakan data yang dibutuhkan
    const { rtProfileId, appConfig } = useAuth();
    const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId];
    const [templatesMap, setTemplatesMap] = useState({});

    // Mengambil data awal (maps)
    useEffect(() => {
        if (!rtProfileId) return;
        const fetchInitialMaps = async () => {
            try {

                // Ambil SEMUA jenis iuran untuk dijadikan "kamus"
                const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
                const templatesSnap = await getDocs(query(collection(db, templatesPath)));
                const tmplMap = {};
                templatesSnap.forEach(doc => { tmplMap[doc.id] = doc.data(); });
                setTemplatesMap(tmplMap);

            } catch (err) {
                console.error("Error fetching initial maps:", err);
            }
        };
        fetchInitialMaps();
    }, [rtProfileId]);

    const sendWhatsappMetaNotifications = async (householdsToNotify, template, billMonth, billYear) => {
        const isWhatsAppEnabled = currentRtConfig?.isWhatsappIntegrationEnabled;
        if (!isWhatsAppEnabled) {
            return;
        }

        if (!householdsToNotify || householdsToNotify.length === 0) {
            return;
        }

        const functions = getFunctions();
        // Memanggil fungsi backend yang baru, sendWhatsappMetaNotification
        const sendWhatsappMetaNotification = httpsCallable(functions, 'sendWhatsappMetaNotification');

        let notificationsSent = 0;
        let notificationsFailed = 0;
        let failedData = [];

        // Fungsi pembantu untuk memformat periode tagihan
        const formatBillPeriodForDisplay = (bill) => {
            // Langkah 1: Ambil "aturan" dari template yang terhubung
            const template = templatesMap[bill.duesTemplateId];
            if (!template) return "Info Iuran Tidak Ditemukan"; // Pengaman jika template terhapus

            // Langkah 2: Ambil data penting dari template dan bill
            const periodType = template.period;
            const monthIndex = bill.billPeriodMonth - 1; // Ubah ke index 0-11 untuk JS
            const year = bill.billPeriodYear;

            // Langkah 3: Terapkan logika "penerjemahan" berdasarkan tipe periode
            switch (periodType) {
                case 'triwulan':
                    if (monthIndex >= 0 && monthIndex <= 2) return `Triwulan 1 (${year})`;   // Jan-Mar
                    if (monthIndex >= 3 && monthIndex <= 5) return `Triwulan 2 (${year})`;   // Apr-Jun
                    if (monthIndex >= 6 && monthIndex <= 8) return `Triwulan 3 (${year})`;   // Jul-Sep
                    if (monthIndex >= 9 && monthIndex <= 11) return `Triwulan 4 (${year})`; // Okt-Des
                    return `Triwulan Tidak Valid`; // Fallback jika data bulan aneh

                case 'semester':
                    if (monthIndex >= 0 && monthIndex <= 5) return `Semester 1 (${year})`;   // Jan-Jun
                    if (monthIndex >= 6 && monthIndex <= 11) return `Semester 2 (${year})`;  // Jul-Des
                    return `Semester Tidak Valid`; // Fallback

                case 'tahunan':
                    return `Tahunan (${year})`;
                case 'sekali bayar':
                    // Untuk periode ini, kita hanya perlu tahunnya
                    return `Sekali Bayar (${year})`;

                default: // 'bulanan'
                    return `${MONTHS[monthIndex]} ${year}`;
            }
        };

        // Menyiapkan data yang dibutuhkan oleh backend
        // const periode = `${MONTHS[billMonth]} ${billYear}`;
        // const jumlah_tagihan = `${template.amount.toLocaleString('id-ID')}`;
        // Membuat objek bill sementara yang berisi data yang diperlukan
        const bill = {
            duesTemplateId: template.id,
            billPeriodMonth: billMonth,
            billPeriodYear: billYear,
        };

        // Menggunakan fungsi yang baru ditambahkan untuk memformat periode
        const periode = formatBillPeriodForDisplay(bill);

        // --- LOGIKA UNTUK MENENTUKAN BIAYA LAYANAN SESUAI DENGAN PUBLICPAYMENTFORM ---
        let serviceFee = 0;
        let total_tagihan_amount = template.amount;

        const shouldChargeFee = currentRtConfig?.isTransactionFeeWaived === false;

        if (shouldChargeFee) {
            const percentage = appConfig.qrisFeePercentage || 0;
            const fixed = appConfig.qrisFeeFixed || 0;

            if (percentage > 0 || fixed > 0) {
                const percentageFee = Math.ceil(template.amount * (percentage / 100));
                serviceFee = percentageFee + fixed;
                total_tagihan_amount = template.amount + serviceFee;
            }
        }
        // --- AKHIR DARI LOGIKA BIAYA LAYANAN ---

        const total_tagihan = `${total_tagihan_amount.toLocaleString('id-ID')}`;

        for (const house of householdsToNotify) {
            if (house.phoneNumber) {
                // Generate nomor tagihan unik, atau bisa pakai ID tagihan dari Firestore jika sudah dibuat
                // const nomor_tagihan = `${Date.now()}`;
                const nomor_tagihan = house.billId.substring(0, 12).toUpperCase();

                // payload ini sekarang sesuai dengan yang diharapkan oleh backend
                const payload = {
                    to: house.phoneNumber,
                    payer_name: house.payerName,
                    template_iuran: template.name,
                    nomor_tagihan: nomor_tagihan,
                    periode: periode,
                    jumlah_tagihan: total_tagihan,
                };

                try {
                    await sendWhatsappMetaNotification(payload);
                    notificationsSent++;
                } catch (err) {
                    console.error(`Gagal mengirim notifikasi Meta ke ${house.payerName}:`, err);
                    notificationsFailed++;
                    failedData.push(house.payerName);
                }
            } else {
                notificationsFailed++;
                failedData.push(house.payerName);
            }
        }

        if (notificationsSent > 0) {
            toast.success(`Berhasil mengirim ${notificationsSent} notifikasi WhatsApp Meta.`);
        }
        if (notificationsFailed > 0) {
            const stringFailedData = failedData.join(', ');
            toast.error(`Gagal mengirim ${notificationsFailed} notifikasi WhatsApp: ${stringFailedData}`, {
                duration: 5000,
            });
        }
    };

    // Mengubah nama fungsi yang di-return agar sesuai dengan panggilan di generatebillspage
    return sendWhatsappMetaNotifications;
};

// --- Halaman Pembuatan Tagihan (FINAL & LENGKAP dengan Definisi yang Benar) ---
const GenerateBillsPage = () => {
    // --- STATE MANAGEMENT & DATA DERIVATION ---
    const { rtProfileId, appConfig } = useAuth();
    const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId];
    const [allActiveTemplates, setAllActiveTemplates] = useState([]);
    const [billableHouseholds, setBillableHouseholds] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isGenerating, setIsGenerating] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [error, setError] = useState('');
    const [selectedTemplateId, setSelectedTemplateId] = useState('');
    const [selectedTemplateObject, setSelectedTemplateObject] = useState(null);
    const [billMonth, setBillMonth] = useState(new Date().getMonth());
    const [billYear, setBillYear] = useState(new Date().getFullYear());
    const [selectedHouseholds, setSelectedHouseholds] = useState({});
    const sendWhatsappNotifications = useWhatsappNotifier();
    const sendWhatsappMetaNotifications = useWhatsappMetaNotifier();

    // console.log('currentRtConfig:', currentRtConfig);

    // --- DATA FETCHING (DIPERBAIKI) ---
    useEffect(() => {
        if (!rtProfileId) { setIsLoading(false); return; }
        const fetchInitialData = async () => {
            setIsLoading(true);
            try {
                // 1. Ambil data template iuran
                const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
                const templatesQuery = query(collection(db, templatesPath), where("isActive", "==", true), orderBy("isPrimary", "desc"), orderBy("name", "asc"));
                const templatesSnap = await getDocs(templatesQuery);
                const templatesData = templatesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setAllActiveTemplates(templatesData);
                if (templatesData.length > 0) {
                    setSelectedTemplateId(templatesData[0].id);
                }

                // 2. Ambil data households
                const householdsPath = getHouseholdsCollectionPath(rtProfileId);
                const householdsQuery = query(collection(db, householdsPath), orderBy("houseIdentifier"));
                const householdsSnap = await getDocs(householdsQuery);
                const allHouseholds = householdsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                // 3. Ambil data occupancies untuk menentukan kepala keluarga
                const payersPath = getOccupanciesCollectionPath(rtProfileId);
                const payersQuery = query(collection(db, payersPath), where("status", "==", "ACTIVE"), where("isPayer", "==", true));
                const payersSnap = await getDocs(payersQuery);
                const payerMap = {};
                const residentQueryPromises = [];
                const residentsPath = getResidentsCollectionPath(rtProfileId);

                payersSnap.forEach(doc => {
                    const payerData = doc.data();
                    payerMap[payerData.householdId] = {
                        payerName: payerData.headOfFamilyName,
                        familyId: payerData.familyId,
                        moveInDate: payerData.moveInDate,
                    };

                    // --- PERBAIKAN UTAMA: Cari residents berdasarkan nama dan familyId ---
                    // Buat query untuk setiap kepala keluarga
                    residentQueryPromises.push(
                        getDocs(query(
                            collection(db, residentsPath),
                            where("fullName", "==", payerData.headOfFamilyName),
                            where("familyId", "==", payerData.familyId)
                        )).then(residentSnap => {
                            // Cek apakah ada hasil, jika ada, kembalikan data phoneNumber
                            if (!residentSnap.empty) {
                                return {
                                    householdId: payerData.householdId,
                                    phoneNumber: residentSnap.docs[0].data().phoneNumber
                                };
                            }
                            return null;
                        })
                    );
                });

                // 4. Jalankan semua query residents secara paralel
                const residentResults = await Promise.all(residentQueryPromises);
                const residentMap = residentResults.reduce((acc, result) => {
                    if (result && result.phoneNumber) { // Hanya tambahkan jika ada phoneNumber
                        acc[result.householdId] = { phoneNumber: result.phoneNumber };
                    }
                    return acc;
                }, {});

                // 5. Gabungkan semua data
                const finalBillableHouseholds = allHouseholds
                    .filter(house => payerMap[house.id])
                    .map(house => {
                        const payerInfo = payerMap[house.id];
                        const residentInfo = residentMap[house.id] || {};
                        return {
                            ...house,
                            ...payerInfo,
                            ...residentInfo
                        };
                    });

                setBillableHouseholds(finalBillableHouseholds);
            } catch (err) {
                console.error("Error fetching initial data:", err);
                setError(`Gagal memuat data awal: ${err.message}`);
            } finally {
                setIsLoading(false);
            }
        };
        fetchInitialData();
    }, [rtProfileId]);

    // --- useEffect BARU UNTUK SINKRONISASI STATE BULAN ---
    useEffect(() => {
        if (selectedTemplateObject) {
            const periodType = selectedTemplateObject.period;
            // Jika periodenya non-bulanan, reset pilihan bulan ke opsi pertama yang valid
            // untuk menghindari penggunaan state bulan yang lama.
            if (periodType === 'triwulan') {
                setBillMonth(0); // Reset ke Triwulan 1 (Januari, index 0)
            } else if (periodType === 'semester') {
                setBillMonth(0); // Reset ke Semester 1 (Januari, index 0)
            } else if (periodType === 'tahunan' || periodType === 'sekali bayar') {
                // Tidak perlu dropdown bulan, bisa di-set ke nilai default
                setBillMonth(0);
            } else {
                // Untuk bulanan, set ke bulan saat ini
                setBillMonth(new Date().getMonth());
            }
        }
    }, [selectedTemplateObject]);

    useEffect(() => {
        const newSelectedTemplate = allActiveTemplates.find(t => t.id === selectedTemplateId);
        setSelectedTemplateObject(newSelectedTemplate || null);
    }, [selectedTemplateId, allActiveTemplates]);

    const handleTemplateChange = (e) => {
        setSelectedTemplateId(e.target.value);
    };

    const handleHouseSelectionChange = (houseId) => {
        setSelectedHouseholds(prev => ({ ...prev, [houseId]: !prev[houseId] }));
    };

    const getSelectedCount = () => Object.values(selectedHouseholds).filter(Boolean).length;

    // --- handleGenerateBills DENGAN LOGIKA YANG SUDAH BENAR & KONSISTEN ---
    const handleGenerateBills = async () => {
        const template = selectedTemplateObject;
        const currentMonth = billMonth;
        const currentYear = billYear;

        if (!template || !currentRtConfig) { setError("Data templat atau konfigurasi RT tidak valid."); return; }
        const isTargeted = template.billingType === 'TARGETED';
        const targetHouseholds = isTargeted ? billableHouseholds.filter(h => selectedHouseholds[h.id]) : billableHouseholds;
        if (isTargeted && targetHouseholds.length === 0) { setError("Pilih minimal satu rumah untuk ditagih."); return; }
        if (!window.confirm(`Yakin ingin membuat tagihan "${template.name}" untuk ${targetHouseholds.length} rumah?`)) return;

        setIsGenerating(true);
        setMessage({ text: '', type: '' });
        setError('');

        try {
            const billsPath = getBillsCollectionPath(rtProfileId);
            const batch = writeBatch(db);
            let billsCreatedCount = 0;
            const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";

            let periodDurationMonths = 1;
            if (template.period === 'triwulan') periodDurationMonths = 3;
            else if (template.period === 'semester') periodDurationMonths = 6;
            else if (template.period === 'tahunan') periodDurationMonths = 12;
            const billPeriodEndDate = new Date(currentYear, currentMonth + periodDurationMonths, 0);
            billPeriodEndDate.setHours(23, 59, 59, 999);
            const householdsToNotify = [];

            for (const house of targetHouseholds) {
                if (template.period !== 'sekali bayar') {
                    const moveInDate = house.moveInDate.toDate();
                    if (moveInDate > billPeriodEndDate) {
                        // console.log(`Dilewati: ${house.houseIdentifier} masuk (${moveInDate.toLocaleDateString()}) setelah periode tagihan berakhir (${billPeriodEndDate.toLocaleDateString()}).`);
                        continue;
                    }
                }
                const checkQuery = query(collection(db, billsPath),
                    where("householdId", "==", house.id), where("duesTemplateId", "==", template.id),
                    where("billPeriodYear", "==", currentYear), where("billPeriodMonth", "==", currentMonth + 1),
                    where("mode", "==", currentMode)
                );
                const existingBillSnap = await getDocs(checkQuery);
                if (!existingBillSnap.empty) { continue; }

                const newBillRef = doc(collection(db, billsPath));
                batch.set(newBillRef, {
                    householdId: house.id, familyId: house.familyId, payerName: house.payerName,
                    billPeriodMonth: currentMonth + 1, billPeriodYear: currentYear,
                    duesTemplateId: template.id, duesType: template.name,
                    amount: template.amount, status: 'UNPAID', createdAt: Timestamp.now(), rtProfileId: rtProfileId, mode: currentMode,
                });
                billsCreatedCount++;
                // console.log('house:', house);
                // householdsToNotify.push(house);
                householdsToNotify.push({ ...house, billId: newBillRef.id }); // Menambahkan informasi billId
            }
            if (billsCreatedCount > 0) {
                await batch.commit(); setMessage({ text: `Berhasil! ${billsCreatedCount} tagihan baru telah dibuat.`, type: 'success' });
                // console.log('HAHAHAHAHA');
                if (currentRtConfig.isWhatsappIntegrationEnabled && currentRtConfig.isWhatsappIntegrationActive) {

                    // await sendWhatsappNotifications(householdsToNotify, template, currentMonth, currentYear);
                    await sendWhatsappMetaNotifications(householdsToNotify, template, currentMonth + 1, currentYear);
                }
            } else { setMessage({ text: "Tidak ada tagihan baru yang dibuat (semua target sudah ada atau tidak memenuhi syarat).", type: 'info' }) }
            setSelectedHouseholds({});
        } catch (error) { setError(`Gagal: ${error.message}`); }
        finally { setIsGenerating(false); }
    };


    const handleGenerateAllRemainingBills = async () => {
        const template = selectedTemplateObject;
        const currentYear = billYear;
        if (!template || !currentRtConfig || template.billingType !== 'RULE_BASED') { return; }
        if (!window.confirm(`Anda akan membuat semua sisa tagihan "${template.name}" untuk tahun ${currentYear}?`)) return;

        setIsGenerating(true);
        setMessage({ text: '', type: '' });
        setError('');

        try {
            const billsPath = getBillsCollectionPath(rtProfileId);
            const batch = writeBatch(db);
            let billsCreatedCount = 0;
            const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";
            const householdsToNotify = [];

            const checkQuery = query(collection(db, billsPath), where("duesTemplateId", "==", template.id), where("billPeriodYear", "==", currentYear), where("mode", "==", currentMode));
            const existingBillsSnap = await getDocs(checkQuery);
            const alreadyBilledMap = new Map();
            existingBillsSnap.forEach(doc => {
                const billData = doc.data();
                const key = `${billData.householdId}-${billData.billPeriodMonth}`;
                alreadyBilledMap.set(key, true);
            });

            for (const house of billableHouseholds) {
                const moveInDate = house.moveInDate.toDate();

                for (let month = template.startMonth - 1; month <= template.endMonth - 1; month++) {
                    let shouldBillThisMonth = false;
                    switch (template.period) {
                        case 'bulanan': shouldBillThisMonth = true; break;
                        case 'triwulan': if ([0, 3, 6, 9].includes(month)) shouldBillThisMonth = true; break;
                        case 'semester': if ([0, 6].includes(month)) shouldBillThisMonth = true; break;
                        case 'tahunan': if (month === (template.startMonth - 1)) shouldBillThisMonth = true; break;
                        case 'sekali bayar': if (month === (template.startMonth - 1)) shouldBillThisMonth = true; break;
                        default: break;
                    }
                    if (!shouldBillThisMonth) continue;

                    const checkKey = `${house.id}-${month + 1}`;
                    if (alreadyBilledMap.has(checkKey)) continue;

                    let periodDurationMonths = 1;
                    if (template.period === 'triwulan') periodDurationMonths = 3;
                    else if (template.period === 'semester') periodDurationMonths = 6;
                    else if (template.period === 'tahunan') periodDurationMonths = 12;
                    const billPeriodEndDate = new Date(currentYear, month + periodDurationMonths, 0);
                    billPeriodEndDate.setHours(23, 59, 59, 999);

                    if (moveInDate > billPeriodEndDate) { continue; }

                    const newBillRef = doc(collection(db, billsPath));
                    batch.set(newBillRef, {
                        householdId: house.id, familyId: house.familyId, payerName: house.payerName,
                        billPeriodMonth: month + 1, billPeriodYear: currentYear,
                        duesTemplateId: template.id, duesType: template.name,
                        amount: template.amount, status: 'UNPAID', createdAt: Timestamp.now(), rtProfileId: rtProfileId, mode: currentMode
                    });
                    billsCreatedCount++;
                    // Tambahkan ke array notifikasi untuk diproses setelah batch commit
                    householdsToNotify.push({ ...house, billId: newBillRef.id, billPeriodMonth: month + 1, billPeriodYear: currentYear });
                }
            }
            if (billsCreatedCount > 0) {
                await batch.commit(); setMessage({ text: `Berhasil! ${billsCreatedCount} tagihan baru telah dibuat untuk sisa periode.`, type: 'success' });
                // Panggil handler notifikasi
                if (currentRtConfig.isWhatsappIntegrationEnabled && currentRtConfig.isWhatsappIntegrationActive) {

                    for (const house of householdsToNotify) {
                        // await sendWhatsappNotifications([house], template, house.billPeriodMonth, house.billPeriodYear);
                        await sendWhatsappMetaNotifications([house], template, house.billPeriodMonth, house.billPeriodYear);
                    }
                }
            } else { setMessage({ text: "Tidak ada tagihan baru yang dibuat (semua sudah lengkap untuk tahun ini).", type: 'info' }); }
        } catch (error) {
            setError(`Gagal: ${error.message}`);
        } finally {
            setIsGenerating(false);
        }
    };

    const renderPeriodSelector = () => {
        const periodType = selectedTemplateObject?.period;
        let label = "Untuk Bulan*";
        let options = MONTHS.map((m, i) => ({ label: m, value: i }));

        switch (periodType) {
            case 'triwulan': label = "Untuk Triwulan*"; options = QUARTERS; break;
            case 'semester': label = "Untuk Semester*"; options = SEMESTERS; break;
            case 'sekali bayar': case 'tahunan': return null;
            default: break;
        }
        return (
            <div>
                <label htmlFor="billPeriod" className="block text-sm font-medium text-slate-700">{label}</label>
                <select id="billPeriod" value={billMonth} onChange={e => setBillMonth(parseInt(e.target.value))} className={commonInputStyle}>
                    {options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
            </div>
        );
    };

    // --- UI RENDERING ---
    if (isLoading) return <div className={cardStyle}><LoadingSpinner /></div>;

    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-4">Buat Tagihan Iuran</h2>
            {message.text && <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '' })} />}
            {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}

            {allActiveTemplates.length === 0 && !isLoading ? (
                <p className="text-center text-slate-500 p-4">Tidak ada jenis iuran yang aktif.</p>
            ) : (
                <div className="space-y-4">
                    <div className="p-4 border rounded-lg bg-slate-50 space-y-4">
                        <select id="duesTypeSelect" value={selectedTemplateId} onChange={handleTemplateChange} className={commonInputStyle}>
                            {allActiveTemplates.map(template => (
                                <option key={template.id} value={template.id}>
                                    {`${template.name} ${template.isPrimary ? '(UTAMA)' : ''} - Rp ${template.amount.toLocaleString('id-ID')}`}
                                </option>
                            ))}
                        </select>
                        <div className="grid grid-cols-2 gap-4">
                            {renderPeriodSelector()}
                            <div className={!renderPeriodSelector() ? 'col-span-2' : ''}>
                                <label htmlFor="billYear" className="block text-sm font-medium text-slate-700">Tahun*</label>
                                <select id="billYear" value={billYear} onChange={e => setBillYear(parseInt(e.target.value))} className={commonInputStyle}>
                                    {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>

                    {selectedTemplateObject?.billingType === 'TARGETED' && (
                        <div className="p-4 border rounded-lg bg-slate-50">
                            <h3 className="font-semibold text-slate-800 mb-2">Pilih Rumah yang Akan Ditagih ({getSelectedCount()} terpilih)</h3>
                            <div className="max-h-60 overflow-y-auto space-y-2 border p-3 rounded-md bg-white">
                                {billableHouseholds.map(house => (
                                    <label key={house.id} className="flex items-center space-x-3 p-2 rounded hover:bg-slate-100 cursor-pointer">
                                        <input type="checkbox" checked={!!selectedHouseholds[house.id]} onChange={() => handleHouseSelectionChange(house.id)} className="h-5 w-5 rounded border-gray-300 text-sky-600 focus:ring-sky-500" />
                                        <span>{house.houseIdentifier} ({house.payerName})</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    )}

                    {selectedTemplateObject?.billingType === 'RULE_BASED' && (
                        <div className="p-4 border rounded-lg bg-sky-50 text-sky-800 text-sm">
                            Tagihan ini bersifat "Berbasis Aturan" dan akan dibuat untuk semua rumah berpenghuni yang memenuhi syarat pada periode yang dipilih.
                        </div>
                    )}

                    <div className="flex flex-col sm:flex-row gap-3">
                        {/* Tombol Utama (untuk satu periode) */}
                        <button
                            onClick={handleGenerateBills}
                            className={`${primaryButtonStyle} w-full`}
                            disabled={isGenerating || (selectedTemplateObject?.billingType === 'TARGETED' && getSelectedCount() === 0)}
                        >
                            {isGenerating ? <LoadingSpinner /> : (selectedTemplateObject?.billingType === 'TARGETED' ? `Buat Tagihan untuk ${getSelectedCount()} Rumah` : `Buat Tagihan (Hanya Periode Terpilih)`)}
                        </button>

                        {/* Tombol Aksi Sekunder (hanya muncul untuk iuran Rule-Based) */}
                        {selectedTemplateObject?.billingType === 'RULE_BASED' && (
                            <button
                                onClick={handleGenerateAllRemainingBills}
                                className={`${secondaryButtonStyle} w-full`}
                                disabled={isGenerating}
                                title={`Membuat semua tagihan yang belum ada di tahun ${billYear} sesuai periode aktif templat`}
                            >
                                {isGenerating ? <LoadingSpinner /> : `Generate Semua Sisa Periode ${billYear}`}
                            </button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

// --- Halaman Manajemen Tagihan (FINAL dengan PENGELOMPOKAN) ---
const ManageBillsPage = () => {
    const { rtProfileId } = useAuth();

    // State untuk data mentah dan data yang sudah diproses
    const [groupedBills, setGroupedBills] = useState({}); // <-- State utama kita sekarang
    const [householdsMap, setHouseholdsMap] = useState({});
    const [templatesMap, setTemplatesMap] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    // State untuk filter
    const [filterMonth, setFilterMonth] = useState(0);
    const [filterYear, setFilterYear] = useState(new Date().getFullYear());
    const [filterStatus, setFilterStatus] = useState('ALL');
    const [filterDuesType, setFilterDuesType] = useState('ALL');

    // Fungsi "Penerjemah" Periode (tidak berubah)
    const formatBillPeriodForDisplay = (bill) => {
        // Langkah 1: Ambil "aturan" dari template yang terhubung
        const template = templatesMap[bill.duesTemplateId];
        if (!template) return "Info Iuran Tidak Ditemukan"; // Pengaman jika template terhapus

        // Langkah 2: Ambil data penting dari template dan bill
        const periodType = template.period;
        const monthIndex = bill.billPeriodMonth - 1; // Ubah ke index 0-11 untuk JS
        const year = bill.billPeriodYear;

        // Langkah 3: Terapkan logika "penerjemahan" berdasarkan tipe periode
        switch (periodType) {
            case 'triwulan':
                if (monthIndex >= 0 && monthIndex <= 2) return `Triwulan 1 (${year})`;   // Jan-Mar
                if (monthIndex >= 3 && monthIndex <= 5) return `Triwulan 2 (${year})`;   // Apr-Jun
                if (monthIndex >= 6 && monthIndex <= 8) return `Triwulan 3 (${year})`;   // Jul-Sep
                if (monthIndex >= 9 && monthIndex <= 11) return `Triwulan 4 (${year})`; // Okt-Des
                return `Triwulan Tidak Valid`; // Fallback jika data bulan aneh

            case 'semester':
                if (monthIndex >= 0 && monthIndex <= 5) return `Semester 1 (${year})`;   // Jan-Jun
                if (monthIndex >= 6 && monthIndex <= 11) return `Semester 2 (${year})`;  // Jul-Des
                return `Semester Tidak Valid`; // Fallback

            case 'tahunan':
                return `Tahunan (${year})`;
            case 'sekali bayar':
                // Untuk periode ini, kita hanya perlu tahunnya
                return `Sekali Bayar (${year})`;

            default: // 'bulanan'
                return `${MONTHS[monthIndex]} ${year}`;
        }
    };

    // Mengambil data awal (maps)
    useEffect(() => {
        if (!rtProfileId) return;
        const fetchInitialMaps = async () => {
            try {
                // Ambil data rumah
                const householdsPath = getHouseholdsCollectionPath(rtProfileId);
                const householdsSnap = await getDocs(query(collection(db, householdsPath)));
                const hhMap = {};
                householdsSnap.forEach(doc => { hhMap[doc.id] = doc.data().houseIdentifier; });
                setHouseholdsMap(hhMap);

                // Ambil SEMUA jenis iuran untuk dijadikan "kamus"
                const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
                const templatesSnap = await getDocs(query(collection(db, templatesPath)));
                const tmplMap = {};
                templatesSnap.forEach(doc => { tmplMap[doc.id] = doc.data(); });
                setTemplatesMap(tmplMap);

            } catch (err) {
                console.error("Error fetching initial maps:", err);
                setError("Gagal memuat data pendukung (rumah/templat).");
            }
        };
        fetchInitialMaps();
    }, [rtProfileId]);
    // --- useEffect UTAMA YANG DIPERBARUI ---
    useEffect(() => {
        if (!rtProfileId || Object.keys(templatesMap).length === 0) {
            setIsLoading(false);
            setGroupedBills({});
            return;
        };

        setIsLoading(true);
        const billsPath = getBillsCollectionPath(rtProfileId);
        let q = query(collection(db, billsPath), orderBy('createdAt', 'desc'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const allBills = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            // 1. Terapkan semua filter di sisi klien
            const filteredBills = allBills.filter(bill => {
                const monthMatch = (filterMonth === 0) || (bill.billPeriodMonth === filterMonth);
                const yearMatch = (filterYear === 0) || (bill.billPeriodYear === filterYear);
                const statusMatch = (filterStatus === 'ALL') || (bill.status === filterStatus);
                const duesTypeMatch = (filterDuesType === 'ALL') || (bill.duesType === filterDuesType);

                return monthMatch && yearMatch && statusMatch && duesTypeMatch;
            });

            // 2. Lakukan pengelompokan berdasarkan rumah
            const groups = {};
            filteredBills.forEach(bill => {
                const houseId = bill.householdId;
                if (!groups[houseId]) {
                    groups[houseId] = {
                        houseIdentifier: householdsMap[houseId] || houseId,
                        payerName: bill.payerName,
                        bills: []
                    };
                }
                groups[houseId].bills.push(bill);
            });

            // --- LANGKAH 3: PENGURUTAN DI DALAM SETIAP GRUP (PERBAIKAN KUNCI) ---
            for (const houseId in groups) {
                groups[houseId].bills.sort((a, b) => {
                    // Pertama, urutkan berdasarkan tahun
                    if (a.billPeriodYear !== b.billPeriodYear) {
                        return a.billPeriodYear - b.billPeriodYear;
                    }
                    // Jika tahunnya sama, urutkan berdasarkan bulan
                    return a.billPeriodMonth - b.billPeriodMonth;
                });
            }
            // --- AKHIR DARI PENGURUTAN ---

            setGroupedBills(groups);
            setIsLoading(false);
        }, (err) => {
            console.error("Error fetching bills:", err);
            setError("Gagal memuat data tagihan.");
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [rtProfileId, filterMonth, filterYear, filterStatus, filterDuesType, templatesMap, householdsMap]);

    const handleDeleteBill = async (billId, billInfo) => {
        if (!window.confirm(`Yakin ingin menghapus tagihan "${billInfo.duesType}" untuk rumah ${householdsMap[billInfo.householdId]}?`)) return;
        try {
            await deleteDoc(doc(db, getBillsCollectionPath(rtProfileId), billId));
        } catch (err) {
            setError("Gagal menghapus tagihan.");
        }
    };
    const StatusBadge = ({ status }) => {
        const styles = { UNPAID: 'bg-red-100 text-red-800', PAID: 'bg-green-100 text-green-800', PENDING_CONFIRMATION: 'bg-yellow-100 text-yellow-800' };
        return <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${styles[status] || 'bg-gray-100 text-gray-800'}`}>{status}</span>;
    };

    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-4">Manajemen Tagihan</h2>
            {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}

            {/* Filter Section */}
            <div className="grid md:grid-cols-4 gap-4 mb-6 p-4 border rounded-lg bg-slate-50">
                {/* Filter Bulan */}
                <select value={filterMonth} onChange={e => setFilterMonth(Number(e.target.value))} className={commonInputStyle}>
                    <option value={0}>-- Semua Bulan --</option>
                    {MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
                </select>

                {/* Filter Tahun */}
                <select value={filterYear} onChange={e => setFilterYear(Number(e.target.value))} className={commonInputStyle}>
                    <option value={0}>-- Semua Tahun --</option>
                    {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                </select>

                {/* Filter Status */}
                <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className={commonInputStyle}>
                    <option value="ALL">Semua Status</option>
                    <option value="UNPAID">Belum Dibayar</option>
                    <option value="PAID">Lunas</option>
                    <option value="PENDING_CONFIRMATION">Menunggu Konfirmasi</option>
                </select>

                {/* --- DROPDOWN FILTER BARU --- */}
                <select value={filterDuesType} onChange={e => setFilterDuesType(e.target.value)} className={commonInputStyle}>
                    <option value="ALL">Semua Jenis Iuran</option>
                    {/* Ambil opsi dari templatesMap yang sudah kita fetch */}
                    {Object.values(templatesMap).map(template => (
                        <option key={template.name} value={template.name}>{template.name}</option>
                    ))}
                </select>
            </div>

            {/* --- TAMPILAN DAFTAR TAGIHAN YANG BARU (DENGAN PENGELOMPOKAN) --- */}
            <div className="space-y-4">
                {isLoading ? <LoadingSpinner /> : (
                    Object.keys(groupedBills).length > 0 ? Object.keys(groupedBills).map(houseId => {
                        const group = groupedBills[houseId];
                        return (
                            <div key={houseId} className="p-4 border rounded-lg bg-slate-50 shadow-md">
                                <h3 className="text-lg font-bold text-sky-700 border-b pb-2 mb-2">
                                    {group.houseIdentifier} - (Payer: {group.payerName})
                                </h3>
                                <div className="space-y-2">
                                    {group.bills.map(bill => (
                                        <div key={bill.id} className="p-2 bg-white rounded-md flex justify-between items-center flex-wrap gap-2">
                                            <div>
                                                <p className="font-semibold">{bill.duesType}</p>
                                                <p className="text-sm text-slate-500">
                                                    Periode: {formatBillPeriodForDisplay(bill)} | Rp {bill.amount.toLocaleString('id-ID')} | Bill ID: {bill.id}
                                                </p>
                                            </div>
                                            <div className="text-right flex items-center gap-4">
                                                <StatusBadge status={bill.status} />
                                                {bill.status === 'UNPAID' && (
                                                    <button onClick={() => handleDeleteBill(bill.id, bill)} className="text-xs text-red-500 hover:text-red-700 font-semibold">
                                                        Hapus
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    }) : <p className="text-center text-slate-500 py-4">Tidak ada data tagihan yang cocok dengan filter.</p>
                )}
            </div>
        </div>
    );
};

// Di dalam file App.js Anda

// --- GANTI SELURUH KOMPONEN ManageBankAccountsPage DENGAN VERSI INI ---

// ====================================================================================
// PENTING: PENYEBAB ERROR "onNavigate is not a function"
// Komponen ini memerlukan sebuah properti (prop) bernama 'onNavigate'.
// Error terjadi karena saat Anda memanggil komponen ini, prop tersebut tidak disertakan.
//
// CARA MEMPERBAIKI:
// Cari di mana Anda merender komponen ini (kemungkinan di dalam switch case di App.js).
//
// Ganti baris ini:
// case 'manageBankAccounts': return <ManageBankAccountsPage />;
//
// Menjadi seperti ini:
// case 'manageBankAccounts': return <ManageBankAccountsPage onNavigate={handleAdminNavigate} />;
// ====================================================================================

// ====================================================================
// ============ Komponen SearchableSelect (Versi Perbaikan) ============
// ====================================================================
/**
 * Komponen Select yang dapat dicari untuk daftar opsi yang panjang.
 * Menggunakan Tailwind CSS dan state React standar, tanpa library eksternal.
 * @param {{
* options: Array<{code: string, name: string}>,
* value: string,
* onChange: (value: string) => void,
* placeholder: string,
* disabled?: boolean
* }} props
*/
const SearchableSelect = ({ options, value, onChange, placeholder, disabled }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const containerRef = useRef(null);

    const selectedOption = useMemo(() => {
        return options.find((option) => option.code === value);
    }, [options, value]);

    const filteredOptions = useMemo(() => {
        return options.filter(option =>
            option.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [options, searchTerm]);

    // Handle click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [containerRef]);

    const handleSelect = (option) => {
        onChange(option.code);
        setSearchTerm('');
        setIsOpen(false);
    };

    return (
        <div className="relative w-full" ref={containerRef}>
            <button
                type="button"
                className={`w-full flex justify-between items-center px-4 py-2 border rounded-lg bg-white text-left ${disabled ? 'bg-slate-100 text-slate-400 cursor-not-allowed' : 'hover:border-sky-500'}`}
                onClick={() => setIsOpen(!isOpen)}
                disabled={disabled}
            >
                <span>
                    {selectedOption ? selectedOption.name : placeholder}
                </span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                >
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </button>

            {isOpen && (
                <div className="absolute z-10 mt-1 w-full bg-white border border-slate-300 rounded-lg shadow-lg max-h-60 overflow-hidden">
                    <input
                        type="text"
                        className="w-full p-2 border-b border-slate-200 focus:outline-none"
                        placeholder="Cari bank..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <div className="overflow-y-auto max-h-[200px]">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option) => (
                                <div
                                    key={option.code}
                                    className="px-4 py-2 cursor-pointer hover:bg-slate-100 flex items-center"
                                    onClick={() => handleSelect(option)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className={`h-4 w-4 mr-2 text-sky-500 ${selectedOption?.code === option.code ? 'visible' : 'invisible'}`}
                                    >
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    {option.name}
                                </div>
                            ))
                        ) : (
                            <div className="p-4 text-center text-slate-500">Bank tidak ditemukan.</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
// ====================================================================
// ====================================================================

const ManageBankAccountsPage = ({ onNavigate }) => {
    const { rtProfileId, currentUser, userRole } = useAuth();

    const [accounts, setAccounts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });

    const [showForm, setShowForm] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    // State ini akan digunakan untuk menyimpan data rekening yang sedang diedit
    const [editingAccount, setEditingAccount] = useState(null);

    const [step, setStep] = useState('initial');
    const [otpInput, setOtpInput] = useState('');
    const [bankList, setBankList] = useState([]);
    const [isLoadingBankList, setIsLoadingBankList] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const [validatedAccountName, setValidatedAccountName] = useState('');

    const [bankCode, setBankCode] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [accountHolderName, setAccountHolderName] = useState('');


    useEffect(() => {
        if (!rtProfileId || userRole !== 'admin_rt' || !currentUser?.emailVerified) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        const accountsPath = getBankAccountsCollectionPath(rtProfileId);
        const q = query(collection(db, accountsPath));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedAccounts = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setAccounts(fetchedAccounts);
            // --- PERBAIKAN UTAMA DI SINI ---
            // Set editingAccount jika ada dokumen yang ditemukan.
            if (fetchedAccounts.length > 0) {
                setEditingAccount(fetchedAccounts[0]); // Asumsikan hanya ada satu rekening per RT
            } else {
                setEditingAccount(null);
            }
            setIsLoading(false);
        }, (err) => {
            setError("Gagal memuat data rekening bank.");
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, [rtProfileId, userRole, currentUser]);

    const handleStartProcess = async () => {
        setIsSubmitting(true);
        setMessage({ text: 'Mengirim kode verifikasi ke email Anda...', type: 'info' });
        try {
            if (currentUser) {
                await currentUser.getIdToken(true);
            }
            const functions = getFunctions(app, 'us-central1');
            const sendOtp = httpsCallable(functions, 'sendBankAccountChangeOtp');
            await sendOtp();
            setMessage({ text: 'Kode verifikasi telah dikirim. Silakan periksa email Anda.', type: 'success' });
            setStep('otp');
        } catch (err) {
            setMessage({ text: `Gagal mengirim OTP: ${err.message}`, type: 'error' });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleVerifyOtp = async () => {
        if (otpInput.length !== 6) {
            setMessage({ text: 'Kode OTP harus 6 digit.', type: 'error' });
            return;
        }
        setIsSubmitting(true);
        setMessage({ text: 'Memverifikasi kode...', type: 'info' });
        try {
            const functions = getFunctions(app, 'us-central1');
            const verifyOtp = httpsCallable(functions, 'verifyBankAccountChangeOtp');
            await verifyOtp({ otp: otpInput });
            setStep('form');
            setMessage({ text: '', type: '' });
            fetchBankList();
        } catch (err) {
            setMessage({ text: `Verifikasi Gagal: ${err.message}`, type: 'error' });
        } finally {
            setIsSubmitting(false);
        }
    };

    const fetchBankList = async () => {
        setIsLoadingBankList(true);
        try {
            const functions = getFunctions(app, 'us-central1');
            const getBanks = httpsCallable(functions, 'getAvailableBanks');
            const result = await getBanks();
            setBankList(result.data);
            if (result.data.length > 0) {
                setBankCode(result.data[0].code);
            }
        } catch (err) {
            setMessage({ text: 'Gagal memuat daftar bank.', type: 'error' });
        } finally {
            setIsLoadingBankList(false);
        }
    };

    const handleValidateAccount = async () => {
        if (!bankCode || !accountNumber) {
            setMessage({ text: 'Pilih bank dan masukkan nomor rekening.', type: 'error' });
            return;
        }
        setIsValidating(true);
        setMessage({ text: '', type: '' });
        setValidatedAccountName('');
        try {
            const functions = getFunctions(app, 'us-central1');
            const validateAccount = httpsCallable(functions, 'validateBankAccount');
            const result = await validateAccount({ bank_code: bankCode, account_number: accountNumber });
            if (result.data.is_valid) {
                setValidatedAccountName(result.data.account_holder_name);
                setAccountHolderName(result.data.account_holder_name);
                setStep('validation');
            } else {
                setMessage({ text: result.data.message || 'Rekening tidak valid.', type: 'error' });
            }
        } catch (err) {
            setMessage({ text: `Validasi Gagal: ${err.message}`, type: 'error' });
        } finally {
            setIsValidating(false);
        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const selectedBank = bankList.find(b => b.code === bankCode);
        const dataToSave = {
            bankCode: selectedBank.code,
            bankName: selectedBank.name,
            accountNumber: accountNumber.trim(),
            accountHolderName: validatedAccountName,
            rtProfileId: rtProfileId,
        };

        try {
            const accountsPath = getBankAccountsCollectionPath(rtProfileId);
            const batch = writeBatch(db);

            // --- LOGIKA UTAMA YANG DIPERBAIKI: HAPUS SEMUA DULU ---
            const existingAccountsSnapshot = await getDocs(query(collection(db, accountsPath)));
            existingAccountsSnapshot.forEach((doc) => {
                batch.delete(doc.ref);
            });

            // --- LALU, TAMBAHKAN DOKUMEN BARU ---
            const newDocRef = doc(collection(db, accountsPath));
            batch.set(newDocRef, { ...dataToSave, createdAt: Timestamp.now() });

            await batch.commit();

            setMessage({ text: 'Rekening berhasil diperbarui!', type: 'success' });
            resetAndCloseForm();
        } catch (err) {
            setMessage({ text: `Gagal menyimpan: ${err.message}`, type: 'error' });
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetAndCloseForm = () => {
        setShowForm(false);
        // --- PERBAIKAN KECIL UNTUK MERESET STATE FORM ---
        setEditingAccount(null); // Penting untuk mengosongkan ini saat form ditutup
        setStep('initial');
        setOtpInput('');
        setBankCode('');
        setAccountNumber('');
        setAccountHolderName('');
        setValidatedAccountName('');
        setMessage({ text: '', type: '' });
    };

    if (userRole && userRole !== 'admin_rt') {
        return (
            <div className={cardStyle}>
                <MessageBox type="error" message="Akses ditolak. Hanya Admin RT yang dapat mengelola rekening bank." />
            </div>
        );
    }

    if (currentUser && !currentUser.emailVerified) {
        return (
            <div className={cardStyle}>
                <MessageBox
                    type="error"
                    message="Untuk keamanan, Anda harus memverifikasi alamat email Anda terlebih dahulu sebelum bisa mengelola rekening bank."
                />
                <button
                    onClick={() => onNavigate('accountSettings')}
                    className={`${primaryButtonStyle} mt-4`}
                >
                    Pergi ke Pengaturan Akun
                </button>
            </div>
        );
    }

    return (
        <div className={cardStyle}>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold text-slate-700">Manajemen Rekening Bank</h2>
                <button onClick={() => { setShowForm(true); setStep('initial'); }} className={primaryButtonStyle}>
                    {accounts.length > 0 ? 'Ubah Rekening' : '+ Tambah Rekening'}
                </button>
            </div>

            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />

            <div className="space-y-3">
                {isLoading ? <LoadingSpinner /> : (
                    accounts.length > 0 ? accounts.map(acc => (
                        <div key={acc.id} className="p-4 border rounded-md bg-white shadow-sm">
                            <p className="font-bold text-lg text-sky-700">{acc.bankName}</p>
                            <p className="text-slate-800 font-mono text-base">{acc.accountNumber}</p>
                            <p className="text-sm text-slate-500">a/n {acc.accountHolderName}</p>
                        </div>
                    )) : !showForm && <p className="text-center text-slate-500 py-4">Belum ada rekening bank yang ditambahkan.</p>
                )}
            </div>

            {showForm && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center p-4">
                    <div className="bg-white p-6 rounded-2xl shadow-xl w-full max-w-md">
                        {step === 'initial' && (
                            <div>
                                <h3 className="text-xl font-bold">Verifikasi Perubahan</h3>
                                <p className="text-sm text-slate-500 my-4">Untuk keamanan, kami akan mengirimkan kode verifikasi (OTP) ke email Anda ({currentUser.email}) sebelum Anda dapat mengubah detail rekening bank.</p>
                                <div className="flex justify-end gap-3 mt-6">
                                    <button onClick={resetAndCloseForm} className={secondaryButtonStyle} disabled={isSubmitting}>Batal</button>
                                    <button onClick={handleStartProcess} className={primaryButtonStyle} disabled={isSubmitting}>
                                        {isSubmitting ? <LoadingSpinner /> : 'Kirim Kode OTP'}
                                    </button>
                                </div>
                            </div>
                        )}
                        {step === 'otp' && (
                            <div>
                                <h3 className="text-xl font-bold">Masukkan Kode OTP</h3>
                                <p className="text-sm text-slate-500 my-4">Masukkan 6 digit kode yang kami kirimkan ke email Anda.</p>
                                <input type="text" value={otpInput} onChange={(e) => setOtpInput(e.target.value)} maxLength="6" className={commonInputStyle} />
                                <div className="flex justify-end gap-3 mt-6">
                                    <button onClick={resetAndCloseForm} className={secondaryButtonStyle} disabled={isSubmitting}>Batal</button>
                                    <button onClick={handleVerifyOtp} className={primaryButtonStyle} disabled={isSubmitting}>
                                        {isSubmitting ? <LoadingSpinner /> : 'Verifikasi'}
                                    </button>
                                </div>
                            </div>
                        )}
                        {step === 'form' && (
                            <div>
                                <h3 className="text-xl font-bold">Masukkan Detail Rekening</h3>
                                <div className="space-y-4 mt-4">
                                    <SearchableSelect
                                        options={bankList}
                                        value={bankCode}
                                        onChange={setBankCode}
                                        placeholder={isLoadingBankList ? "Memuat bank..." : "Pilih Bank"}
                                        disabled={isLoadingBankList}
                                    />
                                    <input type="number" value={accountNumber} onChange={e => setAccountNumber(e.target.value)} placeholder="Nomor Rekening" className={commonInputStyle} />
                                </div>
                                <div className="flex justify-end gap-3 mt-6">
                                    <button onClick={resetAndCloseForm} className={secondaryButtonStyle} disabled={isValidating}>Batal</button>
                                    <button onClick={handleValidateAccount} className={primaryButtonStyle} disabled={isValidating}>
                                        {isValidating ? <LoadingSpinner /> : 'Validasi Rekening'}
                                    </button>
                                </div>
                            </div>
                        )}
                        {step === 'validation' && (
                            <form onSubmit={handleFormSubmit}>
                                <h3 className="text-xl font-bold">Konfirmasi Pemilik Rekening</h3>
                                <div className="my-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                                    <p className="text-sm text-slate-500">Rekening ditemukan atas nama:</p>
                                    <p className="text-lg font-bold text-green-800">{validatedAccountName}</p>
                                </div>
                                <p className="text-xs text-slate-500">Pastikan nama di atas sudah benar sebelum menyimpan.</p>
                                <div className="flex justify-end gap-3 mt-6">
                                    <button type="button" onClick={() => setStep('form')} className={secondaryButtonStyle} disabled={isSubmitting}>Ubah Data</button>
                                    <button type="submit" className={primaryButtonStyle} disabled={isSubmitting}>
                                        {isSubmitting ? <LoadingSpinner /> : 'Simpan Rekening'}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};



// --- Komponen ManageFeaturePlansPage (DIPERBARUI DENGAN KONTROL FEE) ---
const ManageFeaturePlansPage = () => {
    const { userRole, refreshAppConfig } = useAuth();
    const [plansData, setPlansData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    const plansDocRef = useMemo(() => doc(db, '/feature_plans/main'), []);

    useEffect(() => {
        const fetchPlans = async () => {
            setIsLoading(true);
            try {
                const docSnap = await getDoc(plansDocRef);
                if (docSnap.exists()) {
                    setPlansData(docSnap.data());
                } else {
                    // --- STRUKTUR DEFAULT DIPERBARUI DENGAN isTransactionFeeWaived ---
                    const defaultPlans = {
                        gratis: { priceMonth: 0, priceYear: 0, isHouseVerificationEnabled: false, isAnnouncementEnabled: false, isDiscordIntegrationEnabled: false, isWhatsappIntegrationEnabled: false, isAgendaEnabled: false, canCreateCustomDuesPeriods: false, canUseTargetedBilling: false, isOcrEnabled: false, isQrisPaymentEnabled: true, isTransactionFeeWaived: false, canPerformOnDemandDisbursement: false, maxFamilyCards: 10, maxResidents: 50 },
                        premium: { priceMonth: 100000, priceYear: 1000000, isHouseVerificationEnabled: true, isAnnouncementEnabled: true, isDiscordIntegrationEnabled: false, isWhatsappIntegrationEnabled: false, isAgendaEnabled: true, canCreateCustomDuesPeriods: false, canUseTargetedBilling: false, isOcrEnabled: false, isQrisPaymentEnabled: true, isTransactionFeeWaived: true, canPerformOnDemandDisbursement: false, maxFamilyCards: 50, maxResidents: 200 },
                        maksimum: { priceMonth: 150000, priceYear: 1500000, isHouseVerificationEnabled: true, isAnnouncementEnabled: true, isDiscordIntegrationEnabled: true, isWhatsappIntegrationEnabled: false, isAgendaEnabled: true, canCreateCustomDuesPeriods: true, canUseTargetedBilling: true, isOcrEnabled: true, isQrisPaymentEnabled: true, isTransactionFeeWaived: true, canPerformOnDemandDisbursement: false, maxFamilyCards: 100, maxResidents: 400 }
                    };
                    setPlansData(defaultPlans);
                    setMessage({ text: "Dokumen plan tidak ditemukan, struktur default telah dibuat. Harap simpan.", type: "info" });
                }
            } catch (error) { setMessage({ text: "Gagal memuat data plan.", type: "error" }); }
            finally { setIsLoading(false); }
        };
        if (userRole === 'superAdmin') { fetchPlans(); }
    }, [userRole, plansDocRef]);

    const handleFeatureChange = (planName, featureName, value, isBoolean = true) => {
        setPlansData(prevPlans => ({
            ...prevPlans,
            [planName]: {
                ...prevPlans[planName],
                [featureName]: isBoolean ? value : Number(value)
            }
        }));
    };

    const handleSaveChanges = async () => {
        setIsSaving(true);
        setMessage({ text: '', type: '' });
        try {
            await setDoc(plansDocRef, plansData, { merge: true });
            if (refreshAppConfig) await refreshAppConfig();
            setMessage({ text: "Perubahan pada paket fitur berhasil disimpan.", type: "success" });
        } catch (error) { setMessage({ text: "Gagal menyimpan perubahan.", type: "error" }); }
        finally { setIsSaving(false); }
    };

    if (userRole !== 'superAdmin') return <div className={cardStyle}><MessageBox message="Akses ditolak." type="error" /></div>;
    if (isLoading) return <div className={cardStyle}><LoadingSpinner /></div>;

    // --- DEFINISI BARIS FITUR DIPERBARUI ---
    const featureRows = [
        { key: 'priceMonth', label: 'Harga per Bulan (Rp)', type: 'number' },
        { key: 'priceYear', label: 'Harga per Tahun (Rp)', type: 'number' },
        { key: 'isHouseVerificationEnabled', label: 'Verifikasi Rumah (OTP/PIN)', type: 'checkbox' },
        { key: 'isAnnouncementEnabled', label: 'Fitur Pengumuman', type: 'checkbox' },
        { key: 'isAgendaEnabled', label: 'Fitur Agenda', type: 'checkbox' },
        { key: 'isDiscordIntegrationEnabled', label: 'Integrasi Notifikasi Discord', type: 'checkbox' },
        { key: 'isWhatsappIntegrationEnabled', label: 'Integrasi Notifikasi Whatsapp', type: 'checkbox' },
        { key: 'canCreateCustomDuesPeriods', label: 'Periode Iuran Kustom', type: 'checkbox' },
        { key: 'canUseTargetedBilling', label: 'Tagihan Bertarget', type: 'checkbox' },
        { key: 'isOcrEnabled', label: 'Fitur OCR Scan KK', type: 'checkbox' },
        { key: 'isQrisPaymentEnabled', label: 'Pembayaran via QRIS (Xendit)', type: 'checkbox' },
        { key: 'isTransactionFeeWaived', label: 'Bebaskan Biaya Layanan QRIS (untuk Warga)', type: 'checkbox' }, // <-- BARIS BARU DI SINI
        { key: 'canPerformOnDemandDisbursement', label: 'Fitur Tarik Dana Cepat (On-Demand)', type: 'checkbox' },
        { key: 'isDisbursementScheduled', label: 'Disbursement Terjadwal (Otomatis & Gratis)', type: 'checkbox' },
        { key: 'maxFamilyCards', label: 'Batas Maks. Kartu Keluarga', type: 'number' },
        { key: 'maxResidents', label: 'Batas Maks. Total Warga', type: 'number' },
    ];

    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-4">Manajemen Paket Fitur (Plans)</h2>
            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-slate-200 border">
                    <thead className="bg-slate-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Fitur</th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">Gratis</th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">Premium</th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">Maksimum</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-200">
                        {plansData && featureRows.map(({ key, label, type }) => (
                            <tr key={key}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">{label}</td>
                                {['gratis', 'premium', 'maksimum'].map(planKey => (
                                    <td key={`${planKey}-${key}`} className="px-6 py-4 whitespace-nowrap text-center">
                                        {type === 'checkbox' ? (
                                            <input type="checkbox" className="h-5 w-5 text-sky-600 rounded"
                                                checked={!!plansData[planKey]?.[key]}
                                                onChange={(e) => handleFeatureChange(planKey, key, e.target.checked)}
                                            />
                                        ) : (
                                            <input type="number" className={`${commonInputStyle} text-center w-24`}
                                                value={plansData[planKey]?.[key] || 0}
                                                onChange={(e) => handleFeatureChange(planKey, key, e.target.value, false)}
                                            />
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <button onClick={handleSaveChanges} className={`${primaryButtonStyle} mt-6`} disabled={isSaving}>
                {isSaving ? <LoadingSpinner /> : "Simpan Perubahan"}
            </button>
        </div>
    );
};

const ManageHouseholdsPage = () => {
    const { rtProfileId } = useAuth(); // Dapatkan rtProfileId dari context
    const [households, setHouseholds] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [editingHousehold, setEditingHousehold] = useState(null);
    const [houseIdentifier, setHouseIdentifier] = useState('');
    const [occupantName, setOccupantName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const fetchHouseholds = useCallback(async () => {
        if (!rtProfileId) { // Jangan fetch jika tidak ada rtProfileId (misalnya Super Admin)
            setIsLoading(false);
            setHouseholds([]);
            return () => { };
        }
        setIsLoading(true);
        try {
            const q = query(collection(db, getHouseholdsCollectionPath(rtProfileId)), orderBy("houseIdentifier"));
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const householdsData = querySnapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
                setHouseholds(householdsData);
                setIsLoading(false);
            }, (err) => {
                console.error("Error fetching households: ", err);
                setError("Gagal memuat data rumah.");
                setIsLoading(false);
            });
            return unsubscribe;
        } catch (err) {
            console.error("Error setting up household listener: ", err);
            setError("Gagal memuat data rumah.");
            setIsLoading(false);
            return () => { };
        }
    }, [rtProfileId]);

    useEffect(() => {
        let unsubscribe = () => { };
        fetchHouseholds().then(unsub => unsubscribe = unsub);
        return () => {
            if (typeof unsubscribe === 'function') {
                unsubscribe();
            }
        };
    }, [fetchHouseholds]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!rtProfileId) {
            setError("Profil RT tidak valid untuk menyimpan data rumah.");
            return;
        }
        if (!houseIdentifier.trim()) {
            setError("Nomor/ID Rumah wajib diisi.");
            return;
        }
        if (phoneNumber.trim() && !/^\+62\d{9,13}$/.test(phoneNumber.trim())) {
            setError("Format Nomor HP tidak valid. Gunakan format internasional (contoh: +6281234567890).");
            return;
        }

        setIsLoading(true);
        setError('');
        try {
            const data = {
                houseIdentifier: houseIdentifier.trim(),
                occupantName: occupantName.trim() || "",
                phoneNumber: phoneNumber.trim() || "",
                rtProfileId: rtProfileId // Selalu tambahkan rtProfileId
            };
            if (editingHousehold) {
                await updateDoc(doc(db, getHouseholdDocPath(rtProfileId, editingHousehold.id)), data);
            } else {
                const qCheck = query(collection(db, getHouseholdsCollectionPath(rtProfileId)), where("houseIdentifier", "==", data.houseIdentifier));
                const checkSnap = await getDocs(qCheck);
                if (!checkSnap.empty) {
                    setError(`Rumah dengan ID ${data.houseIdentifier} sudah ada di RT ini.`);
                    setIsLoading(false);
                    return;
                }
                await addDoc(collection(db, getHouseholdsCollectionPath(rtProfileId)), { ...data, createdAt: Timestamp.now() });
            }
            setShowForm(false);
            setEditingHousehold(null);
            setHouseIdentifier('');
            setOccupantName('');
            setPhoneNumber('');
        } catch (err) {
            console.error("Error saving household:", err);
            setError("Gagal menyimpan data rumah. Error: " + err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleEdit = (household) => {
        setEditingHousehold(household);
        setHouseIdentifier(household.houseIdentifier);
        setOccupantName(household.occupantName || '');
        setPhoneNumber(household.phoneNumber || '');
        setShowForm(true);
        setError('');
    };

    const handleDelete = async (id, houseIdName) => {
        if (!rtProfileId) return;
        if (window.confirm(`Yakin ingin menghapus data rumah ${houseIdName}? Ini tidak bisa dibatalkan.`)) {
            setIsLoading(true);
            setError('');
            try {
                // Cek pembayaran terkait untuk rumah ini di RT ini
                const paymentsQuery = query(collection(db, getPaymentsCollectionPath(rtProfileId)), where("houseId", "==", id), limit(1));
                const paymentsSnap = await getDocs(paymentsQuery);
                if (!paymentsSnap.empty) {
                    setError(`Tidak bisa menghapus rumah ${houseIdName} karena masih memiliki data pembayaran terkait di RT ini. Hapus pembayaran terlebih dahulu atau arsipkan rumah.`);
                    setIsLoading(false);
                    return;
                }
                await deleteDoc(doc(db, getHouseholdDocPath(rtProfileId, id)));
            } catch (err) {
                console.error("Error deleting household:", err);
                setError("Gagal menghapus data rumah. Error: " + err.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const openNewForm = () => {
        setEditingHousehold(null);
        setHouseIdentifier('');
        setOccupantName('');
        setPhoneNumber('');
        setShowForm(true);
        setError('');
    };

    if (!rtProfileId) {
        return <div className={cardStyle}><p className="text-center text-red-500">Admin RT tidak terasosiasi dengan Profil RT yang valid.</p></div>;
    }
    if (isLoading && households.length === 0) return <div className={cardStyle}><LoadingSpinner /><p className="text-center">Memuat data rumah...</p></div>;

    return (
        <div> {/* Mengganti cardStyle dari div utama agar bisa full-width di mobile */}
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-semibold text-slate-700">Kelola Data Rumah</h2>
                <button onClick={openNewForm} className={`${primaryButtonStyle} flex-shrink-0`}>
                    + Tambah Rumah
                </button>
            </div>
            {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}

            {/* Form tambah/edit (tidak berubah) */}
            {showForm && (
                <div className={cardStyle}>
                    <form onSubmit={handleFormSubmit} className="mb-6 p-4 border rounded-md bg-slate-50">
                        <h3 className="text-lg font-medium mb-2">{editingHousehold ? `Edit Data Rumah: ${editingHousehold.houseIdentifier}` : 'Tambah Rumah Baru'}</h3>
                        <div className="mb-3">
                            <label htmlFor="houseIdentifier" className="block text-sm font-medium text-slate-600">Nomor/ID Rumah *</label>
                            <input type="text" id="houseIdentifier" value={houseIdentifier} onChange={(e) => setHouseIdentifier(e.target.value.toUpperCase())} className={commonInputStyle} required />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="occupantName" className="block text-sm font-medium text-slate-600">Nama Penghuni (Opsional)</label>
                            <input type="text" id="occupantName" value={occupantName} onChange={(e) => setOccupantName(e.target.value)} className={commonInputStyle} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="phoneNumber" className="block text-sm font-medium text-slate-600">Nomor HP Pemilik (Format: +62...)</label>
                            <input type="tel" id="phoneNumber" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className={commonInputStyle} placeholder="+6281234567890" />
                            <p className="text-xs text-slate-500 mt-1">Gunakan format internasional, contoh: +6281234567890</p>
                        </div>
                        <div className="flex gap-2">
                            <button type="submit" className={`${primaryButtonStyle}`} disabled={isLoading}>
                                {isLoading ? <LoadingSpinner /> : (editingHousehold ? 'Update Data' : 'Simpan Rumah')}
                            </button>
                            <button type="button" onClick={() => { setShowForm(false); setError(''); }} className={`${secondaryButtonStyle}`}>Batal</button>
                        </div>
                    </form>
                </div>
            )}

            {/* --- AWAL PERUBAHAN TAMPILAN TABEL --- */}

            {/* Tampilan Tabel untuk Desktop (md ke atas) */}
            <div className="hidden md:block overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-slate-200">
                    <thead className="bg-slate-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">ID Rumah</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Nama Penghuni Payer</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Aksi</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-200">
                        {households.map(h => (
                            <tr key={h.id}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">{h.houseIdentifier}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500">{h.occupantName || 'Belum Dihuni'}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-4">
                                    <button onClick={() => handleEdit(h)} className="text-sky-600 hover:text-sky-800">Edit</button>
                                    <button onClick={() => handleDelete(h.id, h.houseIdentifier)} className="text-red-600 hover:text-red-800" disabled={isLoading}>Hapus</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Tampilan Kartu untuk Mobile (di bawah md) */}
            <div className="block md:hidden space-y-3">
                {households.map(h => (
                    <div key={h.id} className="bg-white p-4 rounded-lg shadow">
                        <div>
                            <p className="text-lg font-bold text-sky-700">{h.houseIdentifier}</p>
                            <p className="text-sm text-slate-600">Penghuni: <span className="font-medium">{h.occupantName || 'Belum Dihuni'}</span></p>
                        </div>
                        <div className="mt-3 pt-3 border-t border-slate-200 flex justify-end space-x-4">
                            <button onClick={() => handleEdit(h)} className="text-sm font-semibold text-sky-600 hover:underline">Edit</button>
                            <button onClick={() => handleDelete(h.id, h.houseIdentifier)} className="text-sm font-semibold text-red-500 hover:underline" disabled={isLoading}>Hapus</button>
                        </div>
                    </div>
                ))}
            </div>

            {households.length === 0 && !isLoading && (
                <div className="text-center py-10 bg-white rounded-lg shadow">
                    <p className="text-slate-500">Belum ada data rumah.</p>
                    <p className="text-xs text-slate-400 mt-1">Klik tombol '+ Tambah Rumah' untuk memulai.</p>
                </div>
            )}
            {/* --- AKHIR PERUBAHAN TAMPILAN TABEL --- */}

        </div>
    );
};

// --- ManualPaymentInputPage (FINAL UTUH - Alur Modern & Kontekstual) ---
const ManualPaymentInputPage = () => {
    const { currentUser, appConfig, rtProfileId } = useAuth();

    // State untuk data utama dari Firestore
    const [households, setHouseholds] = useState([]);
    const [allTemplates, setAllTemplates] = useState({});
    const [allBillsForYear, setAllBillsForYear] = useState([]);
    const [paymentsForCard, setPaymentsForCard] = useState([]);

    // State untuk UI dan pilihan pengguna
    const [selectedHouseId, setSelectedHouseId] = useState('');
    const [selectedBills, setSelectedBills] = useState({});
    const [displayYear, setDisplayYear] = useState(new Date().getFullYear());
    const [selectedTemplateForCard, setSelectedTemplateForCard] = useState('');

    // State untuk status loading dan pesan
    const [isLoading, setIsLoading] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    // Mendapatkan konfigurasi RT saat ini dengan useMemo untuk efisiensi
    const currentRtConfig = useMemo(() => {
        if (!appConfig || !rtProfileId) return null;
        return appConfig.rtProfiles?.[rtProfileId] || {};
    }, [appConfig, rtProfileId]);

    // useEffect untuk mengambil data awal (households & templates)
    useEffect(() => {
        if (!rtProfileId) {
            setIsLoading(false);
            return;
        }
        const fetchInitialData = async () => {
            setIsLoading(true);
            try {
                const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
                const templatesSnap = await getDocs(query(collection(db, templatesPath)));
                const tmplMap = {};
                templatesSnap.forEach(doc => { tmplMap[doc.id] = { id: doc.id, ...doc.data() }; });
                setAllTemplates(tmplMap);

                const householdsPath = getHouseholdsCollectionPath(rtProfileId);
                const householdsSnap = await getDocs(query(collection(db, householdsPath), orderBy("houseIdentifier")));
                const householdsData = householdsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                const occupanciesPath = getOccupanciesCollectionPath(rtProfileId);
                const occupanciesQuery = query(collection(db, occupanciesPath), where("status", "==", "ACTIVE"));
                const occupanciesSnap = await getDocs(occupanciesQuery);

                const occupancyMap = {};
                occupanciesSnap.forEach(doc => {
                    const occData = doc.data();
                    if (!occupancyMap[occData.householdId]) {
                        occupancyMap[occData.householdId] = {
                            moveInDate: occData.moveInDate,
                            occupantName: occData.headOfFamilyName
                        };
                    }
                });

                const finalHouseholds = householdsData.map(house => ({
                    ...house,
                    moveInDate: occupancyMap[house.id]?.moveInDate || null,
                    occupantName: occupancyMap[house.id]?.occupantName || house.occupantName || 'N/A'
                }));
                setHouseholds(finalHouseholds);

            } catch (error) {
                console.error("Error fetching initial data for manual payment:", error);
                setMessage({ text: "Gagal memuat data awal.", type: 'error' });
            } finally {
                setIsLoading(false);
            }
        };
        fetchInitialData();
    }, [rtProfileId]);

    // useEffect untuk mengambil SEMUA tagihan saat rumah atau tahun berubah
    useEffect(() => {
        if (!selectedHouseId || !displayYear || !currentRtConfig) {
            setAllBillsForYear([]);
            return;
        }
        setIsLoading(true);
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";
        const q = query(
            collection(db, getBillsCollectionPath(rtProfileId)),
            where("householdId", "==", selectedHouseId),
            where("billPeriodYear", "==", displayYear),
            where("mode", "==", currentMode)
        );
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setAllBillsForYear(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setIsLoading(false);
        }, (error) => {
            setMessage({ text: "Gagal memuat data tagihan.", type: 'error' });
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, [selectedHouseId, displayYear, rtProfileId, currentRtConfig]);

    // useEffect untuk mengambil data pembayaran untuk Kartu Iuran
    useEffect(() => {
        if (!selectedHouseId || !displayYear || !selectedTemplateForCard || !currentRtConfig) {
            setPaymentsForCard([]);
            return;
        }
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";
        const q = query(
            collection(db, getPaymentsCollectionPath(rtProfileId)),
            where("houseId", "==", selectedHouseId),
            where("paymentYear", "==", displayYear),
            where("duesTemplateId", "==", selectedTemplateForCard),
            where("mode", "==", currentMode)
        );
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setPaymentsForCard(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        }, (error) => {
            setMessage({ text: "Gagal memuat data kartu iuran.", type: 'error' });
        });
        return () => unsubscribe();
    }, [selectedHouseId, displayYear, rtProfileId, appConfig, selectedTemplateForCard, currentRtConfig]);

    // Fungsi helper untuk memformat periode tagihan
    const formatBillPeriodForDisplay = (item) => {
        const template = allTemplates[item.duesTemplateId];
        if (!template) return `${MONTHS[(item.billPeriodMonth || 1) - 1]} ${item.billPeriodYear || displayYear}`;

        const periodType = template.period;
        const monthIndex = (item.billPeriodMonth || 1) - 1;
        const year = item.billPeriodYear || displayYear;

        switch (periodType) {
            case 'triwulan':
                if (monthIndex >= 0 && monthIndex <= 2) return `Triwulan 1 (${year})`;
                if (monthIndex >= 3 && monthIndex <= 5) return `Triwulan 2 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 8) return `Triwulan 3 (${year})`;
                if (monthIndex >= 9 && monthIndex <= 11) return `Triwulan 4 (${year})`;
                return `Triwulan Tidak Valid`;
            case 'semester':
                if (monthIndex >= 0 && monthIndex <= 5) return `Semester 1 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 11) return `Semester 2 (${year})`;
                return `Semester Tidak Valid`;
            case 'tahunan': return `Tahunan (${year})`;
            case 'sekali bayar': return `Sekali Bayar (${year})`;
            default: return `${MONTHS[monthIndex]} ${year}`;
        }
    };

    // Kalkulasi data turunan (unpaid bills & total terpilih)
    const { unpaidBillsForList, totalSelectedAmount, selectedBillIds } = useMemo(() => {
        const unpaid = allBillsForYear.filter(b => b.status === 'UNPAID');
        const ids = Object.keys(selectedBills);
        const total = ids.reduce((acc, id) => {
            const bill = unpaid.find(b => b.id === id);
            return acc + (bill ? bill.amount : 0);
        }, 0);
        return { unpaidBillsForList: unpaid, totalSelectedAmount: total, selectedBillIds: ids };
    }, [allBillsForYear, selectedBills]);

    // Handler untuk checkbox
    const handleSelectBill = (billId) => {
        setSelectedBills(prev => {
            const newSelection = { ...prev };
            if (newSelection[billId]) { delete newSelection[billId]; }
            else { newSelection[billId] = true; }
            return newSelection;
        });
    };

    const handleSelectAll = () => {
        if (Object.keys(selectedBills).length === unpaidBillsForList.length) {
            setSelectedBills({});
        } else {
            const allSelected = {};
            unpaidBillsForList.forEach(bill => { allSelected[bill.id] = true; });
            setSelectedBills(allSelected);
        }
    };

    // Handler untuk konfirmasi pembayaran tunai
    const handleConfirmPayment = async () => {
        if (selectedBillIds.length === 0) {
            setMessage({ text: "Pilih minimal satu tagihan untuk dilunasi.", type: 'error' });
            return;
        }

        setIsProcessing(true);
        setMessage({ text: '', type: '' });

        const batch = writeBatch(db);
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";
        const houseData = households.find(h => h.id === selectedHouseId);

        try {
            const firstBill = unpaidBillsForList.find(b => b.id === selectedBillIds[0]);
            const newPaymentRef = doc(collection(db, getPaymentsCollectionPath(rtProfileId)));

            const paymentData = {
                houseId: selectedHouseId,
                familyId: firstBill.familyId,
                payerName: firstBill.payerName,
                amount: totalSelectedAmount,
                status: 'approved',
                paymentMethod: 'cash/manual',
                submissionTimestamp: Timestamp.now(),
                approvalTimestamp: Timestamp.now(),
                recordedBy: currentUser?.uid,
                recordedByEmail: currentUser?.email,
                mode: currentMode,
                rtProfileId: rtProfileId
            };

            if (selectedBillIds.length === 1) {
                paymentData.duesType = firstBill.duesType;
                paymentData.paymentMonth = firstBill.billPeriodMonth;
                paymentData.paymentYear = firstBill.billPeriodYear;
                paymentData.billId = firstBill.id;
                paymentData.duesTemplateId = firstBill.duesTemplateId;
            } else {
                paymentData.duesType = `Pembayaran Tunai Gabungan (${selectedBillIds.length} item)`;
                paymentData.relatedBillIds = selectedBillIds;
                paymentData.isParentBill = true;
            }

            batch.set(newPaymentRef, paymentData);

            selectedBillIds.forEach(billId => {
                const billRef = doc(db, getBillsCollectionPath(rtProfileId), billId);
                batch.update(billRef, { status: 'approved', paymentId: newPaymentRef.id });
            });

            await batch.commit();

            const billsDetails = unpaidBillsForList
                .filter(b => selectedBillIds.includes(b.id))
                .map(b => `- ${b.duesType} (${formatBillPeriodForDisplay(b)})`)
                .join('\n');

            const embed = {
                title: `💰 Pembayaran Tunai Dicatat (RT: ${rtProfileId}${currentMode === "testing" ? " - TESTING" : ""})`,
                description: `Pembayaran tunai telah dicatat oleh **${currentUser?.email || 'Admin'}** untuk **Rumah ${houseData?.houseIdentifier || 'N/A'}**.`,
                color: 0x22c55e,
                fields: [
                    { name: "Total Pembayaran", value: `Rp ${totalSelectedAmount.toLocaleString('id-ID')}`, inline: true },
                    { name: "Jumlah Tagihan", value: `${selectedBillIds.length} item`, inline: true },
                    { name: "Rincian Tagihan Dilunasi", value: "```" + billsDetails + "```", inline: false }
                ],
                timestamp: new Date().toISOString()
            };
            await sendDiscordNotification('payment', currentRtConfig, embed, { PAYMENT_STATUS_WEBHOOK_URL });

            setMessage({ text: `Berhasil mencatat pembayaran tunai.`, type: 'success' });
            setSelectedBills({});

        } catch (error) {
            console.error("Error confirming manual payment:", error);
            setMessage({ text: "Terjadi kesalahan saat menyimpan pembayaran.", type: 'error' });
        } finally {
            setIsProcessing(false);
        }
    };

    // Data untuk dikirim ke komponen anak
    const selectedHouseData = households.find(h => h.id === selectedHouseId);
    const selectedTemplateObject = allTemplates[selectedTemplateForCard];

    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-6">Input Pembayaran & Tinjauan Iuran</h2>
            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />

            <div className="mb-6">
                <SearchableHouseSelect
                    households={households}
                    selectedHouseId={selectedHouseId}
                    onHouseSelect={(id) => {
                        setSelectedHouseId(id);
                        setSelectedBills({});
                        setSelectedTemplateForCard('');
                    }}
                    label="Langkah 1: Pilih Rumah Warga"
                    idPrefix="manual-bill-page"
                />
            </div>

            {selectedHouseId && (
                <div className="space-y-8 animate-fade-in">
                    <div>
                        <h3 className="text-lg font-semibold text-slate-600 mb-3">Langkah 2: Pilih Tagihan Belum Lunas</h3>
                        {isLoading ? <LoadingSpinner /> : (
                            unpaidBillsForList.length > 0 ? (
                                <div className="space-y-2 border rounded-lg p-3 max-h-72 overflow-y-auto">
                                    <div className="flex items-center pb-2 border-b">
                                        <input
                                            type="checkbox"
                                            id="select-all-manual"
                                            checked={unpaidBillsForList.length > 0 && Object.keys(selectedBills).length === unpaidBillsForList.length}
                                            onChange={handleSelectAll}
                                            className="h-4 w-4 rounded"
                                        />
                                        <label htmlFor="select-all-manual" className="ml-2 text-sm font-medium">Pilih Semua ({unpaidBillsForList.length} tagihan)</label>
                                    </div>
                                    {unpaidBillsForList.map(bill => (
                                        <div key={bill.id} onClick={() => handleSelectBill(bill.id)} className={`flex items-center p-2 rounded hover:bg-slate-100 cursor-pointer ${selectedBills[bill.id] ? 'bg-sky-50' : ''}`}>
                                            <input
                                                type="checkbox"
                                                id={bill.id}
                                                checked={!!selectedBills[bill.id]}
                                                readOnly
                                                className="h-4 w-4 rounded"
                                            />
                                            <label htmlFor={bill.id} className="ml-3 flex-grow cursor-pointer">
                                                <p className="font-semibold">{bill.duesType}</p>
                                                <p className="text-xs text-slate-500">{formatBillPeriodForDisplay(bill)}</p>
                                            </label>
                                            <span className="font-semibold">Rp {bill.amount.toLocaleString('id-ID')}</span>
                                        </div>
                                    ))}
                                </div>
                            ) : <p className="text-center text-slate-500 p-4 bg-slate-50 rounded-lg">✓ Semua tagihan untuk tahun {displayYear} sudah lunas.</p>
                        )}
                    </div>

                    <div>
                        <hr className="my-6" />
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-semibold text-slate-600">Langkah 3: Tinjau Kartu Iuran</h3>
                            <select value={displayYear} onChange={(e) => { setDisplayYear(Number(e.target.value)); setSelectedTemplateForCard(''); }} className={`${commonInputStyle} !mt-0 w-auto`}>
                                {YEARS.map(year => <option key={year} value={year}>{year}</option>)}
                            </select>
                        </div>

                        <div className="mb-4">
                            <label htmlFor="template-select-card-manual" className="block text-sm font-medium text-slate-700">Pilih Jenis Iuran untuk Ditampilkan</label>
                            <select
                                id="template-select-card-manual"
                                value={selectedTemplateForCard}
                                onChange={(e) => setSelectedTemplateForCard(e.target.value)}
                                className={commonInputStyle}
                                disabled={!selectedHouseId}
                            >
                                <option value="">-- Pilih Jenis Iuran --</option>
                                {Object.values(allTemplates)
                                    .filter(t => t.year === displayYear)
                                    .map(template => (
                                        <option key={template.id} value={template.id}>{template.name}</option>
                                    ))
                                }
                            </select>
                        </div>

                        {selectedTemplateForCard && selectedHouseData ? (
                            <KartuIuranDisplay
                                houseData={selectedHouseData}
                                year={displayYear}
                                allBillsForYear={allBillsForYear}
                                duesTemplate={selectedTemplateObject}
                            />
                        ) : null}
                    </div>
                </div>
            )}

            {totalSelectedAmount > 0 && (
                <div className="sticky bottom-0 bg-white/80 backdrop-blur-sm p-4 -m-6 mt-6 border-t">
                    <div className="max-w-xl mx-auto">
                        <div className="flex justify-between items-center mb-3">
                            <p className="font-semibold">Total Terpilih ({selectedBillIds.length} item)</p>
                            <p className="text-xl font-bold">Rp {totalSelectedAmount.toLocaleString('id-ID')}</p>
                        </div>
                        <button onClick={handleConfirmPayment} className={`${primaryButtonStyle} w-full`} disabled={isProcessing}>
                            {isProcessing ? <LoadingSpinner /> : "Konfirmasi Pembayaran Tunai"}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

// --- Halaman Persetujuan Pembayaran (FINAL & UTUH) ---
const ApprovePaymentsPage = () => {
    // --- STATE MANAGEMENT ---
    const { appConfig, rtProfileId, currentUser } = useAuth();
    const [payments, setPayments] = useState([]);
    const [householdsMap, setHouseholdsMap] = useState({});
    const [allTemplates, setAllTemplates] = useState({});
    const [billsMap, setBillsMap] = useState({}); // <-- State baru untuk menyimpan detail semua bill
    const [isLoading, setIsLoading] = useState(true);
    const [isUpdating, setIsUpdating] = useState(null);
    const [error, setError] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });
    const [filterStatus, setFilterStatus] = useState('pending');

    // State untuk modal rincian bulk payment
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedBulkPayment, setSelectedBulkPayment] = useState(null);

    const formatBillPeriodForDisplay = (bill) => {
        // Fungsi ini tidak berubah
        const template = allTemplates[bill.duesTemplateId];
        if (!template) return `${MONTHS[bill.paymentMonth - 1]} ${bill.paymentYear}`;
        const periodType = template.period;
        const monthIndex = bill.paymentMonth - 1;
        const year = bill.paymentYear;
        switch (periodType) {
            case 'triwulan':
                if (monthIndex >= 0 && monthIndex <= 2) return `Triwulan 1 (${year})`;
                if (monthIndex >= 3 && monthIndex <= 5) return `Triwulan 2 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 8) return `Triwulan 3 (${year})`;
                if (monthIndex >= 9 && monthIndex <= 11) return `Triwulan 4 (${year})`;
                return `Triwulan Tidak Valid`;
            case 'semester':
                if (monthIndex >= 0 && monthIndex <= 5) return `Semester 1 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 11) return `Semester 2 (${year})`;
                return `Semester Tidak Valid`;
            case 'tahunan':
                return `Tahunan (${year})`
            case 'sekali bayar':
                return `Sekali Bayar (${year})`;
            default: return `${MONTHS[monthIndex]} ${year}`;
        }
    };

    // --- HELPER FUNCTION UNTUK FORMAT PERIODE ---
    const formatPeriodForDisplay = (item) => {
        if (!item?.duesTemplateId || Object.keys(allTemplates).length === 0) return 'Memuat...';
        const template = allTemplates[item.duesTemplateId];
        if (!template) return `Periode Tidak Dikenali`;

        const periodType = template.period;
        const monthIndex = (item.billPeriodMonth || item.paymentMonth) - 1;
        const year = item.billPeriodYear || item.paymentYear;

        switch (periodType) {
            case 'triwulan':
                if (monthIndex === 0) return `Triwulan 1 (${year})`;
                if (monthIndex === 3) return `Triwulan 2 (${year})`;
                if (monthIndex === 6) return `Triwulan 3 (${year})`;
                if (monthIndex === 9) return `Triwulan 4 (${year})`;
                return `Triwulan Tidak Valid`;
            case 'semester':
                if (monthIndex === 0) return `Semester 1 (${year})`;
                if (monthIndex === 6) return `Semester 2 (${year})`;
                return `Semester Tidak Valid`;
            case 'tahunan': case 'sekali bayar': return `Tahun ${year}`;
            default: return `${MONTHS[monthIndex]} ${year}`;
        }
    };

    // --- DATA FETCHING ---
    useEffect(() => {
        if (!rtProfileId) return;
        const fetchSupportData = async () => {
            setIsLoading(true);
            try {
                // Fetch Households
                const householdsPath = getHouseholdsCollectionPath(rtProfileId);
                const householdsSnap = await getDocs(query(collection(db, householdsPath)));
                const hhMap = {};
                householdsSnap.forEach(doc => { hhMap[doc.id] = doc.data().houseIdentifier; });
                setHouseholdsMap(hhMap);

                // Fetch All Bills
                const billsPath = getBillsCollectionPath(rtProfileId);
                const billsSnap = await getDocs(query(collection(db, billsPath)));
                const bMap = {};
                billsSnap.forEach(doc => { bMap[doc.id] = doc.data(); });
                setBillsMap(bMap);

                // --- AMBIL DATA TEMPLAT DI SINI ---
                const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
                const templatesSnap = await getDocs(query(collection(db, templatesPath)));
                const tmplMap = {};
                templatesSnap.forEach(doc => { tmplMap[doc.id] = doc.data(); });
                setAllTemplates(tmplMap);

            } catch (err) { setError("Gagal memuat data pendukung."); }
            finally { setIsLoading(false); }
        };
        fetchSupportData();
    }, [rtProfileId]);

    // Listener untuk data pembayaran (tidak berubah)
    useEffect(() => {
        if (!rtProfileId || !appConfig) return;
        const currentRtConfig = appConfig.rtProfiles?.[rtProfileId] || appConfig;
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";
        const paymentsPath = getPaymentsCollectionPath(rtProfileId);
        let q = query(collection(db, paymentsPath), where("mode", "==", currentMode));
        if (filterStatus !== 'all') { q = query(q, where("status", "==", filterStatus)); }
        q = query(q, orderBy("submissionTimestamp", "desc"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setPayments(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setIsLoading(false);
        }, (err) => { setError("Gagal memuat data pembayaran."); setIsLoading(false); });
        return () => unsubscribe();
    }, [rtProfileId, appConfig, filterStatus]);

    // --- HANDLER FUNCTIONS ---
    const handleUpdateStatus = async (payment, newStatus) => {
        let adminNotes = "";
        if (newStatus === 'rejected') {
            adminNotes = prompt("Masukkan alasan penolakan (opsional):");
            if (adminNotes === null) return;
        }

        setIsUpdating(payment.id);
        setError('');
        setMessage({ text: '', type: '' });

        try {
            const batch = writeBatch(db);
            const currentRtConfig = appConfig.rtProfiles?.[rtProfileId] || appConfig;
            const paymentRef = doc(db, getPaymentsCollectionPath(rtProfileId), payment.id);

            batch.update(paymentRef, {
                status: newStatus,
                adminNotes: adminNotes || "",
                approvalTimestamp: newStatus === 'approved' ? Timestamp.now() : null,
                processedByUid: currentUser?.uid,
                processedByEmail: currentUser?.email
            });

            const billsToUpdateIds = payment.relatedBillIds || [payment.billId];
            const newBillStatus = newStatus === 'approved' ? 'PAID' : 'UNPAID';

            billsToUpdateIds.forEach(billId => {
                if (billId) {
                    const billRef = doc(db, getBillsCollectionPath(rtProfileId), billId);
                    const updateData = { status: newBillStatus };
                    if (newStatus === 'rejected') {
                        updateData.rejectionReason = adminNotes || "Ditolak tanpa catatan.";
                        updateData.paymentId = null;
                    }
                    batch.update(billRef, updateData);
                }
            });

            await batch.commit();
            setMessage({ text: `Status pembayaran berhasil diubah.`, type: 'success' });

            // --- LOGIKA NOTIFIKASI DISCORD YANG DISEMPURNAKAN ---
            const houseIdentifier = householdsMap[payment.houseId] || payment.houseId;
            const statusEmoji = newStatus === 'approved' ? '✅' : '❌';
            const statusText = newStatus.toUpperCase();
            const color = newStatus === 'approved' ? 0x22c55e : 0xef4444;
            let embed;

            if (!payment.relatedBillIds || payment.relatedBillIds.length <= 1) {
                // Logika untuk pembayaran SATUAN (kode lama Anda, sudah benar)
                const period = formatPeriodForDisplay(payment);
                embed = {
                    title: `${statusEmoji} Status Pembayaran Diperbarui`,
                    description: `Pembayaran untuk *${payment.duesType}* periode *${period}* telah **${statusText}**.`,
                    color: color,
                    fields: [
                        { name: "Rumah", value: houseIdentifier, inline: true },
                        { name: "Jumlah", value: `Rp ${payment.amount.toLocaleString('id-ID')}`, inline: true }
                    ]
                };
                if (newStatus === 'rejected' && adminNotes) {
                    embed.fields.push({ name: "Alasan Penolakan", value: adminNotes, inline: false });
                }
            } else {
                // Logika BARU untuk pembayaran MASSAL
                const details = payment.relatedBillIds.map(billId => {
                    const bill = billsMap[billId];
                    if (!bill) return `- Detail tagihan tidak ditemukan`;
                    // Kita gunakan helper yang sudah ada di dalam komponen ini
                    const period = formatPeriodForDisplay(bill);
                    return `• ${bill.duesType} (${period}): Rp ${bill.amount.toLocaleString('id-ID')}`;
                }).join('\n');

                embed = {
                    title: `${statusEmoji} Status Pembayaran Massal Diperbarui`,
                    description: `Pembayaran gabungan untuk **${houseIdentifier}** telah **${statusText}**.`,
                    color: color,
                    fields: [
                        { name: "Total Pembayaran", value: `Rp ${payment.amount.toLocaleString('id-ID')}`, inline: true },
                        { name: "Jumlah Tagihan", value: `${payment.relatedBillIds.length} item`, inline: true },
                        { name: "Rincian Tagihan yang Dilunasi", value: details, inline: false }
                    ]
                };
                if (newStatus === 'rejected' && adminNotes) {
                    embed.fields.push({ name: "Alasan Penolakan", value: adminNotes, inline: false });
                }
            }

            await sendDiscordNotification('payment', currentRtConfig, embed, { PAYMENT_STATUS_WEBHOOK_URL });

        } catch (err) {
            setError(`Gagal memperbarui status: ${err.message}`);
        } finally {
            setIsUpdating(null);
        }
    };

    const handleShowDetails = (payment) => {
        setSelectedBulkPayment(payment);
        setShowDetailModal(true);
    };

    const viewProof = async (storagePath) => {
        try {
            const proofRef = ref(storage, storagePath);
            const url = await getDownloadURL(proofRef);
            window.open(url, '_blank');
        } catch (err) { setError("Gagal membuka gambar bukti pembayaran."); }
    };

    // --- UI RENDERING ---
    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-4">Persetujuan Pembayaran</h2>
            {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}
            {message.text && <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />}

            <div className="mb-4">
                <label htmlFor="filterStatus" className="mr-2 text-sm font-medium">Filter Status:</label>
                <select id="filterStatus" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} className={`${commonInputStyle} inline-block w-auto text-sm`}>
                    <option value="pending">Menunggu Persetujuan</option>
                    <option value="approved">Disetujui</option>
                    <option value="rejected">Ditolak</option>
                    <option value="all">Semua</option>
                </select>
            </div>

            <div className="space-y-4">
                {isLoading ? <LoadingSpinner /> : (
                    payments.length > 0 ? payments.map(p => {
                        const isBulk = p.relatedBillIds && p.relatedBillIds.length > 0;
                        return (
                            <div key={p.id} className="p-4 border rounded-md bg-slate-50 shadow-sm">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-2">
                                    <div className="md:col-span-2 space-y-1">
                                        <p className="font-bold text-lg">{householdsMap[p.houseId] || p.houseId} - <span className="text-sky-700">{p.duesType}</span></p>
                                        {isBulk && <p className="text-xs font-bold text-blue-600 bg-blue-100 px-2 py-0.5 rounded-full inline-block">{p.relatedBillIds.length} Tagihan Digabung</p>}
                                        <p className="text-sm"><strong>Total Bayar:</strong> Rp {p.amount?.toLocaleString('id-ID') || 'N/A'}</p>
                                        <p className="text-xs text-slate-500"><strong>Metode:</strong> {p.paymentMethod || 'MANUAL'}</p>
                                        <p className="text-xs text-slate-500"><strong>Dikirim:</strong> {p.submissionTimestamp?.toDate().toLocaleString('id-ID')}</p>
                                    </div>
                                    <div className="flex flex-col items-start md:items-end justify-between">
                                        <div>
                                            {p.proofStoragePath && <button onClick={() => viewProof(p.proofStoragePath)} className="text-sm font-semibold text-sky-600 hover:underline px-3 py-1 bg-sky-100 rounded-md">Lihat Bukti</button>}
                                            {isBulk && <button onClick={() => handleShowDetails(p)} className="text-sm font-semibold text-blue-600 hover:underline ml-2">Lihat Rincian</button>}
                                        </div>
                                        {p.status === 'pending' && (
                                            <div className="flex space-x-2 w-full mt-2 md:mt-0">
                                                <button onClick={() => handleUpdateStatus(p, 'rejected')} className={`${dangerButtonStyle} text-sm py-1 px-3 w-1/2`} disabled={isUpdating === p.id}>Tolak</button>
                                                <button onClick={() => handleUpdateStatus(p, 'approved')} className={`${primaryButtonStyle} bg-green-500 hover:bg-green-600 focus:ring-green-500 text-sm py-1 px-3 w-1/2`} disabled={isUpdating === p.id}>Setujui</button>
                                            </div>
                                        )}
                                        {(p.status === 'approved' || p.status === 'rejected') && (
                                            <div className="mt-2 text-right">
                                                <p className={`text-sm font-bold ${p.status === 'approved' ? 'text-green-600' : 'text-red-600'}`}>STATUS: {p.status.toUpperCase()}</p>
                                                <p className="text-xs text-slate-500">Oleh: {p.processedByEmail || 'Sistem'}</p>
                                            </div>
                                        )}
                                        {isUpdating === p.id && <div className="mt-2"><LoadingSpinner /></div>}
                                    </div>
                                </div>
                            </div>
                        )
                    }) : <p className="text-center text-slate-500 py-4">Tidak ada data pembayaran dengan status "{filterStatus}".</p>
                )}
            </div>

            {/* --- MODAL RINCIAN BULK PAYMENT YANG DIPERBAIKI --- */}
            {showDetailModal && selectedBulkPayment && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
                    <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
                        <h3 className="text-lg font-semibold mb-4">Rincian Pembayaran Gabungan</h3>
                        <div className="text-sm space-y-2 border-t border-b py-2 max-h-60 overflow-y-auto">
                            {(selectedBulkPayment.relatedBillIds || []).map(billId => {
                                const billDetail = billsMap[billId];
                                return billDetail ? (
                                    <div key={billId} className="flex justify-between">
                                        {/* Sekarang kita gunakan helper yang sudah ada di komponen ini */}
                                        <span>{billDetail.duesType} ({formatPeriodForDisplay(billDetail)})</span>
                                        <span>Rp {billDetail.amount.toLocaleString('id-ID')}</span>
                                    </div>
                                ) : <p key={billId}>Detail tagihan {billId} tidak ditemukan.</p>;
                            })}
                        </div>
                        <div className="flex justify-between font-bold text-base mt-2">
                            <span>Total</span>
                            <span>Rp {selectedBulkPayment.amount.toLocaleString('id-ID')}</span>
                        </div>
                        <button onClick={() => setShowDetailModal(false)} className={`${secondaryButtonStyle} w-full mt-6`}>Tutup</button>
                    </div>
                </div>
            )}
        </div>
    );
};

// --- RecordExpensePage (FINAL - dengan Sumber Dana Dinamis) ---
const RecordExpensePage = () => {
    const { currentUser, appConfig, rtProfileId, userRole } = useAuth();

    // 1. Ubah state untuk menyimpan objek utuh, bukan hanya nama
    const [duesTemplates, setDuesTemplates] = useState([]);

    const [jenisKegiatan, setJenisKegiatan] = useState(EXPENSE_TYPES[0]);
    const [deskripsi, setDeskripsi] = useState('');
    const [jumlah, setJumlah] = useState('');
    const [tanggalPengeluaran, setTanggalPengeluaran] = useState(new Date().toISOString().split('T')[0]);
    const [receiptImage, setReceiptImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [recentExpenses, setRecentExpenses] = useState([]);
    const [recentLoading, setRecentLoading] = useState(true);
    const receiptFileInputRef = React.useRef(null);
    // 2. Ubah state untuk menyimpan ID yang terpilih, bukan lagi nama.
    const [selectedDuesTemplateId, setSelectedDuesTemplateId] = useState('');

    // State expenseSource sekarang diinisialisasi kosong, akan diisi oleh data dinamis
    const [expenseSource, setExpenseSource] = useState('');

    // --- EFFECT BARU: MENGAMBIL DATA JENIS IURAN (DUES TEMPLATES) ---
    // useEffect(() => {
    //     if (!rtProfileId) return;

    //     const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
    //     const q = query(collection(db, templatesPath), where("isActive", "==", true));

    //     const unsubscribe = onSnapshot(q, (snapshot) => {
    //         const templatesData = snapshot.docs.map(doc => doc.data().name);
    //         setDuesTemplates(templatesData);
    //         // Set nilai default untuk dropdown jika data sudah termuat
    //         if (templatesData.length > 0) {
    //             setExpenseSource(templatesData[0]);
    //         } else {
    //             setExpenseSource("Kas Umum Lainnya"); // Fallback jika tidak ada template
    //         }
    //     }, (err) => {
    //         console.error("Error fetching dues templates for expenses:", err);
    //         setMessage({ text: "Gagal memuat data sumber dana.", type: "error" });
    //     });

    //     return () => unsubscribe();
    // }, [rtProfileId]);

    useEffect(() => {
        if (!rtProfileId) return;
        const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
        const q = query(collection(db, templatesPath), where("isActive", "==", true));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            // 3. Ambil objek utuh (id dan data) dari Firestore
            const templatesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setDuesTemplates(templatesData);

            // Atur nilai default untuk dropdown
            if (templatesData.length > 0) {
                setSelectedDuesTemplateId(templatesData[0].id);
            } else {
                setSelectedDuesTemplateId("KAS_UMUM"); // Fallback jika tidak ada template
            }
        }, (err) => {
            console.error("Error fetching dues templates for expenses:", err);
            setMessage({ text: "Gagal memuat data sumber dana.", type: "error" });
        });
        return () => unsubscribe();
    }, [rtProfileId]);

    const fetchRecentExpenses = useCallback(async () => {
        if (!appConfig || !rtProfileId) return () => { };

        setRecentLoading(true);
        const currentRtConfig = appConfig.rtProfiles?.[rtProfileId] || appConfig;
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";
        try {
            let q = query(collection(db, getExpensesCollectionPath(rtProfileId)), orderBy("createdAt", "desc"), limit(5));
            if (currentMode === "testing") {
                q = query(q, where("mode", "==", "testing"));
            } else {
                q = query(q, where("mode", "!=", "testing"));
            }

            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const expenses = querySnapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
                setRecentExpenses(expenses);
                setRecentLoading(false);
            }, (err) => {
                console.error("Error fetching recent expenses:", err);
                setMessage({ text: "Gagal memuat pengeluaran terkini.", type: "error" });
                setRecentLoading(false);
            });
            return unsubscribe;
        } catch (error) {
            console.error("Error setting up listener for recent expenses:", error);
            setMessage({ text: "Gagal memuat pengeluaran terkini.", type: "error" });
            setRecentLoading(false);
            return () => { };
        }
    }, [appConfig, rtProfileId]);

    useEffect(() => {
        let unsubscribe = () => { };
        if (appConfig && rtProfileId) {
            fetchRecentExpenses().then(unsub => unsubscribe = unsub);
        } else if (!rtProfileId && appConfig) {
            setRecentLoading(false);
            setRecentExpenses([]);
        }
        return () => {
            if (typeof unsubscribe === 'function') {
                unsubscribe();
            }
        };
    }, [fetchRecentExpenses, appConfig, rtProfileId]);

    const handleReceiptImageChange = (e) => {
        if (e.target.files[0]) {
            if (e.target.files[0].size > 5 * 1024 * 1024) {
                setMessage({ text: "Ukuran file kwitansi maksimal 5MB.", type: "error" });
                setReceiptImage(null);
                if (receiptFileInputRef.current) receiptFileInputRef.current.value = "";
                return;
            }
            setReceiptImage(e.target.files[0]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!jenisKegiatan || !jumlah || !tanggalPengeluaran || parseFloat(jumlah) <= 0 || !selectedDuesTemplateId) {
            setMessage({ text: "Semua field wajib diisi, jumlah harus positif, dan sumber dana harus dipilih.", type: "error" });
            return;
        }
        if (!appConfig || !rtProfileId) {
            setMessage({ text: "Konfigurasi aplikasi atau Profil RT tidak valid. Coba lagi nanti.", type: "error" });
            return;
        }
        if (!currentUser || !currentUser.uid) {
            setMessage({ text: "Sesi pengguna admin tidak valid. Silakan login kembali.", type: "error" });
            setLoading(false);
            return;
        }

        setLoading(true);
        setMessage({ text: '', type: '' });
        let receiptImageUrlToSave = "";
        const currentRtConfig = appConfig.rtProfiles?.[rtProfileId] || appConfig;
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";

        try {
            // console.log("[RecordExpensePage] User attempting upload:", currentUser.email, "(UID:", currentUser.uid, ", Role:", userRole, ", RT:", rtProfileId, ")");
            // console.log("[RecordExpensePage] Mode data:", currentMode);

            if (receiptImage) {
                const imageName = `${appIdForPaths}_expense_${rtProfileId}_${Date.now()}_${receiptImage.name}`;
                const storageRefPath = `expense_receipts/${rtProfileId}/${imageName}`;
                const fileStorageRef = ref(storage, storageRefPath);
                await uploadBytesResumable(fileStorageRef, receiptImage);
                receiptImageUrlToSave = await getDownloadURL(fileStorageRef);
            }

            // 5. Simpan ID dan Nama ke Firestore saat submit
            const selectedTemplate = duesTemplates.find(t => t.id === selectedDuesTemplateId);
            const dataToSave = {
                jenisKegiatan,
                deskripsi: deskripsi.trim() || "",
                jumlah: parseFloat(jumlah),
                tanggalPengeluaran: Timestamp.fromDate(new Date(tanggalPengeluaran + "T00:00:00")),
                receiptImageUrl: receiptImageUrlToSave,
                // Simpan ID untuk referensi, dan Nama untuk kemudahan display
                expenseSourceId: selectedDuesTemplateId === 'KAS_UMUM' ? null : selectedDuesTemplateId,
                expenseSourceName: selectedTemplate ? selectedTemplate.name : "Kas Umum Lainnya",
                dicatatOleh: currentUser.uid,
                dicatatOlehEmail: currentUser.email,
                createdAt: Timestamp.now(),
                mode: currentMode,
                rtProfileId: rtProfileId
            };

            await addDoc(collection(db, getExpensesCollectionPath(rtProfileId)), dataToSave);
            setMessage({ text: "Pengeluaran berhasil dicatat.", type: "success" });

            const embed = {
                title: `📝 Catatan Pengeluaran Baru (RT: ${rtProfileId}${currentMode === "testing" ? " - TESTING" : ""})`,
                description: `Pengeluaran baru telah dicatat oleh ${currentUser?.email || 'Admin'}.`,
                color: currentMode === "testing" ? 0xFFD700 : 0xFFA500,
                fields: [
                    { name: "Jenis Kegiatan", value: jenisKegiatan, inline: true },
                    { name: "Sumber Dana", value: dataToSave.expenseSourceName, inline: true },
                    { name: "Jumlah", value: `Rp ${parseFloat(jumlah).toLocaleString('id-ID')}`, inline: true },
                    { name: "Tanggal", value: new Date(tanggalPengeluaran).toLocaleDateString('id-ID'), inline: true },
                    { name: "Mode Data", value: currentMode.toUpperCase(), inline: true },
                ],
                timestamp: new Date().toISOString()
            };
            if (deskripsi) embed.fields.push({ name: "Deskripsi", value: deskripsi, inline: false });
            if (receiptImageUrlToSave) embed.fields.push({ name: "Link Kwitansi", value: `[Lihat Kwitansi](${receiptImageUrlToSave})`, inline: false });
            await sendDiscordNotification('expense', currentRtConfig, embed, { EXPENSE_RECORD_WEBHOOK_URL });

            // Reset form
            setJenisKegiatan(EXPENSE_TYPES[0]);
            setDeskripsi('');
            setJumlah('');
            setReceiptImage(null);
            if (duesTemplates.length > 0) {
                setSelectedDuesTemplateId(duesTemplates[0].id);
            } else {
                setSelectedDuesTemplateId("KAS_UMUM");
            }
            setTanggalPengeluaran(new Date().toISOString().split('T')[0]);
            if (receiptFileInputRef.current) receiptFileInputRef.current.value = "";

        } catch (error) {
            console.error("Error recording expense (Full Error Object):", JSON.stringify(error, Object.getOwnPropertyNames(error)));
            let detailedErrorMessage = "Gagal mencatat pengeluaran. Error: " + error.message;
            if (error.code && error.code.startsWith('storage/')) {
                detailedErrorMessage = `Kesalahan Storage: ${error.message} (Kode: ${error.code}). Pastikan Anda memiliki izin untuk mengakses path tersebut.`;
            } else if (error.code) {
                detailedErrorMessage = `Kesalahan Firebase: ${error.message} (Kode: ${error.code}).`;
            }
            setMessage({ text: detailedErrorMessage, type: "error" });
        } finally {
            setLoading(false);
        }
    };

    if (!appConfig) return <div className={cardStyle}><LoadingSpinner /><p className="text-center">Memuat konfigurasi...</p></div>;
    if (!rtProfileId && appConfig) {
        return <div className={cardStyle}><p className="text-center text-slate-500">Admin RT tidak terasosiasi dengan Profil RT yang valid untuk mencatat pengeluaran.</p></div>;
    }


    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-6">Catat Pengeluaran Cluster (RT: {rtProfileId})</h2>
            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="jenisKegiatan" className="block text-sm font-medium text-slate-700">Jenis Kegiatan *</label>
                    <select id="jenisKegiatan" value={jenisKegiatan} onChange={(e) => setJenisKegiatan(e.target.value)} className={commonInputStyle} required>
                        {EXPENSE_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
                    </select>
                </div>

                <div>
                    <label htmlFor="expenseSource" className="block text-sm font-medium text-slate-700">Sumber Dana Pengeluaran *</label>
                    {/* 4. Atur <select> untuk menggunakan ID sebagai value */}
                    <select
                        id="expenseSource"
                        value={selectedDuesTemplateId}
                        onChange={(e) => setSelectedDuesTemplateId(e.target.value)}
                        className={commonInputStyle}
                        required
                        disabled={duesTemplates.length === 0 && selectedDuesTemplateId !== 'KAS_UMUM'}
                    >
                        {duesTemplates.map(template => (
                            <option key={template.id} value={template.id}>
                                {template.name}
                            </option>
                        ))}
                        <option value="KAS_UMUM">Kas Umum Lainnya</option>
                    </select>
                </div>

                {/* Sisa form tidak berubah */}
                <div>
                    <label htmlFor="deskripsi" className="block text-sm font-medium text-slate-700">Deskripsi (Opsional)</label>
                    <input type="text" id="deskripsi" value={deskripsi} onChange={(e) => setDeskripsi(e.target.value)} className={commonInputStyle} placeholder="Detail kegiatan atau item pengeluaran" />
                </div>
                <div>
                    <label htmlFor="jumlah" className="block text-sm font-medium text-slate-700">Jumlah (Rp) *</label>
                    <input type="number" id="jumlah" value={jumlah} onChange={(e) => setJumlah(e.target.value)} className={commonInputStyle} placeholder="Contoh: 150000" required min="1" />
                </div>
                <div>
                    <label htmlFor="tanggalPengeluaran" className="block text-sm font-medium text-slate-700">Tanggal Pengeluaran *</label>
                    <input type="date" id="tanggalPengeluaran" value={tanggalPengeluaran} onChange={(e) => setTanggalPengeluaran(e.target.value)} className={commonInputStyle} required />
                </div>
                <div className="mb-4">
                    <label htmlFor="receiptImageFile" className="block text-sm font-medium text-slate-700">Unggah Kwitansi (Opsional, Max 5MB)</label>
                    <input type="file" id="receiptImageFile" ref={receiptFileInputRef} onChange={handleReceiptImageChange} accept="image/*" className={`${commonInputStyle} file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-sky-50 file:text-sky-700 hover:file:bg-sky-100`} />
                    {receiptImage && <p className="text-xs text-slate-500 mt-1">File: {receiptImage.name}</p>}
                </div>
                <button type="submit" className={`${primaryButtonStyle} w-full`} disabled={loading}>
                    {loading ? <LoadingSpinner /> : 'Simpan Pengeluaran'}
                </button>
            </form>

            <div className="mt-8">
                <h3 className="text-lg font-semibold text-slate-600 mb-3">5 Pengeluaran Terkini ({(appConfig?.rtProfiles?.[rtProfileId] || appConfig)?.isTestingMode ? "Mode Testing" : "Mode Live"}):</h3>
                {recentLoading && <LoadingSpinner />}
                {!recentLoading && recentExpenses.length === 0 && <p className="text-slate-500">Belum ada data pengeluaran untuk mode ini.</p>}
                <ul className="space-y-2">
                    {recentExpenses.map(exp => (
                        <li key={exp.id} className="text-sm p-3 border rounded-md bg-slate-50 shadow-sm">
                            <span className="font-medium">{exp.jenisKegiatan}</span> (Sumber: {exp.expenseSource || 'Kas Umum'}) - Rp {exp.jumlah.toLocaleString('id-ID')}
                            <span className="block text-xs text-slate-500">Tanggal: {exp.tanggalPengeluaran.toDate().toLocaleDateString('id-ID')}</span>
                            {exp.deskripsi && <span className="block text-xs text-slate-500">Deskripsi: {exp.deskripsi}</span>}
                            {exp.receiptImageUrl && <a href={exp.receiptImageUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-sky-500 hover:underline">Lihat Kwitansi</a>}
                            <span className="text-xs text-slate-400 block">Dicatat oleh: {exp.dicatatOlehEmail || exp.dicatatOleh}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

const ToastifyCSS = () => {
    useEffect(() => {
        const link = document.createElement('link');
        link.href = 'https://cdn.jsdelivr.net/npm/react-toastify@9.1.1/dist/ReactToastify.min.css';
        link.rel = 'stylesheet';
        document.head.appendChild(link);
        return () => {
            document.head.removeChild(link);
        };
    }, []);
    return null;
};

// Di dalam App.js, bersama komponen halaman admin lainnya
const setupFCM = async (app, db, currentUser, rtProfileId, loggedInHouseData) => {
    // Log tracing awal: Memeriksa input
    // console.log("FCM Setup Tracing: Memulai setupFCM...");
    // console.log("FCM Setup Tracing: Parameter yang diterima:", {
    //     currentUser: !!currentUser,
    //     rtProfileId: rtProfileId,
    //     loggedInHouseData: loggedInHouseData,
    //     isOccupantNamePresent: !!(loggedInHouseData && loggedInHouseData.occupantName),
    // });
    // LOG BARU: UID dan status pengguna
    // console.log("FCM Setup Tracing: Status pengguna saat ini:", {
    //     uid: currentUser ? currentUser.uid : null,
    //     isAnonymous: currentUser ? currentUser.isAnonymous : null,
    // });


    // Memastikan semua prasyarat terpenuhi sebelum melanjutkan.
    if (!currentUser || !('Notification' in window) || !('serviceWorker' in navigator) || !loggedInHouseData || !loggedInHouseData.occupantName || !rtProfileId) {
        // console.warn('FCM setup skipped: Prerequisites are not met. Log di atas menunjukkan nilai yang hilang.');
        return;
    }

    const messaging = getMessaging(app);

    try {
        // console.log('FCM Setup Tracing: Meminta izin notifikasi...');
        const permission = await Notification.requestPermission();

        if (permission === 'granted') {
            // console.log('FCM Setup Tracing: Izin notifikasi diberikan.');

            // Listener untuk pesan saat aplikasi berada di latar depan
            onMessage(messaging, (payload) => {
                // console.log('FCM Setup Tracing: Pesan latar depan diterima:', payload);
                const { title, body } = payload.notification;
                toast.info(title, { body: body, autoClose: 5000 });
            });

            // Fungsi pembantu untuk menyimpan token ke Firestore
            const saveToken = async (token) => {
                // Log tracing: Memeriksa data sebelum membuat path Firestore
                // console.log("FCM Setup Tracing: Memulai saveToken. Parameter:", {
                //     rtProfileId,
                //     loggedInHouseData,
                //     token
                // });
                // LOG BARU: UID pengguna sebelum operasi Firestore
                // console.log("FCM Setup Tracing: UID yang akan digunakan untuk menulis:", currentUser.uid);

                // Memastikan data yang diperlukan valid
                if (!rtProfileId || !loggedInHouseData || !loggedInHouseData.occupantName) {
                    // console.error("FCM Setup Tracing: Data tidak lengkap untuk membuat path Firestore. Melewati penyimpanan.");
                    return;
                }

                const residentsRef = collection(db, getResidentsCollectionPath(rtProfileId));
                const q = query(residentsRef, where("fullName", "==", loggedInHouseData.occupantName));

                // Log tracing: Jalankan dan periksa snapshot query
                // console.log("FCM Setup Tracing: Mencari dokumen penduduk dengan nama:", loggedInHouseData.occupantName);
                const residentSnapshot = await getDocs(q);
                // console.log(`FCM Setup Tracing: Hasil query, ditemukan ${residentSnapshot.docs.length} dokumen.`);


                // Perbaikan: Hentikan jika dokumen tidak ditemukan
                if (residentSnapshot.empty) {
                    // console.error("FCM Setup Tracing: Dokumen penduduk tidak ditemukan untuk occupantName:", loggedInHouseData.occupantName);
                    return;
                }

                const residentDoc = residentSnapshot.docs[0];
                const residentDocId = residentDoc.id;

                // Log tracing: ID dokumen penduduk
                // console.log("FCM Setup Tracing: ID dokumen penduduk yang ditemukan:", residentDocId);

                // Perbaikan: Periksa kembali validitas ID dokumen
                if (!residentDocId) {
                    // console.error("FCM Setup Tracing: ID dokumen penduduk tidak valid.");
                    return;
                }

                const userDocRef = doc(db, getResidentsCollectionPath(rtProfileId), residentDocId);

                // Periksa apakah dokumen sudah ada sebelum mencoba memperbarui
                const userDoc = await getDoc(userDocRef);
                // console.log("FCM Setup Tracing: Dokumen ada?", userDoc.exists());

                if (userDoc.exists()) {
                    // Periksa apakah fcmTokens ada dan merupakan array
                    const fcmTokens = userDoc.data().fcmTokens;
                    // console.log("FCM Setup Tracing: Tipe fcmTokens:", Array.isArray(fcmTokens) ? 'array' : 'bukan array');

                    if (Array.isArray(fcmTokens)) {
                        // Gunakan arrayUnion untuk menambahkan token ke array yang sudah ada
                        // console.log("FCM Setup Tracing: Menggunakan arrayUnion untuk memperbarui token.");
                        await updateDoc(userDocRef, {
                            fcmTokens: arrayUnion(token),
                            userId: currentUser.uid,
                        });
                        // console.log('FCM Setup Tracing: Token FCM berhasil diperbarui dengan arrayUnion.');
                    } else {
                        // Jika fcmTokens bukan array, timpa dengan array baru yang berisi token
                        // console.log("FCM Setup Tracing: Menimpa fcmTokens dengan array baru.");
                        await setDoc(userDocRef, {
                            fcmTokens: [token],
                            userId: currentUser.uid,
                        }, { merge: true });
                        // console.log('FCM Setup Tracing: Token FCM berhasil diset sebagai array baru.');
                    }
                } else {
                    // Jika dokumen pengguna tidak ada, buat dengan token
                    // console.log("FCM Setup Tracing: Dokumen pengguna tidak ada, membuat dokumen baru.");
                    await setDoc(userDocRef, {
                        fcmTokens: [token],
                        userId: currentUser.uid,
                    });
                    // console.log('FCM Setup Tracing: Dokumen pengguna baru dibuat dengan token FCM.');
                }
            };

            // Dapatkan token saat ini dan simpan. getToken() sekarang menangani penyegaran token secara otomatis.
            // console.log("FCM Setup Tracing: Mendapatkan token FCM saat ini...");
            const currentToken = await getToken(messaging, {
                vapidKey: 'BPtO3HkOiixfygEF4vLcTYbhVGEKZzf-CGgXPG1Y4J0zXhsPehRvjQLzQwe2fLvc6yI2bKwi2er9kqKFeb7CHbs',
            });

            if (currentToken) {
                // console.log('FCM Setup Tracing: Token FCM ditemukan. Memanggil saveToken.');
                await saveToken(currentToken);
            } else {
                // console.log('FCM Setup Tracing: Tidak ada token registrasi yang tersedia.');
            }
        } else {
            // console.log('FCM Setup Tracing: Izin notifikasi ditolak.');
        }
    } catch (err) {
        // console.error('FCM Setup Tracing: Terjadi kesalahan selama inisialisasi FCM:', err);
    }
};

const getAnnouncementsCollectionPath = (rtProfileId) => `artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/announcements`;
const getResidentNotificationsCollectionPath = (userId) => `artifacts/${appIdForPaths}/users/${userId}/notifications`;

// --- NEW FCM CLOUD FUNCTION CALLABLE ---

// --- Halaman Pengurus: Manajemen Pengumuman ---
const ManageAnnouncementsPage = () => {
    const functions = getFunctions(app, 'us-central1');
    const sendFCMNotification = httpsCallable(functions, 'sendFCMNotification');
    const { rtProfileId, currentUser } = useAuth();

    const [announcements, setAnnouncements] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    // State untuk form tambah/edit
    const [showForm, setShowForm] = useState(false);
    const [editingAnnouncement, setEditingAnnouncement] = useState(null);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // --- State untuk Pagination (LENGKAP) ---
    const [currentPage, setCurrentPage] = useState(1);
    const [lastVisibleDoc, setLastVisible] = useState(null);
    const [pageHistory, setPageHistory] = useState([null]);
    const [isLastPage, setIsLastPage] = useState(false);
    const ANNOUNCEMENTS_PER_PAGE = 5;

    const fetchAnnouncementsPage = useCallback(async (page, direction, cursor) => {
        if (!rtProfileId) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        setError('');

        try {
            const announcementsPath = getAnnouncementsCollectionPath(rtProfileId);
            let q;

            if (direction === 'next' && cursor) {
                q = query(collection(db, announcementsPath), orderBy("createdAt", "desc"), startAfter(cursor), limit(ANNOUNCEMENTS_PER_PAGE));
            } else {
                q = query(collection(db, announcementsPath), orderBy("createdAt", "desc"), limit(ANNOUNCEMENTS_PER_PAGE));
            }

            const documentSnapshots = await getDocs(q);
            const announcementsData = documentSnapshots.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            if (!documentSnapshots.empty) {
                setAnnouncements(announcementsData);
                const newFirstVisible = documentSnapshots.docs[0];
                const newLastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];

                setLastVisible(newLastVisible);
                if (direction === 'next') {
                    setPageHistory(prev => ([...prev, newFirstVisible]));
                } else if (page === 1) {
                    setPageHistory([null]);
                }

                const checkLastPageQuery = query(collection(db, announcementsPath), orderBy("createdAt", "desc"), startAfter(newLastVisible), limit(1));
                const nextDoc = await getDocs(checkLastPageQuery);
                setIsLastPage(nextDoc.empty);
            } else {
                if (direction === 'next') setIsLastPage(true);
                else setAnnouncements([]);
            }
        } catch (err) {
            console.error("Error fetching announcements page:", err);
            setError("Gagal memuat data pengumuman.");
        } finally {
            setIsLoading(false);
        }
    }, [rtProfileId, ANNOUNCEMENTS_PER_PAGE]);

    useEffect(() => {
        fetchAnnouncementsPage(1, 'first', null);
    }, [fetchAnnouncementsPage]);

    const handleNextPage = () => {
        if (isLastPage) return;
        const nextPageNum = currentPage + 1;
        setCurrentPage(nextPageNum);
        fetchAnnouncementsPage(nextPageNum, 'next', lastVisibleDoc);
    };

    const handlePrevPage = () => {
        if (currentPage <= 1) return;
        const prevPageNum = currentPage - 1;
        setCurrentPage(prevPageNum);
        fetchAnnouncementsPage(prevPageNum, 'prev', pageHistory[prevPageNum - 1]);
    };

    const resetForm = () => {
        setTitle('');
        setContent('');
        setEditingAnnouncement(null);
        setShowForm(false);
        setError('');
    };

    const handleEdit = (ann) => {
        setEditingAnnouncement(ann);
        setTitle(ann.title);
        setContent(ann.content);
        setShowForm(true);
        window.scrollTo(0, 0);
    };

    const handleDelete = async (id, annTitle) => {
        if (!window.confirm(`Yakin ingin menghapus pengumuman "${annTitle}"?`)) return;
        setIsSubmitting(true);
        try {
            const annPath = getAnnouncementsCollectionPath(rtProfileId);
            await deleteDoc(doc(db, annPath, id));
            setCurrentPage(1);
            fetchAnnouncementsPage(1, 'first', null);
        } catch (err) {
            setError("Gagal menghapus pengumuman.");
        }
        setIsSubmitting(false);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!title.trim() || !content.trim()) {
            setError("Judul dan isi pengumuman tidak boleh kosong.");
            return;
        }
        setIsSubmitting(true);
        setError('');
        const announcementsPath = getAnnouncementsCollectionPath(rtProfileId);
        try {
            if (editingAnnouncement) {
                const annRef = doc(db, announcementsPath, editingAnnouncement.id);
                await updateDoc(annRef, { title: title.trim(), content: content.trim(), updatedAt: Timestamp.now() });
            } else {
                // --- PERBAIKAN UTAMA DI SINI ---
                // Tambahkan dokumen pengumuman baru
                await addDoc(collection(db, announcementsPath), {
                    title: title.trim(),
                    content: content.trim(),
                    authorName: currentUser.email,
                    authorUid: currentUser.uid,
                    createdAt: Timestamp.now(),
                    updatedAt: Timestamp.now(),
                    rtProfileId: rtProfileId,
                });

                // --- PANGGIL FUNGSI BACKEND BARU UNTUK NOTIFIKASI ---
                await sendFCMNotification({
                    rtProfileId: rtProfileId,
                    title: `Pengumuman Baru dari RT ${rtProfileId}`,
                    body: title.trim()
                });
            }
            resetForm();
            setCurrentPage(1);
            fetchAnnouncementsPage(1, 'first', null);
        } catch (err) {
            setError("Gagal menyimpan pengumuman.");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isLoading && announcements.length === 0) return <div className={cardStyle}><LoadingSpinner /><p className="text-center">Memuat pengumuman...</p></div>;

    return (
        <div className={cardStyle}>
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-semibold text-slate-700">Manajemen Pengumuman (RT: {rtProfileId})</h2>
                <button onClick={() => { resetForm(); setShowForm(!showForm); }} className={primaryButtonStyle}>
                    {showForm ? 'Batal' : 'Buat Pengumuman Baru'}
                </button>
            </div>
            {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}

            {showForm && (
                <form onSubmit={handleFormSubmit} className="mb-6 p-4 border rounded-md bg-slate-50 space-y-4">
                    <h3 className="text-lg font-medium">{editingAnnouncement ? `Edit Pengumuman: "${editingAnnouncement.title}"` : "Pengumuman Baru"}</h3>
                    <div><label htmlFor="annTitle" className="block text-sm font-medium text-slate-600">Judul *</label><input type="text" id="annTitle" value={title} onChange={(e) => setTitle(e.target.value)} className={commonInputStyle} required /></div>
                    <div><label htmlFor="annContent" className="block text-sm font-medium text-slate-600">Isi Pengumuman *</label><textarea id="annContent" value={content} onChange={(e) => setContent(e.target.value)} rows="5" className={commonInputStyle} required></textarea></div>
                    <div className="flex gap-2"><button type="submit" className={primaryButtonStyle} disabled={isSubmitting}>{isSubmitting ? <LoadingSpinner /> : (editingAnnouncement ? 'Update Pengumuman' : 'Publikasikan')}</button><button type="button" onClick={resetForm} className={secondaryButtonStyle}>Batal</button></div>
                </form>
            )}

            <div className="space-y-3 mt-6">
                {isLoading ? <LoadingSpinner /> : (
                    announcements.length > 0 ? announcements.map(ann => (
                        <div key={ann.id} className="p-4 border rounded-md bg-slate-50">
                            <div className="flex justify-between items-start">
                                <div>
                                    <h4 className="font-semibold text-sky-600">{ann.title}</h4>
                                    <p className="text-xs text-slate-400 mb-2">Dibuat: {ann.createdAt?.toDate().toLocaleString('id-ID', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                                    <p className="text-sm text-slate-600 whitespace-pre-wrap">{ann.content}</p>
                                </div>
                                <div className="flex-shrink-0 ml-4 space-x-2">
                                    <button onClick={() => handleEdit(ann)} className="text-xs py-1 px-2 bg-yellow-400 hover:bg-yellow-500 text-yellow-800 rounded-md">Edit</button>
                                    <button onClick={() => handleDelete(ann.id, ann.title)} className="text-xs py-1 px-2 bg-red-400 hover:bg-red-500 text-white rounded-md" disabled={isSubmitting}>Hapus</button>
                                </div>
                            </div>
                        </div>
                    )) : <p className="text-center text-slate-500">Belum ada pengumuman untuk RT ini.</p>
                )}
            </div>

            {(announcements.length > 0 || currentPage > 1) && (
                <div className="flex justify-between items-center mt-6">
                    <button
                        onClick={handlePrevPage}
                        className={secondaryButtonStyle}
                        disabled={currentPage === 1 || isLoading}
                    >
                        &laquo; Sebelumnya
                    </button>
                    <span className="text-sm text-slate-500">Halaman {currentPage}</span>
                    <button
                        onClick={handleNextPage}
                        className={primaryButtonStyle}
                        disabled={isLastPage || isLoading}
                    >
                        Selanjutnya &raquo;
                    </button>
                </div>
            )}
        </div>
    );
};


// --- StatCard (untuk Laporan) ---
// const StatCard = ({ title, value, color = "text-slate-700", icon }) => (
//     <div className="bg-slate-50 p-4 rounded-lg shadow">
//         {icon && <div className="text-2xl text-sky-500 mb-1">{icon}</div>}
//         <h4 className="text-sm font-medium text-slate-500 uppercase">{title}</h4>
//         <p className={`text-2xl font-semibold ${color}`}>{value}</p>
//     </div>
// );

// --- FinancialReportsPage ---
// const FinancialReportsPage = () => {
//     const { appConfig, loadingAppConfig, rtProfileId } = useAuth();
//     const [reportMonth, setReportMonth] = useState(new Date().getMonth());
//     const [reportYear, setReportYear] = useState(CURRENT_YEAR);
//     const [loading, setLoading] = useState(false);
//     const [reportData, setReportData] = useState(null);
//     const [error, setError] = useState('');
//     const [totalHouseholds, setTotalHouseholds] = useState(0);
//     const [householdsMap, setHouseholdsMap] = useState({});
//     const [initialDataLoading, setInitialDataLoading] = useState(true);

//     useEffect(() => {
//         const fetchInitialReportData = async () => {
//             if (loadingAppConfig || !rtProfileId) { // Tunggu appConfig dan rtProfileId
//                 setInitialDataLoading(loadingAppConfig || !rtProfileId); // Tetap loading jika salah satu belum ada
//                 if (!rtProfileId && !loadingAppConfig) { // Jika appConfig ada tapi rtProfileId tidak (misal super admin)
//                     setError("Pilih Profil RT untuk melihat laporan keuangan spesifik.");
//                 }
//                 return;
//             }
//             setInitialDataLoading(true);
//             setError('');
//             try {
//                 const householdsQuery = query(collection(db, getHouseholdsCollectionPath(rtProfileId)));
//                 const householdsSnap = await getDocs(householdsQuery);
//                 setTotalHouseholds(householdsSnap.size);
//                 const hhMap = {};
//                 householdsSnap.forEach(d => { hhMap[d.id] = d.data(); });
//                 setHouseholdsMap(hhMap);

//             } catch (err) {
//                 console.error("Error fetching initial report data (households):", err);
//                 setError("Gagal memuat data rumah untuk laporan. Error: " + err.message);
//             }
//             setInitialDataLoading(false);
//         };
//         fetchInitialReportData();
//     }, [loadingAppConfig, rtProfileId]);

//     const generateReport = async () => {
//         if (!appConfig || !rtProfileId) {
//             setError("Konfigurasi aplikasi atau Profil RT belum termuat. Tidak bisa membuat laporan.");
//             return;
//         }
//         const currentRtConfig = appConfig.rtProfiles?.[rtProfileId] || appConfig; // Ambil config RT atau global
//         if (totalHouseholds === 0 && currentRtConfig.monthlyDues === 0) {
//             setError("Data rumah atau konfigurasi iuran belum ada. Tidak bisa membuat laporan.");
//             return;
//         }
//         setLoading(true);
//         setError('');
//         setReportData(null);
//         const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";

//         const currentReportMonth = parseInt(reportMonth);
//         const currentReportYear = parseInt(reportYear);

//         const startDate = new Date(currentReportYear, currentReportMonth, 1);
//         const endDate = new Date(currentReportYear, currentReportMonth + 1, 0, 23, 59, 59);

//         try {
//             let paymentsQueryBase = query(
//                 collection(db, getPaymentsCollectionPath(rtProfileId)),
//                 where("status", "==", "approved"),
//                 where("paymentYear", "==", currentReportYear),
//                 where("paymentMonth", "==", currentReportMonth + 1)
//             );
//             if (currentMode === "testing") {
//                 paymentsQueryBase = query(paymentsQueryBase, where("mode", "==", "testing"));
//             } else {
//                 paymentsQueryBase = query(paymentsQueryBase, where("mode", "!=", "testing"));
//             }
//             const paymentsSnapshot = await getDocs(paymentsQueryBase);
//             const monthlyPayments = paymentsSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));

//             const totalIncomeMonthByDuesType = monthlyPayments.reduce((acc, p) => {
//                 const type = p.duesType || "Iuran Rutin";
//                 acc[type] = (acc[type] || 0) + p.amount;
//                 return acc;
//             }, {});
//             const totalIncomeMonth = Object.values(totalIncomeMonthByDuesType).reduce((sum, amount) => sum + amount, 0);

//             const paidHouseholdsThisMonthSet = new Set(monthlyPayments.filter(p => p.duesType === "Iuran Rutin").map(p => p.houseId));
//             const paidHouseholdsThisMonthCount = paidHouseholdsThisMonthSet.size;

//             let expensesQueryBase = query(
//                 collection(db, getExpensesCollectionPath(rtProfileId)),
//                 where("tanggalPengeluaran", ">=", Timestamp.fromDate(startDate)),
//                 where("tanggalPengeluaran", "<=", Timestamp.fromDate(endDate))
//             );
//             if (currentMode === "testing") {
//                 expensesQueryBase = query(expensesQueryBase, where("mode", "==", "testing"));
//             } else {
//                 expensesQueryBase = query(expensesQueryBase, where("mode", "!=", "testing"));
//             }
//             const expensesQuery = query(expensesQueryBase, orderBy("tanggalPengeluaran", "desc"));

//             const expensesSnapshot = await getDocs(expensesQuery);
//             const monthlyExpensesDocs = expensesSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));

//             const totalExpensesMonthBySource = monthlyExpensesDocs.reduce((acc, e) => {
//                 const source = e.expenseSource || "Kas Umum/Rutin";
//                 acc[source] = (acc[source] || 0) + e.jumlah;
//                 return acc;
//             }, {});
//             const totalExpensesMonth = Object.values(totalExpensesMonthBySource).reduce((sum, amount) => sum + amount, 0);

//             const expectedIncomeMonth = totalHouseholds * (currentRtConfig.monthlyDues || 0);
//             const unpaidHouseholdsMonthCount = totalHouseholds - paidHouseholdsThisMonthCount;
//             const shortfallMonth = expectedIncomeMonth - (totalIncomeMonthByDuesType["Iuran Rutin"] || 0);

//             let allApprovedPaymentsQueryBase = query(collection(db, getPaymentsCollectionPath(rtProfileId)), where("status", "==", "approved"));
//             if (currentMode === "testing") {
//                 allApprovedPaymentsQueryBase = query(allApprovedPaymentsQueryBase, where("mode", "==", "testing"));
//             } else {
//                 allApprovedPaymentsQueryBase = query(allApprovedPaymentsQueryBase, where("mode", "!=", "testing"));
//             }
//             const allApprovedPaymentsSnap = await getDocs(allApprovedPaymentsQueryBase);

//             const cumulativeIncomeByDuesType = allApprovedPaymentsSnap.docs.reduce((acc, docSnap) => {
//                 const p = docSnap.data();
//                 const type = p.duesType || "Iuran Rutin";
//                 acc[type] = (acc[type] || 0) + p.amount;
//                 return acc;
//             }, {});
//             const cumulativeIncome = Object.values(cumulativeIncomeByDuesType).reduce((sum, amount) => sum + amount, 0);

//             let allExpensesQueryBase = query(collection(db, getExpensesCollectionPath(rtProfileId)));
//             if (currentMode === "testing") {
//                 allExpensesQueryBase = query(allExpensesQueryBase, where("mode", "==", "testing"));
//             } else {
//                 allExpensesQueryBase = query(allExpensesQueryBase, where("mode", "!=", "testing"));
//             }
//             const allExpensesSnap = await getDocs(allExpensesQueryBase);

//             const cumulativeExpensesBySource = allExpensesSnap.docs.reduce((acc, docSnap) => {
//                 const e = docSnap.data();
//                 const source = e.expenseSource || "Kas Umum/Rutin";
//                 acc[source] = (acc[source] || 0) + e.jumlah;
//                 return acc;
//             }, {});
//             const cumulativeExpenses = Object.values(cumulativeExpensesBySource).reduce((sum, amount) => sum + amount, 0);

//             let cumulativeExpectedRoutineIncome = 0;
//             const systemStartDate = new Date(currentRtConfig.systemStartYear, currentRtConfig.systemStartMonth, 1);
//             const reportPeriodEndDateForCumulative = new Date(currentReportYear, currentReportMonth + 1, 0);

//             if (systemStartDate <= reportPeriodEndDateForCumulative && totalHouseholds > 0 && currentRtConfig.monthlyDues > 0) {
//                 let tempDate = new Date(systemStartDate);
//                 while (tempDate <= reportPeriodEndDateForCumulative) {
//                     cumulativeExpectedRoutineIncome += totalHouseholds * currentRtConfig.monthlyDues;
//                     tempDate.setMonth(tempDate.getMonth() + 1);
//                 }
//             }
//             const cumulativeRoutineShortfall = cumulativeExpectedRoutineIncome - (cumulativeIncomeByDuesType["Iuran Rutin"] || 0);

//             setReportData({
//                 totalIncomeMonth, totalIncomeMonthByDuesType,
//                 totalExpensesMonth, totalExpensesMonthBySource,
//                 paidHouseholdsThisMonthCount, unpaidHouseholdsMonthCount,
//                 expectedIncomeMonth, shortfallMonth,
//                 cumulativeIncome, cumulativeIncomeByDuesType,
//                 cumulativeExpenses, cumulativeExpensesBySource,
//                 cumulativeExpectedRoutineIncome, cumulativeRoutineShortfall,
//                 detailedPayments: monthlyPayments,
//                 detailedExpenses: monthlyExpensesDocs,
//             });

//         } catch (err) {
//             console.error("Error generating report:", err);
//             setError("Gagal membuat laporan: " + err.message);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const formatCurrency = (amount) => `Rp ${amount != null ? amount.toLocaleString('id-ID') : '0'}`;
//     const getHouseIdentifier = (houseId) => householdsMap[houseId]?.houseIdentifier || houseId || "Rumah Dihapus";

//     const exportToCSV = () => {
//         if (!reportData) {
//             setError("Silakan buat laporan terlebih dahulu sebelum mengekspor.");
//             return;
//         }
//         const currentRtConfig = appConfig.rtProfiles?.[rtProfileId] || appConfig;
//         const currentMode = currentRtConfig.isTestingMode ? "TESTING" : "LIVE";
//         let csvContent = "data:text/csv;charset=utf-8,";
//         csvContent += `Laporan Keuangan RT ${rtProfileId || 'Global'} - ${MONTHS[reportMonth]} ${reportYear} (Mode: ${currentMode})\n\n`;

//         csvContent += "Ringkasan Bulan Ini\nDeskripsi,Jumlah\n";
//         csvContent += `Total Uang Masuk,${reportData.totalIncomeMonth}\n`;
//         Object.entries(reportData.totalIncomeMonthByDuesType || {}).forEach(([type, amount]) => {
//             csvContent += `  Pemasukan ${type.replace(/,/g, '')},${amount}\n`;
//         });
//         csvContent += `Total Uang Keluar,${reportData.totalExpensesMonth}\n`;
//         Object.entries(reportData.totalExpensesMonthBySource || {}).forEach(([source, amount]) => {
//             csvContent += `  Pengeluaran dari ${source.replace(/,/g, '')},${amount}\n`;
//         });
//         csvContent += `Saldo Bulan Ini,${reportData.totalIncomeMonth - reportData.totalExpensesMonth}\n`;
//         csvContent += `Warga Sudah Bayar (Iuran Rutin),${reportData.paidHouseholdsThisMonthCount} dari ${totalHouseholds}\n`;
//         csvContent += `Target Iuran Rutin Bulan Ini,${reportData.expectedIncomeMonth}\n`;
//         csvContent += `Kekurangan Iuran Rutin Bulan Ini,${reportData.shortfallMonth}\n\n`;

//         csvContent += `Ringkasan Kumulatif (Hingga Akhir ${MONTHS[reportMonth]} ${reportYear})\nDeskripsi,Jumlah\n`;
//         csvContent += `Total Semua Iuran Masuk,${reportData.cumulativeIncome}\n`;
//         Object.entries(reportData.cumulativeIncomeByDuesType || {}).forEach(([type, amount]) => {
//             csvContent += `  Total Pemasukan ${type.replace(/,/g, '')},${amount}\n`;
//         });
//         csvContent += `Total Semua Pengeluaran,${reportData.cumulativeExpenses}\n`;
//         Object.entries(reportData.cumulativeExpensesBySource || {}).forEach(([source, amount]) => {
//             csvContent += `  Total Pengeluaran dari ${source.replace(/,/g, '')},${amount}\n`;
//         });
//         csvContent += `Saldo Kas Keseluruhan,${reportData.cumulativeIncome - reportData.cumulativeExpenses}\n`;
//         csvContent += `Target Iuran Rutin Seharusnya (Kumulatif),${reportData.cumulativeExpectedRoutineIncome}\n`;
//         csvContent += `Total Kekurangan Iuran Rutin (Kumulatif),${reportData.cumulativeRoutineShortfall}\n\n`;

//         csvContent += `Rincian Iuran Masuk Disetujui - ${MONTHS[reportMonth]} ${reportYear}\nNo. Rumah,Jenis Iuran,Tanggal Setuju,Jumlah\n`;
//         reportData.detailedPayments.forEach(p => {
//             csvContent += `"${getHouseIdentifier(p.houseId)}","${(p.duesType || 'Iuran Rutin').replace(/,/g, '')}","${p.approvalTimestamp?.toDate().toLocaleDateString('id-ID') || 'N/A'}",${p.amount}\n`;
//         });
//         csvContent += "\n";

//         csvContent += `Rincian Pengeluaran - ${MONTHS[reportMonth]} ${reportYear}\nTanggal,Jenis Kegiatan,Sumber Dana,Deskripsi,Jumlah\n`;
//         reportData.detailedExpenses.forEach(exp => {
//             csvContent += `${exp.tanggalPengeluaran.toDate().toLocaleDateString('id-ID')},"${exp.jenisKegiatan.replace(/,/g, '')}","${(exp.expenseSource || 'Kas Umum/Rutin').replace(/,/g, '')}","${(exp.deskripsi || '-').replace(/,/g, '')}",${exp.jumlah}\n`;
//         });

//         const encodedUri = encodeURI(csvContent);
//         const link = document.createElement("a");
//         link.setAttribute("href", encodedUri);
//         link.setAttribute("download", `Laporan Keuangan RT ${rtProfileId || 'Global'} - ${MONTHS[reportMonth]} ${reportYear} - Mode ${currentMode}.csv`);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     if (initialDataLoading || loadingAppConfig) return <div className={cardStyle}><LoadingSpinner /><p className="text-center">Memuat data laporan...</p></div>;
//     if (!appConfig && !loadingAppConfig) return <div className={cardStyle}><MessageBox message="Konfigurasi aplikasi tidak termuat. Tidak bisa menampilkan laporan." type="error" /></div>;
//     if (!rtProfileId && appConfig) {
//         return <div className={cardStyle}><p className="text-center text-slate-500">Admin RT tidak terasosiasi dengan Profil RT yang valid untuk melihat laporan.</p></div>;
//     }

//     return (
//         <div className={cardStyle}>
//             <h2 className="text-2xl font-semibold text-slate-700 mb-6">Laporan Keuangan (RT: {rtProfileId})</h2>
//             {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}
//             <div className="grid md:grid-cols-3 gap-4 mb-6 p-4 border rounded-md bg-slate-50 items-end">
//                 <div>
//                     <label htmlFor="reportMonth" className="block text-sm font-medium text-slate-700">Bulan</label>
//                     <select id="reportMonth" value={reportMonth} onChange={e => setReportMonth(parseInt(e.target.value))} className={commonInputStyle}>
//                         {MONTHS.map((m, i) => <option key={i} value={i}>{m}</option>)}
//                     </select>
//                 </div>
//                 <div>
//                     <label htmlFor="reportYear" className="block text-sm font-medium text-slate-700">Tahun</label>
//                     <select id="reportYear" value={reportYear} onChange={e => setReportYear(parseInt(e.target.value))} className={commonInputStyle}>
//                         {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
//                     </select>
//                 </div>
//                 <button onClick={generateReport} className={`${primaryButtonStyle} h-10`} disabled={loading || (totalHouseholds === 0 && (appConfig.rtProfiles?.[rtProfileId] || appConfig).monthlyDues === 0)}>
//                     {loading ? <LoadingSpinner /> : "Buat Laporan"}
//                 </button>
//             </div>

//             {(totalHouseholds === 0 && (appConfig.rtProfiles?.[rtProfileId] || appConfig).monthlyDues === 0 && !loading) && <MessageBox message="Data rumah atau konfigurasi iuran belum ada. Lengkapi di Pengaturan atau Kelola Data Rumah." type="error" />}

//             {reportData && (<button onClick={exportToCSV} className={`${secondaryButtonStyle} mb-4`}>Ekspor ke CSV</button>)}

//             {reportData && (
//                 <div className="space-y-6 mt-2">
//                     <h3 className="text-xl font-semibold text-slate-700 mb-3">Ringkasan - {MONTHS[reportMonth]} ${reportYear} (Mode: {(appConfig.rtProfiles?.[rtProfileId] || appConfig).isTestingMode ? "TESTING" : "LIVE"})</h3>
//                     <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
//                         <StatCard title="Total Uang Masuk Bulan Ini" value={formatCurrency(reportData.totalIncomeMonth)} icon="📥" />
//                         {Object.entries(reportData.totalIncomeMonthByDuesType || {}).map(([type, amount]) =>
//                             <StatCard key={`income-${type}`} title={`Pemasukan ${type}`} value={formatCurrency(amount)} />
//                         )}
//                         <StatCard title="Total Uang Keluar Bulan Ini" value={formatCurrency(reportData.totalExpensesMonth)} color="text-red-500" icon="📤" />
//                         {Object.entries(reportData.totalExpensesMonthBySource || {}).map(([source, amount]) =>
//                             <StatCard key={`expense-${source}`} title={`Pengeluaran dari ${source}`} value={formatCurrency(amount)} color="text-red-400" />
//                         )}
//                         <StatCard title="Saldo Bulan Ini" value={formatCurrency(reportData.totalIncomeMonth - reportData.totalExpensesMonth)} color={(reportData.totalIncomeMonth - reportData.totalExpensesMonth) >= 0 ? "text-green-500" : "text-red-500"} icon="💰" />
//                         <StatCard title="Warga Sudah Bayar (Iuran Rutin)" value={`${reportData.paidHouseholdsThisMonthCount} dari ${totalHouseholds}`} icon="👨‍👩‍👧‍👦✔️" />
//                         <StatCard title="Target Iuran Rutin Bulan Ini" value={formatCurrency(reportData.expectedIncomeMonth)} icon="🎯" />
//                         <StatCard title="Kekurangan Iuran Rutin Bulan Ini" value={formatCurrency(reportData.shortfallMonth)} color={reportData.shortfallMonth > 0 ? "text-red-500" : "text-green-500"} icon="📉" />
//                     </div>

//                     <h3 className="text-xl font-semibold text-slate-700 mb-3 mt-8">Ringkasan Kumulatif (Hingga Akhir {MONTHS[reportMonth]} ${reportYear}, Mode: {(appConfig.rtProfiles?.[rtProfileId] || appConfig).isTestingMode ? "TESTING" : "LIVE"})</h3>
//                     <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
//                         <StatCard title="Total Semua Iuran Masuk" value={formatCurrency(reportData.cumulativeIncome)} icon="🏦" />
//                         {Object.entries(reportData.cumulativeIncomeByDuesType || {}).map(([type, amount]) =>
//                             <StatCard key={`cum-income-${type}`} title={`Total Pemasukan ${type}`} value={formatCurrency(amount)} />
//                         )}
//                         <StatCard title="Total Semua Pengeluaran" value={formatCurrency(reportData.cumulativeExpenses)} color="text-red-500" icon="💸" />
//                         {Object.entries(reportData.cumulativeExpensesBySource || {}).map(([source, amount]) =>
//                             <StatCard key={`cum-expense-${source}`} title={`Total Pengeluaran dari ${source}`} value={formatCurrency(amount)} color="text-red-400" />
//                         )}
//                         <StatCard title="Saldo Kas Keseluruhan" value={formatCurrency(reportData.cumulativeIncome - reportData.cumulativeExpenses)} color={(reportData.cumulativeIncome - reportData.cumulativeExpenses) >= 0 ? "text-green-500" : "text-red-500"} icon="🏛️" />
//                         <StatCard title="Target Iuran Rutin Seharusnya (Kumulatif)" value={formatCurrency(reportData.cumulativeExpectedRoutineIncome)} icon="📈" />
//                         <StatCard title="Total Kekurangan Iuran Rutin (Kumulatif)" value={formatCurrency(reportData.cumulativeRoutineShortfall)} color={reportData.cumulativeRoutineShortfall > 0 ? "text-red-500" : "text-green-500"} icon="📊" />
//                     </div>

//                     <div className="mt-6">
//                         <h3 className="text-lg font-semibold text-slate-600 mb-2">Rincian Iuran Masuk Disetujui - {MONTHS[reportMonth]} ${reportYear}</h3>
//                         {reportData.detailedPayments.length === 0 ? <p className="text-slate-500">Tidak ada iuran masuk yang disetujui bulan ini.</p> : (
//                             <div className="overflow-x-auto"><table className="min-w-full divide-y divide-slate-200 text-sm">
//                                 <thead className="bg-slate-50"><tr>
//                                     <th className="px-3 py-2 text-left font-medium text-slate-500 uppercase">Rumah</th>
//                                     <th className="px-3 py-2 text-left font-medium text-slate-500 uppercase">Jenis Iuran</th>
//                                     <th className="px-3 py-2 text-left font-medium text-slate-500 uppercase">Tgl Setuju</th>
//                                     <th className="px-3 py-2 text-right font-medium text-slate-500 uppercase">Jumlah</th>
//                                 </tr></thead>
//                                 <tbody className="bg-white divide-y divide-slate-200">
//                                     {reportData.detailedPayments.map(p => (<tr key={p.id}>
//                                         <td className="px-3 py-2">{getHouseIdentifier(p.houseId)}</td>
//                                         <td className="px-3 py-2">{p.duesType || "Iuran Rutin"}</td>
//                                         <td className="px-3 py-2">{p.approvalTimestamp?.toDate().toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' }) || 'N/A'}</td>
//                                         <td className="px-3 py-2 text-right">{formatCurrency(p.amount)}</td>
//                                     </tr>))}
//                                 </tbody>
//                             </table></div>
//                         )}
//                     </div>

//                     <div className="mt-6">
//                         <h3 className="text-lg font-semibold text-slate-600 mb-2">Rincian Pengeluaran - {MONTHS[reportMonth]} ${reportYear}</h3>
//                         {reportData.detailedExpenses.length === 0 ? <p className="text-slate-500">Tidak ada pengeluaran bulan ini.</p> : (
//                             <div className="overflow-x-auto"><table className="min-w-full divide-y divide-slate-200 text-sm">
//                                 <thead className="bg-slate-50"><tr>
//                                     <th className="px-3 py-2 text-left font-medium text-slate-500 uppercase">Tanggal</th>
//                                     <th className="px-3 py-2 text-left font-medium text-slate-500 uppercase">Jenis Kegiatan</th>
//                                     <th className="px-3 py-2 text-left font-medium text-slate-500 uppercase">Sumber Dana</th>
//                                     <th className="px-3 py-2 text-left font-medium text-slate-500 uppercase">Deskripsi</th>
//                                     <th className="px-3 py-2 text-right font-medium text-slate-500 uppercase">Jumlah</th>
//                                 </tr></thead>
//                                 <tbody className="bg-white divide-y divide-slate-200">
//                                     {reportData.detailedExpenses.map(exp => (<tr key={exp.id}>
//                                         <td className="px-3 py-2">{exp.tanggalPengeluaran.toDate().toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' })}</td>
//                                         <td className="px-3 py-2">{exp.jenisKegiatan}</td>
//                                         <td className="px-3 py-2">{exp.expenseSource || "Kas Umum/Rutin"}</td>
//                                         <td className="px-3 py-2">{exp.deskripsi || '-'}</td>
//                                         <td className="px-3 py-2 text-right">{formatCurrency(exp.jumlah)}</td>
//                                     </tr>))}
//                                 </tbody>
//                             </table></div>
//                         )}
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// --- Komponen Modal Konfirmasi yang Bisa Dipakai Ulang ---
const ConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    children,
    confirmText = "Konfirmasi",
    cancelText = "Batal",
    isConfirming = false
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center backdrop-blur-sm p-4 animate-fade-in">
            <div className="bg-white p-6 rounded-2xl shadow-xl max-w-sm w-full mx-auto">
                <h3 className="text-xl font-bold text-slate-800">{title}</h3>
                <div className="text-sm text-slate-600 my-4 space-y-2">
                    {children}
                </div>
                <div className="flex justify-end gap-3 mt-6">
                    <button onClick={onClose} className={secondaryButtonStyle} disabled={isConfirming}>
                        {cancelText}
                    </button>
                    <button onClick={onConfirm} className={primaryButtonStyle} disabled={isConfirming}>
                        {isConfirming ? <LoadingSpinner /> : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

// --- StatCard (untuk Laporan) ---
const StatCard = ({ title, value, color = "text-slate-700", icon, description }) => (
    <div className="bg-white p-4 rounded-xl shadow-md">
        <div className="flex items-center space-x-3">
            {icon && <div className={`text-2xl ${color}`}>{icon}</div>}
            <div>
                <h4 className="text-sm font-semibold text-slate-500 uppercase">{title}</h4>
                <p className={`text-2xl font-bold ${color}`}>{value}</p>
                {description && <p className="text-xs text-slate-400">{description}</p>}
            </div>
        </div>
    </div>
);


// --- FinancialReportsPage (FINAL - UX Sesuai Permintaan) ---
const FinancialReportsPage = () => {
    const { appConfig, rtProfileId } = useAuth();
    const [transactions, setTransactions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [expandedDisbursementId, setExpandedDisbursementId] = useState(null);
    const [allTemplates, setAllTemplates] = useState({});
    const [allBills, setAllBills] = useState([]);
    const [householdsMap, setHouseholdsMap] = useState({});
    // --- STATE BARU UNTUK PROSES DISBURSEMENT ---
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [isDisbursing, setIsDisbursing] = useState(false);
    const [disburseMessage, setDisburseMessage] = useState({ text: '', type: '' });
    const [billsMap, setBillsMap] = useState(new Map());

    useEffect(() => {
        if (!rtProfileId || !appConfig) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        const currentRtConfig = appConfig.rtProfiles?.[rtProfileId] || {};
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";
        const unsubscribers = [];

        // --- TAMBAHKAN LISTENER BARU UNTUK HOUSEHOLDS ---
        const householdsQuery = query(collection(db, getHouseholdsCollectionPath(rtProfileId)));
        const unsubHouseholds = onSnapshot(householdsQuery, (snapshot) => {
            const hhMap = {};
            snapshot.docs.forEach(doc => {
                hhMap[doc.id] = doc.data();
            });
            setHouseholdsMap(hhMap);
        }, (err) => { console.error("Error fetching households map:", err); });

        // 1. Ambil data households dan occupancies terlebih dahulu untuk membuat peta
        const fetchHouseholdAndPayerData = async () => {
            try {
                const householdsPath = getHouseholdsCollectionPath(rtProfileId);
                const householdsSnap = await getDocs(query(collection(db, householdsPath)));
                const householdsData = {};
                householdsSnap.forEach(doc => {
                    householdsData[doc.id] = doc.data();
                });

                const occupanciesPath = getOccupanciesCollectionPath(rtProfileId);
                const payersQuery = query(collection(db, occupanciesPath), where("status", "==", "ACTIVE"), where("isPayer", "==", true));
                const payersSnap = await getDocs(payersQuery);

                const payerMap = {};
                payersSnap.forEach(doc => {
                    const payerData = doc.data();
                    payerMap[payerData.householdId] = payerData.headOfFamilyName;
                });

                // Gabungkan data: prioritaskan nama dari payer, fallback ke nama di household
                const finalHouseholdMap = {};
                Object.keys(householdsData).forEach(houseId => {
                    finalHouseholdMap[houseId] = {
                        ...householdsData[houseId],
                        occupantName: payerMap[houseId] || householdsData[houseId].occupantName || 'N/A'
                    };
                });
                setHouseholdsMap(finalHouseholdMap);

            } catch (err) {
                console.error("Error fetching household/payer map:", err);
            }
        };

        fetchHouseholdAndPayerData();

        unsubscribers.push(unsubHouseholds);

        // Listener untuk Pemasukan (Payments)
        const paymentsQuery = query(collection(db, getPaymentsCollectionPath(rtProfileId)), where("status", "==", "approved"), where("mode", "==", currentMode));
        const unsubPayments = onSnapshot(paymentsQuery, (snapshot) => {
            const paymentsData = snapshot.docs.map(doc => ({
                id: doc.id, type: 'payment', date: doc.data().approvalTimestamp.toDate(),
                description: doc.data().isParentBill ? `Pembayaran Gabungan (${doc.data().relatedBillIds?.length || 0} item)` : `Iuran ${doc.data().duesType || 'Tidak Diketahui'}`,
                amount: doc.data().amount, ...doc.data()
            }));
            setTransactions(prev => [...paymentsData, ...prev.filter(t => t.type !== 'payment')]);
            setIsLoading(false);
        }, (err) => { setError("Gagal memuat data pemasukan."); setIsLoading(false); });
        unsubscribers.push(unsubPayments);

        // Listener untuk Pengeluaran (Expenses)
        const expensesQuery = query(collection(db, getExpensesCollectionPath(rtProfileId)), where("mode", "==", currentMode));
        const unsubExpenses = onSnapshot(expensesQuery, (snapshot) => {
            const expensesData = snapshot.docs.map(doc => ({
                id: doc.id, type: 'expense', date: doc.data().createdAt.toDate(),
                description: doc.data().jenisKegiatan, amount: -doc.data().jumlah, ...doc.data()
            }));
            setTransactions(prev => [...expensesData, ...prev.filter(t => t.type !== 'expense')]);
            setIsLoading(false);
        }, (err) => { setError("Gagal memuat data pengeluaran."); setIsLoading(false); });
        unsubscribers.push(unsubExpenses);

        // Listener untuk Data Disbursement
        const getDisbursementsCollectionPath = (rtId) => `artifacts/${appIdForPaths}/public/data/rtProfiles/${rtId}/disbursements`;
        const disbursementsQuery = query(collection(db, getDisbursementsCollectionPath(rtProfileId)), orderBy("timestamp", "desc"));
        const unsubDisbursements = onSnapshot(disbursementsQuery, (snapshot) => {
            const disbursementsData = snapshot.docs.map(doc => ({
                id: doc.id, type: 'disbursement', date: doc.data().timestamp.toDate(),
                description: `Penarikan Dana ke ${doc.data().destinationBankAccount?.bankCode || 'Bank'}`,
                amount: doc.data().netAmountReceived, ...doc.data()
            }));
            setTransactions(prev => [...disbursementsData, ...prev.filter(t => t.type !== 'disbursement')]);
            setIsLoading(false);
        }, (err) => { setError("Gagal memuat data penarikan dana."); setIsLoading(false); });
        unsubscribers.push(unsubDisbursements);

        return () => unsubscribers.forEach(unsub => unsub());

    }, [rtProfileId, appConfig]);

    // --- useEffect BARU: KHUSUS MENGAMBIL SEMUA TAGIHAN UNTUK REFERENSI ---
    useEffect(() => {
        if (!rtProfileId) return;

        const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId] || {};
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";

        const billsPath = getBillsCollectionPath(rtProfileId);
        // Query ini mengambil SEMUA tagihan, tidak peduli statusnya, sesuai mode.
        const q = query(collection(db, billsPath), where("mode", "==", currentMode));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const newBillsMap = new Map();
            snapshot.docs.forEach(doc => {
                // Kunci peta adalah ID tagihan, nilainya adalah seluruh data tagihan
                newBillsMap.set(doc.id, { id: doc.id, ...doc.data() });
            });
            setBillsMap(newBillsMap);
            // console.log(`[FinancialReports] billsMap berhasil diperbarui dengan ${newBillsMap.size} item.`);
        }, (err) => {
            console.error("Gagal mengambil data bills untuk lookup:", err);
        });

        return () => unsubscribe();
    }, [rtProfileId, appConfig]);

    const formatBillPeriodForDisplay = (bill) => {
        // Fungsi ini tidak berubah
        const template = allTemplates[bill.duesTemplateId];
        if (!template) return `${MONTHS[bill.paymentMonth - 1]} ${bill.paymentYear}`;
        const periodType = template.period;
        const monthIndex = bill.paymentMonth - 1;
        const year = bill.paymentYear;
        switch (periodType) {
            case 'triwulan':
                if (monthIndex >= 0 && monthIndex <= 2) return `Triwulan 1 (${year})`;
                if (monthIndex >= 3 && monthIndex <= 5) return `Triwulan 2 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 8) return `Triwulan 3 (${year})`;
                if (monthIndex >= 9 && monthIndex <= 11) return `Triwulan 4 (${year})`;
                return `Triwulan Tidak Valid`;
            case 'semester':
                if (monthIndex >= 0 && monthIndex <= 5) return `Semester 1 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 11) return `Semester 2 (${year})`;
                return `Semester Tidak Valid`;
            case 'tahunan':
                return `Tahunan (${year})`
            case 'sekali bayar':
                return `Sekali Bayar (${year})`;
            default: return `${MONTHS[monthIndex]} ${year}`;
        }
    };

    const formatBillPeriodForDisplayMerge = (bill) => {
        // Fungsi ini tidak berubah
        const template = allTemplates[bill.duesTemplateId];
        if (!template) return `${MONTHS[bill.billPeriodMonth - 1]} ${bill.billPeriodYear}`;
        const periodType = template.period;
        const monthIndex = bill.billPeriodMonth - 1;
        const year = bill.billPeriodYear;
        switch (periodType) {
            case 'triwulan':
                if (monthIndex >= 0 && monthIndex <= 2) return `Triwulan 1 (${year})`;
                if (monthIndex >= 3 && monthIndex <= 5) return `Triwulan 2 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 8) return `Triwulan 3 (${year})`;
                if (monthIndex >= 9 && monthIndex <= 11) return `Triwulan 4 (${year})`;
                return `Triwulan Tidak Valid`;
            case 'semester':
                if (monthIndex >= 0 && monthIndex <= 5) return `Semester 1 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 11) return `Semester 2 (${year})`;
                return `Semester Tidak Valid`;
            case 'tahunan':
                return `Tahunan (${year})`
            case 'sekali bayar':
                return `Sekali Bayar (${year})`;
            default: return `${MONTHS[monthIndex]} ${year}`;
        }
    };

    // 1. Fungsi ini HANYA untuk membuka modal konfirmasi
    // --- FUNGSI handleOpenDisburseModal YANG DIPERBARUI ---
    const handleOpenDisburseModal = () => {
        // 1. Cek apakah sedang dalam mode testing
        // console.log('cek tarik currentRtConfig.isTestingMde:' + currentRtConfig.isTestingMode);
        // console.log('cek tarik appConfig.isTestingMode:' + appConfig.isTestingMode);
        if (currentRtConfig?.isTestingMode === true) {
            // 2. Jika ya, tampilkan pesan informasi, JANGAN buka modal
            setDisburseMessage({
                text: "Fitur Tarik Dana tidak tersedia dalam Mode Testing. Pencairan dana hanya dapat dilakukan untuk data transaksi 'live'.",
                type: 'info'
            });
            return; // Hentikan eksekusi
        }

        // 3. Jika tidak dalam mode testing, lanjutkan alur seperti biasa
        const { digitalBalance } = financialSummary;
        if (digitalBalance === 0) {
            setDisburseMessage({ text: "Tidak ada saldo digital yang bisa ditarik.", type: 'info' });
            return;
        }
        setIsConfirmModalOpen(true);
        setDisburseMessage({ text: '', type: '' });
    };

    // 2. Fungsi ini akan dipanggil dari DALAM MODAL untuk eksekusi
    const executeDisbursement = async () => {
        setIsDisbursing(true);
        setDisburseMessage({ text: 'Memproses penarikan dana...', type: 'info' });

        try {
            const functions = getFunctions(app, 'us-central1');
            const triggerDisbursement = httpsCallable(functions, 'triggerDisbursement');
            const result = await triggerDisbursement({ rtId: rtProfileId });
            setDisburseMessage({ text: result.data.message || 'Penarikan dana berhasil diproses.', type: 'success' });
        } catch (error) {
            console.error("Error triggering disbursement:", error);
            setDisburseMessage({ text: `Gagal: ${error.message}`, type: 'error' });
        } finally {
            setIsDisbursing(false);
            setIsConfirmModalOpen(false); // Tutup modal setelah selesai
        }
    };

    const financialSummary = useMemo(() => {
        // Buat billsMap di sini agar selalu up-to-date dengan `transactions`
        // const allBills = transactions.filter(t => t.type === 'payment' || t.type === 'bill'); // Asumsi bills juga ada di transactions atau diambil terpisah
        // const billsMap = new Map(allBills.map(b => [b.id, b]));

        const disbursementTransactions = transactions.filter(t => t.type === 'disbursement');
        const totalIncome = transactions.filter(t => t.type === 'payment').reduce((acc, curr) => acc + curr.amount, 0);
        const totalExpenses = transactions.filter(t => t.type === 'expense').reduce((acc, curr) => acc + Math.abs(curr.amount), 0);
        const totalDisbursementFees = disbursementTransactions
            .filter(t => t.status === 'COMPLETED')
            .reduce((acc, curr) => acc + (curr.serviceFee || 0), 0);
        const totalCash = totalIncome - totalExpenses - totalDisbursementFees;
        const digitalBalanceAvailable = transactions
            .filter(t => t.type === 'payment' && t.paymentMethod === 'QRIS' && t.isDisbursed !== true)
            .reduce((acc, curr) => acc + curr.amount, 0);
        const pendingDisbursementBalance = disbursementTransactions
            .filter(t => t.status === 'PENDING')
            .reduce((acc, curr) => acc + (curr.grossAmount || 0), 0);
        const physicalBalance = totalCash - digitalBalanceAvailable - pendingDisbursementBalance;

        const disbursedPaymentIds = new Set(
            transactions
                .filter(t => t.type === 'disbursement' && Array.isArray(t.paymentIds))
                .flatMap(d => d.paymentIds)
        );

        const mainTransactionList = transactions.filter(t => {
            if (t.type === 'payment' && t.paymentMethod === 'QRIS') {
                return !disbursedPaymentIds.has(t.id);
            }
            return true;
        });
        const sortedTransactions = mainTransactionList.sort((a, b) => b.date - a.date);

        return {
            physicalBalance,
            digitalBalance: digitalBalanceAvailable,
            pendingDisbursementBalance,
            totalExpenses,
            totalCash,
            sortedTransactions, // <-- Pastikan billsMap dikembalikan
        };
    }, [transactions]); // Dependensi tetap pada transactions

    useEffect(() => {
        if (financialSummary.sortedTransactions.length > 0) {
            const latestTransaction = financialSummary.sortedTransactions[0];
            if (latestTransaction.type === 'disbursement') {
                setExpandedDisbursementId(latestTransaction.id);
            }
        }
    }, [financialSummary.sortedTransactions]);

    const handleTransactionClick = (transaction) => {
        if (transaction.type === 'disbursement') {
            setExpandedDisbursementId(prevId => prevId === transaction.id ? null : transaction.id);
        }
    };

    // --- FUNGSI BARU UNTUK MENANGANI PENARIKAN DANA ---
    const handleDisburse = async () => {
        const { digitalBalance } = financialSummary;
        if (digitalBalance === 0) {
            alert("Tidak ada saldo digital yang bisa ditarik.");
            return;
        }

        const confirmation = window.confirm(
            `Anda akan menarik seluruh saldo digital sebesar ${formatCurrency(digitalBalance)}.\n\n` +
            `Biaya layanan akan dikenakan dan jumlah bersih yang akan ditransfer ke rekening RT.\n\nLanjutkan?`
        );

        if (!confirmation) return;

        setIsDisbursing(true);
        setDisburseMessage({ text: 'Memproses penarikan dana...', type: 'info' });

        try {
            const functions = getFunctions(app, 'us-central1');
            const triggerDisbursement = httpsCallable(functions, 'triggerDisbursement');

            const result = await triggerDisbursement({ rtId: rtProfileId });

            setDisburseMessage({ text: result.data.message || 'Penarikan dana berhasil diproses.', type: 'success' });
        } catch (error) {
            console.error("Error triggering disbursement:", error);
            setDisburseMessage({ text: `Gagal: ${error.message}`, type: 'error' });
        } finally {
            setIsDisbursing(false);
        }
    };

    const formatCurrency = (amount) => `Rp ${amount != null ? amount.toLocaleString('id-ID') : '0'}`;

    if (isLoading) return <div className={cardStyle}><LoadingSpinner /></div>;
    if (error) return <div className={cardStyle}><MessageBox message={error} type="error" /></div>;

    const currentRtConfig = appConfig.rtProfiles?.[rtProfileId] || {};
    const canDisburse = currentRtConfig.canPerformOnDemandDisbursement === true;
    const fastDisbursementFee = appConfig.fastDisbursementFee || 7000;
    // ... sisa return JSX ...
    return (
        <div className={cardStyle}>
            <MessageBox message={disburseMessage.text} type={disburseMessage.type} onClose={() => setDisburseMessage({ text: '', type: '' })} />
            <div className="p-4 border rounded-lg bg-slate-50 space-y-4">
                <h3 className="text-lg font-semibold text-slate-600">Rincian Saldo Kas</h3>
                <StatCard
                    title="Saldo di Kas/Rekening RT"
                    value={formatCurrency(financialSummary.physicalBalance)}
                    icon="💼"
                    description="Dari iuran tunai & dana QRIS yang sudah ditarik"
                />

                {/* --- KARTU BARU UNTUK SALDO YANG SEDANG DIPROSES --- */}
                {financialSummary.pendingDisbursementBalance > 0 && (
                    <StatCard
                        title="Saldo Sedang Diproses"
                        value={formatCurrency(financialSummary.pendingDisbursementBalance)}
                        color="text-yellow-600"
                        icon="🕒"
                        description="Menunggu konfirmasi berhasil dari bank"
                    />
                )}

                <div className="bg-white p-4 rounded-xl shadow-md">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center space-x-3">
                            <div className="text-2xl">📱</div>
                            <div>
                                <h4 className="text-sm font-semibold text-slate-500 uppercase">Saldo Digital (Tersedia)</h4>
                                <p className="text-2xl font-bold text-slate-700">{formatCurrency(financialSummary.digitalBalance)}</p>
                                <p className="text-xs text-slate-400">Dana dari QRIS, siap untuk ditarik</p>
                            </div>
                        </div>
                        {canDisburse && (
                            <button
                                onClick={handleOpenDisburseModal}
                                className={`${primaryButtonStyle} disabled:bg-slate-400 disabled:cursor-not-allowed`}
                                disabled={financialSummary.digitalBalance === 0 || isDisbursing}
                                title={financialSummary.digitalBalance === 0 ? "Tidak ada saldo digital untuk ditarik" : "Tarik Dana Cepat"}
                            >
                                {isDisbursing ? <LoadingSpinner /> : 'Tarik Dana Cepat'}
                            </button>
                        )}
                    </div>
                </div>
            </div>

            <div className="mt-8">
                <h3 className="text-lg font-semibold text-slate-600 mb-3">Riwayat Transaksi Digital (Siap tarik dan Sudah ditarik)</h3>
                <div className="space-y-2">
                    {financialSummary.sortedTransactions.slice(0, 10).map(t => {
                        const isDisbursement = t.type === 'disbursement';
                        const isPayment = t.type === 'payment';
                        const isExpense = t.type === 'expense';
                        const isExpanded = expandedDisbursementId === t.id;

                        const houseInfo = t.houseId ? householdsMap[t.houseId] : null;

                        // --- LOGIKA BARU UNTUK MENENTUKAN TAMPILAN BERDASARKAN STATUS ---
                        let statusText = '';
                        let statusColor = '';
                        let icon = ' K'; // Default

                        // Buat deskripsi yang lebih informatif
                        let primaryDesc = t.description;
                        let secondaryDesc = houseInfo ? `Rumah ${houseInfo.houseIdentifier} (${houseInfo.occupantName || 'N/A'})` : '';

                        if (isPayment) {
                            icon = '📥';
                            statusColor = 'text-green-600';
                            if (t.relatedBillIds) {
                                // --- LOGIKA BARU UNTUK MEMBUAT RINGKASAN PERIODE ---
                                const childBillDetails = (t.relatedBillIds || [])
                                    .map(id => transactions.find(p => p.id === id))
                                    .filter(Boolean);

                                const periodSummary = childBillDetails
                                    .map(child => formatBillPeriodForDisplay(child))
                                    .slice(0, 2) // Ambil 2 periode pertama
                                    .join(', ');

                                const finalSummary = childBillDetails.length > 2 ? `${periodSummary}, ...` : periodSummary;

                                primaryDesc = t.description; // Contoh: "Pembayaran Gabungan (2 item)"
                                secondaryDesc = `${finalSummary} - ${secondaryDesc}`; // Tambahkan ringkasan periode di deskripsi sekunder

                            } else {
                                // Logika untuk pembayaran tunggal (tidak berubah)
                                primaryDesc = `Iuran ${t.duesType}`;
                                secondaryDesc = `${formatBillPeriodForDisplay(t)} - ${secondaryDesc}`;
                            }
                        } else if (isExpense) {
                            icon = '📤';
                            statusColor = 'text-red-600';
                        } else if (isDisbursement) {
                            switch (t.status) {
                                case 'PENDING':
                                    icon = '🕒'; // Ikon jam
                                    statusText = 'Sedang Diproses';
                                    statusColor = 'text-yellow-600';
                                    break;
                                case 'FAILED':
                                    icon = '⚠️'; // Ikon peringatan
                                    statusText = 'Gagal';
                                    statusColor = 'text-red-600';
                                    break;
                                case 'COMPLETED':
                                    icon = '🏦'; // Ikon bank
                                    statusText = 'Berhasil Diterima';
                                    statusColor = 'text-blue-600';
                                    break;
                                default:
                                    icon = '🏦';
                                    statusColor = 'text-slate-700';
                            }
                        }

                        // const houseInfo = t.houseId ? householdsMap[t.houseId] : null;
                        // let primaryDesc = t.description;
                        // let secondaryDesc = houseInfo ? `Rumah ${houseInfo.houseIdentifier} (${houseInfo.occupantName || 'N/A'})` : '';


                        return (
                            <div key={t.id} className="bg-white rounded-lg shadow-sm border overflow-hidden">
                                <div
                                    className={`flex items-center p-3 transition-colors ${isDisbursement ? 'cursor-pointer hover:bg-slate-50' : ''}`}
                                    onClick={() => handleTransactionClick(t)}
                                >
                                    <div className="mr-4 text-2xl">{t.type === 'payment' ? '📥' : t.type === 'expense' ? '📤' : '🏦'}</div>
                                    <div className="flex-grow">
                                        {/* --- TAMPILAN DESKRIPSI BARU --- */}
                                        <p className="font-semibold">{primaryDesc}</p>
                                        {secondaryDesc && <p className="text-xs text-slate-500">{secondaryDesc}</p>}
                                        <p className="text-xs text-slate-400">{t.type === 'payment' ? t.paymentMethod : null}</p>

                                        {/* Tampilkan status HANYA untuk disbursement */}
                                        {isDisbursement && (
                                            <span className={`text-xs font-bold ${statusColor}`}>{statusText}</span>
                                        )}
                                        <p className="text-xs text-slate-400 mt-1">{t.date.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                                    </div>
                                    <p className={`font-bold ${t.type === 'payment' ? 'text-green-600' : 'text-slate-700'
                                        }`}>
                                        {t.type === 'payment' ? '+' : ''}{formatCurrency(Math.abs(t.amount))}
                                    </p>
                                </div>

                                {isExpanded && (
                                    <div className="bg-slate-100 p-4 border-t border-slate-200">
                                        <h5 className="font-bold text-sm mb-2 text-slate-700">Rincian Penarikan</h5>
                                        <div className="space-y-1 text-sm">
                                            <div className="flex justify-between"><span>Total Dana Ditarik</span><span className="font-medium">{formatCurrency(t.grossAmount)}</span></div>
                                            <div className="flex justify-between text-red-600"><span>Biaya Layanan</span><span className="font-medium">- {formatCurrency(t.serviceFee)}</span></div>
                                            <hr className="my-1 border-slate-300" />
                                            <div className="flex justify-between font-bold"><span>Dana Diterima di Rekening</span><span>{formatCurrency(t.netAmountReceived)}</span></div>
                                        </div>

                                        <h5 className="font-bold text-sm mt-4 pt-2 border-t ...">Termasuk {t.paymentIds?.length || 0} Pembayaran QRIS:</h5>
                                        <div className="space-y-2 text-xs max-h-40 overflow-y-auto">
                                            {transactions
                                                .filter(p => t.paymentIds?.includes(p.id))
                                                .map(p => {
                                                    const paymentHouseInfo = householdsMap[p.houseId];
                                                    let detailDesc = '';
                                                    let secondaryDetailDesc = '';
                                                    let thirdDetailDesc = '';
                                                    // --- PERBAIKAN UTAMA DI SINI ---
                                                    // Gunakan p.relatedBillIds sebagai penanda yang pasti
                                                    if (p.relatedBillIds && p.relatedBillIds.length > 0) {
                                                        // Jika ini pembayaran gabungan, buat ringkasan periode
                                                        const periodSummary = p.relatedBillIds.map(billId => {
                                                            // Cari detail tagihan di `billsMap` dari state
                                                            const billDetail = billsMap.get(billId);
                                                            // console.log('billDetail:', billDetail);
                                                            // Panggil formatBillPeriodForDisplay dengan data bill yang lengkap
                                                            return billDetail ? formatBillPeriodForDisplayMerge(billDetail) : null;
                                                        }).filter(Boolean).join(', ');

                                                        detailDesc = `Pembayaran Gabungan: ${periodSummary}`;
                                                    } else {
                                                        // Jika pembayaran tunggal, format seperti biasa
                                                        detailDesc = `Iuran ${p.duesType} (${formatBillPeriodForDisplay(p)})`;
                                                    }
                                                    secondaryDetailDesc = p.date ? `Dibuat pada ${p.date.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}` : '';
                                                    thirdDetailDesc = `${p.paymentMethod}`
                                                    // --- AKHIR PERBAIKAN ---


                                                    return (
                                                        <div key={p.id} className="flex justify-between items-center border-b pb-1">
                                                            <div>
                                                                <p className="font-semibold">{detailDesc}</p>
                                                                {secondaryDetailDesc && <p className="text-xs text-slate-500">{secondaryDetailDesc}</p>}
                                                                {thirdDetailDesc && <p className="text-xs text-slate-500">{thirdDetailDesc}</p>}
                                                                <p className="text-slate-500">
                                                                    {paymentHouseInfo ? `Rumah ${paymentHouseInfo.houseIdentifier}` : 'Info rumah tidak ada'}
                                                                </p>
                                                            </div>
                                                            <span className="font-mono text-green-600">+{formatCurrency(p.amount)}</span>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>
            {/* --- Render Modal Konfirmasi di sini --- */}
            <ConfirmationModal
                isOpen={isConfirmModalOpen}
                onClose={() => setIsConfirmModalOpen(false)}
                onConfirm={executeDisbursement}
                title="Konfirmasi Penarikan Dana"
                confirmText="Ya, Lanjutkan Penarikan"
                isConfirming={isDisbursing}
            >
                <p className="mb-4">Anda akan menarik seluruh saldo digital yang tersedia. Dana akan ditransfer ke rekening RT terdaftar setelah dipotong biaya layanan.</p>
                <div className="text-left text-sm bg-slate-100 p-3 rounded-lg border space-y-1">
                    <div className="flex justify-between">
                        <span>Total Saldo Digital</span>
                        <span className="font-medium">{formatCurrency(financialSummary.digitalBalance)}</span>
                    </div>
                    <div className="flex justify-between text-red-600">
                        <span>Biaya Layanan</span>
                        <span className="font-medium">- {formatCurrency(fastDisbursementFee)}</span>
                    </div>
                    <hr className="my-1 !mt-2 !mb-2 border-slate-300" />
                    <div className="flex justify-between font-bold text-base">
                        <span>Jumlah Diterima di Rekening</span>
                        <span>{formatCurrency(financialSummary.digitalBalance - fastDisbursementFee)}</span>
                    </div>
                </div>
            </ConfirmationModal>
        </div>
    );
};

// --- Komponen TransactionReportsPage (FINAL - Dengan Riwayat Disbursement) ---
const TransactionReportsPage = () => {
    const { rtProfileId, appConfig } = useAuth();

    // State untuk data mentah
    const [payments, setPayments] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [disbursements, setDisbursements] = useState([]); // <-- State baru
    const [allBills, setAllBills] = useState([]);
    const [duesTemplates, setDuesTemplates] = useState([]);
    const [householdsMap, setHouseholdsMap] = useState({});
    const [allTemplates, setAllTemplates] = useState({});

    // State untuk filter
    const [filterYear, setFilterYear] = useState(new Date().getFullYear());
    const [filterMonth, setFilterMonth] = useState('ALL');
    const [filterDuesType, setFilterDuesType] = useState('ALL');

    // State untuk export
    const [isExporting, setIsExporting] = useState(false);

    // State untuk UI
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [expandedDisbursementId, setExpandedDisbursementId] = useState(null);

    const formatCurrency = (amount) => `Rp ${amount != null ? amount.toLocaleString('id-ID') : '0'}`;
    const handleTransactionClick = (transaction) => {
        if (transaction.type === 'disbursement') {
            setExpandedDisbursementId(prevId => prevId === transaction.id ? null : transaction.id);
        }
    };

    const getDisbursementsCollectionPath = (rtId) => `artifacts/${appIdForPaths}/public/data/rtProfiles/${rtId}/disbursements`;

    const formatBillPeriodForDisplay = (bill) => {
        // Fungsi ini tidak berubah
        const template = allTemplates[bill.duesTemplateId];
        if (!template) return `${MONTHS[bill.paymentMonth - 1]} ${bill.paymentYear}`;
        const periodType = template.period;
        const monthIndex = bill.paymentMonth - 1;
        const year = bill.paymentYear;
        switch (periodType) {
            case 'triwulan':
                if (monthIndex >= 0 && monthIndex <= 2) return `Triwulan 1 (${year})`;
                if (monthIndex >= 3 && monthIndex <= 5) return `Triwulan 2 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 8) return `Triwulan 3 (${year})`;
                if (monthIndex >= 9 && monthIndex <= 11) return `Triwulan 4 (${year})`;
                return `Triwulan Tidak Valid`;
            case 'semester':
                if (monthIndex >= 0 && monthIndex <= 5) return `Semester 1 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 11) return `Semester 2 (${year})`;
                return `Semester Tidak Valid`;
            case 'tahunan':
                return `Tahunan (${year})`
            case 'sekali bayar':
                return `Sekali Bayar (${year})`;
            default: return `${MONTHS[monthIndex]} ${year}`;
        }
    };

    const formatBillPeriodForDisplayMerge = (bill) => {
        // Fungsi ini tidak berubah
        const template = allTemplates[bill.duesTemplateId];
        if (!template) return `${MONTHS[bill.billPeriodMonth - 1]} ${bill.billPeriodYear}`;
        const periodType = template.period;
        const monthIndex = bill.billPeriodMonth - 1;
        const year = bill.billPeriodYear;
        switch (periodType) {
            case 'triwulan':
                if (monthIndex >= 0 && monthIndex <= 2) return `Triwulan 1 (${year})`;
                if (monthIndex >= 3 && monthIndex <= 5) return `Triwulan 2 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 8) return `Triwulan 3 (${year})`;
                if (monthIndex >= 9 && monthIndex <= 11) return `Triwulan 4 (${year})`;
                return `Triwulan Tidak Valid`;
            case 'semester':
                if (monthIndex >= 0 && monthIndex <= 5) return `Semester 1 (${year})`;
                if (monthIndex >= 6 && monthIndex <= 11) return `Semester 2 (${year})`;
                return `Semester Tidak Valid`;
            case 'tahunan':
                return `Tahunan (${year})`
            case 'sekali bayar':
                return `Sekali Bayar (${year})`;
            default: return `${MONTHS[monthIndex]} ${year}`;
        }
    };

    // Mengambil semua data yang relevan
    useEffect(() => {
        if (!rtProfileId) { setIsLoading(false); return; }

        const currentRtConfig = appConfig.rtProfiles?.[rtProfileId] || {};
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";
        const unsubscribers = [];

        const fetchData = async () => {
            setIsLoading(true);
            try {
                // --- PERBAIKAN: Tambahkan disbursements ke daftar fetch ---
                const collectionsToFetch = [
                    getDocs(query(collection(db, getPaymentsCollectionPath(rtProfileId)), where("status", "==", "approved"), where("mode", "==", currentMode))),
                    getDocs(query(collection(db, getExpensesCollectionPath(rtProfileId)), where("mode", "==", currentMode))),
                    getDocs(query(collection(db, getDisbursementsCollectionPath(rtProfileId)))), // <-- AMBIL DISBURSEMENT
                    getDocs(query(collection(db, getBillsCollectionPath(rtProfileId)), where("mode", "==", currentMode))),
                    getDocs(query(collection(db, getDuesTemplatesCollectionPath(rtProfileId)))),
                    getDocs(query(collection(db, getHouseholdsCollectionPath(rtProfileId)))),
                ];

                const [
                    paymentsSnap, expensesSnap, disbursementsSnap,
                    billsSnap, templatesSnap, householdsSnap
                ] = await Promise.all(collectionsToFetch);

                // Update semua state dengan data baru
                setPayments(paymentsSnap.docs.map(doc => ({ ...doc.data(), id: doc.id, date: doc.data().approvalTimestamp.toDate(), type: 'payment' })));
                setExpenses(expensesSnap.docs.map(doc => ({ ...doc.data(), id: doc.id, amount: -doc.data().jumlah, date: doc.data().createdAt.toDate(), type: 'expense' })));
                setDisbursements(disbursementsSnap.docs.map(doc => ({ ...doc.data(), id: doc.id, date: doc.data().timestamp.toDate(), type: 'disbursement' })));
                setAllBills(billsSnap.docs.map(doc => ({ ...doc.data(), id: doc.id })));
                setDuesTemplates(templatesSnap.docs.map(doc => ({ ...doc.data(), id: doc.id })));
                const tmplMap = {};
                templatesSnap.forEach(doc => { tmplMap[doc.id] = doc.data(); });
                setAllTemplates(tmplMap);
                const hhMap = {};
                // householdsSnap.forEach(doc => { hhMap[doc.id] = doc.data(); });
                // setHouseholdsMap(hhMap);

                const fetchHouseholdAndPayerData = async () => {
                    try {
                        const householdsPath = getHouseholdsCollectionPath(rtProfileId);
                        const householdsSnap = await getDocs(query(collection(db, householdsPath)));
                        const householdsData = {};
                        householdsSnap.forEach(doc => {
                            householdsData[doc.id] = doc.data();
                        });

                        const occupanciesPath = getOccupanciesCollectionPath(rtProfileId);
                        const payersQuery = query(collection(db, occupanciesPath), where("status", "==", "ACTIVE"), where("isPayer", "==", true));
                        const payersSnap = await getDocs(payersQuery);

                        const payerMap = {};
                        payersSnap.forEach(doc => {
                            const payerData = doc.data();
                            payerMap[payerData.householdId] = payerData.headOfFamilyName;
                        });

                        // Gabungkan data: prioritaskan nama dari payer, fallback ke nama di household
                        const finalHouseholdMap = {};
                        Object.keys(householdsData).forEach(houseId => {
                            finalHouseholdMap[houseId] = {
                                ...householdsData[houseId],
                                occupantName: payerMap[houseId] || householdsData[houseId].occupantName || 'N/A'
                            };
                        });
                        setHouseholdsMap(finalHouseholdMap);

                    } catch (err) {
                        console.error("Error fetching household/payer map:", err);
                    }
                };

                fetchHouseholdAndPayerData();

            } catch (err) {
                setError("Gagal memuat data laporan.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [rtProfileId, appConfig]);

    // "Otak" kalkulasi laporan
    const reportData = useMemo(() => {
        if (isLoading) return null;

        const billsMap = new Map(allBills.map(b => [b.id, b]));

        // Filter transaksi berdasarkan filter utama
        const filterStartDate = new Date(filterYear, filterMonth === 'ALL' ? 0 : filterMonth - 1, 1);
        const filterEndDate = new Date(filterYear, filterMonth === 'ALL' ? 11 : filterMonth - 1, 31, 23, 59, 59);

        // const paymentsInPeriod = payments.filter(p =>
        //     p.date >= filterStartDate && p.date <= filterEndDate &&
        //     (filterDuesType === 'ALL' || p.duesTemplateId === filterDuesType)
        // );
        // --- AWAL PERBAIKAN LOGIKA FILTER ---
        const paymentsInPeriod = payments.filter(p => {
            const paymentDate = p.date;
            const matchesYear = paymentDate.getFullYear() === filterYear;
            const matchesMonth = (filterMonth === 'ALL' || (paymentDate.getMonth() + 1) === filterMonth);

            if (!matchesYear || !matchesMonth) return false;

            if (filterDuesType === 'ALL') return true;

            if (p.relatedBillIds) { // Untuk pembayaran gabungan
                return p.relatedBillIds.some(billId => billsMap.get(billId)?.duesTemplateId === filterDuesType);
            } else { // Untuk pembayaran tunggal
                return p.duesTemplateId === filterDuesType;
            }
        });
        // --- AKHIR PERBAIKAN LOGIKA FILTER ---
        const expensesInPeriod = expenses.filter(e => e.date >= filterStartDate && e.date <= filterEndDate);
        const disbursementsInPeriod = disbursements.filter(d => d.date >= filterStartDate && d.date <= filterEndDate);

        // Kalkulasi untuk "Kas pada Periode Ini"
        const incomeInPeriod = paymentsInPeriod.reduce((acc, p) => acc + p.amount, 0);
        const expenseInPeriod = expensesInPeriod.reduce((acc, e) => acc + Math.abs(e.amount), 0);
        const netCashInPeriod = incomeInPeriod - expenseInPeriod;

        // Kalkulasi untuk "Total Kas Hingga Akhir Periode"
        const cumulativeIncome = payments.filter(p => p.date <= filterEndDate).reduce((acc, p) => acc + p.amount, 0);
        const cumulativeExpenses = expenses.filter(e => e.date <= filterEndDate).reduce((acc, e) => acc + Math.abs(e.amount), 0);
        const totalCash = cumulativeIncome - cumulativeExpenses;

        // Gabungkan dan urutkan transaksi untuk ditampilkan di riwayat
        const historyForDisplay = [...paymentsInPeriod, ...expensesInPeriod, ...disbursementsInPeriod]
            .sort((a, b) => b.date - a.date);

        return { netCashInPeriod, totalCash, historyForDisplay, billsMap };
    }, [isLoading, payments, expenses, disbursements, allBills, filterYear, filterMonth, filterDuesType]);

    // ... sisa handler (formatCurrency, formatBillPeriodForDisplay) ...

    // --- FUNGSI BARU UNTUK EXPORT KE CSV ---
    const handleExportToCSV = () => {
        if (!reportData || reportData.historyForDisplay.length === 0) {
            alert("Tidak ada data untuk diunduh pada filter yang dipilih.");
            return;
        }

        setIsExporting(true);

        // Fungsi helper untuk membersihkan data dari koma
        const escapeCsvCell = (cell) => {
            const strCell = String(cell || '');
            if (strCell.includes(',')) {
                return `"${strCell.replace(/"/g, '""')}"`;
            }
            return strCell;
        };

        let csvContent = "data:text/csv;charset=utf-8,";

        // Menambahkan Header Laporan
        const monthName = filterMonth === 'ALL' ? `Tahun` : MONTHS[filterMonth - 1];
        // console.log('monthName', monthName);
        csvContent += `Laporan Transaksi RT ${rtProfileId} - Periode ${monthName} ${filterYear}\n`;
        csvContent += `Jenis Iuran: ${filterDuesType === 'ALL' ? 'Semua' : duesTemplates.find(t => t.id === filterDuesType)?.name || 'N/A'}\n\n`;

        // Menambahkan Ringkasan
        csvContent += "RINGKASAN\n";
        csvContent += `Saldo Kas pada Periode,Rp ${reportData.netCashInPeriod}\n`;
        csvContent += `Total Kas s/d Akhir Periode,Rp ${reportData.totalCash}\n\n`;

        // Menambahkan Header Tabel Transaksi
        csvContent += "RINCIAN TRANSAKSI\n";
        const headers = ["Tanggal", "Tipe", "Deskripsi", "Rumah", "Pembayar", "Periode Penagihan", "Jumlah (Rp)"];
        csvContent += headers.join(",") + "\n";

        // Menambahkan Baris Data Transaksi
        // reportData.historyForDisplay.forEach(t => {
        //     const type = t.type === 'payment' ? 'PEMASUKAN' : 'PENGELUARAN';
        //     const description = escapeCsvCell(t.duesType || t.jenisKegiatan);
        //     const houseIdentifier = escapeCsvCell(householdsMap[t.houseId]?.houseIdentifier || 'N/A');
        //     const date = t.date.toLocaleDateString('id-ID');
        //     const amount = t.amount;

        //     const row = [date, type, description, houseIdentifier, amount].join(",");
        //     csvContent += row + "\n";
        // });
        reportData.historyForDisplay.forEach(t => {
            let periodDetail;
            if (t.relatedBillIds) {
                const childBillDetails = (t.relatedBillIds || [])
                    .map(id => allBills.find(p => p.id === id))
                    .filter(Boolean);

                const periodSummary = childBillDetails
                    .map(child => formatBillPeriodForDisplayMerge(child))
                    .slice(0, 2) // Ambil 2 periode pertama
                    .join('|');

                const finalSummary = childBillDetails.length > 2 ? `${periodSummary}| ...` : periodSummary;
                periodDetail = finalSummary;
            } else {
                periodDetail = formatBillPeriodForDisplay(t);
            }

            const type = t.type === 'payment' ? 'PEMASUKAN' : t.type === 'expense' ? 'PENGELUARAN' : 'PENARIKAN DANA';
            const description = t.duesType || t.jenisKegiatan || t.description || `(Biaya Layanan: Rp ${t.serviceFee || 0}) - Status:${t.status || 'GAGAL'}`;
            const houseIdentifier = householdsMap[t.houseId]?.houseIdentifier || 'N/A';
            const houseName = householdsMap[t.houseId]?.occupantName || 'N/A';
            const periodSummary = t.type === 'disbursement' ? 'N/A' : periodDetail;
            const date = t.date.toLocaleDateString('id-ID');
            // Gunakan amount yang benar untuk setiap tipe
            const amount = t.type === 'disbursement' ? t.netAmountReceived : t.amount;

            const row = [date, type, description, houseIdentifier, houseName, periodSummary, amount].join(",");
            csvContent += row + "\n";
        });

        // Membuat dan memicu link download
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `laporan_transaksi_satuwarga_${filterYear}_${filterMonth}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setIsExporting(false);
    };

    if (isLoading) return <div className={cardStyle}><LoadingSpinner /></div>;
    if (error) return <MessageBox message={error} type="error" />;

    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-6">Laporan Transaksi Rinci</h2>

            {/* ... Area Filter tidak berubah ... */}
            <div className="grid md:grid-cols-3 gap-4 mb-6 p-4 border rounded-lg bg-slate-50">
                <select value={filterYear} onChange={e => setFilterYear(Number(e.target.value))} className={commonInputStyle}>
                    {YEARS.map(y => <option key={y} value={y}>Tahun {y}</option>)}
                </select>
                <select value={filterMonth} onChange={e => setFilterMonth(e.target.value === 'ALL' ? 'ALL' : Number(e.target.value))} className={commonInputStyle}>
                    <option value="ALL">Semua Bulan</option>
                    {MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
                </select>
                <select value={filterDuesType} onChange={e => setFilterDuesType(e.target.value)} className={commonInputStyle}>
                    <option value="ALL">Semua Jenis Iuran</option>
                    {duesTemplates.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                </select>
            </div>

            {/* Kartu Ringkasan (tidak berubah) */}
            {reportData && (
                <div className="grid md:grid-cols-2 gap-6 mb-8">
                    <StatCard
                        title={`Saldo Kas pada ${filterMonth === 'ALL' ? 'Tahun' : MONTHS[filterMonth - 1]} ${filterYear}`}
                        value={formatCurrency(reportData.netCashInPeriod)}
                        color={reportData.netCashInPeriod >= 0 ? 'text-green-600' : 'text-red-600'}
                        icon="📊"
                        description="Pemasukan - Pengeluaran di periode terpilih"
                    />
                    <StatCard
                        title={`Total Kas s/d Akhir ${filterMonth === 'ALL' ? 'Tahun' : MONTHS[filterMonth - 1]} ${filterYear}`}
                        value={formatCurrency(reportData.totalCash)}
                        icon="🏦"
                        description="Akumulasi saldo kas"
                    />
                </div>
            )}

            {/* --- Riwayat Transaksi --- */}
            <div className="mt-8">
                <div className="flex justify-between items-center mb-3">
                    <h3 className="text-lg font-semibold text-slate-600">Riwayat Transaksi (Sesuai Filter)</h3>
                    {/* --- TOMBOL UNDUH YANG SUDAH BERFUNGSI --- */}
                    <button
                        onClick={handleExportToCSV}
                        className={`${secondaryButtonStyle} text-sm`}
                        disabled={isExporting}
                    >
                        {isExporting ? <LoadingSpinner /> : 'Unduh Laporan (CSV)'}
                    </button>

                </div>
                <div className="space-y-2">
                    {reportData && reportData.historyForDisplay.length > 0 ? (
                        reportData.historyForDisplay.map(t => {
                            const isDisbursement = t.type === 'disbursement';
                            const isPayment = t.type === 'payment';
                            const isExpense = t.type === 'expense';
                            const isExpanded = expandedDisbursementId === t.id;

                            // Tentukan ikon, warna, dan deskripsi berdasarkan tipe transaksi
                            let icon, statusColor, primaryDesc, secondaryDesc;

                            if (isPayment) {
                                icon = '📥';
                                statusColor = 'text-green-600';
                                const houseInfo = householdsMap[t.houseId];
                                primaryDesc = `Iuran ${t.duesType}`;
                                secondaryDesc = houseInfo ? `Rumah ${houseInfo.houseIdentifier} (${houseInfo.occupantName || 'N/A'})` : '';
                                // secondaryDesc = t.relatedBillIds?.length ? secondaryDesc : `${formatBillPeriodForDisplay(t)} - ${secondaryDesc}` + ` (${t.duePeriod})`;

                                if (t.relatedBillIds) {
                                    const childBillDetails = (t.relatedBillIds || [])
                                        .map(id => allBills.find(b => b.id === id))
                                        .filter(Boolean);

                                    const periodSummary = childBillDetails
                                        .map(child => formatBillPeriodForDisplayMerge(child))
                                        .slice(0, 2) // Ambil 2 periode pertama
                                        .join(', ');

                                    const duesTemplateSummary = childBillDetails
                                        .map(child => allTemplates[child.duesTemplateId]?.name)
                                        .slice(0, 1) // Ambil 1 jenis iuran pertama

                                    const finalSummary = childBillDetails.length > 2 ? `${periodSummary}, ...` : `Iuran ${duesTemplateSummary} - ${periodSummary}`;
                                    primaryDesc = `Pembayaran Gabungan (${t.relatedBillIds?.length || 0} item)`;
                                    // secondaryDesc = `${formatBillPeriodForDisplayMerge(t)} - ${secondaryDesc}`;
                                    secondaryDesc = `:${finalSummary} - ${secondaryDesc}`;
                                } else {
                                    // secondaryDesc = `${formatBillPeriodForDisplay(t)} - ${secondaryDesc}`;
                                    secondaryDesc = `${formatBillPeriodForDisplay(t)} - ${secondaryDesc}`;
                                }
                            } else if (isDisbursement) {
                                icon = '🏦';
                                statusColor = 'text-blue-600'; // Default, akan ditimpa oleh status
                                primaryDesc = `Penarikan Dana ke ${t.destinationBankAccount?.bankCode || 'Bank'}`;
                                // amount = t.netAmountReceived;
                                secondaryDesc = `Status: ${t.status}`;

                                switch (t.status) {
                                    case 'PENDING': statusColor = 'text-yellow-600'; break;
                                    case 'FAILED': statusColor = 'text-red-600'; break;
                                    default: break;
                                }
                            } else { // Expense
                                icon = '📤';
                                statusColor = 'text-red-600';
                                primaryDesc = t.jenisKegiatan;
                                secondaryDesc = t.deskripsi;
                            }

                            return (
                                <div key={t.id} className="bg-white rounded-lg shadow-sm border overflow-hidden">
                                    <div
                                        className={`flex items-center p-3 transition-colors ${isDisbursement ? 'cursor-pointer hover:bg-slate-50' : ''}`}
                                        onClick={() => handleTransactionClick(t)}
                                    >
                                        <div className={`mr-4 text-2xl`}>{icon}</div>
                                        <div className="flex-grow">
                                            <p className="font-semibold">{primaryDesc}</p>
                                            <p className="text-xs text-slate-500">{secondaryDesc}</p>
                                            <p className="text-xs text-slate-400 mt-1">
                                                {t.date.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                            </p>
                                        </div>
                                        <p className={`font-bold ${statusColor}`}>
                                            {isPayment ? '+' : ''}{formatCurrency(isExpense ? Math.abs(t.amount) : isDisbursement ? Math.abs(t.netAmountReceived) : t.amount)}

                                        </p>
                                    </div>

                                    {isExpanded && (
                                        <div className="bg-slate-100 p-4 border-t border-slate-200">
                                            <h5 className="font-bold text-sm mb-2 text-slate-700">Rincian Penarikan</h5>
                                            <div className="space-y-1 text-sm">
                                                <div className="flex justify-between"><span>Total Dana Ditarik dari Saldo</span><span className="font-medium">{formatCurrency(t.grossAmount)}</span></div>
                                                <div className="flex justify-between text-red-600"><span>Biaya Layanan</span><span className="font-medium">- {formatCurrency(t.serviceFee)}</span></div>
                                                <hr className="my-1 border-slate-300" />
                                                <div className="flex justify-between font-bold"><span>Dana Diterima di Rekening</span><span>{formatCurrency(t.netAmountReceived)}</span></div>
                                            </div>

                                            <h5 className="font-bold text-sm mt-4 pt-2 border-t border-slate-200 mb-2">Termasuk {t.paymentIds?.length || 0} Pembayaran QRIS:</h5>
                                            <div className="space-y-2 text-xs max-h-40 overflow-y-auto">
                                                {t.paymentIds?.map(paymentId => {
                                                    const paymentDetail = payments.find(p => p.id === paymentId);
                                                    if (!paymentDetail) return null;

                                                    const paymentHouseInfo = householdsMap[paymentDetail.houseId];
                                                    let detailDesc;

                                                    if (paymentDetail.relatedBillIds) {
                                                        const periodSummary = paymentDetail.relatedBillIds.map(billId => {
                                                            const billDetail = reportData.billsMap.get(billId);
                                                            return billDetail ? formatBillPeriodForDisplayMerge(billDetail) : null;
                                                        }).filter(Boolean).join(', ');
                                                        detailDesc = `Pembayaran Gabungan: ${periodSummary || 'Periode tidak ditemukan'}`;
                                                    } else {
                                                        detailDesc = `Iuran ${paymentDetail.duesType} (${formatBillPeriodForDisplay(paymentDetail)})`;
                                                    }

                                                    return (
                                                        <div key={paymentDetail.id} className="flex justify-between items-center border-b pb-1">
                                                            <div>
                                                                <p className="font-semibold">{detailDesc}</p>
                                                                <p className="text-slate-500">{paymentHouseInfo ? `Rumah ${paymentHouseInfo.houseIdentifier} (${paymentHouseInfo.occupantName})` : 'Info rumah tidak ada'}</p>
                                                            </div>
                                                            <span className="font-mono text-green-600">+{formatCurrency(paymentDetail.amount)}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    ) : (
                        <div className="text-center text-slate-500 py-8 bg-slate-50 rounded-lg">
                            <p>Tidak ada transaksi yang cocok dengan filter yang dipilih.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// --- AppSettingsPage ---
// GANTI SELURUH KOMPONEN INI
const AppSettingsPage = () => {
    // 1. PASTIKAN refreshAppConfig DIAMBIL DARI useAuth()
    const {
        appConfig: globalAppConfig,
        loadingAppConfig,
        userRole,
        rtProfileId,
        updateSpecificRtConfig // <-- Ambil fungsi baru
    } = useAuth();

    const [appConfigData, setAppConfigData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [otpLoading, setOtpLoading] = useState(false);
    const [currentActiveOtp, setCurrentActiveOtp] = useState('');
    const [resetLoading, setResetLoading] = useState(false);
    // --- STATE BARU UNTUK FORM TESTING ---
    const [testDisbursementId, setTestDisbursementId] = useState('');
    const [isTestingWebhook, setIsTestingWebhook] = useState(false);
    // --- STATE BARU UNTUK TOMBOL TES ---
    const [isChecking, setIsChecking] = useState(false);
    const [isCheckingDisbursement, setIsCheckingDisbursement] = useState(false);
    const [isCheckingBillSubscriptionScheduler, setIsCheckingBillSubscriptionScheduler] = useState(false);
    const [shareableMessage, setShareableMessage] = useState('');
    const [rtConfig, setRtConfig] = useState(null);

    const handleTestWebhook = async (targetStatus) => {
        if (!testDisbursementId) {
            alert("Harap masukkan ID Disbursement yang akan diuji.");
            return;
        }
        setIsTestingWebhook(true);
        try {
            const functions = getFunctions(app, 'us-central1');
            const testWebhook = httpsCallable(functions, 'testDisbursementWebhook');
            const result = await testWebhook({ disbursementId: testDisbursementId, targetStatus: targetStatus });
            alert(`Sukses: ${result.data.message}`);
        } catch (error) {
            alert(`Gagal: ${error.message}`);
        } finally {
            setIsTestingWebhook(false);
        }
    };


    useEffect(() => {
        if (loadingAppConfig || !globalAppConfig) return;

        const loadPageData = async () => {
            let configForState = null;
            let activeOtp = "Memuat...";
            let rtIdForMessage = '';

            if (userRole === 'superAdmin') {
                configForState = globalAppConfig;
                try {
                    const otpSnap = await getDoc(doc(db, getAccessCodeDocPath()));
                    activeOtp = (otpSnap.exists() && otpSnap.data().isActive) ? otpSnap.data().code : "Tidak ada OTP global aktif.";
                } catch (error) {
                    activeOtp = "Gagal memuat OTP global.";
                }
            } else if (userRole === 'admin_rt' && rtProfileId && globalAppConfig.rtProfiles?.[rtProfileId]) {
                // --- AWAL PERBAIKAN ---
                // Ambil data terbaru langsung dari Firestore untuk RT yang sedang aktif
                const rtProfileRef = doc(db, getRtProfileDocPath(rtProfileId));
                const freshProfileSnap = await getDoc(rtProfileRef);
                const freshProfileData = freshProfileSnap.exists() ? freshProfileSnap.data() : {};

                // Gabungkan data terbaru dengan data global (untuk jaga-jaga jika ada config lain)
                // Data dari `freshProfileData` akan menimpa data lama di `globalAppConfig`
                configForState = { ...globalAppConfig.rtProfiles[rtProfileId], ...freshProfileData };
                // --- AKHIR PERBAIKAN ---

                // Console log sekarang akan menampilkan data yang baru saja kita ambil
                // console.log('DATA TERBARU DARI FIRESTORE:', configForState.subscriptionStatus, configForState.subscriptionValidUntil);
                rtIdForMessage = rtProfileId;
                try {
                    const rtOtpRef = doc(db, getRtSpecificAccessCodeDocPath(rtProfileId));
                    const rtOtpSnap = await getDoc(rtOtpRef);
                    activeOtp = (rtOtpSnap.exists() && rtOtpSnap.data().isActive) ? rtOtpSnap.data().code : `Tidak ada OTP aktif.`;
                } catch (error) {
                    activeOtp = `Gagal memuat OTP.`;
                }
            }
            setAppConfigData(configForState);
            setCurrentActiveOtp(activeOtp);

            // --- BUAT TEMPLATE PESAN DI SINI ---
            if (rtIdForMessage && activeOtp.length === 6) {
                const template = `*PENGUMUMAN UNTUK WARGA*\n\nAssalamualaikum Wr. Wb.\n\nUntuk mempermudah pengelolaan iuran dan informasi, RT kita sekarang menggunakan aplikasi *SATUWARGA*.\n\nSilakan akses dan masuk dengan cara berikut:\n\n1. Buka situs: *app.satuwarga.com*\n2. Masukkan Kode RT: *${rtIdForMessage}*\n3. Masukkan Kode Akses: *${activeOtp}*\n4. Pilih nomor rumah sesuai hunian Anda.\n\nTerima kasih atas perhatian dan kerja samanya.\n\n- Pengurus RT`;
                setShareableMessage(template);
            } else {
                setShareableMessage('Buat kode OTP baru untuk melihat template pesan yang bisa dibagikan.');
            }
        };

        loadPageData();
    }, [userRole, rtProfileId, globalAppConfig, loadingAppConfig]);

    // --- FUNGSI BARU UNTUK MENYALIN TEKS ---
    const handleCopyText = () => {
        navigator.clipboard.writeText(shareableMessage).then(() => {
            toast.success('Template pesan berhasil disalin!');
        }).catch(err => {
            // setMessage({ text: 'Gagal menyalin teks.', type: 'error' });
            toast.error('Gagal menyalin teks.');
        });
    };

    // --- Variabel baru untuk menentukan status langganan ---
    const isSubscribedAndActive = useMemo(() => {
        if (!appConfigData) return false;
        return appConfigData.subscriptionStatus === 'ACTIVE' &&
            appConfigData.subscriptionValidUntil &&
            appConfigData.subscriptionValidUntil.toDate() > new Date();
    }, [appConfigData]);

    // Dapatkan config RT saat ini dengan aman
    // const currentRtConfig = appConfigData.rtConfigs.find(config => config.rtId === rtProfileId);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        // Gunakan parseFloat untuk input angka agar nilainya benar
        const val = type === 'checkbox' ? checked : type === 'number' ? parseFloat(value) || 0 : value;
        setAppConfigData(prev => ({
            ...prev,
            [name]: val
        }));
    };

    const handleSave = async () => {
        setLoading(true);
        setMessage({ text: '', type: '' });
        if (!appConfigData || appConfigData.monthlyDues <= 0) {
            setMessage({ text: "Iuran bulanan harus lebih besar dari 0.", type: "error" });
            setLoading(false);
            return;
        }

        try {
            if (userRole === 'superAdmin') {
                const { rtProfiles, ...globalDataToSave } = appConfigData;
                await setDoc(doc(db, getAppConfigDocPath()), globalDataToSave, { merge: true });
            } else if (userRole === 'admin_rt' && rtProfileId) {
                const rtConfigRef = doc(db, getRtSpecificConfigDocPath(rtProfileId));
                await setDoc(rtConfigRef, appConfigData, { merge: true });

                // 2. PANGGIL FUNGSI UPDATE STATE LOKAL, BUKAN REFRESH DARI DB
                updateSpecificRtConfig(rtProfileId, appConfigData);
            }

            setMessage({ text: "Pengaturan berhasil disimpan.", type: "success" });
        } catch (error) {
            setMessage({ text: "Gagal menyimpan pengaturan: " + error.message, type: "error" });
        }
        setLoading(false);
    };

    // ... (Fungsi generateAndSendOtp dan handleResetTestingData tidak berubah) ...

    const generateAndSendOtp = async () => {
        if (userRole === 'superAdmin' && !window.confirm("Ini akan membuat OTP Global baru. Lanjutkan?")) return;
        if (userRole === 'admin_rt' && !window.confirm(`Ini akan membuat OTP baru khusus untuk RT ${rtProfileId}. Lanjutkan?`)) return;

        setOtpLoading(true);
        setMessage({ text: '', type: '' });
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let newOtp = '';
        for (let i = 0; i < 6; i++) {
            newOtp += characters.charAt(Math.floor(Math.random() * characters.length));
        }

        try {
            let otpDocRef;
            let discordMessageTitle;

            if (userRole === 'superAdmin') {
                otpDocRef = doc(db, getAccessCodeDocPath());
                discordMessageTitle = "🔑 Kode Akses Global Baru Telah Dibuat!";
            } else if (userRole === 'admin_rt' && rtProfileId) {
                otpDocRef = doc(db, getRtSpecificAccessCodeDocPath(rtProfileId));
                discordMessageTitle = `🔑 Kode Akses Baru untuk RT ${rtProfileId} Telah Dibuat!`;
            } else {
                setMessage({ text: "Tidak dapat membuat OTP: Peran tidak valid.", type: "error" });
                setOtpLoading(false);
                return;
            }

            await setDoc(otpDocRef, {
                code: newOtp,
                isActive: true,
                createdAt: Timestamp.now(),
                validUntil: Timestamp.fromDate(new Date(Date.now() + 30 * 24 * 60 * 60 * 1000))
            });

            const embed = {
                title: discordMessageTitle,
                description: `Kode akses baru adalah: **${newOtp}**\nKode ini aktif dan dapat digunakan.`,
                color: 0x00AEFF,
                timestamp: new Date().toISOString()
            };

            const wasSent = await sendDiscordNotification(
                'otp',
                appConfigData,
                embed,
                { OTP_NOTIFICATION_WEBHOOK_URL }
            );

            if (wasSent) {
                setMessage({ text: `Kode OTP baru: ${newOtp} berhasil dibuat dan dikirim ke Discord.`, type: "success" });
            } else {
                setMessage({ text: `Kode OTP baru: ${newOtp} berhasil dibuat. (Notifikasi Discord tidak dikirim karena fitur tidak aktif atau URL belum diatur).`, type: "info" });
            }

            setCurrentActiveOtp(newOtp);
        } catch (error) {
            console.error("Error generating/sending OTP:", error);
            setMessage({ text: "Gagal membuat/mengirim Kode OTP: " + error.message, type: "error" });
        } finally {
            setOtpLoading(false);
        }
    };

    const handleResetTestingData = async () => {
        if (!rtProfileId && userRole !== 'superAdmin') {
            setMessage({ text: "Fungsi ini hanya untuk Admin RT.", type: "error" });
            return;
        }
        const targetRtId = userRole === 'superAdmin' ? 'global_testing_data' : rtProfileId;

        if (!window.confirm(`Yakin ingin mereset semua data transaksi (Pembayaran & Pengeluaran) dalam Mode Testing untuk ${targetRtId}? Tindakan ini tidak bisa dibatalkan.`)) {
            return;
        }
        setResetLoading(true);
        setMessage({ text: '', type: '' });
        try {
            const batch = writeBatch(db);
            let deletedCount = 0;

            const paymentsTestQuery = query(collection(db, getPaymentsCollectionPath(rtProfileId || null)), where("mode", "==", "testing"));
            const paymentsTestSnapshot = await getDocs(paymentsTestQuery);
            paymentsTestSnapshot.forEach(docSnap => {
                batch.delete(docSnap.ref);
                deletedCount++;
            });

            const expensesTestQuery = query(collection(db, getExpensesCollectionPath(rtProfileId || null)), where("mode", "==", "testing"));
            const expensesTestSnapshot = await getDocs(expensesTestQuery);
            expensesTestSnapshot.forEach(docSnap => {
                batch.delete(docSnap.ref);
                deletedCount++;
            });

            // --- TAMBAHAN BARU: Hapus data 'bills' mode testing ---
            const billsTestQuery = query(collection(db, getBillsCollectionPath(rtProfileId)), where("mode", "==", "testing"));
            const billsTestSnapshot = await getDocs(billsTestQuery);
            billsTestSnapshot.forEach(docSnap => {
                batch.delete(docSnap.ref);
                deletedCount++;
            });
            // --- AKHIR TAMBAHAN ---

            if (deletedCount > 0) {
                await batch.commit();
                setMessage({ text: `Semua data transaksi mode testing (${deletedCount} item) untuk RT ${rtProfileId || 'Global'} berhasil direset.`, type: "success" });
            } else {
                setMessage({ text: `Tidak ada data transaksi mode testing untuk RT ${rtProfileId || 'Global'} untuk direset.`, type: "info" });
            }

        } catch (error) {
            console.error("Error resetting testing data:", error);
            setMessage({ text: "Gagal mereset data testing. Error: " + error.message, type: "error" });
        }
        setResetLoading(false);
    };


    if (!appConfigData) return <div className={cardStyle}><LoadingSpinner /><p>Memuat pengaturan...</p></div>;

    // if (!appConfigData) return <div className={cardStyle}><LoadingSpinner /><p>Memuat pengaturan RT...</p></div>;
    // --- BLOK KODE UNTUK TESTING ---
    const handleTestDisbursement = async () => {
        // 1. Cek status login di sisi klien SEBELUM memanggil fungsi
        // 'authGlobal' adalah instance auth yang Anda definisikan di atas App.js
        // console.log("Mencoba memanggil fungsi. Status currentUser:", authGlobal.currentUser);

        // 2. Tambahkan pengaman (Guard Clause)
        if (!authGlobal.currentUser) {
            alert("Gagal: Tidak ada pengguna yang login menurut Firebase Auth. Silakan refresh halaman dan coba lagi.");
            return;
        }

        const functions = getFunctions(app, 'us-central1');// 'app' adalah instance firebase Anda
        const triggerDisbursement = httpsCallable(functions, 'triggerDisbursement');

        const rtIdToTest = 'RTPUS'; // <-- GANTI DENGAN ID RT UJI COBA ANDA
        // console.log(`Mencoba memicu disbursement untuk RT: ${rtIdToTest}`);

        try {
            const result = await triggerDisbursement({ rtId: rtIdToTest });
            // console.log("Hasil disbursement:", result.data);
            alert(`Sukses: ${result.data.message}`);
        } catch (error) {
            console.error("Error memanggil fungsi disbursement:", error);
            alert(`Gagal: ${error.message}`);
        }
    };
    // --- AKHIR BLOK KODE TESTING ---

    // --- FUNGSI BARU UNTUK MEMANGGIL CLOUD FUNCTION ---
    const handleManualCheck = async () => {
        if (!window.confirm("Anda akan menjalankan pengecekan status langganan untuk semua RT sekarang. Lanjutkan?")) {
            return;
        }
        setIsChecking(true);
        setMessage({ text: "Memulai pengecekan status langganan...", type: "info" });

        try {
            const functions = getFunctions(app, 'us-central1');
            const manualCheckSubscriptions = httpsCallable(functions, 'manualCheckSubscriptions');

            const result = await manualCheckSubscriptions();

            // Tampilkan hasil dari Cloud Function
            setMessage({ text: result.data.message || "Proses selesai.", type: "success" });
        } catch (error) {
            console.error("Error triggering manual check:", error);
            setMessage({ text: `Gagal: ${error.message}`, type: "error" });
        } finally {
            setIsChecking(false);
        }
    };

    const handlemanualTriggerScheduler = async () => {
        if (!window.confirm("Anda akan menjalankan pengecekan status langganan untuk semua RT sekarang. Lanjutkan?")) {
            return;
        }
        setIsCheckingDisbursement(true);
        setMessage({ text: "Memulai pengecekan status langganan...", type: "info" });

        try {
            const functions = getFunctions(app, 'us-central1');
            const manualTriggerScheduler = httpsCallable(functions, 'manualTriggerScheduler');

            const result = await manualTriggerScheduler();

            // Tampilkan hasil dari Cloud Function
            setMessage({ text: result.data.message || "Proses selesai.", type: "success" });
        } catch (error) {
            console.error("Error triggering manual check:", error);
            setMessage({ text: `Gagal: ${error.message}`, type: "error" });
        } finally {
            setIsCheckingDisbursement(false);
        }
    };

    const handleManualGenerateSubscriptionBills = async () => {
        if (!window.confirm("Anda akan menjalankan pengecekan status langganan untuk semua RT sekarang. Lanjutkan?")) {
            return;
        }
        setIsChecking(true);
        setMessage({ text: "Memulai pengecekan status langganan...", type: "info" });

        try {
            const functions = getFunctions(app, 'us-central1');
            const manualGenerateSubscriptionBills = httpsCallable(functions, 'manualGenerateSubscriptionBills');

            const result = await manualGenerateSubscriptionBills();

            // Tampilkan hasil dari Cloud Function
            setMessage({ text: result.data.message || "Proses selesai.", type: "success" });
        } catch (error) {
            console.error("Error triggering manual check:", error);
            setMessage({ text: `Gagal: ${error.message}`, type: "error" });
        } finally {
            setIsChecking(false);
        }
    };

    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-6">
                Pengaturan Aplikasi {userRole === 'admin_rt' && rtProfileId ? `(RT: ${rtProfileId})` : '(Global)'}
            </h2>
            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />

            <div className="space-y-4">
                {/* --- KONTROL BARU UNTUK SUPER ADMIN --- */}
                {userRole === 'superAdmin' && (
                    <div className="p-4 border rounded-lg bg-yellow-50 space-y-4">
                        <h3 className="text-lg font-semibold text-slate-700">Pengaturan Biaya Layanan QRIS (Global)</h3>
                        <div>
                            <label htmlFor="qrisFeePercentage" className="block text-sm font-medium text-slate-700">Persentase Biaya Layanan (%)</label>
                            <input type="number" name="qrisFeePercentage" value={appConfigData.qrisFeePercentage || ''} onChange={handleChange} className={commonInputStyle} step="0.1" placeholder="Contoh: 1.0" />
                            <p className="text-xs text-slate-500 mt-1">Gunakan titik sebagai pemisah desimal. Contoh: 1.5 untuk 1.5%.</p>
                        </div>
                        <div>
                            <label htmlFor="vatPercentage" className="block text-sm font-medium text-slate-700">Persentase Biaya PPN (%)</label>
                            <input type="number" name="vatPercentage" value={appConfigData.vatPercentage || ''} onChange={handleChange} className={commonInputStyle} step="0.1" placeholder="Contoh: 12.0" />
                            <p className="text-xs text-slate-500 mt-1">Gunakan titik sebagai pemisah desimal. Contoh: 1.5 untuk 1.5%.</p>
                        </div>
                        <div>
                            <label htmlFor="qrisFeeFixed" className="block text-sm font-medium text-slate-700">Biaya Tetap per Transaksi (Rp)</label>
                            <input type="number" name="qrisFeeFixed" value={appConfigData.qrisFeeFixed || ''} onChange={handleChange} className={commonInputStyle} placeholder="Contoh: 5000" />
                        </div>
                        {/* --- INPUT BARU UNTUK BIAYA DISBURSEMENT CEPAT --- */}
                        <hr className="border-yellow-200" />
                        <div>
                            <label htmlFor="fastDisbursementFee" className="block text-sm font-medium text-slate-700">Biaya Layanan Tarik Dana Cepat (Rp)</label>
                            <input type="number" name="fastDisbursementFee" value={appConfigData.fastDisbursementFee || ''} onChange={handleChange} className={commonInputStyle} placeholder="Contoh: 7000" />
                            <p className="text-xs text-slate-500 mt-1">Total biaya yang dibebankan ke RT untuk penarikan darurat.</p>
                        </div>
                        {/* --- INPUT BARU UNTUK BIAYA PLATFORM XENDIT --- */}
                        <hr className="border-yellow-200" />
                        <div>
                            <label htmlFor="xenditQrisFeePercentage" className="block text-sm font-medium text-slate-700">Persentase Biaya Platform QRIS Xendit (%)</label>
                            <input type="number" name="xenditQrisFeePercentage" value={appConfigData.xenditQrisFeePercentage || ''} onChange={handleChange} className={commonInputStyle} step="0.1" placeholder="Contoh: 0.7" />
                            <p className="text-xs text-slate-500 mt-1">Ini adalah biaya asli dari Xendit. Digunakan untuk perhitungan keuntungan bersih.</p>
                        </div>
                        {/* --- INPUT BARU UNTUK BIAYA DISBURSEMENT XENDIT --- */}
                        <div>
                            <label htmlFor="xenditDisbursementFee" className="block text-sm font-medium text-slate-700">Biaya Platform Disbursement Xendit (Rp)</label>
                            <input type="number" name="xenditDisbursementFee" value={appConfigData.xenditDisbursementFee || ''} onChange={handleChange} className={commonInputStyle} placeholder="Contoh: 5000" />
                            <p className="text-xs text-slate-500 mt-1">Biaya asli dari Xendit untuk pengiriman dana.</p>
                        </div>
                        {/* --- TOMBOL TESTING SEMENTARA (HANYA UNTUK SUPER ADMIN) --- */}
                        {userRole === 'superAdmin' && (
                            <div className="mt-6 p-4 border-2 border-dashed border-red-400 rounded-lg">
                                <h4 className="text-lg font-bold text-red-600">Area Testing Khusus</h4>
                                <p className="text-sm text-slate-500 mb-2">Tombol ini untuk menguji fungsi disbursement secara manual.</p>
                                <button onClick={handleTestDisbursement} className={dangerButtonStyle}>
                                    Test Trigger Disbursement untuk RTTEST
                                </button>
                            </div>
                        )}
                        {userRole === 'superAdmin' && (
                            <div className="mt-8 p-4 border-2 border-dashed border-orange-400 rounded-lg">
                                <div>
                                    <label htmlFor="deviceTokenFonnte" className="block text-sm font-medium text-slate-700">TOKEN Device Integrasi Whatsapp</label>
                                    <input type="password" name="deviceTokenFonnte" value={appConfigData.deviceTokenFonnte || ''} onChange={handleChange} className={commonInputStyle} step="0.1" />
                                    <p className="text-xs text-slate-500 mt-1">Ini adalah Token Device untuk integrasi Whatsapp.</p>
                                </div>
                            </div>
                        )}

                        {/* --- AREA TESTING WEBHOOK (HANYA UNTUK SUPER ADMIN) --- */}
                        {userRole === 'superAdmin' && (
                            <div className="mt-8 p-4 border-2 border-dashed border-purple-400 rounded-lg">
                                <h4 className="text-lg font-bold text-purple-600">Area Uji Coba Webhook</h4>
                                <p className="text-sm text-slate-500 mb-2">Masukkan ID Dokumen Disbursement untuk mensimulasikan webhook.</p>
                                <input
                                    type="text"
                                    value={testDisbursementId}
                                    onChange={(e) => setTestDisbursementId(e.target.value)}
                                    placeholder="ID Dokumen Disbursement"
                                    className={commonInputStyle}
                                />
                                <div className="flex space-x-2 mt-2">
                                    <button onClick={() => handleTestWebhook('COMPLETED')} disabled={isTestingWebhook} className="w-1/2 px-4 py-2 rounded-md font-semibold text-white bg-green-500 hover:bg-green-600">
                                        {isTestingWebhook ? <LoadingSpinner /> : "Test SUKSES"}
                                    </button>
                                    <button onClick={() => handleTestWebhook('FAILED')} disabled={isTestingWebhook} className="w-1/2 px-4 py-2 rounded-md font-semibold text-white bg-red-500 hover:bg-red-600">
                                        {isTestingWebhook ? <LoadingSpinner /> : "Test GAGAL"}
                                    </button>
                                </div>
                            </div>
                        )}
                        {userRole === 'superAdmin' && (
                            <div className="pt-2">
                                <h4 className="text-md font-semibold text-slate-600 mb-2">Otomatisasi & Penjadwalan Scheduler</h4>
                                <label className="flex items-center space-x-3 p-3 bg-white rounded-md border cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name="enableDisbursementScheduler"
                                        checked={!!appConfigData.enableDisbursementScheduler}
                                        onChange={handleChange}
                                        className="h-5 w-5 rounded text-sky-600 focus:ring-sky-500"
                                    />
                                    <div>
                                        <span className="font-medium text-slate-800">Aktifkan Disbursement Otomatis</span>
                                        <p className="text-xs text-slate-500">Jika aktif, sistem akan otomatis melakukan disbursement RT yang kedaluwarsa setiap hari.</p>
                                    </div>
                                </label>
                            </div>
                        )}
                        {userRole === 'superAdmin' && (
                            <div className="pt-2">
                                <p className="text-xs text-slate-500 mb-2">Gunakan tombol ini untuk menjalankan proses pengecekan triggered schedule disbursement.</p>
                                <button
                                    type="button"
                                    onClick={handlemanualTriggerScheduler}
                                    className={primaryButtonStyle}
                                    disabled={isCheckingDisbursement}
                                >
                                    {isCheckingDisbursement ? <LoadingSpinner /> : "Jalankan Pengecekan Scheduled Sekarang"}
                                </button>
                            </div>
                        )}
                        {userRole === 'superAdmin' && (
                            <div className="pt-2">
                                <h4 className="text-md font-semibold text-slate-600 mb-2">Otomatisasi & Penjadwalan</h4>
                                <label className="flex items-center space-x-3 p-3 bg-white rounded-md border cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name="enableSubscriptionScheduler"
                                        checked={!!appConfigData.enableSubscriptionScheduler}
                                        onChange={handleChange}
                                        className="h-5 w-5 rounded text-sky-600 focus:ring-sky-500"
                                    />
                                    <div>
                                        <span className="font-medium text-slate-800">Aktifkan Pengecekan Langganan Otomatis</span>
                                        <p className="text-xs text-slate-500">Jika aktif, sistem akan otomatis mengubah status langganan RT yang kedaluwarsa setiap hari.</p>
                                    </div>
                                </label>
                            </div>
                        )}
                        {userRole === 'superAdmin' && (
                            <div className="pt-2">
                                <p className="text-xs text-slate-500 mb-2">Gunakan tombol ini untuk menjalankan proses pengecekan langganan kedaluwarsa secara manual tanpa menunggu jadwal harian.</p>
                                <button
                                    type="button"
                                    onClick={handleManualCheck}
                                    className={secondaryButtonStyle}
                                    disabled={isChecking}
                                >
                                    {isChecking ? <LoadingSpinner /> : "Jalankan Pengecekan Langganan Sekarang"}
                                </button>
                            </div>
                        )}
                        <hr className="my-4" />
                        {userRole === 'superAdmin' && (
                            <label className="flex items-center space-x-3 p-3 bg-white rounded-md border cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="enableSubscriptionBillingScheduler" // <-- Nama field baru
                                    checked={!!appConfigData.enableSubscriptionBillingScheduler}
                                    onChange={handleChange}
                                    className="h-5 w-5 rounded text-sky-600 focus:ring-sky-500"
                                />
                                <div>
                                    <span className="font-medium text-slate-800">Aktifkan Penagihan Langganan Otomatis</span>
                                    <p className="text-xs text-slate-500">Otomatis membuat tagihan untuk RT yang langganannya akan habis.</p>
                                </div>
                            </label>
                        )}
                        {userRole === 'superAdmin' && (
                            <div className="pt-2">
                                <p className="text-xs text-slate-500 mb-2">Gunakan tombol ini untuk menjalankan proses pengecekan generate bill langganan kedaluwarsa secara manual tanpa menunggu jadwal harian.</p>
                                <button
                                    type="button"
                                    onClick={handleManualGenerateSubscriptionBills}
                                    className={primaryButtonStyle}
                                    disabled={isCheckingBillSubscriptionScheduler}
                                >
                                    {isCheckingBillSubscriptionScheduler ? <LoadingSpinner /> : "Jalankan Generate Bill Langganan Sekarang"}
                                </button>
                            </div>
                        )}
                    </div>
                )}
                {/* <div>
                    <label htmlFor="monthlyDues" className="block text-sm font-medium text-slate-700">Iuran Bulanan per Rumah (Rp) *</label>
                    <input type="number" name="monthlyDues" value={appConfigData.monthlyDues || ''} onChange={handleChange} className={commonInputStyle} required />
                </div>
                <div>
                    <label htmlFor="systemStartMonth" className="block text-sm font-medium text-slate-700">Bulan Mulai Sistem *</label>
                    <select name="systemStartMonth" value={appConfigData.systemStartMonth != null ? appConfigData.systemStartMonth : 0} onChange={handleChange} className={commonInputStyle} required>
                        {MONTHS.map((m, i) => <option key={i} value={i}>{m}</option>)}
                    </select>
                </div>
                <div>
                    <label htmlFor="systemStartYear" className="block text-sm font-medium text-slate-700">Tahun Mulai Sistem *</label>
                    <select name="systemStartYear" value={appConfigData.systemStartYear || CURRENT_YEAR} onChange={handleChange} className={commonInputStyle} required>
                        {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                </div> */}
                {/* <div className="flex items-center">
                    <input type="checkbox" name="isTestingMode" id="isTestingModeToggle" checked={!!appConfigData.isTestingMode} onChange={handleChange} className="h-4 w-4 ..." />
                    <label htmlFor="isTestingModeToggle" className="ml-2 ...">Aktifkan Mode Testing {userRole === 'admin_rt' ? `untuk RT ${rtProfileId}` : '(Global)'}</label>
                </div> */}

                {userRole === 'superAdmin' && (
                    <div className="flex items-center pt-2 border-t">
                        <input type="checkbox" name="isHouseVerificationEnabled" checked={appConfigData.isHouseVerificationEnabled} onChange={handleChange} className="h-4 w-4 ..." />
                        <label htmlFor="isHouseVerificationEnabledToggle" className="ml-2 ...">Aktifkan Verifikasi Rumah dengan OTP HP & PIN (Global Default)</label>
                    </div>
                )}

                {userRole === 'admin_rt' && appConfigData.isDiscordIntegrationEnabled && (
                    <div className="p-4 border-t mt-4 pt-4 bg-blue-50 rounded-lg">
                        <h3 className="text-lg font-semibold text-slate-700">Integrasi Notifikasi Discord</h3>
                        <p className="text-sm text-slate-500 mb-3">Fitur ini diaktifkan oleh Super Admin. Masukkan URL Webhook Discord Anda di bawah ini. Kosongkan jika tidak ingin menggunakan notifikasi untuk jenis tertentu.</p>
                        <div className="space-y-3">
                            <div>
                                <label htmlFor="paymentWebhookUrl" className="block text-sm font-medium text-slate-600">URL Webhook Pembayaran</label>
                                <input type="url" name="paymentWebhookUrl" value={appConfigData.paymentWebhookUrl || ''} onChange={handleChange} className={commonInputStyle} placeholder="https://discord.com/api/webhooks/..." />
                            </div>
                            <div>
                                <label htmlFor="expenseWebhookUrl" className="block text-sm font-medium text-slate-600">URL Webhook Pengeluaran</label>
                                <input type="url" name="expenseWebhookUrl" value={appConfigData.expenseWebhookUrl || ''} onChange={handleChange} className={commonInputStyle} placeholder="https://discord.com/api/webhooks/..." />
                            </div>
                            <div>
                                <label htmlFor="otpWebhookUrl" className="block text-sm font-medium text-slate-600">URL Webhook Kode Akses (OTP)</label>
                                <input type="url" name="otpWebhookUrl" value={appConfigData.otpWebhookUrl || ''} onChange={handleChange} className={commonInputStyle} placeholder="https://discord.com/api/webhooks/..." />
                            </div>
                        </div>
                    </div>
                )}

                {appConfigData.isWhatsappIntegrationEnabled && (
                    <>
                        <div className="flex items-center pt-2 border-t">
                            <input type="checkbox" name="isWhatsappIntegrationActive" checked={appConfigData.isWhatsappIntegrationActive} onChange={handleChange} className="h-4 w-4" />
                            <label htmlFor="isWhatsappIntegrationActiveToggle" className="ml-2 ...">Aktifkan Whatsapp Notification</label>
                            {/* span kecil untuk menginfokan jika whatsapp integration diaktifkan maka anda harus memastikan nomor whatsapp anda terdaftar di whatsapp dan juga nomor whatsapp tertaut ke keluarga pembayar.
                        jika nomor pembayar tidak terdata di pembayar, maka akan menggunakan nomor yang tertaut di data rumah. jika tidak ada juga maka tidak akan terkirim notifikasi */}
                        </div>
                        <span className="ml-2 text-xs text-slate-500">* Jika whatsapp integration diaktifkan maka anda harus memastikan nomor whatsapp warga anda terdaftar di whatsapp dan juga <b>nomor whatsapp tertaut ke keluarga pembayar.</b>
                            <br />jika nomor pembayar tidak terdata di pembayar, maka akan menggunakan <b>nomor yang tertaut di data rumah</b>. jika tidak ada juga maka <b>tidak akan terkirim notifikasi</b></span>
                    </>
                )}

                {/* Tombol Simpan Pengaturan */}
                {userRole === 'superAdmin' || (appConfigData && appConfigData.isDiscordIntegrationEnabled) || (appConfigData && appConfigData.isWhatsappIntegrationEnabled) ? (
                    <button onClick={handleSave} className={`${primaryButtonStyle} w-full`} disabled={loading}>
                        {loading ? <LoadingSpinner /> : 'Simpan Pengaturan'}
                    </button>
                ) : null}
                <hr className="my-6" />

                {/* --- KARTU STATUS LANGGANAN BARU (HANYA UNTUK ADMIN RT) --- */}
                {userRole === 'admin_rt' && (
                    <div className="p-4 border-2 rounded-xl bg-white mb-6 shadow-md">
                        <h3 className="text-sm font-semibold text-slate-500 uppercase mb-2">Status Paket Langganan</h3>
                        <div className="flex flex-wrap justify-between items-center gap-4">
                            <div>
                                <p className="text-2xl font-bold text-sky-700 capitalize">{appConfigData.plan || 'Gratis'}</p>
                                {appConfigData.plan !== 'gratis' && (
                                    isSubscribedAndActive ? (
                                        <p className="text-sm text-green-600 font-semibold">Aktif hingga {appConfigData.subscriptionValidUntil.toDate().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                                    ) : (
                                        <p className="text-sm text-red-600 font-semibold">Telah Kedaluwarsa</p>
                                    )
                                )}
                            </div>
                            {/* <button onClick={() => alert('Fitur upgrade/perpanjangan akan segera tersedia. Hubungi Super Admin untuk saat ini.')} className={`${primaryButtonStyle} flex-shrink-0`}>
                                {appConfigData.plan === 'gratis' ? 'Upgrade Paket' : 'Perpanjang Langganan'}
                            </button> */}
                        </div>
                    </div>
                )}

                <h3 className="text-lg font-semibold text-slate-600">Manajemen Kode Akses {userRole === 'admin_rt' && rtProfileId ? `RT ${rtProfileId}` : 'Global'}</h3>
                <p className="text-sm text-slate-500 mb-1">Kode OTP Aktif Saat Ini: <strong className="text-sky-600">{currentActiveOtp || "Memuat..."}</strong></p>
                {/* --- BAGIAN BARU UNTUK TEMPLATE PESAN --- */}
                {userRole === 'admin_rt' && (
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-slate-700 mb-2">Template Pesan untuk Warga</label>
                        <div className="p-4 border rounded-md bg-slate-100 text-sm text-slate-800 whitespace-pre-wrap">
                            {shareableMessage}
                        </div>
                        <button
                            onClick={handleCopyText}
                            className={`${primaryButtonStyle} w-full mt-2`}
                            disabled={!shareableMessage.includes('Kode RT')} // Nonaktifkan jika belum ada OTP
                        >
                            Salin Teks Pesan
                        </button>
                    </div>
                )}
                <button onClick={generateAndSendOtp} className={`${secondaryButtonStyle} w-full`} disabled={otpLoading}>{otpLoading ? <LoadingSpinner /> : 'Buat & Kirim Kode OTP Baru'}</button>



                {appConfigData.isTestingMode && userRole === 'admin_rt' && rtProfileId && (
                    <>
                        <hr className="my-6" />
                        <h3 className="text-lg font-semibold text-slate-600">Reset Data Mode Testing (RT: {rtProfileId})</h3>
                        <p className="text-sm text-slate-500 mb-2">
                            Tindakan ini akan menghapus semua data pembayaran dan pengeluaran yang dibuat dalam mode testing untuk RT ini. Data master (rumah, pengguna RT ini) dan data mode live tidak akan terpengaruh.
                        </p>
                        <button
                            onClick={handleResetTestingData}
                            className={`${dangerButtonStyle} w-full`}
                            disabled={resetLoading}
                        >
                            {resetLoading ? <LoadingSpinner /> : `Reset Data Testing RT ${rtProfileId}`}
                        </button>
                    </>
                )}
            </div>
        </div >
    );
};

// --- Komponen SubscriptionBillingPage (FINAL - Menggunakan Modal Invoice) ---
const SubscriptionBillingPage = ({ onNavigate, pagePayload }) => {
    const { appConfig, rtProfileId } = useAuth();

    // State untuk data
    const [subscriptionBills, setSubscriptionBills] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    // State untuk modal dan proses pembayaran
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedBill, setSelectedBill] = useState(null);
    const [qrisData, setQrisData] = useState(null);
    const [isGeneratingQr, setIsGeneratingQr] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false); // State baru untuk download
    const [countdown, setCountdown] = useState('');
    const [isProcessingUpgrade, setIsProcessingUpgrade] = useState(false);
    // --- State BARU untuk mengelola alur modal upgrade ---
    const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
    const [modalStep, setModalStep] = useState('plan_selection'); // 'plan_selection', 'cycle_selection', 'agreement'
    const [selectedPlanForUpgrade, setSelectedPlanForUpgrade] = useState(null); // Menyimpan { key, details }
    const [selectedCycle, setSelectedCycle] = useState('yearly');
    const [isProcessing, setIsProcessing] = useState(false);

    // State baru untuk mencegah modal terbuka berulang kali
    const [hasAutoOpenedModal, setHasAutoOpenedModal] = useState(false);

    // Ref untuk menunjuk ke elemen invoice yang akan di-screenshot
    const invoiceRef = useRef(null);

    // Ambil data profil RT saat ini untuk mengetahui plan mereka
    const currentRtConfig = useMemo(() => {
        if (!appConfig || !rtProfileId) return null;
        return appConfig.rtProfiles?.[rtProfileId] || {};
    }, [appConfig, rtProfileId]);

    // Ambil data harga plan dari appConfig
    const availablePlans = useMemo(() => {
        if (!appConfig?.plans) return {};
        const { gratis, ...paidPlans } = appConfig.plans;
        return paidPlans;
    }, [appConfig]);

    // Mengambil data tagihan langganan
    // --- useEffect #1: HANYA mengambil daftar tagihan ---
    useEffect(() => {
        if (!rtProfileId) { setIsLoading(false); return; }

        setIsLoading(true);
        const billsRef = collection(db, 'rt_subscription_bills');
        const q = query(billsRef, where("rtId", "==", rtProfileId), orderBy("createdAt", "desc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const billsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setSubscriptionBills(billsData); // Hanya update daftar utama
            setIsLoading(false);
        }, (err) => {
            setError("Gagal memuat riwayat tagihan langganan.");
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, [rtProfileId]);

    // --- USE EFFECT BARU UNTUK MEMBUKA MODAL OTOMATIS ---
    useEffect(() => {
        // Jalankan hanya jika:
        // 1. Ada payload `openBillId`
        // 2. Daftar tagihan sudah dimuat (bukan array kosong)
        // 3. Modal belum pernah dibuka secara otomatis di sesi ini
        // console.log("EFFECT BARU UNTUK MEMBUKA MODAL OTOMATIS", pagePayload?.openBillId);
        if (pagePayload?.openBillId && subscriptionBills.length > 0 && !hasAutoOpenedModal) {
            const billToOpen = subscriptionBills.find(b => b.id === pagePayload.openBillId);

            if (billToOpen) {
                // console.log("Membuka modal pembayaran otomatis untuk bill:", billToOpen.id);
                openPaymentModal(billToOpen);
                setHasAutoOpenedModal(true); // Tandai bahwa kita sudah membuka modal
            }
        }
    }, [pagePayload, subscriptionBills, hasAutoOpenedModal]);

    useEffect(() => {
        // Jangan lakukan apa-apa jika modal tidak terbuka atau tidak ada bill yang dipilih
        if (!isModalOpen || !selectedBill) return;

        // Cari versi terbaru dari bill yang sedang dibuka di dalam daftar utama
        const updatedBillInModal = subscriptionBills.find(b => b.id === selectedBill.id);

        if (updatedBillInModal) {
            // Untuk mencegah loop, kita hanya update jika datanya benar-benar berbeda
            if (JSON.stringify(updatedBillInModal) !== JSON.stringify(selectedBill)) {
                // console.log("Status tagihan di modal diperbarui secara real-time.");
                setSelectedBill(updatedBillInModal);
            }
        }
    }, [subscriptionBills, selectedBill, isModalOpen]);

    // useEffect untuk countdown timer QRIS
    useEffect(() => {
        if (!qrisData?.expires_at) { setCountdown(''); return; }
        const intervalId = setInterval(() => {
            const expiryDate = qrisData.expires_at.toDate();
            const diff = expiryDate.getTime() - new Date().getTime();
            if (diff <= 0) {
                clearInterval(intervalId);
                setCountdown("Kedaluwarsa");
                setQrisData(null); // Reset QR data agar tombol muncul lagi
            } else {
                const minutes = Math.floor((diff / 1000) / 60);
                const seconds = Math.floor((diff / 1000) % 60);
                setCountdown(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
            }
        }, 1000);
        return () => clearInterval(intervalId);
    }, [qrisData]);

    // --- LOGIKA BARU UNTUK ALUR UPGRADE ---
    const handleOpenUpgradeModal = () => {
        setModalStep('plan_selection');
        setSelectedPlanForUpgrade(null);
        setIsUpgradeModalOpen(true);
        setError('');
    };

    const handleCloseUpgradeModal = () => {
        setIsUpgradeModalOpen(false);
        setTimeout(() => {
            setSelectedPlanForUpgrade(null);
        }, 300);
    };

    const handlePlanSelect = (planKey) => {
        const planDetails = availablePlans[planKey];
        if (planDetails) {
            setSelectedPlanForUpgrade({ key: planKey, ...planDetails });
            setModalStep('cycle_selection');
        }
    };

    const handleCycleSelect = (cycle) => {
        setSelectedCycle(cycle);
        setModalStep('agreement');
    };

    const handleConfirmAndCreateBill = async () => {
        if (!selectedPlanForUpgrade) return;
        setIsProcessing(true);
        setError('');
        try {
            const functions = getFunctions(app, 'us-central1');
            const createSubscriptionBill = httpsCallable(functions, 'createSubscriptionBill');

            const result = await createSubscriptionBill({
                rtId: rtProfileId,
                plan: selectedPlanForUpgrade.key,
                billingCycle: selectedCycle
            });

            handleCloseUpgradeModal(); // Tutup modal upgrade

            // Ambil data tagihan baru dan buka modal pembayaran
            const newBillRef = doc(db, 'rt_subscription_bills', result.data.billId);
            const newBillSnap = await getDoc(newBillRef);
            if (newBillSnap.exists()) {
                openPaymentModal({ id: newBillSnap.id, ...newBillSnap.data() });
            }
        } catch (error) {
            console.error("Gagal membuat tagihan upgrade:", error);
            setError(`Gagal membuat tagihan upgrade: ${error.message}`);
        } finally {
            setIsProcessing(false);
        }
    };

    // Handler untuk membuka modal pembayaran
    const openPaymentModal = (bill) => {
        // console.log("Opening payment modal for bill:", bill);
        setSelectedBill(bill);
        if (bill.qrisData && bill.qrisData.expires_at?.toDate() > new Date()) {
            setQrisData(bill.qrisData);
        } else {
            setQrisData(null);
        }
        setIsModalOpen(true);
    };

    // Handler untuk menutup modal
    const closeModal = () => {
        setIsModalOpen(false);
        setTimeout(() => {
            setSelectedBill(null);
            setQrisData(null);
            setIsGeneratingQr(false);
            setError('');
        }, 300);
    };

    // Handler untuk membuat QRIS di dalam modal
    const handleGenerateQris = async () => {
        if (!selectedBill) return;
        setIsGeneratingQr(true);
        setError('');
        // console.log("Membuat QRIS untuk tagihan:", selectedBill);
        try {
            const functions = getFunctions(app, 'us-central1');
            const createSubscriptionQris = httpsCallable(functions, 'createSubscriptionQris');
            const result = await createSubscriptionQris({ subscriptionBillId: selectedBill.id });
            // Konversi timestamp dari hasil Cloud Function
            const qrisResultWithTimestamp = { ...result.data, expires_at: Timestamp.fromDate(new Date(result.data.expires_at)) };
            setQrisData(qrisResultWithTimestamp);
        } catch (err) {
            // console.log("Gagal membuat QR:", err);
            setError(`Gagal membuat QR: ${err.message}`);
        } finally {
            setIsGeneratingQr(false);
        }
    };

    // Handler untuk tombol upgrade dari paket gratis
    const handleUpgradePlan = async () => {
        const targetPlan = 'premium';
        const billingCycle = 'yearly';
        const confirmation = window.confirm(`Anda akan membuat tagihan untuk upgrade ke paket ${targetPlan}. Lanjutkan?`);
        if (!confirmation) return;

        setIsProcessingUpgrade(true);
        setError('');

        try {
            const functions = getFunctions(app, 'us-central1');
            const createSubscriptionBill = httpsCallable(functions, 'createSubscriptionBill');
            const result = await createSubscriptionBill({ rtId: rtProfileId, plan: targetPlan, billingCycle: billingCycle });

            // Setelah tagihan dibuat, langsung buka modal pembayarannya
            const newBillRef = doc(db, 'rt_subscription_bills', result.data.billId);
            const newBillSnap = await getDoc(newBillRef);
            if (newBillSnap.exists()) {
                openPaymentModal({ id: newBillSnap.id, ...newBillSnap.data() });
            }

        } catch (error) {
            console.error("Error creating upgrade bill:", error);
            setError(`Gagal membuat tagihan upgrade: ${error.message}`);
        } finally {
            setIsProcessingUpgrade(false);
        }
    };

    // --- FUNGSI BARU UNTUK DOWNLOAD INVOICE ---
    // --- FUNGSI DOWNLOAD INVOICE DENGAN URUTAN YANG BENAR ---
    const handleDownloadInvoice = async () => {
        // Langkah 1: Tangkap elemen DOM terlebih dahulu.
        const invoiceElement = invoiceRef.current;

        // Langkah 2: Jika elemen tidak ada, jangan lakukan apa-apa.
        if (!invoiceElement) {
            console.error("Referensi ke elemen invoice tidak ditemukan.");
            setError("Gagal mengunduh, elemen tidak ditemukan.");
            return;
        }

        // Langkah 3: BARU setelah elemen ditangkap, set status loading.
        // Ini tidak akan lagi mengganggu referensi yang sudah kita simpan.
        setIsDownloading(true);
        setError(''); // Bersihkan error lama

        try {
            // Langkah 4: Lakukan proses 'screenshot' pada elemen yang sudah ditangkap.
            const canvas = await html2canvas(invoiceElement, {
                scale: 2,
                backgroundColor: null,
                useCORS: true // Tambahkan ini untuk memastikan gambar eksternal (jika ada) ikut ter-render
            });

            const dataUrl = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = `invoice-satuwarga-${selectedBill.id.substring(0, 8)}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            console.error("Gagal membuat gambar invoice:", err);
            setError("Gagal mengunduh invoice.");
        } finally {
            // Langkah 5: Selalu set loading kembali ke false.
            setIsDownloading(false);
        }
    };

    if (isLoading) return <div className={cardStyle}><LoadingSpinner /></div>;

    const isFreePlan = currentRtConfig?.plan === 'gratis';

    return (
        <>
            <div className={cardStyle}>
                <h2 className="text-2xl font-semibold text-slate-700 mb-6">Langganan & Penagihan</h2>
                {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}

                {isFreePlan && (
                    <div className="p-6 border-2 border-dashed border-sky-300 rounded-xl bg-sky-50 text-center mb-6">
                        <h3 className="text-xl font-bold text-sky-800">Tingkatkan Pengalaman Anda!</h3>
                        <p className="text-slate-600 mt-2 mb-4">Anda saat ini menggunakan paket Gratis. Upgrade ke paket Premium untuk membuka semua fitur unggulan, termasuk disbursement otomatis, notifikasi Discord, dan banyak lagi.</p>
                        <button onClick={handleOpenUpgradeModal} className={primaryButtonStyle} disabled={isProcessingUpgrade}>
                            {isProcessingUpgrade ? <LoadingSpinner /> : 'Upgrade ke Premium Sekarang'}
                        </button>
                    </div>
                )}

                <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-slate-600">Riwayat Tagihan</h3>
                    {subscriptionBills.length > 0 ? (
                        subscriptionBills.map(bill => (
                            <div key={bill.id} className="p-4 border rounded-lg bg-white shadow-sm flex justify-between items-center flex-wrap gap-2">
                                <div>
                                    <p className="font-bold text-sky-700">Tagihan Langganan - {bill.planName.charAt(0).toUpperCase() + bill.planName.slice(1)}</p>
                                    <p className="text-sm text-slate-600">Jumlah: <span className="font-semibold">Rp {bill.amount.toLocaleString('id-ID')}</span></p>
                                    <p className="text-xs text-slate-400">Dibuat: {bill.createdAt.toDate().toLocaleDateString('id-ID')}</p>
                                </div>
                                <div className="flex-shrink-0">
                                    {/* --- TOMBOL KONTEKSTUAL BARU --- */}
                                    {bill.status === 'UNPAID' ? (
                                        <button onClick={() => openPaymentModal(bill)} className={primaryButtonStyle}>
                                            Bayar Sekarang
                                        </button>
                                    ) : (
                                        <button onClick={() => openPaymentModal(bill)} className={`${secondaryButtonStyle} bg-green-600 hover:bg-green-700`}>
                                            Lihat Invoice Lunas
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (<p className="text-center text-slate-500 py-4">Tidak ada riwayat tagihan.</p>)}
                </div>
            </div>

            {/* --- MODAL UPGRADE MULTI-LANGKAH --- */}
            {isUpgradeModalOpen && (
                <div className="fixed inset-0 z-[51] bg-black bg-opacity-60 flex items-center justify-center p-4">
                    <div className="bg-white p-6 rounded-2xl shadow-xl max-w-lg w-full mx-auto relative">
                        <button onClick={handleCloseUpgradeModal} className="absolute top-4 right-4 text-slate-400 hover:text-slate-800 text-2xl">&times;</button>

                        {modalStep === 'plan_selection' && (
                            <div className="animate-fade-in">
                                <h3 className="text-xl font-bold text-slate-800 text-center">Pilih Paket Upgrade</h3>
                                <div className="grid md:grid-cols-2 gap-4 mt-6">
                                    {Object.entries(availablePlans).map(([planKey, planDetails]) => (
                                        <div key={planKey} className="border-2 border-slate-200 rounded-lg p-4 flex flex-col text-center">
                                            <h4 className="text-lg font-bold text-sky-700 capitalize">{planKey}</h4>
                                            <p className="text-xs text-slate-500">Mulai dari</p>
                                            <p className="font-semibold text-2xl my-2">Rp {(planDetails.priceMonth || 0).toLocaleString('id-ID')}<span className="text-sm font-normal">/bulan</span></p>
                                            <button onClick={() => handlePlanSelect(planKey)} className={`${primaryButtonStyle} w-full mt-4`}>Pilih</button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {modalStep === 'cycle_selection' && selectedPlanForUpgrade && (
                            <div className="animate-fade-in">
                                <button onClick={() => setModalStep('plan_selection')} className="text-sm text-sky-600 hover:underline mb-4">← Kembali pilih paket</button>
                                <h3 className="text-xl font-bold">Pilih Siklus Penagihan</h3>
                                <p>Paket: <span className="font-semibold capitalize">{selectedPlanForUpgrade.key}</span></p>
                                <div className="space-y-3 mt-4">
                                    <div onClick={() => handleCycleSelect('yearly')} className="p-4 border-2 rounded-lg cursor-pointer hover:border-sky-500">
                                        <p className="font-bold">Tahunan - Rp {(selectedPlanForUpgrade.priceYear || 0).toLocaleString('id-ID')}</p>
                                        <p className="text-xs text-green-600">Pilihan Terbaik & Lebih Hemat!</p>
                                    </div>
                                    <div onClick={() => handleCycleSelect('monthly')} className="p-4 border-2 rounded-lg cursor-pointer hover:border-sky-500">
                                        <p className="font-bold">Bulanan - Rp {(selectedPlanForUpgrade.priceMonth || 0).toLocaleString('id-ID')}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {modalStep === 'agreement' && selectedPlanForUpgrade && (
                            <div className="animate-fade-in">
                                <button onClick={() => setModalStep('cycle_selection')} className="text-sm text-sky-600 hover:underline mb-4">← Kembali pilih siklus</button>
                                <h3 className="text-xl font-bold">Syarat & Ketentuan</h3>
                                <div className="text-sm text-slate-500 my-4 p-3 border rounded-md bg-slate-50 max-h-40 overflow-y-auto">
                                    <p>Dengan melanjutkan, Anda setuju untuk membuat tagihan langganan paket **{selectedPlanForUpgrade.key}** dengan siklus **{selectedCycle}**.</p>
                                </div>
                                <button onClick={handleConfirmAndCreateBill} disabled={isProcessing} className={primaryButtonStyle}>
                                    {isProcessing ? <LoadingSpinner /> : "Setuju & Buat Tagihan"}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* --- MODAL INVOICE & PEMBAYARAN (DESAIN BARU) --- */}
            {isModalOpen && selectedBill && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center backdrop-blur-sm p-4 animate-fade-in" onClick={closeModal}>
                    {/* Pembungkus utama modal, sekarang menjadi 'position context' */}
                    <div className="relative max-w-md w-full" onClick={(e) => e.stopPropagation()}>

                        <div ref={invoiceRef} className="p-6 bg-white rounded-t-2xl overflow-hidden">
                            {/* --- STEMPEL STATUS BARU --- */}
                            {selectedBill.status === 'PAID' ? (
                                <div className="absolute top-10 right-4 text-center transform rotate-[35deg] opacity-25">
                                    <div className="border-4 border-green-500 rounded-full px-6 py-2">
                                        <span className="text-3xl font-bold text-green-500 uppercase tracking-wider">LUNAS</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="absolute top-20 right-4 text-center transform rotate-[30deg] opacity-20">
                                    <div className="border-4 border-orange-500 rounded-full px-6 py-2">
                                        <span className="text-3xl font-bold text-orange-500 uppercase tracking-wider">BELUM LUNAS</span>
                                    </div>
                                </div>
                            )}
                            <div className="flex justify-between items-start mb-4 pb-4 border-b">
                                {/* Header dengan Logo */}
                                <div>
                                    <img src={`${process.env.PUBLIC_URL}/icon/logo-satuwarga-text.png`} alt="Logo Satuwarga" className="h-7" />
                                    <p className="text-xs text-slate-400 mt-1">INVOICE LANGGANAN</p>
                                </div>
                                <button onClick={closeModal} className="text-slate-400 hover:text-slate-800 text-2xl font-bold">&times;</button>
                            </div>

                            {/* --- Area Invoice --- */}
                            <div className="text-sm space-y-3">
                                <div>
                                    <p className="text-xs text-slate-500">Tagihan untuk:</p>
                                    <p className="font-semibold text-slate-800">{selectedBill.rtTitle}</p>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-slate-500">Invoice #</span>
                                    <span className="font-mono text-xs">{`SW/INVOICE/${selectedBill.id}`}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-slate-500">Tanggal Terbit</span>
                                    <span className="font-semibold">{selectedBill.createdAt.toDate().toLocaleDateString('id-ID')}</span>
                                </div>
                            </div>

                            {/* --- Rincian Item --- */}
                            <div className="my-4 pt-4 border-t">
                                <div className="flex justify-between items-center">
                                    <div>
                                        <p className="font-semibold text-slate-800">Langganan Paket {selectedBill.planName.charAt(0).toUpperCase() + selectedBill.planName.slice(1)}</p>
                                        <p className="text-xs text-slate-500">Siklus {selectedBill.billingCycle}</p>
                                    </div>
                                    <p className="font-semibold">Rp {selectedBill.amount.toLocaleString('id-ID')}</p>
                                </div>
                            </div>

                            {/* Total */}
                            {selectedBill.status === 'PAID' && (
                                <div className="flex justify-between items-center text-lg font-bold border-t pt-4">
                                    <span className="uppercase">Total Pesanan Dibayar</span>
                                    <span>Rp {selectedBill.amount.toLocaleString('id-ID')}</span>
                                </div>
                            )}

                            {selectedBill.status === 'UNPAID' && (
                                <div className="flex justify-between items-center text-lg font-bold border-t pt-4">
                                    <span className="uppercase">Total Pembayaran</span>
                                    <span>Rp {selectedBill.amount.toLocaleString('id-ID')}</span>
                                </div>
                            )}

                            {selectedBill.status === 'PAID' && (
                                qrisData ? (
                                    <div className="flex flex-col items-center">
                                        <p className="text-sm text-slate-600 mb-2">Pindai kode di bawah ini untuk melihat status nomor invoice</p>
                                        <div className="bg-white p-4 inline-block rounded-lg shadow-md"><QRCodeCanvas value={`SW/INVOICE/${selectedBill.id}: LUNAS`} size={220} /></div>
                                    </div>
                                ) : null
                            )}

                            {/* Area Aksi Pembayaran / Download */}
                            {/* --- AWAL BLOK JSX YANG DIPERBAIKI --- */}
                            {selectedBill.status === 'UNPAID' && (

                                <div className="mt-6 text-center min-h-[250px] flex items-center justify-center">
                                    {selectedBill.status === 'UNPAID' && (
                                        qrisData ? (
                                            // Jika qrisData ADA, tampilkan QR Code
                                            <div className="flex flex-col items-center">
                                                <p className="text-sm text-slate-600 mb-2">Pindai kode di bawah ini untuk membayar</p>
                                                {countdown && <p className={`text-sm font-semibold mt-2 ${countdown === 'Kedaluwarsa' ? 'text-red-500 animate-pulse' : 'text-slate-500'}`}>Tersisa: {countdown}</p>}
                                                <div className="bg-white p-4 inline-block rounded-lg shadow-md">
                                                    <QRCodeCanvas value={qrisData.qr_string} size={220} />
                                                </div>
                                                <img src={`${process.env.PUBLIC_URL}/icon/logo-qris.png`} alt="Logo QRIS" className="h-10 w-auto mt-3" />
                                            </div>
                                        ) : (
                                            // Jika qrisData TIDAK ADA, tampilkan pesan ini
                                            // (Tombol untuk generate ada di footer modal)
                                            <p className="text-slate-400 text-sm">Klik 'Bayar dengan QRIS' di bawah untuk menampilkan kode.</p>
                                        )
                                    )}

                                </div>
                            )}
                            {/* --- AKHIR BLOK JSX YANG DIPERBAIKI --- */}
                        </div>
                        {/* --- BAGIAN 2: FOOTER AKSI (DI LUAR AREA PRINT) --- */}
                        <div className="p-4 bg-slate-50 rounded-b-2xl border-t">
                            {selectedBill.status === 'PAID' ? (
                                <button onClick={handleDownloadInvoice} disabled={isDownloading} className={`${primaryButtonStyle} w-full`}>
                                    {isDownloading ? 'Memproses...' : 'Unduh Invoice (PNG)'}
                                </button>
                            ) : !qrisData ? ( // <-- Tampilkan tombol bayar jika QR belum ada
                                <button onClick={handleGenerateQris} disabled={isGeneratingQr} className={`${primaryButtonStyle} w-full`}>
                                    {isGeneratingQr ? <LoadingSpinner /> : 'Bayar dengan QRIS'}
                                </button>
                            ) : ( // <-- Jika QR sudah ada, tampilkan tombol tutup
                                <button onClick={closeModal} className={`${secondaryButtonStyle} w-full`}>Tutup</button>
                            )}
                        </div>
                        {/* Tombol tutup utama sekarang di luar */}
                        {/* <button onClick={closeModal} className="absolute top-2 right-2 p-2 rounded-full hover:bg-slate-100 text-slate-500 hover:text-slate-800 z-20">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </button> */}
                    </div>
                </div>
            )}
        </>
    );
};

const SubscriptionInvoicePage = ({ billId, onBack }) => {
    const { rtProfileId } = useAuth();
    const [bill, setBill] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [qrisData, setQrisData] = useState(null);
    const [isGeneratingQr, setIsGeneratingQr] = useState(false);
    const [countdown, setCountdown] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });

    // Mengambil detail tagihan spesifik berdasarkan ID
    useEffect(() => {
        if (!billId) { setIsLoading(false); return; }
        const billRef = doc(db, `rt_subscription_bills/${billId}`);
        const unsubscribe = onSnapshot(billRef, (docSnap) => {
            if (docSnap.exists()) {
                setBill({ id: docSnap.id, ...docSnap.data() });
                // Jika sudah ada data QR, langsung tampilkan
                if (docSnap.data().qrisData) {
                    const qrisResult = { ...docSnap.data().qrisData, expires_at: docSnap.data().qrisData.expires_at };
                    // Cek apakah QR sudah kedaluwarsa
                    if (qrisResult.expires_at.toDate() > new Date()) {
                        setQrisData(qrisResult);
                    } else {
                        setMessage({ text: "Kode QR sebelumnya sudah kedaluwarsa.", type: "info" });
                    }
                }
            } else {
                setError("Tagihan tidak ditemukan.");
            }
            setIsLoading(false);
        }, (err) => {
            setError("Gagal memuat data tagihan.");
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, [billId]);

    // useEffect untuk countdown timer QRIS (sama seperti di PublicPaymentForm)
    useEffect(() => {
        if (!qrisData?.expires_at) { setCountdown(''); return; }
        const intervalId = setInterval(() => {
            const expiryDate = qrisData.expires_at.toDate();
            const diff = expiryDate.getTime() - new Date().getTime();
            if (diff <= 0) {
                clearInterval(intervalId);
                setCountdown("Kedaluwarsa");
                setQrisData(null);
                setMessage({ text: "Kode QR sudah kedaluwarsa, silakan buat yang baru.", type: "error" });
                return;
            }
            const minutes = Math.floor((diff / 1000) / 60);
            const seconds = Math.floor((diff / 1000) % 60);
            setCountdown(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [qrisData]);


    const handleGenerateQris = async () => {
        setIsGeneratingQr(true);
        setError('');
        try {
            const functions = getFunctions(app, 'us-central1');
            const createSubscriptionQris = httpsCallable(functions, 'createSubscriptionQris');
            const result = await createSubscriptionQris({ subscriptionBillId: bill.id });

            const qrisResultWithTimestamp = { ...result.data, expires_at: Timestamp.fromDate(new Date(result.data.expires_at)) };
            setQrisData(qrisResultWithTimestamp);

        } catch (err) {
            setError(`Gagal membuat QR: ${err.message}`);
        } finally {
            setIsGeneratingQr(false);
        }
    };

    if (isLoading) return <div className={cardStyle}><LoadingSpinner /></div>;
    if (error) return <div className={cardStyle}><MessageBox message={error} type="error" /><button onClick={onBack} className={`${secondaryButtonStyle} mt-4`}>Kembali</button></div>;
    if (!bill) return <div className={cardStyle}>Tagihan tidak ditemukan.</div>;

    return (
        <div className={cardStyle}>
            <div className="flex items-center mb-4">
                <button onClick={onBack} className="p-2 mr-2 -ml-2 rounded-full hover:bg-slate-200">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <h2 className="text-2xl font-semibold text-slate-700">Detail Tagihan Langganan</h2>
            </div>

            {/* Area Invoice */}
            <div className="border rounded-lg p-6 bg-slate-50 space-y-3">
                <div className="text-center pb-3 border-b">
                    <p className="text-sm text-slate-500">Tagihan untuk</p>
                    <p className="font-bold text-lg text-sky-700">{bill.rtTitle}</p>
                </div>
                <div className="flex justify-between text-sm"><span className="text-slate-500">Paket Layanan</span><span className="font-semibold capitalize">{bill.planName}</span></div>
                <div className="flex justify-between text-sm"><span className="text-slate-500">Siklus</span><span className="font-semibold capitalize">{bill.billingCycle}</span></div>
                <div className="flex justify-between text-sm"><span className="text-slate-500">ID Tagihan</span><span className="font-mono text-xs">{bill.id}</span></div>
                <hr />
                <div className="flex justify-between items-center text-lg font-bold"><span className="uppercase">Total</span><span>Rp {bill.amount.toLocaleString('id-ID')}</span></div>
            </div>

            {/* Area Aksi Pembayaran */}
            <div className="mt-6 text-center">
                {bill.status === 'PAID' ? (
                    <div className="p-4 rounded-lg bg-green-100 text-green-800 font-bold">LUNAS</div>
                ) : qrisData ? (
                    <div className="flex flex-col items-center">
                        <p className="text-sm text-slate-600 mb-2">Pindai kode di bawah ini untuk membayar</p>
                        <div className="bg-white p-4 inline-block rounded-lg shadow-md"><QRCodeSVG value={qrisData.qr_string} size={256} /></div>
                        {countdown && <p className="text-sm font-semibold mt-2">{countdown}</p>}
                    </div>
                ) : (
                    <button onClick={handleGenerateQris} disabled={isGeneratingQr} className={`${primaryButtonStyle} w-full`}>
                        {isGeneratingQr ? <LoadingSpinner /> : 'Bayar dengan QRIS'}
                    </button>
                )}
            </div>
        </div>
    );
};

// --- ManageUsersPage ---
const ManageUsersPage = () => {
    const { currentUser: adminUser, rtProfileId, userRole: currentAdminRole } = useAuth();
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isAddingUser, setIsAddingUser] = useState(false);
    const [error, setError] = useState('');
    const [formMessage, setFormMessage] = useState({ text: '', type: '' });
    const [showForm, setShowForm] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState("bendahara");

    const fetchUsers = useCallback(async () => {
        if (currentAdminRole !== 'superAdmin' && !rtProfileId) {
            setIsLoading(false);
            setUsers([]);
            setError("Admin RT tidak terasosiasi dengan Profil RT yang valid.");
            return () => { };
        }

        setIsLoading(true);
        setError('');
        try {
            let q;
            if (currentAdminRole === 'superAdmin') {
                q = query(collection(db, getAdminUsersCollectionPath()));
            } else if (rtProfileId) {
                q = query(collection(db, getAdminUsersCollectionPath()), where("rtProfileId", "==", rtProfileId));
            } else {
                setIsLoading(false);
                setUsers([]);
                return () => { };
            }

            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const usersData = querySnapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
                setUsers(usersData);
                setIsLoading(false);
            }, (err) => {
                console.error("Error fetching users:", err);
                setError("Gagal memuat data pengguna. Error: " + err.message);
                setIsLoading(false);
            });
            return unsubscribe;
        } catch (err) {
            console.error("Error setting up user listener:", err);
            setError("Gagal memuat data pengguna. Error: " + err.message);
            setIsLoading(false);
            return () => { };
        }
    }, [rtProfileId, currentAdminRole]);

    useEffect(() => {
        let unsubscribe = () => { };
        fetchUsers().then(unsub => unsubscribe = unsub);
        return () => {
            if (typeof unsubscribe === 'function') {
                unsubscribe();
            }
        };
    }, [fetchUsers]);

    const handleAddUser = async (e) => {
        e.preventDefault();
        if (!email || !password || !role) {
            setFormMessage({ text: "Email, password, dan peran wajib diisi.", type: "error" });
            return;
        }
        if (password.length < 6) {
            setFormMessage({ text: "Password minimal 6 karakter.", type: "error" });
            return;
        }

        if (currentAdminRole === 'admin_rt' && role === 'bendahara') {
            const existingBendahara = users.find(u => u.role === 'bendahara' && u.rtProfileId === rtProfileId);
            if (existingBendahara) {
                setFormMessage({ text: `RT ${rtProfileId} sudah memiliki bendahara (${existingBendahara.email}). Hanya satu bendahara yang diizinkan.`, type: "error" });
                return;
            }
        }
        if (currentAdminRole === 'admin_rt' && role === 'admin_rt') {
            setFormMessage({ text: `Admin RT tidak bisa membuat Admin RT lain.`, type: "error" });
            return;
        }


        setIsAddingUser(true);
        setFormMessage({ text: '', type: '' });

        if (!adminUser) {
            setFormMessage({ text: "Sesi admin tidak valid. Silakan login kembali.", type: "error" });
            setIsAddingUser(false);
            return;
        }
        if (currentAdminRole !== 'superAdmin' && !rtProfileId) {
            setFormMessage({ text: "Admin RT harus terasosiasi dengan Profil RT untuk menambah pengguna.", type: "error" });
            setIsAddingUser(false);
            return;
        }


        let userCreationAuth;
        const secondaryAppName = `userCreationApp_${Date.now()}`;
        let secondaryAppInstance;

        try {
            secondaryAppInstance = initializeApp(firebaseConfig, secondaryAppName);
            userCreationAuth = getAuth(secondaryAppInstance);

            // console.log(`[ManageUsersPage] Attempting to create user in Auth with secondary app instance: ${secondaryAppName}`);
            const userCredential = await createUserWithEmailAndPassword(userCreationAuth, email, password);
            const newUserUid = userCredential.user.uid;
            // console.log("[ManageUsersPage] New user created in Auth (secondary app):", newUserUid, email);

            await signOut(userCreationAuth);
            // console.log("[ManageUsersPage] New user signed out from secondary app's auth context.");

            if (secondaryAppInstance) {
                await deleteApp(secondaryAppInstance);
                // console.log(`[ManageUsersPage] Secondary app instance ${secondaryAppName} deleted.`);
            }


            // console.log("[ManageUsersPage] Admin (UID:", adminUser.uid, ") creating Firestore doc for new user UID:", newUserUid);
            await setDoc(doc(db, getAdminUserDocPath(newUserUid)), {
                email: email,
                role: role,
                createdAt: Timestamp.now(),
                createdBy: adminUser.uid,
                rtProfileId: role === 'superAdmin' ? null : rtProfileId // Super admin tidak punya rtProfileId
            });
            // console.log("[ManageUsersPage] Firestore document created for new user:", newUserUid);

            setFormMessage({ text: `Pengguna ${email} (${role}) ${rtProfileId ? `untuk RT ${rtProfileId}` : ''} berhasil ditambahkan.`, type: "success" });
            setEmail('');
            setPassword('');
            setRole(currentAdminRole === 'superAdmin' ? "admin_rt" : "bendahara"); // Reset ke default yang sesuai
            setShowForm(false);

        } catch (err) {
            console.error("[ManageUsersPage] Error adding user:", err);
            if (err.code === 'auth/email-already-in-use') {
                setFormMessage({ text: `Email ${email} sudah terdaftar di sistem autentikasi. Gunakan email lain.`, type: "error" });
            } else if (err.code === 'auth/weak-password') {
                setFormMessage({ text: "Password terlalu lemah. Gunakan minimal 6 karakter.", type: "error" });
            } else {
                setFormMessage({ text: "Gagal menambahkan pengguna: " + (err.message || "Error tidak diketahui"), type: "error" });
            }
            if (secondaryAppInstance) {
                try {
                    await deleteApp(secondaryAppInstance);
                    // console.log(`[ManageUsersPage] Secondary app instance ${secondaryAppName} deleted after error.`);
                } catch (deleteError) {
                    // console.error("[ManageUsersPage] Error deleting secondary app instance after error:", deleteError);
                }
            }
        } finally {
            setIsAddingUser(false);
        }
    };

    const handleDeleteUser = async (userIdToDelete, userEmail, userRoleToDelete) => {
        if (authGlobal.currentUser?.uid === userIdToDelete) {
            setError("Anda tidak dapat menghapus akun Anda sendiri melalui antarmuka ini.");
            return;
        }
        if (currentAdminRole === 'admin_rt' && userRoleToDelete !== 'bendahara') {
            setError("Admin RT hanya dapat menghapus bendahara di RT nya.");
            return;
        }
        if (userRoleToDelete === 'superAdmin' && users.filter(u => u.role === 'superAdmin').length <= 1 && currentAdminRole === 'superAdmin') {
            setError("Tidak bisa menghapus satu-satunya Super Admin.");
            return;
        }


        if (window.confirm(`Yakin ingin menghapus data pengurus untuk ${userEmail} (${userRoleToDelete}) dari daftar pengurus? Ini TIDAK akan menghapus akun login Firebase mereka, hanya data peran di aplikasi ini.`)) {
            setIsAddingUser(true);
            setError('');
            try {
                await deleteDoc(doc(db, getAdminUserDocPath(userIdToDelete)));
                setFormMessage({ text: `Data pengurus untuk ${userEmail} berhasil dihapus dari daftar.`, type: "success" });
            } catch (err) {
                console.error("Error deleting user from Firestore roles:", err);
                setError("Gagal menghapus data peran pengguna. Error: " + err.message);
            } finally {
                setIsAddingUser(false);
            }
        }
    };

    if (isLoading && users.length === 0 && !error) return <div className={cardStyle}><LoadingSpinner /><p className="text-center">Memuat data pengguna...</p></div>;
    if (currentAdminRole !== 'superAdmin' && !rtProfileId && !isLoading) {
        return <div className={cardStyle}><MessageBox message="Admin RT tidak terasosiasi dengan Profil RT yang valid." type="error" /></div>;
    }


    return (
        <div className={cardStyle}>
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-semibold text-slate-700">Manajemen Pengguna {currentAdminRole === 'admin_rt' && rtProfileId ? `(RT: ${rtProfileId})` : ''}</h2>
                {(currentAdminRole === 'superAdmin' || (currentAdminRole === 'admin_rt' && rtProfileId)) &&
                    <button onClick={() => { setShowForm(!showForm); setFormMessage({ text: '', type: '' }); }} className={`${primaryButtonStyle}`}>
                        {showForm ? 'Batal Tambah Pengguna' : 'Tambah Pengguna Baru'}
                    </button>
                }
            </div>
            {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}
            {formMessage.text && <MessageBox message={formMessage.text} type={formMessage.type} onClose={() => setFormMessage({ text: '', type: '' })} />}


            {showForm && (
                <form onSubmit={handleAddUser} className="mb-6 p-4 border rounded-md bg-slate-50">
                    <h3 className="text-lg font-medium mb-2">Form Tambah Pengguna Baru {currentAdminRole === 'admin_rt' && rtProfileId ? `untuk RT ${rtProfileId}` : ''}</h3>
                    <div className="mb-3">
                        <label htmlFor="newUserEmail" className="block text-sm font-medium text-slate-600">Email Pengguna *</label>
                        <input type="email" id="newUserEmail" value={email} onChange={(e) => setEmail(e.target.value)} className={commonInputStyle} required autoComplete="off" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="newUserPassword" className="block text-sm font-medium text-slate-600">Password Awal (min. 6 karakter) *</label>
                        <input type="password" id="newUserPassword" value={password} onChange={(e) => setPassword(e.target.value)} className={commonInputStyle} required minLength="6" autoComplete="new-password" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="newUserRole" className="block text-sm font-medium text-slate-600">Peran *</label>
                        <select
                            id="newUserRole"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            className={commonInputStyle}
                            required
                            // Admin RT hanya bisa membuat bendahara untuk RT-nya
                            disabled={currentAdminRole === 'admin_rt'}
                        >
                            {currentAdminRole === 'superAdmin' && <option value="admin_rt">Admin RT</option>}
                            <option value="bendahara">Bendahara</option>
                            {currentAdminRole === 'superAdmin' && <option value="superAdmin">Super Admin</option>}
                        </select>
                        {currentAdminRole === 'admin_rt' && <p className="text-xs text-slate-500 mt-1">Admin RT hanya dapat menambahkan Bendahara untuk RT ini.</p>}
                    </div>
                    <button type="submit" className={`${primaryButtonStyle}`} disabled={isAddingUser}>
                        {isAddingUser ? <LoadingSpinner /> : 'Tambah Pengguna'}
                    </button>
                </form>
            )}

            <div className="overflow-x-auto">
                <h3 className="text-lg font-semibold text-slate-600 mb-3">Daftar Pengguna Terdaftar {currentAdminRole === 'admin_rt' && rtProfileId ? `(RT: ${rtProfileId})` : ''}</h3>
                <table className="min-w-full divide-y divide-slate-200">
                    <thead className="bg-slate-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Email</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Peran</th>
                            {currentAdminRole === 'superAdmin' && <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Profil RT ID</th>}
                            <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">UID</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Aksi</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-200">
                        {users.map(u => (
                            <tr key={u.id}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-800">{u.email}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500">{u.role}</td>
                                {currentAdminRole === 'superAdmin' && <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500">{u.rtProfileId || 'N/A (Global/Super)'}</td>}
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500">{u.id}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm">
                                    {adminUser?.uid !== u.id && (currentAdminRole === 'superAdmin' || (currentAdminRole === 'admin_rt' && u.role === 'bendahara' && u.rtProfileId === rtProfileId)) && (
                                        <button onClick={() => handleDeleteUser(u.id, u.email, u.role)} className="text-red-600 hover:text-red-800 text-xs" disabled={isAddingUser}>
                                            Hapus (Data Peran)
                                        </button>
                                    )}
                                    {adminUser?.uid === u.id && <span className="text-xs text-slate-400">(Anda)</span>}
                                </td>
                            </tr>
                        ))}
                        {users.length === 0 && !isLoading && (
                            <tr><td colSpan={currentAdminRole === 'superAdmin' ? 5 : 4} className="text-center py-4 text-slate-500">Belum ada pengguna (pengurus) terdaftar untuk lingkup ini.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// --- Komponen Testing Mode Badge ---
const TestingModeBadge = () => (
    <div
        style={{
            position: 'fixed',
            top: '30px',
            left: '-70px',
            width: '220px',
            textAlign: 'center',
            backgroundColor: 'rgba(255, 0, 0, 0.35)',
            color: 'white',
            padding: '8px 10px',
            fontSize: '13px',
            fontWeight: 'bold',
            zIndex: 9999,
            transform: 'rotate(-45deg)',
            transformOrigin: 'center center',
            boxShadow: '0 2px 5px rgba(0,0,0,0.4)',
            pointerEvents: 'none',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            lineHeight: '1.4',
            border: '1px solid rgba(255,255,255,0.5)',
            borderRadius: '4px'
        }}
    >
        Testing Mode
    </div>
);

// --- Komponen HouseSelectionPage (KOREKSI FINAL) ---
const HouseSelectionPage = ({
    onHouseSelectedForOtp,
    onHouseSelectedForPin,
    rtProfileId,
    onExitRtContext,
    onHouseSelectedForCreatePin,
    getEffectiveHouseVerificationStatus
}) => {
    // 1. Ubah nama state agar lebih jelas
    const [enrichedHouseholds, setEnrichedHouseholds] = useState([]);
    const [selectedHouseId, setSelectedHouseId] = useState('');
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState({ text: '', type: '' });

    // const { getEffectiveHouseVerificationStatus } = useAuth(); // <--- HAPUS BARIS INI

    useEffect(() => {
        if (!rtProfileId) {
            setLoading(false);
            return;
        }
        setLoading(true);

        const fetchAndEnrichData = async () => {
            try {
                // Ambil data households mentah
                const householdsQuery = query(collection(db, getHouseholdsCollectionPath(rtProfileId)), orderBy("houseIdentifier"));
                const householdsSnap = await getDocs(householdsQuery);
                const householdsData = householdsSnap.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));

                // Ambil data occupancies (hunian) yang aktif
                const occupanciesPath = getOccupanciesCollectionPath(rtProfileId);
                const occupanciesQuery = query(collection(db, occupanciesPath), where("status", "==", "ACTIVE"));
                const occupanciesSnap = await getDocs(occupanciesQuery);

                // Buat "peta" untuk mencari nama Payer dengan efisien
                const payerMap = new Map();
                occupanciesSnap.forEach(doc => {
                    const occData = doc.data();
                    if (occData.isPayer) {
                        payerMap.set(occData.householdId, occData.headOfFamilyName);
                    }
                });

                // Gabungkan data
                const finalHouseholds = householdsData.map(house => ({
                    ...house,
                    // Prioritaskan nama dari Payer, jika tidak ada, gunakan nama dari data rumah,
                    // jika masih tidak ada, gunakan fallback.
                    occupantName: payerMap.get(house.id) || house.occupantName || 'Penghuni'
                }));

                setEnrichedHouseholds(finalHouseholds);

            } catch (error) {
                console.error("Error fetching and enriching households:", error);
                setMessage({ text: "Gagal memuat data rumah.", type: 'error' });
            } finally {
                setLoading(false);
            }
        };

        fetchAndEnrichData();

    }, [rtProfileId]);

    // --- FUNGSI handleNext YANG SEKARANG LEBIH CERDAS ---
    const handleNext = async () => {
        if (!selectedHouseId) {
            setMessage({ text: "Silakan pilih nomor rumah terlebih dahulu.", type: "error" });
            return;
        }

        setLoading(true);
        setMessage({ text: '', type: '' });

        try {
            // Gunakan data dari `enrichedHouseholds`
            const houseData = enrichedHouseholds.find(h => h.id === selectedHouseId);
            if (!houseData) throw new Error("Data rumah yang dipilih tidak valid.");

            // Sisa dari logika ini tidak berubah, karena sudah dirancang
            // untuk menangani alur verifikasi selanjutnya.
            const storedPinHash = localStorage.getItem(`${PIN_STORAGE_PREFIX}${houseData.id}`);
            if (storedPinHash) {
                onHouseSelectedForPin({ ...houseData, rtProfileId });
            } else {
                const occupanciesPath = getOccupanciesCollectionPath(rtProfileId);
                const q = query(collection(db, occupanciesPath), where("householdId", "==", selectedHouseId), where("status", "==", "ACTIVE"), where("isPayer", "==", true), limit(1));
                const occupancySnap = await getDocs(q);
                if (occupancySnap.empty) throw new Error("Rumah ini tidak memiliki data penanggung jawab iuran yang aktif.");

                const payerOccupancyData = occupancySnap.docs[0].data();
                const residentQuery = query(collection(db, getResidentsCollectionPath(rtProfileId)), where("familyId", "==", payerOccupancyData.familyId), limit(1));
                const residentSnap = await getDocs(residentQuery);
                const residentData = residentSnap.empty ? {} : residentSnap.docs[0].data();

                const finalHouseData = { ...houseData, rtProfileId, phoneNumber: residentData.phoneNumber || '', payerName: payerOccupancyData.headOfFamilyName, familyId: payerOccupancyData.familyId, moveInDate: payerOccupancyData.moveInDate };
                const isOtpVerificationEnabled = getEffectiveHouseVerificationStatus(rtProfileId);

                if (isOtpVerificationEnabled && finalHouseData.phoneNumber) {
                    onHouseSelectedForOtp(finalHouseData);
                } else {
                    onHouseSelectedForCreatePin(finalHouseData);
                }
            }
        } catch (err) {
            console.error("Error processing house selection:", err);
            setMessage({ text: `Terjadi kesalahan: ${err.message}`, type: "error" });
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className={cardStyle}><LoadingSpinner /></div>;
    // console.log(enrichedHouseholds);
    return (
        <div className={`${cardStyle} max-w-md mx-auto`}>
            <h2 className="text-2xl font-semibold text-center text-slate-700 mb-6">Pilih Rumah Anda</h2>
            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />
            <div className="mb-4">
                <SearchableHouseSelect
                    households={enrichedHouseholds}
                    selectedHouseId={selectedHouseId}
                    onHouseSelect={setSelectedHouseId}
                    label="Pilih Nomor Rumah Anda *"
                    idPrefix="house-select-main"
                />
            </div>
            <button onClick={handleNext} className={`${primaryButtonStyle} w-full`} disabled={loading}>
                {loading ? <LoadingSpinner /> : 'Selanjutnya'}
            </button>
            <div className="text-center mt-4">
                <button onClick={onExitRtContext} className="text-sm text-slate-500 hover:text-slate-700 hover:underline">
                    Bukan RT Anda? Keluar Sesi RT
                </button>
            </div>
        </div>
    );
};

// --- Komponen PhoneOtpVerificationPage (Menggunakan Firebase Phone Auth) ---
// --- GANTI SELURUH KOMPONEN PhoneOtpVerificationPage DENGAN VERSI FINAL INI ---

// GANTI SELURUH KOMPONEN PhoneOtpVerificationPage DENGAN VERSI FINAL INI

const PhoneOtpVerificationPage = ({ houseData, onPhoneOtpVerified, onCancel }) => {
    const [phoneOtpInput, setPhoneOtpInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [confirmationResultState, setConfirmationResultState] = useState(null);
    const recaptchaContainerRef = useRef(null);

    // --- LOGIKA BARU: KIRIM OTP OTOMATIS SAAT HALAMAN DIMUAT ---
    useEffect(() => {
        // Kita beri jeda 500 milidetik untuk memastikan semua script siap
        const timer = setTimeout(() => {
            handleSendPhoneOtp();
        }, 500);

        return () => clearTimeout(timer); // Cleanup timer
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Array dependensi kosong agar hanya berjalan sekali saat mount

    const handleSendPhoneOtp = async () => {
        // Jangan kirim ulang jika sedang loading atau sudah ada hasilnya
        if (loading || confirmationResultState) return;

        if (!houseData || !houseData.phoneNumber) {
            setMessage({ text: "Nomor HP tidak ditemukan pada data penanggung jawab.", type: "error" });
            return;
        }

        setLoading(true);
        setMessage({ text: `Mengirim kode verifikasi ke ${houseData.phoneNumber}...`, type: "info" });

        try {
            // workaround untuk testing di localhost
            authGlobal.settings.appVerificationDisabledForTesting = true;

            const verifier = new RecaptchaVerifier(authGlobal, recaptchaContainerRef.current, { 'size': 'invisible' });

            const confirmationResult = await signInWithPhoneNumber(authGlobal, houseData.phoneNumber, verifier);

            setConfirmationResultState(confirmationResult);
            setMessage({ text: `Kode OTP berhasil dikirim. Silakan periksa HP Anda.`, type: "success" });

        } catch (error) {
            console.error("Error mengirim OTP:", error);
            // Memberikan pesan error yang lebih spesifik jika memungkinkan
            let errorMessage = `Gagal mengirim OTP: ${error.message}`;
            if (error.code === 'auth/captcha-check-failed') {
                errorMessage = "Verifikasi reCAPTCHA gagal. Pastikan koneksi internet Anda stabil dan coba muat ulang halaman.";
            } else if (error.code === 'auth/invalid-phone-number') {
                errorMessage = "Format nomor HP tidak valid. Pastikan formatnya benar (contoh: +628123...).";
            }
            setMessage({ text: errorMessage, type: "error" });
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitPhoneOtp = async (e) => {
        e.preventDefault();
        if (!confirmationResultState || phoneOtpInput.length !== 6) return;
        setLoading(true);

        try {
            await confirmationResultState.confirm(phoneOtpInput);
            setMessage({ text: "Verifikasi OTP HP berhasil!", type: "success" });
            // Matikan kembali mode testing setelah berhasil
            authGlobal.settings.appVerificationDisabledForTesting = false;
            // Beri jeda agar pengguna bisa membaca pesan sukses
            setTimeout(() => onPhoneOtpVerified(houseData), 1500);

        } catch (error) {
            console.error("Error verifikasi OTP:", error);
            setMessage({ text: "Kode OTP salah atau sudah kedaluwarsa.", type: "error" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`${cardStyle} max-w-md mx-auto`}>
            <h2 className="text-2xl font-semibold text-center">Verifikasi Nomor HP</h2>
            {/* Div ini untuk 'jangkar' reCAPTCHA, bisa disembunyikan */}
            <div ref={recaptchaContainerRef} id="recaptcha-container-phone-otp" className="my-2 flex justify-center"></div>

            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />

            <form onSubmit={handleSubmitPhoneOtp}>
                <div className="mb-4">
                    <label htmlFor="phone-otp" className="block text-sm">Masukkan Kode OTP (6 Digit)</label>
                    <input type="text" id="phone-otp" value={phoneOtpInput} onChange={(e) => setPhoneOtpInput(e.target.value)} className={commonInputStyle} maxLength="6" required />
                </div>
                <button type="submit" className={`${primaryButtonStyle} w-full`} disabled={loading || !confirmationResultState}>
                    {loading ? <LoadingSpinner /> : 'Verifikasi OTP HP'}
                </button>
            </form>

            <button onClick={onCancel} className={`${secondaryButtonStyle} w-full mt-2`}>
                Batal / Pilih Rumah Lain
            </button>
        </div>
    );
};

// --- Komponen CreatePinPage (Baru) ---
// Ganti seluruh komponen CreatePinPage Anda dengan ini
const CreatePinPage = ({ houseData, onPinCreated, onCancel }) => {
    const [pin, setPin] = useState('');
    const [confirmPin, setConfirmPin] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [pinStep, setPinStep] = useState('enter');

    // ... (fungsi handleDigitClick, handleDelete, handleSubmit tidak berubah)
    const handleDigitClick = (digit) => { if (pinStep === 'enter') { if (pin.length < 6) setPin(pin + digit); } else { if (confirmPin.length < 6) setConfirmPin(confirmPin + digit); } };
    const handleDelete = () => { if (pinStep === 'enter') { setPin(pin.slice(0, -1)); } else { setConfirmPin(confirmPin.slice(0, -1)); } };
    const handleSubmit = (e) => { e.preventDefault(); setMessage({ text: '', type: '' }); if (pinStep === 'enter') { if (pin.length !== 6 || !/^\d{6}$/.test(pin)) { setMessage({ text: "PIN Baru harus 6 digit angka.", type: "error" }); return; } setPinStep('confirm'); } else { if (confirmPin.length !== 6 || !/^\d{6}$/.test(confirmPin)) { setMessage({ text: "Konfirmasi PIN harus 6 digit angka.", type: "error" }); return; } if (pin !== confirmPin) { setMessage({ text: "PIN dan Konfirmasi PIN tidak cocok. Silakan ulangi dari awal.", type: "error" }); setPin(''); setConfirmPin(''); setPinStep('enter'); return; } setLoading(true); const pinHash = `hashed_${pin}_${houseData.id}`; localStorage.setItem(`${PIN_STORAGE_PREFIX}${houseData.id}`, pinHash); setTimeout(() => { onPinCreated(houseData); setLoading(false); }, 1500); } };

    // Sub-komponen untuk tampilan
    const PinInputDisplay = ({ value }) => (<div className="flex justify-center gap-2 my-4"> {[...Array(6)].map((_, i) => (<div key={i} className={`w-10 h-10 border-2 rounded-full flex items-center justify-center transition-all ${value.length > i ? 'bg-white border-white' : 'bg-transparent border-orange-200'}`}> {value.length > i && <span className="text-orange-500 text-xl">•</span>} </div>))} </div>);
    const KeypadButton = ({ number, onClick }) => (<button type="button" onClick={() => onClick(number.toString())} className="aspect-square bg-white/20 hover:bg-white/30 rounded-full text-3xl font-semibold text-white focus:outline-none focus:ring-2 focus:ring-white transition-colors flex items-center justify-center"> {number} </button>);
    const BackspaceButton = ({ onClick }) => (<button type="button" onClick={onClick} className="aspect-square bg-white/20 hover:bg-white/30 rounded-full text-2xl font-semibold text-white focus:outline-none focus:ring-2 focus:ring-white flex items-center justify-center transition-colors"> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z" /></svg> </button>);

    return (
        <div className="w-full flex flex-col items-center">
            <h2 className="text-3xl font-semibold text-center">{pinStep === 'enter' ? 'Buat PIN Baru' : 'Konfirmasi PIN'}</h2>
            <p className="text-sm text-center text-orange-100 mt-2 mb-4">Untuk Rumah: <strong>{houseData?.houseIdentifier}</strong></p>
            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />
            <form onSubmit={handleSubmit} className="w-full flex flex-col items-center">
                <PinInputDisplay value={pinStep === 'enter' ? pin : confirmPin} />

                {/* --- PERUBAHAN DI SINI: Tambahkan max-w-xs --- */}
                <div className="w-full max-w-xs grid grid-cols-3 gap-4 my-6">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => <KeypadButton key={num} number={num} onClick={handleDigitClick} />)}
                    <div></div>
                    <KeypadButton number={0} onClick={handleDigitClick} />
                    <BackspaceButton onClick={handleDelete} />
                </div>

                <button type="submit" className="w-full max-w-xs bg-white text-orange-600 font-bold py-3 rounded-xl shadow-lg hover:bg-orange-50 transition-colors" disabled={loading || (pinStep === 'enter' && pin.length !== 6) || (pinStep === 'confirm' && confirmPin.length !== 6)}>
                    {loading ? <LoadingSpinner /> : (pinStep === 'enter' ? 'Selanjutnya' : 'Simpan PIN')}
                </button>
            </form>
            <div className="text-center mt-6">
                <button onClick={onCancel} className="text-sm text-orange-100 hover:text-white hover:underline">Batal</button>
            </div>
        </div>
    );
};

// --- Komponen EnterPinPage (DIPERBARUI DENGAN LOGIKA FREE PLAN) ---
const EnterPinPage = ({ houseData, onPinVerified, onCancel, onForgotPin }) => {
    const [pinInput, setPinInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    // 1. Ambil appConfig dari useAuth untuk mengetahui konfigurasi RT
    const { appConfig } = useAuth();

    // 2. Tentukan apakah ini alur premium berdasarkan konfigurasi RT
    const isPremiumFlow = useMemo(() => {
        if (!appConfig || !houseData?.rtProfileId) return false;
        const rtConfig = appConfig.rtProfiles?.[houseData.rtProfileId];
        // Jika verifikasi rumah (OTP HP) diaktifkan, maka itu adalah alur premium
        return rtConfig?.isHouseVerificationEnabled === true;
    }, [appConfig, houseData]);


    // Logika verifikasi PIN tidak berubah
    useEffect(() => {
        if (!houseData) return;
        if (pinInput.length !== 6) return;
        const verifyPin = () => {
            setLoading(true);
            setMessage({ text: '', type: '' });
            const storedPinHash = localStorage.getItem(`${PIN_STORAGE_PREFIX}${houseData.id}`);
            const inputPinHash = `hashed_${pinInput}_${houseData.id}`;
            setTimeout(() => {
                if (storedPinHash && inputPinHash === storedPinHash) {
                    onPinVerified(houseData);
                } else {
                    setMessage({ text: "PIN salah. Silakan coba lagi.", type: "error" });
                    setPinInput('');
                    setLoading(false);
                }
            }, 200);
        };
        verifyPin();
    }, [pinInput, houseData, onPinVerified]);

    const handleDigitClick = (digit) => { if (pinInput.length < 6) setPinInput(prevPin => prevPin + digit); };
    const handleDelete = () => { setPinInput(prevPin => prevPin.slice(0, -1)); };

    const PinInputDisplay = ({ value }) => (<div className="flex justify-center gap-2 my-4"> {[...Array(6)].map((_, i) => (<div key={i} className={`w-10 h-10 border-2 rounded-full flex items-center justify-center transition-all ${value.length > i ? 'bg-white border-white' : 'bg-transparent border-orange-200'}`} > {value.length > i && <span className="text-orange-500 text-xl">•</span>} </div>))} </div>);
    const KeypadButton = ({ number, onClick }) => (<button type="button" onClick={() => onClick(number.toString())} className="aspect-square bg-white/20 hover:bg-white/30 rounded-full text-3xl font-semibold text-white focus:outline-none focus:ring-2 focus:ring-white transition-colors flex items-center justify-center"> {number} </button>);
    const BackspaceButton = ({ onClick }) => (<button type="button" onClick={onClick} className="aspect-square bg-white/20 hover:bg-white/30 rounded-full text-2xl font-semibold text-white focus:outline-none focus:ring-2 focus:ring-white flex items-center justify-center transition-colors"> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z" /></svg> </button>);

    return (
        <div className="w-full flex flex-col items-center">
            <h2 className="text-3xl font-semibold text-center">Masukkan PIN</h2>
            <p className="text-sm text-center text-orange-100 mt-2 mb-4">Untuk Rumah: <strong>{houseData?.houseIdentifier}</strong></p>
            {loading && <LoadingSpinner />}
            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />
            <PinInputDisplay value={pinInput} />
            <div className="w-full max-w-xs grid grid-cols-3 gap-4 my-6">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => <KeypadButton key={num} number={num} onClick={handleDigitClick} />)}

                {/* 3. Tampilkan link "Lupa PIN?" secara kondisional */}
                {isPremiumFlow ? (
                    <button type="button" onClick={() => onForgotPin(houseData)} className="aspect-square flex items-center justify-center text-base font-semibold text-orange-100 hover:text-white transition-colors rounded-full hover:bg-white/10">Lupa?</button>
                ) : (
                    // Beri placeholder kosong agar layout keypad tidak rusak
                    <div></div>
                )}

                <KeypadButton number={0} onClick={handleDigitClick} />
                <BackspaceButton onClick={handleDelete} />
            </div>

            <div className="w-full text-center mt-6">
                <button onClick={onCancel} className="text-sm text-orange-100 hover:text-white hover:underline">Pilih Rumah Lain</button>
            </div>
        </div>
    );
};

// --- Komponen PublicAnnouncementsPage (GANTI SELURUHNYA) ---
const PublicAnnouncementsPage = ({ rtProfileId, onBack }) => {
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // --- State dan Ref untuk Infinite Scroll ---
    const [lastVisible, setLastVisible] = useState(null); // Menyimpan dokumen terakhir yang terlihat
    const [hasMore, setHasMore] = useState(true);         // Menandakan apakah masih ada data untuk dimuat
    const [loadingMore, setLoadingMore] = useState(false);  // Status loading saat memuat data tambahan
    const observer = useRef(); // Ref untuk Intersection Observer
    const ANNOUNCEMENTS_PER_PAGE = 10; // Tentukan berapa banyak pengumuman per halaman

    // --- useCallback untuk elemen terakhir yang akan diobservasi ---
    const lastAnnouncementElementRef = useCallback(node => {
        if (loading || loadingMore) return; // Jangan lakukan apa-apa jika sedang loading
        if (observer.current) observer.current.disconnect(); // Putuskan observer lama

        observer.current = new IntersectionObserver(entries => {
            // Jika elemen terakhir terlihat di layar DAN masih ada data untuk dimuat
            if (entries[0].isIntersecting && hasMore) {
                // console.log("[PublicAnnouncementsPage] Elemen terakhir terlihat, memuat lebih banyak...");
                fetchMoreAnnouncements();
            }
        });

        if (node) observer.current.observe(node); // Amati elemen baru
    }, [loading, loadingMore, hasMore]); // Dependensi untuk membuat ulang observer jika state ini berubah


    // --- Fungsi untuk memuat data selanjutnya ---
    const fetchMoreAnnouncements = useCallback(async () => {
        if (!lastVisible) { // Jika tidak ada dokumen terakhir, berarti sudah akhir
            setHasMore(false);
            return;
        }
        setLoadingMore(true);
        const announcementsPath = `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/announcements`;
        const nextQuery = query(
            collection(db, announcementsPath),
            orderBy("createdAt", "desc"),
            startAfter(lastVisible), // Mulai dari setelah dokumen terakhir yang terlihat
            limit(ANNOUNCEMENTS_PER_PAGE)
        );

        try {
            const documentSnapshots = await getDocs(nextQuery);
            if (documentSnapshots.empty) {
                setHasMore(false); // Tidak ada lagi data
            } else {
                const newAnnouncements = documentSnapshots.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setAnnouncements(prev => [...prev, ...newAnnouncements]); // Gabungkan dengan data lama
                setLastVisible(documentSnapshots.docs[documentSnapshots.docs.length - 1]); // Update dokumen terakhir
                setHasMore(newAnnouncements.length === ANNOUNCEMENTS_PER_PAGE); // Cek jika masih ada kemungkinan data lebih
            }
        } catch (err) {
            console.error("Error fetching more announcements:", err);
            setError("Gagal memuat pengumuman selanjutnya.");
        }
        setLoadingMore(false);
    }, [lastVisible, rtProfileId]); // Dependensi untuk fungsi ini

    // --- Fetch data awal (saat komponen pertama kali dimuat) ---
    useEffect(() => {
        if (!rtProfileId) {
            setError("Profil RT tidak valid.");
            setLoading(false);
            return;
        }
        setLoading(true);
        const announcementsPath = `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/announcements`;
        const firstQuery = query(
            collection(db, announcementsPath),
            orderBy("createdAt", "desc"),
            limit(ANNOUNCEMENTS_PER_PAGE)
        );

        const unsubscribe = onSnapshot(firstQuery, (snapshot) => {
            if (snapshot.empty) {
                setHasMore(false);
                setAnnouncements([]);
            } else {
                const announcementsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setAnnouncements(announcementsData);
                setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
                setHasMore(announcementsData.length === ANNOUNCEMENTS_PER_PAGE);
            }
            setLoading(false);
        }, (err) => {
            console.error("Error fetching initial announcements:", err);
            setError("Gagal memuat pengumuman.");
            setLoading(false);
        });

        return () => unsubscribe(); // Cleanup listener onSnapshot
    }, [rtProfileId]);

    if (loading) return <div className={cardStyle}><LoadingSpinner /><p className="text-center">Memuat Pengumuman...</p></div>;
    if (error) return <div className={cardStyle}><MessageBox message={error} type="error" /></div>;

    return (
        <div className={`${cardStyle} max-w-2xl mx-auto`}>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold text-slate-700">Pengumuman RT</h2>
                <button onClick={onBack} className={secondaryButtonStyle}>Kembali</button>
            </div>
            {announcements.length === 0 ? (
                <p className="text-center text-slate-500">Belum ada pengumuman.</p>
            ) : (
                <div className="space-y-4">
                    {announcements.map((ann, index) => {
                        // Jika ini adalah elemen terakhir, pasang ref ke elemen tersebut
                        if (announcements.length === index + 1) {
                            return (
                                <div ref={lastAnnouncementElementRef} key={ann.id} className="p-4 border rounded-lg bg-slate-50">
                                    <h3 className="font-bold text-lg text-sky-700">{ann.title}</h3>
                                    <p className="text-xs text-slate-400 mb-2">
                                        Dipublikasikan pada: {ann.createdAt?.toDate().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                    </p>
                                    <p className="text-slate-600 whitespace-pre-wrap">{ann.content}</p>
                                </div>
                            );
                        } else {
                            return (
                                <div key={ann.id} className="p-4 border rounded-lg bg-slate-50">
                                    <h3 className="font-bold text-lg text-sky-700">{ann.title}</h3>
                                    <p className="text-xs text-slate-400 mb-2">
                                        Dipublikasikan pada: {ann.createdAt?.toDate().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                    </p>
                                    <p className="text-slate-600 whitespace-pre-wrap">{ann.content}</p>
                                </div>
                            );
                        }
                    })}
                </div>
            )}

            {/* Tampilkan spinner di bagian bawah saat sedang memuat data selanjutnya */}
            <div className="text-center mt-6 h-10">
                {loadingMore && <LoadingSpinner />}
                {!hasMore && announcements.length > 0 && <p className="text-sm text-slate-400">Anda sudah mencapai akhir daftar pengumuman.</p>}
            </div>
        </div>
    );
};

// --- Halaman Kartu Iuran Digital (Versi Baru - FINAL dengan Ringkasan) ---
const KartuIuranPage = ({ loggedInHouseData, onNavigate, rtProfileId }) => {
    // --- STATE MANAGEMENT ---
    const { appConfig } = useAuth();
    const [bills, setBills] = useState([]);
    const [allTemplates, setAllTemplates] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [showQrModal, setShowQrModal] = useState(false);
    const [availableHouseholds, setAvailableHouseholds] = useState([]);
    const [publicSelectedHouse, setPublicSelectedHouse] = useState(null);

    // --- DATA DERIVATION ---
    const sessionData = loggedInHouseData || publicSelectedHouse;
    const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId];

    // --- DATA FETCHING ---
    useEffect(() => {
        const fetchDataForSession = async () => {
            if (!rtProfileId || !sessionData?.familyId) {
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            try {
                const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
                const templatesSnap = await getDocs(query(collection(db, templatesPath)));
                const tmplMap = {};
                templatesSnap.forEach(doc => { tmplMap[doc.id] = doc.data(); });
                setAllTemplates(tmplMap);

                const currentMode = currentRtConfig?.isTestingMode ? "testing" : "live";
                const billsPath = getBillsCollectionPath(rtProfileId);
                const q = query(collection(db, billsPath),
                    where("familyId", "==", sessionData.familyId),
                    where("mode", "==", currentMode)
                );
                const billsSnapshot = await getDocs(q);
                const billsData = billsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setBills(billsData);
            } catch (err) {
                setError("Gagal memuat data kartu iuran.");
                console.error("Error fetching data for Kartu Iuran:", err);
            } finally {
                setIsLoading(false);
            }
        };

        const fetchAvailableHouseholds = async () => {
            if (!rtProfileId || loggedInHouseData) {
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            try {
                const householdsPath = getHouseholdsCollectionPath(rtProfileId);
                const householdsSnap = await getDocs(query(collection(db, householdsPath), orderBy("houseIdentifier")));
                setAvailableHouseholds(householdsSnap.docs.map(d => ({ id: d.id, ...d.data() })));
            } catch (err) {
                setError("Gagal memuat daftar rumah.");
            } finally {
                setIsLoading(false);
            }
        };

        if (sessionData) {
            fetchDataForSession();
        } else {
            fetchAvailableHouseholds();
        }
    }, [rtProfileId, sessionData, currentRtConfig, loggedInHouseData]);

    // --- FUNGSI HANDLER ---
    const handlePublicHouseSelect = async (houseId) => {
        if (!houseId) {
            setPublicSelectedHouse(null);
            return;
        }
        setIsLoading(true);
        setError('');
        try {
            const payersPath = getOccupanciesCollectionPath(rtProfileId);
            const q = query(collection(db, payersPath), where("householdId", "==", houseId), where("isPayer", "==", true), where("status", "==", "ACTIVE"), limit(1));
            const payerSnap = await getDocs(q);
            if (!payerSnap.empty) {
                const payerData = payerSnap.docs[0].data();
                const houseData = availableHouseholds.find(h => h.id === houseId);
                const newSession = { ...houseData, familyId: payerData.familyId, moveInDate: payerData.moveInDate, payerName: payerData.headOfFamilyName, rtProfileId };
                setPublicSelectedHouse(newSession);
            } else {
                setError("Data penanggung jawab iuran untuk rumah ini tidak ditemukan. Hubungi pengurus.");
            }
        } catch (err) {
            setError("Gagal mengambil data hunian.");
        } finally {
            setIsLoading(false);
        }
    };

    // --- KALKULASI DATA RINGKASAN (BAGIAN BARU) ---
    const iuranSummary = useMemo(() => {
        if (!bills || bills.length === 0) {
            return { totalTunggakan: 0, tunggakanBulanIni: 0, jumlahBulanNunggak: 0 };
        }

        const now = new Date();
        const currentMonth = now.getMonth() + 1; // bulan (1-12)
        const currentYear = now.getFullYear();

        const unpaidBills = bills.filter(b => (b.status === 'UNPAID' || b.status === 'PENDING_QRIS') && !b.rejectionReason);

        const totalTunggakan = unpaidBills.reduce((acc, bill) => acc + bill.amount, 0);

        const tunggakanBulanIni = unpaidBills
            .filter(b => b.billPeriodMonth === currentMonth && b.billPeriodYear === currentYear)
            .reduce((acc, bill) => acc + bill.amount, 0);

        const jumlahBulanNunggak = unpaidBills.filter(b => {
            const template = allTemplates[b.duesTemplateId];
            // Hanya hitung tunggakan yang sifatnya bulanan/rutin untuk metrik ini
            return template && (template.period === 'bulanan' || template.isPrimary);
        }).length;

        return { totalTunggakan, tunggakanBulanIni, jumlahBulanNunggak };
    }, [bills, allTemplates]);


    // Data untuk QR Code Identitas
    const identityQrData = useMemo(() => {
        if (!rtProfileId || !sessionData?.id) return null;
        return JSON.stringify({
            rtId: rtProfileId,
            householdId: sessionData.id,
            payerName: sessionData.payerName
        });
    }, [rtProfileId, sessionData]);


    if (isLoading) return <div className={cardStyle}><LoadingSpinner /></div>;
    if (error) return <div className={cardStyle}><MessageBox message={error} type="error" /></div>;

    if (!sessionData) {
        return (
            <div className={`${cardStyle} max-w-lg mx-auto`}>
                <h2 className="text-2xl font-semibold text-center text-slate-700 mb-6">Pilih Rumah Anda</h2>
                <p className="text-center text-sm text-slate-500 mb-4">Untuk melihat Kartu Identitas Digital, silakan pilih rumah Anda terlebih dahulu.</p>
                <SearchableHouseSelect
                    households={availableHouseholds}
                    selectedHouseId={publicSelectedHouse?.id || ''}
                    onHouseSelect={handlePublicHouseSelect}
                    label="Nomor Rumah Anda *"
                    idPrefix="public-kartu-iuran"
                />
            </div>
        );
    }

    return (
        <div className="space-y-6">
            {/* --- BAGIAN 1: KARTU IDENTITAS DIGITAL --- */}
            <div className="p-5 bg-gradient-to-br from-sky-500 to-sky-700 rounded-2xl shadow-lg text-white relative overflow-hidden animate-fade-in">
                <div className="absolute -top-4 -right-4 w-24 h-24 bg-white/10 rounded-full"></div>
                <div className="absolute -bottom-8 -left-4 w-32 h-32 bg-white/10 rounded-full"></div>

                <div className="relative z-10">
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-sm font-light">{currentRtConfig?.rtTitle || "Warga"}</p>
                            <p className="text-lg font-bold">{sessionData.payerName || "Nama Payer"}</p>
                        </div>
                        <img src={currentRtConfig?.logoUrl || LOGO_URL} alt="Logo RT" className="w-10 h-10 rounded-full bg-white p-1" />
                    </div>
                    <div className="flex justify-between items-end mt-8">
                        <div>
                            <p className="text-xs uppercase">Rumah</p>
                            <p className="font-mono text-base tracking-wider">{sessionData.houseIdentifier}</p>
                        </div>
                        {identityQrData && (
                            <button onClick={() => setShowQrModal(true)} className="p-2 bg-white/20 rounded-lg hover:bg-white/30">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v1m6 11h-1m-2-11h1m-6.758 11.243l.707.707M5.636 5.636l.707.707M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6" />
                                </svg>
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* --- BAGIAN 2: RINGKASAN STATUS IURAN (IMPLEMENTASI BARU) --- */}
            <div>
                <h3 className="text-base font-semibold text-slate-700 mb-2">Ringkasan Status Iuran</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div className="bg-red-50 p-4 rounded-xl text-center shadow-sm">
                        <p className="text-xs font-semibold text-red-800 uppercase">Total Tunggakan</p>
                        <p className="text-2xl font-bold text-red-600 mt-1">
                            Rp {iuranSummary.totalTunggakan.toLocaleString('id-ID')}
                        </p>
                    </div>
                    <div className="bg-yellow-50 p-4 rounded-xl text-center shadow-sm">
                        <p className="text-xs font-semibold text-yellow-800 uppercase">Tagihan Bulan Ini</p>
                        <p className="text-2xl font-bold text-yellow-600 mt-1">
                            Rp {iuranSummary.tunggakanBulanIni.toLocaleString('id-ID')}
                        </p>
                    </div>
                    <div className="bg-slate-100 p-4 rounded-xl text-center shadow-sm">
                        <p className="text-xs font-semibold text-slate-700 uppercase">Jumlah Tunggakan</p>
                        <p className="text-2xl font-bold text-slate-800 mt-1">
                            {iuranSummary.jumlahBulanNunggak} <span className="text-base font-medium">Bulan</span>
                        </p>
                    </div>
                </div>
            </div>


            {/* --- MODAL UNTUK MENAMPILKAN QR CODE IDENTITAS --- */}
            {showQrModal && identityQrData && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-70 flex items-center justify-center p-4" onClick={() => setShowQrModal(false)}>
                    <div className="bg-white p-6 rounded-lg shadow-xl flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
                        <h3 className="text-lg font-semibold mb-2 text-slate-800">QR Code Identitas Warga</h3>
                        <p className="text-sm text-center text-slate-500 mb-4">Tunjukkan kode ini kepada petugas untuk verifikasi.</p>
                        <div className="bg-white p-4 inline-block rounded-lg shadow-inner">
                            <QRCodeSVG value={identityQrData} size={256} level={"H"} includeMargin={true} />
                        </div>
                        <button onClick={() => setShowQrModal(false)} className={`${secondaryButtonStyle} w-full mt-6`}>Tutup</button>
                    </div>
                </div>
            )}
        </div>
    );
};

// --- Halaman Pusat Tagihan & Pembayaran Warga (FINAL DEFINITIF - SEMUA FITUR LENGKAP) ---
const PusatTagihanPage = ({ loggedInHouseData, onViewChange, rtProfileId, onNavigate, refreshSignal }) => {
    // --- STATE MANAGEMENT ---
    const { appConfig } = useAuth();
    const [bills, setBills] = useState([]);
    const [allTemplates, setAllTemplates] = useState({});
    const [paymentHistory, setPaymentHistory] = useState([]);
    const [availableHouseholds, setAvailableHouseholds] = useState([]);
    const [publicSelectedHouse, setPublicSelectedHouse] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [activeTab, setActiveTab] = useState('ALL_UNPAID');
    const [viewMode, setViewMode] = useState('summary');
    const [selectedDuesType, setSelectedDuesType] = useState(null);
    const [lastVisiblePayment, setLastVisiblePayment] = useState(null);
    const [hasMoreHistory, setHasMoreHistory] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const observerTarget = useRef(null);
    const PAYMENTS_PER_PAGE = 5;
    const [selectionMode, setSelectionMode] = useState(false);
    const [selectedBills, setSelectedBills] = useState({});
    const [message, setMessage] = useState({ text: '', type: '' });
    const sessionData = loggedInHouseData || publicSelectedHouse;
    const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId];

    // --- HELPER FUNCTION ---
    const formatBillPeriodForDisplay = (item) => {
        const template = allTemplates[item.duesTemplateId];
        if (!template) return `${MONTHS[(item.billPeriodMonth || item.paymentMonth) - 1]} ${item.billPeriodYear || item.paymentYear}`;
        const periodType = template.period;
        const monthIndex = (item.billPeriodMonth || item.paymentMonth) - 1;
        const year = item.billPeriodYear || item.paymentYear;
        switch (periodType) {
            case 'triwulan':
                if (monthIndex === 0) return `Triwulan 1 (${year})`;
                if (monthIndex === 3) return `Triwulan 2 (${year})`;
                if (monthIndex === 6) return `Triwulan 3 (${year})`;
                if (monthIndex === 9) return `Triwulan 4 (${year})`;
                return `Triwulan Tidak Valid`;
            case 'semester':
                if (monthIndex === 0) return `Semester 1 (${year})`;
                if (monthIndex === 6) return `Semester 2 (${year})`;
                return `Semester Tidak Valid`;
            case 'tahunan':
                return `Tahunan (${year})`
            case 'sekali bayar':
                return `Sekali Bayar (${year})`;
            default: return `${MONTHS[monthIndex]} ${year}`;
        }
    };

    const formatParentBillTitle = (parentBill) => {
        // Ambil 2 periode pertama untuk ditampilkan sebagai ringkasan
        const childPeriods = (parentBill.relatedBillIds || [])
            .map(id => {
                const childBill = bills.find(b => b.id === id);
                return childBill ? formatBillPeriodForDisplay(childBill) : null;
            })
            .filter(Boolean) // Hapus yang mungkin tidak ditemukan
            .slice(0, 2); // Ambil maksimal 2 item pertama

        let periodSummary = childPeriods.join(', ');
        if ((parentBill.relatedBillIds?.length || 0) > 2) {
            periodSummary += ', ...'; // Tambahkan elipsis jika lebih dari 2
        }

        return `${parentBill.duesType} (${periodSummary})`;
    };

    // const formatPaymentPeriodForDisplay = (bill) => {
    //     // Fungsi ini tidak berubah
    //     const template = allTemplates[bill.duesTemplateId];
    //     if (!template) return `${MONTHS[bill.paymentMonth - 1]} ${bill.paymentYear}`;
    //     const periodType = template.period;
    //     const monthIndex = bill.paymentMonth - 1;
    //     const year = bill.paymentYear;
    //     switch (periodType) {
    //         case 'triwulan':
    //             if (monthIndex >= 0 && monthIndex <= 2) return `Triwulan 1 (${year})`;
    //             if (monthIndex >= 3 && monthIndex <= 5) return `Triwulan 2 (${year})`;
    //             if (monthIndex >= 6 && monthIndex <= 8) return `Triwulan 3 (${year})`;
    //             if (monthIndex >= 9 && monthIndex <= 11) return `Triwulan 4 (${year})`;
    //             return `Triwulan Tidak Valid`;
    //         case 'semester':
    //             if (monthIndex >= 0 && monthIndex <= 5) return `Semester 1 (${year})`;
    //             if (monthIndex >= 6 && monthIndex <= 11) return `Semester 2 (${year})`;
    //             return `Semester Tidak Valid`;
    //         case 'tahunan':
    //             return `Tahunan (${year})`
    //         case 'sekali bayar':
    //             return `Sekali Bayar (${year})`;
    //         default: return `${MONTHS[monthIndex]} ${year}`;
    //     }
    // };

    const handleLoadMoreHistory = useCallback(async () => {
        if (isLoadingMore || !hasMoreHistory || !lastVisiblePayment) return;

        setIsLoadingMore(true);
        try {
            const paymentsPath = getPaymentsCollectionPath(rtProfileId);
            const q = query(collection(db, paymentsPath),
                where("familyId", "==", sessionData.familyId),
                orderBy("submissionTimestamp", "desc"),
                startAfter(lastVisiblePayment),
                limit(PAYMENTS_PER_PAGE)
            );
            const snapshot = await getDocs(q);
            const newHistoryData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            setPaymentHistory(prev => [...prev, ...newHistoryData]);
            setLastVisiblePayment(snapshot.docs[snapshot.docs.length - 1]);
            setHasMoreHistory(newHistoryData.length === PAYMENTS_PER_PAGE);

        } catch (err) {
            console.error("Error loading more history:", err);
            setError("Gagal memuat riwayat selanjutnya.");
        } finally {
            setIsLoadingMore(false);
        }
    }, [isLoadingMore, hasMoreHistory, lastVisiblePayment, rtProfileId, sessionData]);

    // --- DATA FETCHING ---
    useEffect(() => {
        if (!rtProfileId) return;
        const fetchSupportData = async () => {
            try {
                const templatesPath = getDuesTemplatesCollectionPath(rtProfileId);
                const templatesSnap = await getDocs(query(collection(db, templatesPath)));
                const tmplMap = {};
                templatesSnap.forEach(doc => { tmplMap[doc.id] = doc.data(); });
                setAllTemplates(tmplMap);

                if (!loggedInHouseData) {
                    const householdsPath = getHouseholdsCollectionPath(rtProfileId);
                    const householdsSnap = await getDocs(query(collection(db, householdsPath), orderBy("houseIdentifier")));
                    setAvailableHouseholds(householdsSnap.docs.map(d => ({ id: d.id, ...d.data() })));
                }
            } catch (err) { setError("Gagal memuat data pendukung."); }
        };
        fetchSupportData();
    }, [rtProfileId, loggedInHouseData]);

    // --- FUNGSI BARU UNTUK MENANGANI LANJUTKAN PEMBAYARAN SECARA CERDAS ---
    const handleContinuePayment = (billToContinue) => {
        if (billToContinue.isParentBill) {
            // Logika untuk pembayaran massal
            const childBills = billToContinue.relatedBillIds
                .map(id => bills.find(b => b.id === id))
                .filter(Boolean);

            if (childBills.length === 0) {
                setMessage({ text: "Detail tagihan tidak ditemukan.", type: "error" });
                return;
            }

            const originalTotalAmount = childBills.reduce((acc, bill) => acc + bill.amount, 0);

            // --- PERBAIKAN KUNCI DI SINI: KIRIM ID DARI PARENT BILL YANG SUDAH ADA ---
            const bulkPaymentContext = {
                isBulkPayment: true,
                billsData: childBills,
                totalAmount: originalTotalAmount,
                sessionData: sessionData,
                allTemplates: allTemplates,
                method: 'QRIS',
                existingParentBillId: billToContinue.id // <-- Tambahkan ini
            };
            onNavigate('submit_payment_form', bulkPaymentContext);

        } else {
            // Logika untuk pembayaran tunggal
            onNavigate('submit_payment_form', {
                billData: billToContinue,
                sessionData: sessionData,
                allTemplates: allTemplates,
                method: 'QRIS'
            });
        }
    };

    // --- HELPER FUNCTION UNTUK FORMAT PERIODE ---
    // const formatPeriodForDisplay = (item) => {
    //     if (!item?.duesTemplateId || Object.keys(allTemplates).length === 0) return 'Memuat...';
    //     console.log('display item', item);
    //     const template = allTemplates[item.duesTemplateId];
    //     if (!template) return `Periode Tidak Dikenali`;

    //     const periodType = template.period;
    //     const monthIndex = (item.billPeriodMonth || item.paymentMonth) - 1;
    //     const year = item.billPeriodYear || item.paymentYear;

    //     switch (periodType) {
    //         case 'triwulan':
    //             if (monthIndex === 0) return `Triwulan 1 (${year})`;
    //             if (monthIndex === 3) return `Triwulan 2 (${year})`;
    //             if (monthIndex === 6) return `Triwulan 3 (${year})`;
    //             if (monthIndex === 9) return `Triwulan 4 (${year})`;
    //             return `Triwulan Tidak Valid`;
    //         case 'semester':
    //             if (monthIndex === 0) return `Semester 1 (${year})`;
    //             if (monthIndex === 6) return `Semester 2 (${year})`;
    //             return `Semester Tidak Valid`;
    //         case 'tahunan': case 'sekali bayar': return `Tahun ${year}`;
    //         default: return `${MONTHS[monthIndex]} ${year}`;
    //     }
    // };

    // --- useEffect #2 UTAMA YANG DIPERBAIKI ---
    useEffect(() => {
        if (!rtProfileId || !sessionData?.familyId || !currentRtConfig) {
            setIsLoading(false);
            setBills([]);
            return;
        }

        setIsLoading(true);
        const currentMode = currentRtConfig.isTestingMode ? "testing" : "live";
        const billsPath = getBillsCollectionPath(rtProfileId);

        // --- PERBAIKAN KUERI DI SINI ---
        // Kita buat kueri lebih sederhana, hanya berdasarkan familyId
        const q = query(collection(db, billsPath),
            where("familyId", "==", sessionData.familyId)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const allBillsForFamily = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            // Lakukan filter "mode" di sisi aplikasi
            const billsInCurrentMode = allBillsForFamily.filter(bill => bill.mode === currentMode);

            // console.log(`Data tagihan riil yang diambil (${currentMode} mode):`, billsInCurrentMode);
            setBills(billsInCurrentMode); // Set state dengan data yang sudah difilter
            setIsLoading(false);
        }, (err) => {
            setError("Gagal memuat data tagihan.");
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [rtProfileId, sessionData, currentRtConfig, refreshSignal]);
    // --- useEffect BARU (#3): Mengambil Riwayat Transaksi & Setup Observer ---
    useEffect(() => {
        if (!rtProfileId || !sessionData?.familyId) {
            setPaymentHistory([]);
            setHasMoreHistory(false);
            return;
        }

        const paymentsPath = getPaymentsCollectionPath(rtProfileId);
        const q = query(collection(db, paymentsPath),
            where("familyId", "==", sessionData.familyId),
            orderBy("submissionTimestamp", "desc"),
            limit(PAYMENTS_PER_PAGE)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const historyData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPaymentHistory(historyData);
            setLastVisiblePayment(snapshot.docs[snapshot.docs.length - 1]);
            setHasMoreHistory(historyData.length === PAYMENTS_PER_PAGE);
            setIsLoading(false); // Set loading false setelah data pertama masuk
        }, (err) => {
            console.error("Error listening to payment history:", err);
            setError("Gagal memuat riwayat transaksi.");
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [rtProfileId, sessionData, refreshSignal]);

    // --- useEffect BARU (#4): Untuk `Intersection Observer` ---
    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    handleLoadMoreHistory();
                }
            },
            { threshold: 1.0 }
        );

        const target = observerTarget.current;
        if (target) {
            observer.observe(target);
        }

        return () => {
            if (target) {
                observer.unobserve(target);
            }
        };
    }, [handleLoadMoreHistory]);

    // --- useEffect & useMemo (Tidak ada perubahan logika, hanya sumber data) ---
    useEffect(() => { if (onViewChange) { onViewChange(viewMode === 'detail'); } }, [viewMode, onViewChange]);

    // --- useMemo YANG LENGKAP ---
    // --- useMemo DENGAN DEPENDENCY ARRAY YANG BENAR ---
    const { summaryCard, summaryGrid, detailBills, tabs, filteredHistory, totalSelectedAmount } = useMemo(() => {
        const billsMap = new Map(bills.map(bill => [bill.id, bill]));

        // Buat daftar riwayat pembayaran yang "bersih" terlebih dahulu
        const cleanPaymentHistory = paymentHistory.map(payment => {
            let displayAmount = payment.amount;
            // Jika ini pembayaran QRIS yang ada di payload (bukan dari bill), coba cari fee
            if (payment.xenditWebhookPayload?.data) {
                const feeCharged = payment.xenditWebhookPayload.data.fee?.amount || 0;
                if (feeCharged > 0) {
                    displayAmount = payment.amount - feeCharged;
                }
            }
            return {
                ...payment,
                displayAmount: displayAmount, // Jumlah iuran asli tanpa fee
                displayPeriod: payment.isParentBill
                    ? (payment.relatedBillIds || []).map(id => billsMap.get(id) ? formatBillPeriodForDisplay(billsMap.get(id)) : '').filter(Boolean).join(', ')
                    : formatBillPeriodForDisplay(payment)
            };
        });

        const unpaidBills = bills.filter(b => (b.status === 'UNPAID' || b.status === 'PENDING_QRIS') && !b.rejectionReason);
        const pendingBills = bills.filter(b => ['pending', 'PENDING_QRIS', 'PENDING_BULK'].includes(b.status));
        const paidBills = bills.filter(b => (b.status === 'PAID' || b.status === 'approved') && !b.parentBillId);
        const rejectedBills = unpaidBills.filter(b => b.rejectionReason);

        const now = new Date();
        const currentMonthUnpaidBills = unpaidBills.filter(b => b.billPeriodMonth === (now.getMonth() + 1) && b.billPeriodYear === now.getFullYear());

        let billsForProcessing = []; // Inisialisasi sebagai array kosong
        let cardDescription = '';
        let historyForDisplay = cleanPaymentHistory;

        switch (activeTab) {
            case 'CURRENT_MONTH':
                billsForProcessing = currentMonthUnpaidBills;
                cardDescription = `${billsForProcessing.length} tagihan bulan ini`;
                break;
            case 'PENDING':
                billsForProcessing = pendingBills;
                cardDescription = `${billsForProcessing.length} tagihan dalam proses`;
                historyForDisplay = cleanPaymentHistory.filter(p => p.status === 'pending');
                break;
            case 'PAID':
                billsForProcessing = paidBills; // Gunakan paidBills yang sudah di-filter
                cardDescription = `${billsForProcessing.length} tagihan sudah lunas`;
                historyForDisplay = cleanPaymentHistory.filter(p => p.status === 'approved');
                break;
            case 'REJECTED':
                billsForProcessing = rejectedBills;
                cardDescription = `${billsForProcessing.length} tagihan ditolak`;
                historyForDisplay = cleanPaymentHistory.filter(p => p.status === 'rejected' && bills.some(b => (p.relatedBillIds || [p.billId]).includes(b.id) && b.status === 'UNPAID'));
                break;
            default: // ALL_UNPAID
                billsForProcessing = unpaidBills;
                cardDescription = `Total dari ${billsForProcessing.length} tagihan belum dibayar`;
                break;
        }

        // Kalkulasi total amount sekarang aman karena billsForProcessing selalu array
        const totalAmount = billsForProcessing.reduce((acc, bill) => acc + bill.amount, 0);

        const mainCardData = { total: `Rp ${totalAmount.toLocaleString('id-ID')}`, description: cardDescription };
        const summary = {};
        billsForProcessing.forEach(bill => {
            if (!summary[bill.duesType]) { summary[bill.duesType] = { count: 0, total: 0 }; }
            summary[bill.duesType].count++;
            summary[bill.duesType].total += bill.amount;
        });
        const gridData = Object.keys(summary).map(duesType => ({ duesType, ...summary[duesType] })).sort((a, b) => b.total - a.total);
        const detailBillData = selectedDuesType ? billsForProcessing.filter(b => b.duesType === selectedDuesType).sort((a, b) => a.billPeriodYear - b.billPeriodYear || a.billPeriodMonth - b.billPeriodMonth) : [];
        const tabItems = [
            { id: 'ALL_UNPAID', title: `Semua Tunggakan (${unpaidBills.length})` },
            { id: 'PENDING', title: `Menunggu (${pendingBills.length})` },
            { id: 'REJECTED', title: `Ditolak (${rejectedBills.length})` },
            { id: 'PAID', title: `Lunas (${paidBills.length})` }
        ];
        const totalAmountForSelection = Object.keys(selectedBills).reduce((acc, billId) => {
            const bill = bills.find(b => b.id === billId);
            return acc + (selectedBills[billId] && bill ? bill.amount : 0);
        }, 0);

        return { summaryCard: mainCardData, summaryGrid: gridData, detailBills: detailBillData, tabs: tabItems, filteredHistory: historyForDisplay, totalSelectedAmount: totalAmountForSelection };
    }, [bills, paymentHistory, activeTab, selectedDuesType, selectedBills, allTemplates]);

    // --- HANDLER FUNCTIONS ---
    // (Semua handler, termasuk untuk bulk selection, tidak ada perubahan)
    const handleSummaryCardClick = (duesType) => { setSelectedDuesType(duesType); setViewMode('detail'); };
    const handleBackToSummary = () => { setViewMode('summary'); setSelectedDuesType(null); };

    // --- HANDLER BARU UNTUK MODE SELEKSI ---
    const handleEnterSelectionMode = (billToSelect) => {
        setSelectionMode(true);
        setSelectedBills({ [billToSelect.id]: true }); // Langsung pilih item pertama
    };

    const handleToggleBillSelection = (billId) => {
        setSelectedBills(prev => {
            const newSelection = { ...prev };
            if (newSelection[billId]) {
                delete newSelection[billId];
            } else {
                newSelection[billId] = true;
            }
            return newSelection;
        });
    };

    const handleCancelSelectionMode = () => { setSelectionMode(false); setSelectedBills({}); };

    // --- FUNGSI INI SEKARANG DIISI DENGAN LOGIKA NAVIGASI ---
    const handleProcessBulkPayment = () => {
        const selectedIds = Object.keys(selectedBills);
        if (selectedIds.length === 0) return;

        // Ambil objek bill lengkap berdasarkan ID yang dipilih
        const billsToPay = bills.filter(b => selectedIds.includes(b.id));

        // Kirim payload khusus untuk pembayaran massal
        onNavigate('submit_payment_form', {
            isBulkPayment: true,      // Penanda ini pembayaran massal
            billsData: billsToPay,    // Kirim array of bills
            totalAmount: totalSelectedAmount,
            sessionData: sessionData,
            allTemplates: allTemplates
        });
    };

    const handleRetryBulkPayment = (payment) => {
        if (!payment.relatedBillIds || payment.relatedBillIds.length === 0) return;

        const billsToReselect = {};
        payment.relatedBillIds.forEach(id => {
            // Cek apakah tagihan tersebut masih ada dan berstatus UNPAID
            if (bills.some(b => b.id === id && b.status === 'UNPAID')) {
                billsToReselect[id] = true;
            }
        });

        if (Object.keys(billsToReselect).length > 0) {
            setSelectedBills(billsToReselect);
            setSelectionMode(true);
            // Cari duesType dari bill pertama untuk masuk ke halaman detail yang benar
            const firstBill = bills.find(b => b.id === Object.keys(billsToReselect)[0]);
            if (firstBill) {
                setSelectedDuesType(firstBill.duesType);
                setViewMode('detail');
            }
        } else {
            setMessage({ text: "Semua tagihan dalam pembayaran ini mungkin sudah dilunasi.", type: "info" });
        }
    };

    if (error) return <div className={cardStyle}><MessageBox message={error} type="error" onClose={() => setError('')} /></div>

    if (!sessionData) {
        return (
            <div className={`${cardStyle} max-w-lg mx-auto`}>
                <h2 className="text-2xl font-semibold text-center text-slate-700 mb-6">Pilih Rumah Anda</h2>
                <p className="text-center text-sm text-slate-500 mb-4">Untuk melihat tagihan, silakan pilih rumah Anda.</p>
                {isLoading && availableHouseholds.length === 0 ? <LoadingSpinner /> : <SearchableHouseSelect
                    households={availableHouseholds}
                    selectedHouseId={publicSelectedHouse?.id || ''}
                    onHouseSelect={async (houseId) => {
                        if (!houseId) { setPublicSelectedHouse(null); return; }
                        try {
                            const payersPath = getOccupanciesCollectionPath(rtProfileId);
                            const q = query(collection(db, payersPath), where("householdId", "==", houseId), where("isPayer", "==", true), limit(1));
                            const payerSnap = await getDocs(q);
                            if (!payerSnap.empty) {
                                const payerData = payerSnap.docs[0].data();
                                const houseData = availableHouseholds.find(h => h.id === houseId);
                                const newSession = { ...houseData, familyId: payerData.familyId, moveInDate: payerData.moveInDate, payerName: payerData.headOfFamilyName, rtProfileId };
                                setPublicSelectedHouse(newSession);
                            } else { setError("Data penanggung jawab iuran untuk rumah ini tidak ditemukan."); }
                        } catch (err) { setError("Gagal mengambil data hunian."); }
                    }}
                    label="Nomor Rumah Anda *" idPrefix="public-bill-center"
                />}
            </div>
        );
    }

    // Tampilan Detail (saat kartu diklik)
    if (viewMode === 'detail') {
        return (
            <div className="flex flex-col h-full animate-fade-in">
                <div className="flex items-center p-1 mb-2">
                    <BackButton onClick={handleBackToSummary} />
                    <h2 className="font-bold text-lg text-slate-800 text-center flex-1">{selectedDuesType}</h2>
                    {!selectionMode && detailBills.filter(b => b.status === 'UNPAID').length > 1 && (
                        <button onClick={handleEnterSelectionMode} className="text-sm font-semibold text-sky-600 ml-auto pr-2 hover:underline">Pilih Banyak</button>
                    )}
                </div>
                <div className={`${cardStyle} text-left py-4`}>
                    <p className="text-sm font-medium text-slate-500">Total Tagihan "{selectedDuesType}"</p>
                    <p className="text-3xl font-bold text-red-500 mt-1">Rp {detailBills.reduce((acc, bill) => acc + bill.amount, 0).toLocaleString('id-ID')}</p>
                </div>
                <div className="space-y-2 px-1 mt-2 flex-grow overflow-y-auto pb-24">
                    {isLoading ? <LoadingSpinner /> : detailBills.map(bill => {
                        const isSelected = !!selectedBills[bill.id];
                        return (
                            <div key={bill.id} onClick={() => selectionMode && bill.status === 'UNPAID' && handleToggleBillSelection(bill.id)} className={`p-3 bg-white rounded-lg shadow-sm border flex items-center gap-3 transition-all ${selectionMode && bill.status === 'UNPAID' ? 'cursor-pointer' : ''} ${isSelected ? 'border-2 border-sky-500 bg-sky-50' : ''}`}>
                                {selectionMode && bill.status === 'UNPAID' && (
                                    <input type="checkbox" checked={isSelected} readOnly className="h-5 w-5 rounded border-gray-300 text-sky-600 focus:ring-0" />
                                )}
                                <div className="flex-grow">
                                    {bill.rejectionReason && <div className="p-2 mb-2 text-xs text-red-700 bg-red-100 border-l-4 border-red-500 rounded-r-md"><p className="font-bold">Ditolak:</p><p>{bill.rejectionReason}</p></div>}
                                    <p className="font-semibold">
                                        {bill.isParentBill ? formatParentBillTitle(bill) : formatBillPeriodForDisplay(bill)}
                                    </p>
                                    <p className="text-lg font-bold mt-1">Rp {bill.amount.toLocaleString('id-ID')}</p>
                                    {bill.status === 'pending' && <span className="text-xs text-amber-600 font-medium">Diproses</span>}
                                    {bill.status === 'PENDING_QRIS' && <span className="text-xs text-sky-600 font-medium">Menunggu Pembayaran QR</span>}
                                    {(bill.status === 'PAID' || bill.status === 'approved') && <span className="text-xs text-green-600 font-medium">Lunas</span>}
                                </div>
                                <div className="flex-shrink-0">
                                    {!selectionMode && bill.status === 'UNPAID' && <button onClick={() => onNavigate('submit_payment_form', { billData: bill, sessionData: sessionData, allTemplates: allTemplates, method: 'MANUAL' })} className={`${primaryButtonStyle}`}>{bill.rejectionReason ? 'Bayar Ulang' : 'Bayar'}</button>}
                                    {/* --- PERBAIKAN TOMBOL LANJUTKAN BAYAR DI SINI --- */}
                                    {!selectionMode && bill.status === 'PENDING_QRIS' && (
                                        <button onClick={() => handleContinuePayment(bill)} className={`${secondaryButtonStyle}`}>
                                            Lanjutkan Bayar
                                        </button>
                                    )}

                                </div>
                            </div>
                        );
                    })}
                </div>

                {selectionMode && (
                    <div className="fixed bottom-0 left-0 right-0 w-full max-w-lg mx-auto p-4 bg-white border-t border-slate-200 shadow-lg-top animate-slide-up">
                        <div className="flex justify-between items-center mb-2">
                            <p className="text-sm font-semibold">{Object.keys(selectedBills).length} tagihan dipilih</p>
                            <p className="text-lg font-bold">Rp {totalSelectedAmount.toLocaleString('id-ID')}</p>
                        </div>
                        <div className="flex gap-2">
                            <button onClick={handleCancelSelectionMode} className={`${secondaryButtonStyle} w-1/3`}>Batal</button>
                            <button onClick={handleProcessBulkPayment} className={`${primaryButtonStyle} w-2/3`} disabled={Object.keys(selectedBills).length === 0}>
                                Bayar Tagihan Terpilih
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    // Tampilan Utama (Summary/Grid)
    return (
        <div className="flex flex-col h-full space-y-4">
            <SlidingTabs tabs={tabs} activeTab={activeTab} onSelectTab={setActiveTab} />
            <div className={`${cardStyle} text-left py-4 -mt-1`}>
                <p className="text-sm font-medium text-slate-500">{summaryCard.description}</p>
                <p className={`text-3xl font-bold mt-1 ${activeTab === 'PAID' ? 'text-green-500' : 'text-red-500'}`}>{summaryCard.total}</p>
            </div>
            {activeTab === 'REJECTED' ? (
                <div>
                    <h3 className="font-bold text-slate-700">Pembayaran Ditolak</h3>
                    <div className="space-y-2 mt-2">
                        {filteredHistory.length > 0 ? filteredHistory.map(payment => (
                            <div key={payment.id} className="p-3 bg-white rounded-lg shadow-sm border">
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center gap-4">
                                        <div className="text-2xl text-red-600">❌</div>
                                        <div>
                                            <p className="font-semibold">{payment.duesType}</p>
                                            <p className="text-sm text-slate-800">Rp {payment.amount.toLocaleString('id-ID')}</p>
                                            <p className="text-xs text-slate-400 mt-1">{payment.submissionTimestamp.toDate().toLocaleString('id-ID')}</p>
                                        </div>
                                    </div>
                                    {/* --- PERBAIKAN LOGIKA TOMBOL DIMULAI DI SINI --- */}
                                    <div>
                                        {payment.relatedBillIds && payment.status === 'rejected' ? (
                                            // Jika ini pembayaran massal yang ditolak
                                            <button onClick={() => handleRetryBulkPayment(payment)} className={primaryButtonStyle}>
                                                Coba Lagi
                                            </button>
                                        ) : (
                                            // Jika ini pembayaran satuan yang ditolak
                                            <button onClick={() => {
                                                const rejectedBill = bills.find(b => b.id === payment.billId);
                                                if (rejectedBill) {
                                                    onNavigate('submit_payment_form', {
                                                        billData: rejectedBill,
                                                        sessionData: sessionData,
                                                        allTemplates: allTemplates
                                                    });
                                                } else {
                                                    alert("Detail tagihan asli tidak ditemukan lagi.");
                                                }
                                            }} className={primaryButtonStyle}>
                                                Bayar Ulang
                                            </button>
                                        )}
                                    </div>
                                    {/* --- AKHIR PERBAIKAN LOGIKA TOMBOL --- */}
                                </div>
                                {payment.adminNotes && <div className="mt-2 p-2 text-xs text-red-700 bg-red-100 border-l-4 border-red-400"><strong>Alasan:</strong> {payment.adminNotes}</div>}
                            </div>
                        )) : <p className="text-center text-sm text-slate-500 py-4">Tidak ada pembayaran yang ditolak.</p>}
                    </div>
                </div>
            ) : (
                <div className="px-1 flex-grow overflow-y-auto">
                    <h3 className="font-bold text-slate-700">Rincian Tagihan</h3>
                    <div className="grid grid-cols-2 gap-3 mt-2">
                        {isLoading ? <LoadingSpinner /> : (
                            summaryGrid.length > 0 ? summaryGrid.map(card => (
                                <div key={card.duesType} onClick={() => handleSummaryCardClick(card.duesType)} className="p-4 bg-white rounded-xl shadow-md cursor-pointer hover:bg-slate-50 transition-colors">
                                    <p className="font-semibold text-sm truncate">{card.duesType}</p>
                                    <p className="text-xs text-slate-500">{card.count} Tagihan</p>
                                    <p className="font-bold text-lg mt-2 text-slate-800">Rp {card.total.toLocaleString('id-ID')}</p>
                                </div>
                            )) : <p className="col-span-2 text-center text-slate-500 py-8">Tidak ada tagihan pada kategori ini.</p>
                        )}
                    </div>
                </div>
            )}
            {/* --- BAGIAN RIWAYAT TRANSAKSI YANG DISEMPURNAKAN --- */}
            {activeTab !== 'REJECTED' ? (
                <div>
                    <h3 className="font-bold text-slate-700">Riwayat Transaksi Terkini</h3>
                    <div className="space-y-2 mt-2">
                        {isLoading && paymentHistory.length === 0 ? <LoadingSpinner /> : (
                            filteredHistory.length > 0 ? filteredHistory.map(payment => {
                                let statusIcon, statusColor, statusText;
                                switch (payment.status) {
                                    case 'approved':
                                        statusIcon = '✅'; statusColor = 'text-green-600'; statusText = 'Disetujui'; break;
                                    case 'rejected':
                                        statusIcon = '❌'; statusColor = 'text-red-600'; statusText = 'Ditolak'; break;
                                    default: // pending
                                        statusIcon = '⏳'; statusColor = 'text-amber-600'; statusText = 'Diproses'; break;
                                }
                                return (
                                    <div key={payment.id} className="p-3 bg-white rounded-lg shadow-sm border flex items-center gap-4">
                                        <div className={`text-2xl ${statusColor}`}>{statusIcon}</div>
                                        <div className="flex-grow">
                                            <p className="font-semibold">{payment.duesType}</p>
                                            {/* --- BARIS BARU UNTUK MENAMPILKAN PERIODE --- */}
                                            {/* <p className="text-xs font-semibold text-slate-600">
                                                Periode: {MONTHS[payment.paymentMonth - 1]} {payment.paymentYear}
                                            </p> */}
                                            <p className="text-xs font-semibold text-slate-600">
                                                Periode: {payment.displayPeriod}
                                            </p>
                                            <p className="text-sm text-slate-800">Rp {payment.amount.toLocaleString('id-ID')}</p>
                                            <p className="text-xs text-slate-400 mt-1">
                                                {payment.submissionTimestamp.toDate().toLocaleString('id-ID', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                                                <span className="mx-1">|</span>
                                                {payment.paymentMethod || 'MANUAL'}
                                            </p>
                                        </div>
                                        <p className={`text-sm font-bold ${statusColor}`}>{statusText}</p>
                                    </div>
                                )
                            }) : <p className="text-center text-sm text-slate-500 py-4">Tidak ada riwayat transaksi pada kategori ini.</p>
                        )}
                    </div>
                    {/* --- Elemen Pemicu Infinite Scroll (tidak berubah) --- */}
                    <div ref={observerTarget} className="h-10 flex items-center justify-center">
                        {isLoadingMore && <LoadingSpinner />}
                        {!hasMoreHistory && paymentHistory.length > 0 && (
                            <p className="text-xs text-slate-400">Anda sudah mencapai akhir riwayat.</p>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

const PublicSubHeader = ({ publicPageState, loggedInHouseData, rtProfile, publicSelectedRtProfileId, handleExitRtContext }) => {
    // Komponen ini tidak perlu ditampilkan pada halaman-halaman awal verifikasi
    if (publicPageState === 'global_otp' || publicPageState === 'enter_pin' || publicPageState === 'create_pin' || publicPageState === 'phone_auth_init_and_recaptcha') {
        return null;
    }

    // Jangan tampilkan apa-apa jika pengguna sudah login penuh (karena header utama sudah menanganinya)
    if (loggedInHouseData) {
        return null;
    }

    return (
        <div className="text-center mb-4 text-sm text-slate-600">
            {publicSelectedRtProfileId ? (
                // Tampil jika BARU memilih RT (belum login rumah)
                <>
                    <span>Anda sedang melihat RT: <strong>{rtProfile?.rtTitle || publicSelectedRtProfileId}</strong></span>
                    <button
                        onClick={handleExitRtContext} // Fungsi ini mereset sesi RT sepenuhnya
                        className="ml-2 text-xs text-red-500 hover:text-red-700 hover:underline focus:outline-none"
                    >
                        (Ganti RT)
                    </button>
                </>
            ) : null}
        </div>
    );
};

function useIdleTimer({ onIdle, idleTime = 180000, enabled = true }) {
    const timeoutId = useRef();

    const resetTimer = useCallback(() => {
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(onIdle, idleTime);
    }, [onIdle, idleTime]);

    useEffect(() => {
        // JIKA TIMER TIDAK DIAKTIFKAN, BERSIHKAN SEMUANYA DAN BERHENTI
        if (!enabled) {
            clearTimeout(timeoutId.current);
            return;
        }

        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
        const handleActivity = () => {
            resetTimer();
        };

        events.forEach(event => window.addEventListener(event, handleActivity));
        resetTimer();

        // Cleanup akan selalu berjalan untuk membersihkan listener
        return () => {
            clearTimeout(timeoutId.current);
            events.forEach(event => window.removeEventListener(event, handleActivity));
        };
    }, [enabled, resetTimer]); // Tambahkan `enabled` sebagai dependensi

    return {
        resetTimer
    };
}

// Tambahkan komponen Modal baru ini di atas fungsi App()

// --- GANTI SELURUH KOMPONEN MODAL INI ---
const MoveOccupantModal = ({ isOpen, onClose, occupancyData, households, rtProfileId, onSuccess }) => {
    const [destinationHouseId, setDestinationHouseId] = useState('');
    const [isMoving, setIsMoving] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!isOpen) {
            setDestinationHouseId('');
            setError('');
        }
    }, [isOpen]);

    if (!isOpen || !occupancyData) return null;

    const availableHouses = households.filter(h => h.id !== occupancyData.householdId);

    const handleConfirmMove = async () => {
        if (!destinationHouseId) {
            setError("Anda harus memilih rumah tujuan.");
            return;
        }
        setIsMoving(true);
        setError('');

        const batch = writeBatch(db);
        const originHouse = households.find(h => h.id === occupancyData.householdId);

        try {
            // --- LOGIKA BARU (BAGIAN 1) ---
            // Cek dan nonaktifkan pembayar di RUMAH TUJUAN jika ada
            const destinationHouseOccupants = await getDocs(query(collection(db, getOccupanciesCollectionPath(rtProfileId)), where("householdId", "==", destinationHouseId), where("status", "==", "ACTIVE")));
            const existingPayerInDestination = destinationHouseOccupants.docs.find(doc => doc.data().isPayer === true);

            if (occupancyData.isPayer && existingPayerInDestination) {
                const oldPayerRef = doc(db, getOccupanciesCollectionPath(rtProfileId), existingPayerInDestination.id);
                batch.update(oldPayerRef, { isPayer: false });
            }
            // --- AKHIR LOGIKA BARU (BAGIAN 1) ---

            // Update hunian lama
            const oldOccupancyRef = doc(db, getOccupanciesCollectionPath(rtProfileId), occupancyData.id);
            batch.update(oldOccupancyRef, {
                status: 'MOVED_OUT',
                moveOutDate: Timestamp.now()
            });

            // Buat hunian baru
            const newOccupancyRef = doc(collection(db, getOccupanciesCollectionPath(rtProfileId)));
            batch.set(newOccupancyRef, {
                householdId: destinationHouseId,
                familyId: occupancyData.familyId,
                headOfFamilyName: occupancyData.headOfFamilyName,
                isPayer: occupancyData.isPayer,
                moveInDate: Timestamp.now(),
                moveOutDate: null,
                status: 'ACTIVE',
                createdAt: Timestamp.now(),
                rtProfileId
            });

            await batch.commit();

            // --- LOGIKA BARU (BAGIAN 2) ---
            // Cek apakah RUMAH ASAL perlu pembayar baru
            let successMessage = `Keluarga ${occupancyData.headOfFamilyName} berhasil dipindahkan.`;
            if (occupancyData.isPayer) {
                const remainingOccupants = await getDocs(query(collection(db, getOccupanciesCollectionPath(rtProfileId)), where("householdId", "==", occupancyData.householdId), where("status", "==", "ACTIVE")));
                if (remainingOccupants.docs.length > 0) {
                    successMessage += `\n\nPERHATIAN: Rumah asal (${originHouse?.houseIdentifier}) kini tidak memiliki penanggung jawab iuran. Harap tetapkan secara manual.`;
                }
            }
            // --- AKHIR LOGIKA BARU (BAGIAN 2) ---

            onSuccess(successMessage);
            onClose();

        } catch (err) {
            console.error("Error moving occupant:", err);
            setError("Gagal memindahkan penghuni. Silakan coba lagi.");
        } finally {
            setIsMoving(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center backdrop-blur-sm p-4">
            <div className="bg-white p-6 rounded-2xl shadow-xl max-w-md w-full mx-auto">
                <h3 className="text-xl font-bold text-slate-800">Proses Pindah Hunian</h3>
                <p className="text-sm text-slate-600 mt-2">
                    Anda akan memindahkan keluarga: <strong className="text-slate-800">{occupancyData.headOfFamilyName}</strong>.
                </p>
                {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}
                <div className="my-4">
                    <SearchableHouseSelect
                        households={availableHouses}
                        selectedHouseId={destinationHouseId}
                        onHouseSelect={setDestinationHouseId}
                        label="Pilih Rumah Tujuan Baru*"
                        idPrefix="move-occupant"
                    />
                </div>
                <div className="flex justify-end gap-3 mt-6">
                    <button onClick={onClose} className={secondaryButtonStyle} disabled={isMoving}>Batal</button>
                    <button onClick={handleConfirmMove} className={primaryButtonStyle} disabled={isMoving}>
                        {isMoving ? <LoadingSpinner /> : 'Konfirmasi Pindah'}
                    </button>
                </div>
            </div>
        </div>
    );
};

const FeatureGateModal = ({ isOpen, onClose, featureName }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center backdrop-blur-sm">
            <div className="bg-white p-8 rounded-2xl shadow-xl text-center max-w-sm mx-4 transform transition-all" >
                <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-amber-100">
                    {/* Ikon Gembok/Kunci */}
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800 mt-4">Fitur Terkunci</h3>
                <p className="text-slate-600 my-4">
                    Fitur <strong className="text-slate-800">{featureName}</strong> belum aktif untuk RT Anda. Silakan hubungi pengurus RT untuk mengaktifkan fitur ini atau upgrade paket layanan.
                </p>
                <button
                    onClick={onClose}
                    className={`${secondaryButtonStyle} w-full`}
                >
                    Saya Mengerti
                </button>
            </div>
        </div>
    );
};

// 1. Tambahkan komponen baru ini di atas fungsi App()
const GenericHeader = ({ title, onExit }) => (
    <div className="w-full max-w-lg mx-auto flex justify-between items-center p-4">
        <h2 className="font-bold text-xl text-slate-700">{title}</h2>
        <button onClick={onExit} title="Keluar dari Sesi RT" className="p-2 rounded-full hover:bg-slate-200 active:bg-slate-300">
            {/* Ikon Exit/Logout */}
            <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
            </svg>
        </button>
    </div>
);

// --- Helper Baru untuk Path Firestore ---
const getAgendasCollectionPath = (rtProfileId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/agendas`;

// Komponen ini mengurus semua logika peta.
const GoogleMapPicker = ({ onLocationSelect, initialPosition }) => {
    const mapRef = useRef(null);
    const searchBoxRef = useRef(null);
    const [map, setMap] = useState(null);
    const [marker, setMarker] = useState(null);

    useEffect(() => {
        if (!window.google) {
            console.error("Google Maps script not loaded!");
            return;
        }

        const jakartaCoords = { lat: -6.2088, lng: 106.8456 };

        const initializeMap = (centerCoords) => {
            const gMap = new window.google.maps.Map(mapRef.current, {
                center: centerCoords,
                zoom: 15,
                mapTypeControl: false,
                streetViewControl: false,
            });

            const gMarker = new window.google.maps.Marker({
                position: centerCoords,
                map: gMap,
                draggable: true,
            });

            setMap(gMap);
            setMarker(gMarker);

            gMap.addListener('click', (e) => {
                const coords = { lat: e.latLng.lat(), lng: e.latLng.lng() };
                gMarker.setPosition(e.latLng);
                onLocationSelect(coords);
            });

            gMarker.addListener('dragend', (e) => {
                const coords = { lat: e.latLng.lat(), lng: e.latLng.lng() };
                onLocationSelect(coords);
            });
        };

        if (initialPosition) {
            initializeMap(initialPosition);
        } else if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const userCoords = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    initializeMap(userCoords);
                    onLocationSelect(userCoords);
                },
                () => {
                    initializeMap(jakartaCoords);
                }
            );
        } else {
            initializeMap(jakartaCoords);
        }
    }, []);

    useEffect(() => {
        if (!map || !searchBoxRef.current) return;

        const searchBox = new window.google.maps.places.SearchBox(searchBoxRef.current);
        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(searchBoxRef.current);

        const listener = searchBox.addListener('places_changed', () => {
            const places = searchBox.getPlaces();
            if (places.length === 0) return;

            const place = places[0];
            if (!place.geometry || !place.geometry.location) return;

            map.setCenter(place.geometry.location);
            map.setZoom(17);
            marker.setPosition(place.geometry.location);

            const coords = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
            onLocationSelect(coords, place.formatted_address);
        });

        return () => window.google.maps.event.removeListener(listener);

    }, [map, marker, onLocationSelect]);

    return (
        <div>
            <input
                ref={searchBoxRef}
                type="text"
                placeholder="Cari lokasi atau letakkan pin di peta..."
                className={`${commonInputStyle} mb-2`}
            />
            <div ref={mapRef} style={{ height: '300px', width: '100%', borderRadius: '8px' }}></div>
        </div>
    );
};


// --- Komponen ManageAgendasPage yang sudah diperbarui ---
const ManageAgendasPage = () => {
    const { rtProfileId, currentUser } = useAuth();
    const [agendas, setAgendas] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editingAgenda, setEditingAgenda] = useState(null);
    const [activityName, setActivityName] = useState('');
    const [activityDate, setActivityDate] = useState('');
    const [description, setDescription] = useState('');
    const [locationName, setLocationName] = useState('');
    const [locationCoords, setLocationCoords] = useState(null);
    const [allowParticipation, setAllowParticipation] = useState(true);

    useEffect(() => {
        if (!rtProfileId) {
            setIsLoading(false);
            return;
        }
        const q = query(collection(db, getAgendasCollectionPath(rtProfileId)), orderBy("activityDate", "desc"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const agendasData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setAgendas(agendasData);
            setIsLoading(false);
        }, (err) => {
            setError("Gagal memuat data agenda.");
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, [rtProfileId]);

    const resetForm = () => {
        setActivityName(''); setActivityDate(''); setDescription('');
        setLocationName(''); setLocationCoords(null); setAllowParticipation(true);
        setEditingAgenda(null); setShowForm(false);
    };

    const handleLocationSelect = (coords, address) => {
        setLocationCoords(coords);
        if (address) { setLocationName(address); }
    };

    const handleEdit = (agenda) => {
        setEditingAgenda(agenda);
        setActivityName(agenda.activityName);
        const date = agenda.activityDate.toDate();
        const formattedDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0, 16);
        setActivityDate(formattedDate);
        setDescription(agenda.description || '');
        setLocationName(agenda.locationName || '');
        if (agenda.locationCoords) {
            setLocationCoords({ lat: agenda.locationCoords.latitude, lng: agenda.locationCoords.longitude });
        } else {
            setLocationCoords(null);
        }
        setAllowParticipation(agenda.allowParticipation === undefined ? true : agenda.allowParticipation);
        setShowForm(true);
        window.scrollTo(0, 0);
    };

    const handleDelete = async (agendaId, agendaTitle) => {
        if (!window.confirm(`Yakin ingin menghapus agenda "${agendaTitle}"?`)) return;

        setIsSubmitting(true);
        setError('');

        try {
            // Kita hanya akan menghapus dokumen agenda utamanya saja untuk sekarang.
            // Ini akan memvalidasi bahwa izin 'delete' Anda sudah berfungsi.
            const agendaDocRef = doc(db, getAgendasCollectionPath(rtProfileId), agendaId);
            await deleteDoc(agendaDocRef);

            // Kita tidak perlu lagi memuat ulang data secara manual karena
            // onSnapshot akan mendeteksi perubahan dan memperbarui UI secara otomatis.

        } catch (err) {
            console.error("Error deleting agenda document:", err);
            setError("Gagal menghapus agenda. Periksa console untuk detail.");
        }

        setIsSubmitting(false);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!activityName.trim() || !activityDate) {
            setError("Nama Kegiatan dan Tanggal wajib diisi.");
            return;
        }
        setIsSubmitting(true);
        setError('');

        // ---- PERBAIKAN KUNCI DI SINI ----
        // Menggunakan new GeoPoint() dari Firebase, bukan new Timestamp()
        const dataToSave = {
            activityName: activityName.trim(),
            activityDate: Timestamp.fromDate(new Date(activityDate)),
            description: description.trim(),
            locationName: locationName.trim(),
            locationCoords: locationCoords ? new GeoPoint(locationCoords.lat, locationCoords.lng) : null,
            allowParticipation: allowParticipation,
            updatedAt: Timestamp.now(),
            authorName: currentUser.email,
            authorUid: currentUser.uid,
            rtProfileId: rtProfileId,
            isActive: true,
        };

        try {
            if (editingAgenda) {
                const agendaRef = doc(db, getAgendasCollectionPath(rtProfileId), editingAgenda.id);
                await updateDoc(agendaRef, dataToSave);
            } else {
                dataToSave.createdAt = Timestamp.now();
                await addDoc(collection(db, getAgendasCollectionPath(rtProfileId)), dataToSave);
            }
            resetForm();
        } catch (err) {
            console.error("Error saving agenda:", err);
            setError("Gagal menyimpan agenda. Periksa console untuk detail.");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isLoading) return <div className={cardStyle}><LoadingSpinner /><p className="text-center">Memuat data agenda...</p></div>;

    return (
        <div className={cardStyle}>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold text-slate-700">Manajemen Agenda RT</h2>
                <button onClick={() => { resetForm(); setShowForm(!showForm); }} className={primaryButtonStyle}>
                    {showForm ? 'Batal' : 'Buat Agenda Baru'}
                </button>
            </div>
            {error && <MessageBox message={error} type="error" onClose={() => setError('')} />}

            {showForm && (
                <form onSubmit={handleFormSubmit} className="mb-8 p-6 border rounded-lg bg-slate-50 space-y-4">
                    <h3 className="text-xl font-medium mb-3">{editingAgenda ? `Edit Agenda` : 'Agenda Baru'}</h3>
                    <div><label htmlFor="activityName" className="block text-sm font-medium text-slate-700">Nama Kegiatan *</label><input type="text" id="activityName" value={activityName} onChange={(e) => setActivityName(e.target.value)} className={commonInputStyle} required /></div>
                    <div><label htmlFor="activityDate" className="block text-sm font-medium text-slate-700">Tanggal & Waktu *</label><input type="datetime-local" id="activityDate" value={activityDate} onChange={(e) => setActivityDate(e.target.value)} className={commonInputStyle} required /></div>
                    <div><label htmlFor="description" className="block text-sm font-medium text-slate-700">Deskripsi</label><textarea id="description" value={description} onChange={(e) => setDescription(e.target.value)} rows="4" className={commonInputStyle}></textarea></div>

                    <div>
                        <label className="block text-sm font-medium text-slate-700">Lokasi</label>
                        <p className="text-xs text-slate-500 mb-2">Cari nama tempat atau klik langsung pada peta untuk menentukan lokasi.</p>
                        <GoogleMapPicker onLocationSelect={handleLocationSelect} initialPosition={locationCoords} />
                    </div>
                    <div><label htmlFor="locationName" className="block text-sm font-medium text-slate-700 mt-2">Nama Lokasi (Teks)</label><input type="text" id="locationName" value={locationName} onChange={(e) => setLocationName(e.target.value)} className={commonInputStyle} placeholder="Contoh: Lapangan Serbaguna RW 09" /></div>

                    <div className="flex items-center pt-2">
                        <input type="checkbox" id="allowParticipation" checked={allowParticipation} onChange={(e) => setAllowParticipation(e.target.checked)} className="h-4 w-4 text-sky-600 border-gray-300 rounded focus:ring-sky-500" />
                        <label htmlFor="allowParticipation" className="ml-2 block text-sm text-gray-900">Izinkan Warga untuk Berpartisipasi?</label>
                    </div>

                    <div className="flex gap-4 pt-3">
                        <button type="submit" className={primaryButtonStyle} disabled={isSubmitting}>{isSubmitting ? <LoadingSpinner /> : (editingAgenda ? 'Update Agenda' : 'Simpan Agenda')}</button>
                        <button type="button" onClick={resetForm} className={secondaryButtonStyle}>Batal</button>
                    </div>
                </form>
            )}

            <div className="space-y-3">
                <h3 className="text-lg font-semibold text-slate-600">Daftar Agenda</h3>
                {agendas.length === 0 ? <p className="text-slate-500 text-center py-4">Belum ada agenda yang dibuat.</p>
                    : agendas.map(agenda => (
                        // --- Gunakan komponen baru di sini ---
                        <AdminAgendaItem
                            key={agenda.id}
                            agenda={agenda}
                            rtProfileId={rtProfileId}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    ))}
            </div>

            {/* <div className="space-y-3">
                <h3 className="text-lg font-semibold text-slate-600">Daftar Agenda</h3>
                {agendas.length === 0 ? <p className="text-slate-500 text-center py-4">Belum ada agenda yang dibuat.</p> : agendas.map(agenda => (
                    <div key={agenda.id} className="p-4 border rounded-md bg-slate-50">
                        <div className="flex justify-between items-start">
                            <div>
                                <h4 className="font-semibold text-sky-600">{agenda.activityName}</h4>
                                <p className="text-sm text-slate-500">
                                    {agenda.activityDate.toDate().toLocaleString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                </p>
                                <p className="text-xs text-slate-400">Lokasi: {agenda.locationName || 'Tidak ditentukan'}</p>
                                <p className={`text-xs mt-1 font-medium ${agenda.allowParticipation ? 'text-green-600' : 'text-slate-500'}`}>
                                    {agenda.allowParticipation ? 'Partisipasi Dibuka' : 'Hanya Informasi'}
                                </p>
                            </div>
                            <div className="flex-shrink-0 ml-4 space-x-2">
                                <button onClick={() => handleEdit(agenda)} className="text-xs py-1 px-2 bg-yellow-400 hover:bg-yellow-500 text-yellow-800 rounded-md">Edit</button>
                                <button onClick={() => handleDelete(agenda.id, agenda.activityName)} className="text-xs py-1 px-2 bg-red-400 hover:bg-red-500 text-white rounded-md" disabled={isSubmitting}>Hapus</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div> */}
        </div>
    );
};

const AdminAgendaItem = ({ agenda, rtProfileId, onEdit, onDelete }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [participants, setParticipants] = useState([]);
    const [isLoadingParticipants, setIsLoadingParticipants] = useState(false);

    // Fungsi ini akan mengambil data partisipan HANYA saat diperlukan
    const fetchParticipants = () => {
        if (!isExpanded) { // Jika sudah terbuka, jangan fetch lagi
            setIsLoadingParticipants(true);
            const participantsPath = getAgendaParticipantsCollectionPath(rtProfileId, agenda.id);
            const q = query(collection(db, participantsPath), orderBy("joinedAt", "asc"));

            getDocs(q).then(snapshot => {
                const participantsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setParticipants(participantsData);
                setIsLoadingParticipants(false);
            }).catch(error => {
                console.error("Gagal mengambil data partisipan:", error);
                setIsLoadingParticipants(false);
            });
        }
        // Toggle tampilan
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="p-4 border rounded-md bg-slate-50 shadow-sm">
            <div className="flex justify-between items-start">
                {/* Bagian detail agenda yang bisa diklik */}
                <div className="flex-grow cursor-pointer" onClick={fetchParticipants}>
                    <h4 className="font-semibold text-sky-600">{agenda.activityName}</h4>
                    <p className="text-sm text-slate-500">
                        {agenda.activityDate.toDate().toLocaleString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    </p>
                    <p className="text-xs text-slate-400">Lokasi: {agenda.locationName || 'Tidak ditentukan'}</p>
                    <p className={`text-xs mt-1 font-medium ${agenda.allowParticipation ? 'text-green-600' : 'text-slate-500'}`}>
                        {agenda.allowParticipation ? 'Partisipasi Dibuka' : 'Hanya Informasi'}
                    </p>
                </div>
                {/* Tombol aksi */}
                <div className="flex-shrink-0 ml-4 space-x-2">
                    <button onClick={() => onEdit(agenda)} className="text-xs py-1 px-3 bg-yellow-400 hover:bg-yellow-500 text-yellow-800 rounded-md">Edit</button>
                    <button onClick={() => onDelete(agenda.id, agenda.activityName)} className="text-xs py-1 px-3 bg-red-400 hover:bg-red-500 text-white rounded-md">Hapus</button>
                </div>
            </div>

            {/* Bagian detail partisipan yang bisa expand/collapse */}
            {isExpanded && (
                <div className="mt-4 pt-4 border-t border-slate-200 animate-fade-in-fast">
                    <h5 className="font-bold text-sm text-slate-700 mb-2">Daftar Partisipan ({participants.length})</h5>
                    {isLoadingParticipants ? (
                        <LoadingSpinner />
                    ) : (
                        participants.length > 0 ? (
                            <ul className="list-decimal list-inside text-sm space-y-1">
                                {participants.map(p => (
                                    <li key={p.id}>
                                        <span className="font-semibold">{p.occupantName || 'Warga'}</span> ({p.houseIdentifier || 'N/A'})
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-sm text-slate-500 italic">Belum ada yang berpartisipasi.</p>
                        )
                    )}
                </div>
            )}
        </div>
    );
};

// --- Helper Baru untuk Path Partisipan ---
const getAgendaParticipantsCollectionPath = (rtProfileId, agendaId) => `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/agendas/${agendaId}/participants`;


// --- Komponen Baru: Kalender ---
const CalendarView = ({ onDateClick, events, selectedDate }) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const startDay = startOfMonth.getDay();
    const daysInMonth = endOfMonth.getDate();
    const eventDates = useMemo(() => new Set(events.map(e => e.activityDate.toDate().toDateString())), [events]);
    const changeMonth = (offset) => { setCurrentDate(prev => new Date(prev.getFullYear(), prev.getMonth() + offset, 1)); };

    const renderCells = () => {
        const cells = [];
        for (let i = 0; i < startDay; i++) {
            cells.push(<div key={`empty-start-${i}`} className="p-2 border-b border-r border-slate-200"></div>);
        }
        for (let day = 1; day <= daysInMonth; day++) {
            const fullDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
            const dateString = fullDate.toDateString();
            const hasEvent = eventDates.has(dateString);
            const isSelected = selectedDate?.toDateString() === dateString;
            cells.push(
                <div key={day} onClick={() => onDateClick(fullDate)} className={`p-2 border-b border-r border-slate-200 text-center cursor-pointer transition-colors ${isSelected ? 'bg-orange-500 text-white font-bold' : hasEvent ? 'bg-orange-100 hover:bg-orange-200' : 'bg-white hover:bg-slate-50'}`}>
                    <span className={`w-8 h-8 flex items-center justify-center rounded-full mx-auto ${hasEvent && !isSelected ? 'font-bold text-orange-700' : ''}`}>{day}</span>
                </div>
            );
        }
        return cells;
    };

    return (
        <div className="bg-white p-4 rounded-xl shadow-md">
            <div className="flex justify-between items-center mb-4">
                <button onClick={() => changeMonth(-1)} className="font-bold text-lg p-2 rounded-full hover:bg-slate-100">&lt;</button>
                <h3 className="text-xl font-semibold text-slate-700">{currentDate.toLocaleString('id-ID', { month: 'long', year: 'numeric' })}</h3>
                <button onClick={() => changeMonth(1)} className="font-bold text-lg p-2 rounded-full hover:bg-slate-100">&gt;</button>
            </div>
            <div className="grid grid-cols-7 text-xs text-center text-slate-500 font-semibold mb-2">
                <div className="py-2">Min</div><div className="py-2">Sen</div><div className="py-2">Sel</div><div className="py-2">Rab</div><div className="py-2">Kam</div><div className="py-2">Jum</div><div className="py-2">Sab</div>
            </div>
            <div className="grid grid-cols-7 gap-px bg-slate-200 border-l border-t border-slate-200">{renderCells()}</div>
        </div>
    );
};

// --- Komponen Baru: Detail Agenda (DENGAN DEBUG LOG) ---
const AgendaDetailCard = ({ agenda, rtProfileId, houseId, loggedInHouseData, onParticipateError }) => {
    const [isJoining, setIsJoining] = useState(false);
    const [participants, setParticipants] = useState([]);
    const [isParticipant, setIsParticipant] = useState(false);

    // --- STATE BARU UNTUK KONTROL EXPAND/COLLAPSE ---
    const [isExpanded, setIsExpanded] = useState(false);

    // const { households } = useRT();
    // console.log('households', households);

    useEffect(() => {
        if (!agenda.allowParticipation) return;

        const participantsPath = getAgendaParticipantsCollectionPath(rtProfileId, agenda.id);
        const q = query(collection(db, participantsPath), orderBy("joinedAt", "desc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const participantsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setParticipants(participantsData);
            if (houseId) {
                setIsParticipant(participantsData.some(p => p.id === houseId));
            }
        }, (error) => {
            console.error("Firestore permission error on participants listener:", error);
            onParticipateError("Tidak dapat memuat daftar partisipan.");
        });
        return () => unsubscribe();
    }, [agenda.id, rtProfileId, houseId, agenda.allowParticipation, onParticipateError]);

    const handleJoin = async () => {
        // console.log('join nih', loggedInHouseData?.payerName);
        // console.log('house id', houseId);
        if (!houseId) {
            onParticipateError("Anda harus login ke rumah terlebih dahulu untuk berpartisipasi.");
            return;
        }
        setIsJoining(true);
        const participantRef = doc(db, getAgendaParticipantsCollectionPath(rtProfileId, agenda.id), houseId);
        try {
            // const houseInfo = households.find(h => h.id === houseId);
            await setDoc(participantRef, {
                joinedAt: Timestamp.now(),
                houseIdentifier: loggedInHouseData?.houseIdentifier || 'N/A',
                occupantName: loggedInHouseData?.payerName || 'Warga'
            });
        } catch (error) {
            onParticipateError("Gagal bergabung ke agenda.");
        }
        setIsJoining(false);
    };

    const handleLeave = async () => {
        if (!houseId) return;
        setIsJoining(true);
        const participantRef = doc(db, getAgendaParticipantsCollectionPath(rtProfileId, agenda.id), houseId);
        try {
            await deleteDoc(participantRef);
        } catch (error) {
            onParticipateError("Gagal membatalkan partisipasi.");
        }
        setIsJoining(false);
    };

    const locationUrl = agenda.locationCoords
        ? `https://www.google.com/maps/search/?api=1&query=${agenda.locationCoords.latitude},${agenda.locationCoords.longitude}`
        : null;

    return (
        <div className="bg-slate-50 p-4 rounded-lg border border-slate-200">
            <h4 className="font-bold text-lg text-sky-700">{agenda.activityName}</h4>
            <p className="text-sm text-slate-500 mb-2">
                {agenda.activityDate.toDate().toLocaleString('id-ID', { weekday: 'long', hour: '2-digit', minute: '2-digit' })} WIB
            </p>
            <p className="text-slate-600 whitespace-pre-wrap mb-3">{agenda.description}</p>
            {agenda.locationName && (
                <div className="text-sm flex items-center space-x-2 text-slate-500 mb-4">
                    <span>📍</span>
                    <span>{agenda.locationName}</span>
                    {locationUrl && <a href={locationUrl} target="_blank" rel="noopener noreferrer" className="text-sky-500 hover:underline">(Lihat Peta)</a>}
                </div>
            )}

            {agenda.allowParticipation && (
                <div>
                    <div className="flex justify-between items-center mb-2">
                        {/* Judul partisipan sekarang menjadi tombol untuk expand/collapse */}
                        <button onClick={() => setIsExpanded(!isExpanded)} className="font-semibold text-sm hover:underline focus:outline-none flex items-center">
                            Partisipan ({participants.length})
                            <svg className={`w-4 h-4 ml-1 transition-transform ${isExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                        </button>

                        {/* Tombol Join/Batal tetap di sini */}
                        {isParticipant ? (
                            <button onClick={handleLeave} disabled={isJoining} className="text-xs font-semibold text-red-500 hover:underline">
                                {isJoining ? "Memproses..." : "Batal Ikut"}
                            </button>
                        ) : (
                            <button onClick={handleJoin} disabled={isJoining} className="text-xs font-semibold text-sky-500 hover:underline">
                                {isJoining ? "Memproses..." : "+ Ikut Serta"}
                            </button>
                        )}
                    </div>

                    {/* Daftar partisipan hanya ditampilkan jika isExpanded bernilai true */}
                    {isExpanded && (
                        <div className="bg-white rounded p-3 border max-h-32 overflow-y-auto mt-2">
                            {participants.length > 0 ? (
                                <ul className="space-y-1 text-sm text-slate-700">
                                    {participants.map(p => (
                                        <li key={p.id} className="flex items-center space-x-2">
                                            <span className="text-green-500">✓</span>
                                            <span>
                                                {p.occupantName || 'Warga'} ({p.houseIdentifier || 'N/A'})
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-sm text-slate-400 text-center">Jadilah yang pertama berpartisipasi!</p>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// --- Komponen Baru: Halaman Utama Agenda Publik (DENGAN DEBUG LOG) ---
// Ganti seluruh komponen PublicAgendaPage Anda
const PublicAgendaPage = ({ rtProfileId, loggedInHouseData, initialDate }) => {
    const [agendas, setAgendas] = useState([]);
    // Gunakan 'initialDate' jika ada, jika tidak, gunakan tanggal hari ini
    const [selectedDate, setSelectedDate] = useState(initialDate || new Date());
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });

    // console.log('loggedInHouseData', loggedInHouseData);

    // useEffect untuk mengambil data tetap sama
    useEffect(() => {
        if (!rtProfileId) { setLoading(false); return; }
        setLoading(true);
        const q = query(collection(db, getAgendasCollectionPath(rtProfileId)), orderBy("activityDate", "desc"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const agendasData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setAgendas(agendasData);
            setLoading(false);
        }, (err) => {
            console.error("Error fetching agendas:", err);
            setError("Gagal memuat data agenda.");
            setLoading(false);
        });
        return () => unsubscribe();
    }, [rtProfileId]);

    const handleDateClick = (date) => {
        setSelectedDate(date);
    };

    const agendasForSelectedDate = agendas.filter(agenda =>
        agenda.activityDate.toDate().toDateString() === selectedDate.toDateString()
    );

    return (
        <div>
            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />
            <CalendarView
                onDateClick={handleDateClick}
                events={agendas}
                selectedDate={selectedDate}
            />

            <div className="mt-6">
                <h3 className="font-bold text-lg mb-4 text-slate-700">
                    Agenda untuk {selectedDate.toLocaleDateString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                </h3>
                {loading && <LoadingSpinner />}
                {error && <MessageBox message={error} type="error" />}
                {!loading && agendasForSelectedDate.length > 0 ? (
                    <div className="space-y-4">
                        {agendasForSelectedDate.map(agenda => (
                            <AgendaDetailCard
                                key={agenda.id}
                                agenda={agenda}
                                rtProfileId={rtProfileId}
                                houseId={loggedInHouseData?.id}
                                loggedInHouseData={loggedInHouseData}
                                onParticipateError={(err) => setMessage({ text: err, type: 'error' })}
                            />
                        ))}
                    </div>
                ) : !loading && (
                    <p className="text-center text-slate-500 py-4">Tidak ada agenda di tanggal ini.</p>
                )}
            </div>
        </div>
    );
};

// Letakkan ini di atas function App()
function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

// --- Main App Component ---
// GANTI SELURUH FUNGSI APP ANDA DENGAN KODE LENGKAP DI BAWAH INI

// GANTI SELURUH FUNGSI APP DENGAN KODE FINAL YANG SUDAH DIPERBAIKI INI

function App() {
    // =============================================================
    // BAGIAN 1: SEMUA HOOKS DAN STATE DIDEFINISIKAN DI SINI
    // =============================================================
    const { currentUser, userRole, loadingAuth, userId, logout, appConfig, loadingAppConfig, rtProfileId: adminRtProfileId } = useAuth();
    const [currentPage, setCurrentPage] = useState('dashboard');
    const [currentAdminPage, setCurrentAdminPage] = useState('dashboard');
    const [currentPath, setCurrentPath] = useState(window.location.pathname);
    const [publicPageState, setPublicPageState] = useState('global_otp');
    const [isInitializing, setIsInitializing] = useState(true);
    const [showForcedLogoutModal, setShowForcedLogoutModal] = useState(false);
    const [selectedHouseForOtpOrPin, setSelectedHouseForOtpOrPin] = useState(null);
    const [loggedInHouseData, setLoggedInHouseData] = useState(null);
    const [publicSelectedRtProfileId, setPublicSelectedRtProfileId] = useState(null);
    const [isRtSpecificTestingMode, setIsRtSpecificTestingMode] = useState(false);
    const [loadingRtSpecificConfig, setLoadingRtSpecificConfig] = useState(false);
    const { rtProfile, loadingRt, setRtProfile } = useRT();
    const hasInitialized = useRef(false);

    // State untuk fitur baru, dipindahkan ke level atas
    const [showFeatureGateModal, setShowFeatureGateModal] = useState(false);
    const [gatedFeatureName, setGatedFeatureName] = useState('');
    const [isIdle, setIsIdle] = useState(false);
    const [initialAgendaDate, setInitialAgendaDate] = useState(null);
    const [isDetailViewActive, setIsDetailViewActive] = useState(false);
    // Di dalam function App(), di dekat state lainnya
    const [paymentContext, setPaymentContext] = useState(null);
    const [paymentSuccessSignal, setPaymentSuccessSignal] = useState(0);
    const prevAppConfig = usePrevious(appConfig);
    const [pagePayload, setPagePayload] = useState(null);
    const [postLoginRedirect, setPostLoginRedirect] = useState(null);
    // --- STATE BARU UNTUK MENANGANI PROMPT UPDATE ---
    const [updateRegistration, setUpdateRegistration] = useState(null);

    // --- USE EFFECT BARU UNTUK MENDENGARKAN EVENT DARI SW ---
    useEffect(() => {
        const handleUpdate = (event) => {
            // console.log("Event 'swUpdate' diterima di App.js, menampilkan modal.");
            setUpdateRegistration(event.detail);
        };

        window.addEventListener('swUpdate', handleUpdate);

        // Cleanup listener saat komponen di-unmount
        return () => window.removeEventListener('swUpdate', handleUpdate);
    }, []);
    // ---------------------------------------------------------------- //
    // ----- STATE UNTUK PWA INSTALL PROMPT
    // ---------------------------------------------------------------- //
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallButton, setShowInstallButton] = useState(false);

    useEffect(() => {
        // console.log("--- PWA INSTALL PROMPT DEBUGGING ---");

        // 1. Cek Service Worker dan manifest
        if ('serviceWorker' in navigator) {
            // console.log('✅ Service Worker API is supported.');
            navigator.serviceWorker.getRegistrations().then(registrations => {
                if (registrations.length > 0) {
                    // console.log('✅ Service Worker is registered.');
                } else {
                    // console.log('❌ No Service Worker is registered. This is a critical issue.');
                }
            });
        } else {
            // console.log('❌ Service Worker API is NOT supported.');
        }

        fetch('/manifest.json')
            .then(response => {
                if (response.ok) {
                    // console.log('✅ manifest.json file found and accessible.');
                } else {
                    // console.log('❌ manifest.json file NOT found (HTTP Status: ' + response.status + ').');
                }
            })
            .catch(error => {
                // console.log('❌ Failed to fetch manifest.json: ' + error.message);
            });

        // 2. Cek apakah di standalone mode
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
        if (isStandalone) {
            // console.log('App is already installed (standalone mode). Hiding install button.');
            setShowInstallButton(false);
        } else {
            // console.log('App is NOT in standalone mode. It can be installed.');
        }


        // 3. Listener untuk beforeinstallprompt
        const handleBeforeInstallPrompt = (e) => {
            // console.log("-----------------------------------------");
            // console.log("✅ Event 'beforeinstallprompt' has fired!");
            // console.log("-----------------------------------------");
            e.preventDefault();
            setDeferredPrompt(e);
            setShowInstallButton(true);
            // console.log("showInstallButton state is now true.");
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        // 4. Cek protokol
        if (window.location.protocol === 'https:') {
            // console.log('✅ App is served over HTTPS.');
        } else {
            // console.log('❌ App is NOT served over HTTPS. This is likely the cause of the problem.');
        }

        // 5. Cleanup
        return () => {
            // console.log("Cleaning up PWA install event listener.");
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = useCallback(() => {
        // console.log("User clicked install button.");
        if (deferredPrompt) {
            // console.log("deferredPrompt exists, showing installation dialog.");
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    // console.log('User accepted the install prompt.');
                } else {
                    // console.log('User dismissed the install prompt.');
                }
                setDeferredPrompt(null);
                setShowInstallButton(false);
            });
        } else {
            // console.log("No deferredPrompt to show. The event never fired.");
        }
    }, [deferredPrompt]);
    // ---------------------------------------------------------------- //
    // ----- AKHIR DARI PWA INSTALL PROMPT
    // ---------------------------------------------------------------- //

    // =============================================================
    // BAGIAN 2: SEMUA FUNGSI HANDLER DIDEFINISIKAN DI SINI
    // =============================================================
    const navigate = useCallback((path) => { window.history.pushState({}, '', path); setCurrentPath(path); }, []);
    // ... (Semua fungsi handler Anda yang lain seperti getEffectiveHouseVerificationStatus, handleExitRtContext, dll. tetap di sini) ...
    const getEffectiveHouseVerificationStatus = useCallback((targetRtId) => { if (!appConfig) { return true; } if (rtProfile && rtProfile.id === targetRtId && rtProfile.isHouseVerificationEnabled !== undefined) { return rtProfile.isHouseVerificationEnabled; } if (appConfig.rtProfiles && appConfig.rtProfiles[targetRtId] && appConfig.rtProfiles[targetRtId].isHouseVerificationEnabled !== undefined) { return appConfig.rtProfiles[targetRtId].isHouseVerificationEnabled; } const globalDefault = appConfig.isHouseVerificationEnabled; return globalDefault; }, [appConfig, rtProfile]);
    const handleExitRtContext = useCallback(() => {
        localStorage.clear(); // Cara lebih cepat untuk menghapus semua
        if (setRtProfile) setRtProfile(null);
        setPublicPageState('global_otp');
        setLoggedInHouseData(null);
        setPublicSelectedRtProfileId(null);
        setSelectedHouseForOtpOrPin(null);
        navigate('/');

        // TAMBAHKAN BARIS INI untuk mereset penanda
        hasInitialized.current = false;
    }, [setRtProfile, navigate]);
    const handleRtVerifiedAndSelected = useCallback((verifiedRtId) => {
        if (verifiedRtId) {
            // console.log(`[App] RT ${verifiedRtId} terverifikasi. Mengarahkan ke pemilihan rumah.`);
            localStorage.setItem('isGlobalOtpVerified', 'true');
            localStorage.setItem('rtCode', verifiedRtId);
            setPublicSelectedRtProfileId(verifiedRtId);

            // Langsung arahkan ke halaman pemilihan rumah, tanpa syarat.
            setPublicPageState('house_selection');

        } else {
            // Jika verifikasi gagal, reset semua sesi.
            handleExitRtContext();
        }
    }, [handleExitRtContext]);
    // Versi baru yang lebih stabil
    // Versi baru yang sudah benar
    const handleProceedToPhoneAuth = (houseData) => {
        // console.log("Navigasi ke halaman verifikasi OTP HP...");
        setSelectedHouseForOtpOrPin(houseData);
        setPublicPageState('phone_auth_init_and_recaptcha');
    };

    // Handler BARU untuk lanjut ke halaman MASUKKAN PIN
    const handleProceedToEnterPin = (houseData) => {
        // console.log("Navigasi ke halaman masukkan PIN...");
        setSelectedHouseForOtpOrPin(houseData);
        setPublicPageState('enter_pin');
    };

    // Handler BARU untuk lanjut ke halaman BUAT PIN
    const handleProceedToCreatePin = (houseData) => {
        // console.log("Navigasi ke halaman buat PIN...");
        setSelectedHouseForOtpOrPin(houseData);
        setPublicPageState('create_pin');
    };

    const handlePhoneOtpVerified = (houseData) => { setSelectedHouseForOtpOrPin(houseData); setPublicPageState('create_pin'); };
    // VERSI BARU YANG DIPERBAIKI:
    // --- GANTI SELURUH FUNGSI INI DENGAN VERSI BARU ---
    const handlePinCreatedOrVerified = async (houseData) => {
        // Jangan lakukan apa-apa jika tidak ada data rumah
        if (!houseData?.rtProfileId || !houseData.id) {
            console.error("Gagal memproses login PIN, data rumah tidak lengkap.");
            return;
        }

        try {
            // Tugas fungsi ini sekarang HANYA untuk melengkapi data sesi login warga
            const occupanciesPath = getOccupanciesCollectionPath(houseData.rtProfileId);
            const q = query(collection(db, occupanciesPath),
                where("householdId", "==", houseData.id),
                where("status", "==", "ACTIVE"),
                where("isPayer", "==", true),
                limit(1)
            );
            const occupancySnap = await getDocs(q);
            if (occupancySnap.empty) {
                throw new Error("Sesi tidak valid, data hunian aktif tidak ditemukan.");
            }

            const payerOccupancyData = occupancySnap.docs[0].data();
            const finalLoggedInData = {
                ...houseData,
                familyId: payerOccupancyData.familyId,
                moveInDate: payerOccupancyData.moveInDate,
                payerName: payerOccupancyData.headOfFamilyName
            };

            // Simpan sesi ke localStorage dan state
            localStorage.setItem('loggedInHouseData', JSON.stringify(finalLoggedInData));
            setLoggedInHouseData(finalLoggedInData);

            // Bersihkan state sementara
            setSelectedHouseForOtpOrPin(null);
            localStorage.removeItem('last_house_for_pin');

            // Set halaman tujuan.
            // Kita tidak perlu lagi memanggil setRtProfile di sini.
            // RTProvider akan secara otomatis mendapatkan profil yang benar dari appConfig.
            setPublicPageState('public_dashboard');

        } catch (err) {
            console.error("Gagal memproses login akhir setelah PIN:", err);
            handleExitRtContext(); // Jika gagal, reset sesi sepenuhnya
        }
    };
    // --- LOGIKA BARU UNTUK DETEKSI PERUBAHAN PLAN ---

    // 2. useEffect ini akan berjalan SETIAP KALI appConfig diperbarui
    useEffect(() => {
        // --- TAMBAHKAN GUARD CLAUSE INI DI PALING ATAS ---
        // Jangan jalankan logika auto-logout jika pengguna adalah superAdmin
        if (userRole === 'superAdmin') {
            return;
        }
        // ----------------------------------------------------
        // Jangan jalankan jika ini render pertama atau config belum siap
        if (!prevAppConfig || !appConfig) {
            // console.log("DEBUG: Melewatkan pengecekan plan, config belum siap.");
            return;
        }

        // Tentukan ID RT yang sedang aktif
        const activeRtId = loggedInHouseData?.rtProfileId || adminRtProfileId || publicSelectedRtProfileId;
        if (!activeRtId) return;

        // Dapatkan plan lama dari state sebelumnya dan plan baru dari state sekarang
        const oldPlan = prevAppConfig.rtProfiles?.[activeRtId]?.plan || 'gratis';
        const newPlan = appConfig.rtProfiles?.[activeRtId]?.plan || 'gratis';

        // console.log(`DEBUG: Memeriksa plan untuk RT ${activeRtId}. Plan Lama: ${oldPlan}, Plan Baru: ${newPlan}`);

        // Jika plan berbeda, panggil setState untuk menampilkan modal
        if (oldPlan !== newPlan) {
            // console.log(`%cDEBUG: PERUBAHAN PLAN TERDETEKSI! MEMANGGIL setShowForcedLogoutModal(true)`, 'color: yellow; font-weight: bold;');
            setShowForcedLogoutModal(true);

        }

    }, [appConfig, prevAppConfig, loggedInHouseData, adminRtProfileId]);


    // 3. useEffect ini khusus untuk memantau HASIL dari state modal
    useEffect(() => {
        // Log ini akan memberitahu kita apakah React berhasil memperbarui state atau tidak
        // console.log('%cDEBUG: Nilai state showForcedLogoutModal sekarang adalah:', 'color: cyan;', showForcedLogoutModal);
    }, [showForcedLogoutModal]);


    // --- FUNGSI BARU UNTUK MENANGANI LOGOUT ---
    const handleForcedLogout = useCallback(() => {
        if (userRole) { // Jika admin
            logout();
        } else { // Jika warga
            handleExitRtContext();
        }
        setShowForcedLogoutModal(false);
    }, [userRole, logout, handleExitRtContext]);
    const handleHouseLogout = () => {
        // Hapus data sesi rumah dari localStorage dan state
        localStorage.removeItem('loggedInHouseData');
        setLoggedInHouseData(null);
        setSelectedHouseForOtpOrPin(null);

        // Selama konteks RT masih ada, SELALU kembali ke pemilihan rumah.
        if (publicSelectedRtProfileId) {
            setPublicPageState('house_selection');
        } else {
            // Jika karena suatu hal konteks RT hilang, keluar sepenuhnya.
            handleExitRtContext();
        }
    };
    const handleForgotPin = (houseData) => { localStorage.removeItem(`${PIN_STORAGE_PREFIX}${houseData.id}`); setSelectedHouseForOtpOrPin(houseData); setPublicPageState('phone_auth_init_and_recaptcha'); };
    // KODE BARU
    const postLoginPages = ['public_dashboard', 'payment_form', 'agenda_page', 'announcements_list', 'kartu_iuran_dedicated', 'submit_payment_form'];
    const pinPages = ['enter_pin', 'create_pin']; // <-- TAMBAHKAN BARIS INI DI SINI
    // --- HANDLER UNTUK IDLE TIMEOUT ---
    // GANTI FUNGSI-FUNGSI INI
    const handleIdle = useCallback(() => {
        // Fungsi ini hanya bergantung pada `loggedInHouseData`
        if (loggedInHouseData) {
            // console.log("Pengguna tidak aktif, menampilkan modal...");
            setIsIdle(true);
        }
    }, [loggedInHouseData]); // Tambahkan dependensi

    const handleStayActive = useCallback(() => {
        // Fungsi ini tidak memiliki dependensi
        // console.log("Pengguna mengonfirmasi masih aktif.");
        setIsIdle(false);
    }, []); // Array dependensi kosong

    // Di dalam function App()

    const appStateRef = useRef({});

    useEffect(() => {
        appStateRef.current = {
            loggedInHouseData,
            adminRtProfileId,
            appConfig,
            userRole,
            logout,
            handleExitRtContext, // Kita juga butuh fungsi ini di dalam Ref
        };
    }, [loggedInHouseData, adminRtProfileId, appConfig, userRole, logout, handleExitRtContext]);


    // --- LANGKAH 3: Buat useEffect yang HANYA berjalan sekali untuk memasang listener ---
    useEffect(() => {
        const checkPlanStatus = async () => {
            // Ambil semua state dan fungsi TERBARU dari 'appStateRef.current'
            const state = appStateRef.current;
            const activeRtId = state.loggedInHouseData?.rtProfileId || state.adminRtProfileId;

            if (!activeRtId || !state.appConfig?.rtProfiles) return;

            try {
                const profileRef = doc(db, getRtProfileDocPath(activeRtId));
                const profileSnap = await getDoc(profileRef);

                if (profileSnap.exists()) {
                    const latestPlan = profileSnap.data().plan || 'gratis';
                    const currentPlanInState = state.appConfig.rtProfiles[activeRtId]?.plan || 'gratis';

                    if (latestPlan !== currentPlanInState) {
                        alert("Peran atau paket layanan untuk RT Anda telah diperbarui. Anda akan dikeluarkan untuk menerapkan perubahan.");

                        if (state.userRole) {
                            state.logout();
                        } else {
                            state.handleExitRtContext();
                        }
                    }
                }
            } catch (error) {
                console.error("Gagal memeriksa status plan:", error);
            }
        };

        // console.log("Memasang listener pengecekan plan (hanya sekali).");
        window.addEventListener('focus', checkPlanStatus);

        // Fungsi cleanup untuk listener
        return () => {
            // console.log("Membersihkan listener pengecekan plan.");
            window.removeEventListener('focus', checkPlanStatus);
        };
    }, []); // <-- Array dependensi KOSONG, ini kuncinya!

    // HAPUS useEffect LAMA dan GANTI DENGAN YANG INI:
    useEffect(() => {
        // Fungsi untuk menjalankan inisialisasi App Check
        const initAppCheck = () => {
            try {
                // Pastikan Anda menggunakan Site Key yang benar (status "Protected")
                const enterpriseSiteKey = '6LfuTlMrAAAAANURVGsQPrkfM0ggJygpTunp5fRR';

                // console.log("Menjalankan inisialisasi App Check...");
                initializeAppCheck(app, {
                    provider: new ReCaptchaEnterpriseProvider(enterpriseSiteKey),
                    isTokenAutoRefreshEnabled: true
                });
                // console.log("App Check berhasil diinisialisasi.");
            } catch (error) {
                console.error("Gagal saat inisialisasi App Check:", error);
            }
        };

        // Cek apakah 'grecaptcha' dari Google sudah ada di window
        if (window.grecaptcha?.enterprise) {
            // Jika sudah ada, langsung jalankan
            initAppCheck();
        } else {
            // Jika belum ada, kita tunggu dan cek setiap 100 milidetik
            let attempts = 0;
            const intervalId = setInterval(() => {
                attempts++;
                // Cek lagi apakah sekarang sudah ada
                if (window.grecaptcha?.enterprise) {
                    clearInterval(intervalId); // Hentikan pengecekan
                    initAppCheck(); // Jalankan inisialisasi
                }
                // Berhenti mencoba setelah 50 kali (5 detik) untuk mencegah loop tak terbatas
                else if (attempts > 50) {
                    clearInterval(intervalId);
                    // console.error("reCAPTCHA script tidak termuat setelah 5 detik. Periksa koneksi atau ad-blocker.");
                }
            }, 100);
        }

    }, []); // Array dependensi kosong, hanya berjalan sekali


    const handleSessionTimeout = useCallback(() => {
        // Fungsi ini bergantung pada `loggedInHouseData` untuk disimpan
        // console.log("Sesi timeout, kembali ke halaman PIN.");
        setIsIdle(false);
        if (loggedInHouseData) { // Tambahkan pengecekan untuk keamanan
            localStorage.setItem('last_house_for_pin', JSON.stringify(loggedInHouseData));
            localStorage.removeItem('loggedInHouseData');
            setSelectedHouseForOtpOrPin(loggedInHouseData);
            setLoggedInHouseData(null);
            setPublicPageState('enter_pin');
        }
    }, [loggedInHouseData]); // Tambahkan dependensi (state setter tidak perlu)

    const initializeSession = useCallback(() => {
        // Fungsi ini hanya akan berjalan jika config sudah siap dan belum ada sesi di state
        if (!appConfig || publicSelectedRtProfileId || loggedInHouseData) {
            return;
        }

        const storedRtCode = localStorage.getItem('rtCode');
        const storedHouseDataString = localStorage.getItem('loggedInHouseData');

        if (storedRtCode) {
            setPublicSelectedRtProfileId(storedRtCode);

            if (storedHouseDataString) {
                try {
                    const houseData = JSON.parse(storedHouseDataString);
                    if (houseData.rtProfileId === storedRtCode) {
                        setSelectedHouseForOtpOrPin(houseData);
                        setPublicPageState('enter_pin');
                    } else {
                        handleExitRtContext();
                    }
                } catch {
                    handleExitRtContext();
                }
            } else {
                if (rtProfile) {
                    const isVerificationEnabled = getEffectiveHouseVerificationStatus(storedRtCode);
                    setPublicPageState(isVerificationEnabled ? 'house_selection' : 'public_dashboard');
                }
            }
        } else {
            setPublicPageState('global_otp');
        }
    }, [appConfig, rtProfile, publicSelectedRtProfileId, loggedInHouseData, getEffectiveHouseVerificationStatus, handleExitRtContext]);

    // MENJADI SEPERTI INI:
    const { resetTimer } = useIdleTimer({
        onIdle: handleIdle,
        idleTime: 180000, // Ganti kembali ke 60000 setelah testing selesai
        enabled: !!loggedInHouseData && postLoginPages.includes(publicPageState) && !pinPages.includes(publicPageState)
    });
    // GANTI SELURUH FUNGSI handleNavigation ANDA DENGAN INI

    // Di dalam komponen App

    const handleAdminNavigate = (page, payload = null) => {
        // console.log(`Admin navigasi ke: ${page}`);
        setPagePayload(payload);
        setCurrentAdminPage(page);
        // Update URL agar browser sinkron
        const path = `/pengurus-rt/${page === 'dashboard' ? '' : page}`;
        window.history.pushState({}, '', path);
        setCurrentPath(path);
    };

    const handleNavigation = (page, payload = null) => {
        // Log untuk debugging, sangat membantu melihat alur
        // console.log(`Navigasi dipanggil ke halaman: ${page}`, payload || '');

        setPagePayload(payload);
        if (page === 'subscription_invoice') {
            setCurrentPage(page);

        }
        // console.log(`Navigasi dipanggil ke halaman: ${currentPage} - ${page}`, payload || '');
        // --- Bagian 1: Menangani Data Tambahan (Payload) & Sinyal ---

        // Simpan konteks pembayaran jika targetnya adalah form submit
        if (page === 'submit_payment_form') {
            setPaymentContext(payload);
        }

        // Atur tanggal awal untuk agenda jika ada
        if (page === 'agenda_page' && payload?.date) {
            setInitialAgendaDate(payload.date);
        } else {
            // Selalu reset jika tidak ada payload tanggal, untuk menghindari data basi
            setInitialAgendaDate(null);
        }

        // Tangkap sinyal sukses dari pembayaran untuk me-refresh halaman tagihan
        if (page === 'payment_form' && payload === true) {
            setPaymentSuccessSignal(prev => prev + 1);
        }

        // --- Bagian 2: Menangani Aksi Khusus (seperti menampilkan modal) ---

        // Ini adalah logika untuk "teaser" fitur premium yang kita diskusikan
        if (page === 'show_feature_gate') {
            setGatedFeatureName(payload?.featureName || 'Fitur ini');
            setShowFeatureGateModal(true);
            return; // Hentikan navigasi, hanya tampilkan modal
        }

        // --- Bagian 3: Gerbang Fitur untuk Halaman Tertentu ---
        const rtConf = rtProfile || (publicSelectedRtProfileId && appConfig?.rtProfiles?.[publicSelectedRtProfileId]);

        // Jika halaman yang dituju memerlukan config RT tapi config-nya belum siap, jangan lanjutkan
        if (!rtConf && ['agenda_page', 'announcements_list'].includes(page)) {
            console.error("Tidak bisa navigasi, konteks RT tidak ditemukan.");
            return;
        }

        // Pengecekan fitur Agenda
        if (page === 'agenda_page' && !rtConf?.isAgendaEnabled) {
            setGatedFeatureName('Agenda');
            setShowFeatureGateModal(true);
            return; // Hentikan navigasi
        }

        // Pengecekan fitur Pengumuman
        if (page === 'announcements_list' && !rtConf?.isAnnouncementEnabled) {
            setGatedFeatureName('Pengumuman');
            setShowFeatureGateModal(true);
            return; // Hentikan navigasi
        }

        // --- Bagian 4: Lakukan Navigasi ---
        // Jika lolos semua pengecekan di atas, baru ubah state halaman
        setPublicPageState(page);
    };

    // --- SEMUA useEffect ---
    useEffect(() => { if (loggedInHouseData) { resetTimer(); } }, [publicPageState, loggedInHouseData, resetTimer]);
    useEffect(() => { document.title = "SATUWARGA"; }, []);
    // Ganti seluruh useEffect inisialisasi sesi Anda dengan ini
    useEffect(() => {
        // Jika loading auth atau config belum selesai, jangan lakukan apa-apa
        // Biarkan layar loading utama tampil
        if (loadingAuth || loadingAppConfig) {
            return;
        }

        // Jika sudah pernah inisialisasi, hentikan
        if (hasInitialized.current) {
            // Namun, pastikan layar loading sudah hilang jika kita masuk ke sini
            setIsInitializing(false);
            return;
        }

        const initialize = async () => {
            const searchParams = new URLSearchParams(window.location.search);
            const tokenFromUrl = searchParams.get('token');

            // PRIORITAS #1: Menangani login dari portal via token
            if (tokenFromUrl) {
                try {
                    await signInWithCustomToken(authGlobal, tokenFromUrl);
                    // Setelah ini berhasil, useEffect lain yang bergantung pada `userRole`
                    // akan mengambil alih untuk navigasi. Kita tidak perlu melakukan apa-apa lagi di sini.
                } catch (error) {
                    console.error("Gagal login dengan custom token:", error);
                    alert("Gagal memvalidasi sesi pendaftaran. Silakan coba login secara manual.");
                    window.history.replaceState({}, document.title, "/pengurus-rt");
                }
            } else {
                // PRIORITAS #2: Menangani sesi yang sudah ada dari localStorage
                const lastHouseForPinString = localStorage.getItem('last_house_for_pin');
                const storedHouseDataString = localStorage.getItem('loggedInHouseData');
                const storedRtCode = localStorage.getItem('rtCode');

                if (lastHouseForPinString) {
                    // console.log("Sesi Timeout Terdeteksi, Paksa Re-Autentikasi PIN.");
                    try {
                        const houseData = JSON.parse(lastHouseForPinString);
                        setPublicSelectedRtProfileId(houseData.rtProfileId);
                        setSelectedHouseForOtpOrPin(houseData);
                        setPublicPageState('enter_pin');
                    } catch {
                        handleExitRtContext();
                    }

                    // PRIORITAS 2: Rehidrasi Sesi Aktif
                } else if (storedHouseDataString && storedRtCode) {
                    // console.log("Sesi Aktif Terdeteksi, Memulai Rehidrasi Data...");
                    try {
                        const houseDataFromStorage = JSON.parse(storedHouseDataString);
                        const occupanciesPath = getOccupanciesCollectionPath(houseDataFromStorage.rtProfileId);
                        const q = query(collection(db, occupanciesPath),
                            where("householdId", "==", houseDataFromStorage.id),
                            where("status", "==", "ACTIVE"),
                            where("isPayer", "==", true),
                            limit(1)
                        );
                        const occupancySnap = await getDocs(q);
                        if (occupancySnap.empty) { throw new Error("Sesi tidak valid, data hunian aktif tidak ditemukan."); }

                        const payerOccupancyData = occupancySnap.docs[0].data();
                        const freshLoggedInData = {
                            ...houseDataFromStorage,
                            familyId: payerOccupancyData.familyId,
                            moveInDate: payerOccupancyData.moveInDate,
                            payerName: payerOccupancyData.headOfFamilyName
                        };

                        setLoggedInHouseData(freshLoggedInData);
                        setPublicSelectedRtProfileId(storedRtCode);
                        setPublicPageState('public_dashboard');

                    } catch (err) {
                        console.error("Gagal merehidrasi sesi, membersihkan...", err);
                        handleExitRtContext();
                    }

                    // PRIORITAS 3: Sesi Publik/Free Plan
                } else if (storedRtCode) {
                    // console.log("Sesi Publik Terdeteksi, memuat profil RT...");
                    setPublicSelectedRtProfileId(storedRtCode);
                    const profile = await loadRtProfileFromStorage();
                    if (profile) {
                        if (setRtProfile) setRtProfile(profile);
                        const isVerificationEnabled = getEffectiveHouseVerificationStatus(storedRtCode);
                        setPublicPageState(isVerificationEnabled ? 'house_selection' : 'public_dashboard');
                    } else {
                        handleExitRtContext();
                    }

                    // PRIORITAS 4: Pengguna Baru
                } else {
                    setPublicPageState('global_otp');
                }
            }

            // Tandai bahwa semua jenis inisialisasi sudah selesai
            hasInitialized.current = true;
            setIsInitializing(false);
        };

        initialize();

    }, [appConfig, loadingAuth, loadingAppConfig]); // Dependensi sudah benar

    useEffect(() => {
        // Efek ini berjalan setiap kali `userRole` berubah (misal: dari null ke 'admin_rt')
        if (userRole === 'admin_rt') {
            const searchParams = new URLSearchParams(window.location.search);
            const billIdToOpen = searchParams.get('open_bill_id');

            // Jika ada `open_bill_id` di URL, berarti ini adalah redirect dari portal
            if (billIdToOpen) {
                // console.log(`Pengguna admin terdeteksi. Mengarahkan ke tagihan: ${billIdToOpen}`);

                // Panggil fungsi navigasi dengan halaman dan payload yang benar
                handleAdminNavigate('subscriptionBilling', { openBillId: billIdToOpen });

                // Bersihkan URL setelah navigasi agar rapi
                const cleanPath = window.location.pathname.split('?')[0];
                window.history.replaceState({}, document.title, cleanPath);
            }
        }
    }, [userRole]);

    // useEffect(() => {
    //     // Jalankan HANYA JIKA:
    //     // 1. Ada pengguna yang sudah berhasil login (currentUser tidak null)
    //     // 2. Ada perintah redirect yang tersimpan (postLoginRedirect tidak null)
    //     if (currentUser && postLoginRedirect) {
    //         console.log("Login selesai, menjalankan navigasi yang tertunda ke:", postLoginRedirect.page);

    //         // Lakukan navigasi yang sebenarnya
    //         handleAdminNavigate(postLoginRedirect.page, postLoginRedirect.payload);

    //         // PENTING: Reset state agar tidak redirect lagi saat re-render berikutnya
    //         setPostLoginRedirect(null);
    //     }
    // }, [currentUser, postLoginRedirect]);

    useEffect(() => { let relevantRtId = null; if (currentPath.startsWith('/pengurus-rt')) { if (userRole === 'admin_rt' && adminRtProfileId) { relevantRtId = adminRtProfileId; } } else { if (loggedInHouseData?.rtProfileId) { relevantRtId = loggedInHouseData.rtProfileId; } else if (publicSelectedRtProfileId) { relevantRtId = publicSelectedRtProfileId; } } if (relevantRtId) { setLoadingRtSpecificConfig(true); const rtConfigDocRef = doc(db, getRtSpecificConfigDocPath(relevantRtId)); const unsubscribe = onSnapshot(rtConfigDocRef, (docSnap) => { if (docSnap.exists()) { const rtConfigData = docSnap.data(); setIsRtSpecificTestingMode(rtConfigData.isTestingMode === true); } else { setIsRtSpecificTestingMode(false); } setLoadingRtSpecificConfig(false); }, (error) => { console.error(`[BadgeEffect] Error fetching specific RT config for ${relevantRtId}:`, error); setIsRtSpecificTestingMode(false); setLoadingRtSpecificConfig(false); }); return () => unsubscribe(); } else { setIsRtSpecificTestingMode(false); setLoadingRtSpecificConfig(false); } }, [userRole, adminRtProfileId, loggedInHouseData, publicSelectedRtProfileId, currentPath]);

    // --- TAMPILAN LOADING UTAMA ---
    if (loadingAuth || (loadingAppConfig && !appConfig)) {
        return (<div className="min-h-screen flex items-center justify-center bg-slate-100"><LoadingSpinner /><p className="ml-4 text-slate-600">Memuat aplikasi...</p></div>);
    }

    if (isInitializing) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-100">
                <LoadingSpinner />
                <p className="ml-4 text-slate-600">Mempersiapkan sesi Anda...</p>
            </div>
        );
    }

    // --- BAGIAN 3: LOGIKA RENDER ---
    let pageContent;

    // / ---> TAMBAHKAN BLOK DEBUGGING INI:
    // console.log("--- RENDER CYCLE ---");
    // console.log("Current publicPageState:", publicPageState);
    // console.log("Selected House for PIN/OTP:", selectedHouseForOtpOrPin?.id);
    // console.log("Logged In House Data:", loggedInHouseData?.id);
    // console.log("--------------------");
    // ---> AKHIR BLOK DEBUGGING


    // Di dalam fungsi App(), ganti seluruh blok ini
    if (currentPath.startsWith('/pengurus-rt')) {
        // KONTEN HALAMAN ADMIN
        if (!currentUser || !userRole) {
            pageContent = <AdminLoginPage />;
        } else {
            const activeAdminPage = currentPath.split('/pengurus-rt/')[1] || 'dashboard';
            const currentRtConfig = appConfig?.rtProfiles?.[adminRtProfileId];

            const allAdminNavItems = [
                { title: 'Dasbor', page: 'dashboard', icon: '📊', roles: ['superAdmin', 'admin_rt', 'bendahara'], group: 'Dasbor' },
                { title: 'Manajemen Profil RT', page: 'manageRtProfiles', icon: '🏢', roles: ['superAdmin'], group: 'Super Admin' },
                { title: 'Manajemen Plan', page: 'managePlans', icon: '📦', roles: ['superAdmin'], group: 'Super Admin' },
                { title: 'Pengaturan Global', page: 'globalSettings', icon: '🌍', roles: ['superAdmin'], group: 'Super Admin' },
                { title: 'Data Rumah', page: 'manageHouseholds', icon: '🏠', roles: ['admin_rt'], group: 'Kependudukan' },
                { title: 'Data Keluarga & Warga', page: 'manageFamilies', icon: '👨‍👩‍👧‍👦', roles: ['admin_rt'], group: 'Kependudukan' },
                { title: 'Manajemen Hunian', page: 'manageOccupancy', icon: '🔑', roles: ['admin_rt'], group: 'Kependudukan' },
                { title: 'Jenis Iuran', page: 'manageDuesTemplates', icon: '🏷️', roles: ['admin_rt'], group: 'Keuangan' },
                { title: 'Buat Tagihan', page: 'generateBills', icon: '🧾', roles: ['admin_rt', 'bendahara'], group: 'Keuangan' },
                { title: 'Manajemen Tagihan', page: 'manageBills', icon: '📋', roles: ['admin_rt', 'bendahara'], group: 'Keuangan' },
                { title: 'Input Pembayaran Manual', page: 'manualPayment', icon: '✍️', roles: ['admin_rt', 'bendahara'], group: 'Keuangan' },
                { title: 'Persetujuan Pembayaran', page: 'approvePayments', icon: '👍', roles: ['admin_rt', 'bendahara'], group: 'Keuangan' },
                { title: 'Pengeluaran', page: 'recordExpense', icon: '💸', roles: ['admin_rt', 'bendahara'], group: 'Keuangan' },
                { title: 'Keuangan', page: 'financialReports', icon: '📈', roles: ['admin_rt', 'bendahara'], group: 'Laporan & Keuangan' },
                { title: 'Rekening Bank', page: 'manageBankAccounts', icon: '💳', roles: ['admin_rt', 'bendahara'], group: 'Laporan & Keuangan' },
                {
                    title: 'Laporan Transaksi',
                    page: 'transactionReports', // Nama halaman baru
                    icon: '📄',
                    roles: ['admin_rt', 'bendahara'],
                    group: 'Laporan & Keuangan'
                },
                { title: 'Pengumuman', page: 'manageAnnouncements', icon: '📢', roles: ['admin_rt'], condition: () => currentRtConfig?.isAnnouncementEnabled },
                { title: 'Agenda', page: 'manageAgendas', icon: '🗓️', roles: ['admin_rt'], condition: () => currentRtConfig?.isAgendaEnabled },
                { title: 'Pengaturan Aplikasi', page: 'appSettings', icon: '⚙️', roles: ['admin_rt'], group: 'Akun' },
                {
                    title: 'Langganan & Penagihan',
                    page: 'subscriptionBilling',
                    icon: '⭐',
                    roles: ['admin_rt'],
                    group: 'Langganan & Penagihan',
                },
                { title: 'Manajemen Pengguna', page: 'manageUsers', icon: '👥', roles: ['superAdmin', 'admin_rt'], group: 'Akun' },
                { page: 'accountSettings', roles: ['superAdmin', 'admin_rt', 'bendahara'] },
            ];

            const accessibleNavItems = allAdminNavItems.filter(item => userRole && item.roles.includes(userRole) && (!item.condition || item.condition()));

            const renderActiveAdminPage = () => {

                // BLOK BARU YANG LEBIH AMAN
                // const requestedNavItem = allAdminNavItems.find(item => item.page === activeAdminPage);

                // Pengecekan 1: Apakah rolenya sesuai?
                // BLOK BARU YANG LEBIH SEDERHANA DAN BENAR
                const requestedNavItem = allAdminNavItems.find(item => item.page === activeAdminPage);

                // Pengecekan 1: Apakah rolenya sesuai?
                const hasRoleAccess = requestedNavItem && requestedNavItem.roles.includes(userRole);

                // Pengecekan 2: Apakah fitur diizinkan oleh plan EFEKTIF pengguna?
                // `AuthProvider` sudah menangani logika langganan aktif/kedaluwarsa di belakang layar.
                // `currentRtConfig` yang kita dapat dari `useAuth` sudah berisi fitur yang benar.
                const hasPlanAccess = !requestedNavItem.condition || requestedNavItem.condition();

                // Gabungkan keduanya
                const hasAccess = hasRoleAccess && hasPlanAccess;

                if (!hasAccess && activeAdminPage !== 'dashboard') {
                    // Jika tidak punya akses, paksa kembali ke dasbor
                    handleAdminNavigate('dashboard'); // Gunakan handleAdminNavigate agar lebih konsisten
                    return <AdminDashboardPage />; // Render dasbor sebagai fallback
                }

                switch (activeAdminPage) {
                    case 'dashboard':
                        if (userRole === 'superAdmin') return <SuperAdminDashboard />;
                        else return <AdminDashboardPage />;

                    case 'manageRtProfiles': return <AdminRtManagementPage />;
                    case 'managePlans': return <ManageFeaturePlansPage />;
                    case 'manageHouseholds': return <ManageHouseholdsPage />;
                    case 'manageFamilies': return <ManageFamilyPage />;
                    case 'manageOccupancy': return <ManageOccupancyPage />;
                    case 'manageDuesTemplates': return <ManageDuesTemplatesPage />;
                    case 'generateBills': return <GenerateBillsPage />;
                    case 'manageBills': return <ManageBillsPage />;
                    case 'manualPayment': return <ManualPaymentInputPage />;
                    case 'approvePayments': return <ApprovePaymentsPage />;
                    case 'recordExpense': return <RecordExpensePage />;
                    case 'financialReports': return <FinancialReportsPage />;
                    case 'transactionReports':
                        return <TransactionReportsPage />;
                    case 'manageAnnouncements': return <ManageAnnouncementsPage />;
                    case 'manageAgendas': return <ManageAgendasPage />;
                    case 'manageBankAccounts': return <ManageBankAccountsPage onNavigate={handleAdminNavigate} />;
                    case 'globalSettings':
                    case 'appSettings':
                        return <AppSettingsPage />;
                    // --- PERBAIKAN UTAMA ADA DI DUA CASE BERIKUT ---
                    case 'subscriptionBilling':
                        // Sekarang kita teruskan handleNavigation ke komponen ini
                        return <SubscriptionBillingPage onNavigate={handleAdminNavigate} pagePayload={pagePayload} />;

                    case 'subscription_invoice':
                        // Sekarang pagePayload dijamin tersedia dengan benar
                        return <SubscriptionInvoicePage billId={pagePayload?.billId} onBack={() => handleAdminNavigate('subscriptionBilling')} pagePayload={pagePayload} />;
                    case 'manageUsers': return <ManageUsersPage />;
                    case 'accountSettings':
                        return <AccountSettingsPage />;

                    default:
                        navigate('/pengurus-rt/');
                        if (userRole === 'superAdmin') return <SuperAdminDashboard />;
                        else return <AdminDashboardPage />;
                }
            };

            pageContent = (
                <AdminPageLayout
                    accessibleNavItems={accessibleNavItems}
                    activePage={activeAdminPage}
                    onNavigate={handleAdminNavigate}
                >
                    {renderActiveAdminPage()}
                </AdminPageLayout>
            );
        }
    } else {
        // KONTEN HALAMAN PUBLIK
        const pinPages = ['enter_pin', 'create_pin'];
        const isInAppView = publicSelectedRtProfileId && (postLoginPages.includes(publicPageState) || (loggedInHouseData && postLoginPages.includes(publicPageState)));

        if (isInAppView) {
            let innerContent;
            switch (publicPageState) {
                // ... (bagian ini tidak berubah, biarkan seperti adanya)
                case 'payment_form':
                    const activeRtIdForWarga = loggedInHouseData?.rtProfileId || publicSelectedRtProfileId;
                    innerContent = <PusatTagihanPage
                        loggedInHouseData={loggedInHouseData}
                        onViewChange={setIsDetailViewActive}
                        rtProfileId={activeRtIdForWarga}
                        onNavigate={handleNavigation}
                        refreshSignal={paymentSuccessSignal}
                    />;
                    break;
                case 'submit_payment_form':
                    innerContent = <PublicPaymentForm
                        paymentContext={paymentContext}
                        onBack={() => handleNavigation('payment_form')}
                        onNavigate={handleNavigation}
                    />;
                    break;

                case 'announcements_list':
                    innerContent = <PublicAnnouncementsPage
                        rtProfileId={loggedInHouseData?.rtProfileId || publicSelectedRtProfileId}
                        onBack={() => handleNavigation('public_dashboard')}
                    />;
                    break;

                case 'agenda_page':
                    innerContent = <PublicAgendaPage
                        rtProfileId={loggedInHouseData?.rtProfileId || publicSelectedRtProfileId}
                        loggedInHouseData={loggedInHouseData}
                        initialDate={initialAgendaDate}
                        onBack={() => handleNavigation('public_dashboard')}
                    />;
                    break;

                case 'kartu_iuran_dedicated':
                    innerContent = <KartuIuranPage
                        loggedInHouseData={loggedInHouseData}
                        onNavigate={handleNavigation} // Tambahkan ini jika diperlukan
                        rtProfileId={loggedInHouseData?.rtProfileId || publicSelectedRtProfileId}
                    />;
                    break;
                default:
                    innerContent = <PublicDashboardPage
                        loggedInHouseData={loggedInHouseData}
                        onNavigate={handleNavigation}
                        rtProfileId={loggedInHouseData?.rtProfileId || publicSelectedRtProfileId}
                    />;
                    break;
            }

            pageContent = (
                <div className="min-h-screen bg-slate-100 sm:p-4 font-sans">
                    {isRtSpecificTestingMode && <TestingModeBadge />}
                    <MobileAppLayout
                        header={
                            loggedInHouseData ?
                                <PublicUserHeader userData={loggedInHouseData} onLogout={handleHouseLogout} onNavigate={handleNavigation} /> :
                                <GenericHeader title={rtProfile?.rtTitle || "Iuran Warga"} onExit={handleExitRtContext} />
                        }
                        footer={
                            !isDetailViewActive && <BottomNavBar activePage={publicPageState} onNavigate={handleNavigation} />
                        }
                    >
                        {innerContent}
                    </MobileAppLayout>
                </div>
            );

        } else if (publicSelectedRtProfileId && pinPages.includes(publicPageState)) {
            let pinContent;
            // --- Logika untuk merender halaman PIN sekarang lengkap ---
            if (publicPageState === 'enter_pin') {
                pinContent = <EnterPinPage houseData={selectedHouseForOtpOrPin} onPinVerified={handlePinCreatedOrVerified} onCancel={() => { setPublicPageState('house_selection'); setSelectedHouseForOtpOrPin(null); }} onForgotPin={handleForgotPin} />;
            } else { // publicPageState === 'create_pin'
                pinContent = <CreatePinPage houseData={selectedHouseForOtpOrPin} onPinCreated={handlePinCreatedOrVerified} onCancel={() => { setPublicPageState('house_selection'); setSelectedHouseForOtpOrPin(null); }} />;
            }
            pageContent = (
                <div className="min-h-screen bg-gradient-to-br from-orange-400 to-orange-500 flex items-center justify-center p-4">
                    {isRtSpecificTestingMode && <TestingModeBadge />}
                    {pinContent}
                </div>
            );
        } else {
            let preLoginContent;
            const rtIdForPublicFlow = publicSelectedRtProfileId;

            // --- INI ADALAH LOGIKA RENDER YANG DIPERBARUI TOTAL ---
            switch (publicPageState) {
                case 'global_otp':
                    preLoginContent = <GlobalOtpInputComponent onRtVerifiedAndSelected={handleRtVerifiedAndSelected} />;
                    break;

                case 'house_selection':
                    preLoginContent = <HouseSelectionPage
                        // Berikan semua handler yang dibutuhkan
                        onHouseSelectedForOtp={handleProceedToPhoneAuth}
                        onHouseSelectedForPin={handleProceedToEnterPin}
                        onHouseSelectedForCreatePin={handleProceedToCreatePin}
                        rtProfileId={rtIdForPublicFlow}
                        onExitRtContext={handleExitRtContext}
                        // PASTIKAN BARIS INI ADA DAN SUDAH BENAR
                        getEffectiveHouseVerificationStatus={getEffectiveHouseVerificationStatus}
                    />;
                    break;

                case 'phone_auth_init_and_recaptcha':
                    preLoginContent = <PhoneOtpVerificationPage
                        houseData={selectedHouseForOtpOrPin}
                        onPhoneOtpVerified={handlePhoneOtpVerified}
                        onCancel={() => { setPublicPageState('house_selection'); setSelectedHouseForOtpOrPin(null); }}
                    />;
                    break;

                default:
                    // Fallback jika terjadi state yang tidak terduga, kembali ke awal
                    preLoginContent = <GlobalOtpInputComponent onRtVerifiedAndSelected={handleRtVerifiedAndSelected} />;
                    break;
            }
            // --- AKHIR DARI LOGIKA RENDER YANG DIPERBARUI ---

            if (publicPageState === 'global_otp') {
                // ... (bagian ini tidak berubah, biarkan seperti adanya)
                let displayLogoUrl = LOGO_URL, displayRtTitle = "SATUWARGA";
                if (rtProfile) {
                    displayLogoUrl = rtProfile.logoUrl || LOGO_URL;
                    displayRtTitle = rtProfile.rtTitle || "SATUWARGA";
                }
                pageContent = (
                    <div className="min-h-screen bg-slate-100 p-4 font-sans flex flex-col justify-center items-center relative">
                        <header className="mb-8 text-center">
                            {/* <img src={displayLogoUrl} alt="Logo" className="mx-auto mb-4 h-20 w-auto" />
                            <h1 className="text-4xl font-bold text-sky-700">{displayRtTitle}</h1> */}
                        </header>
                        <main>
                            {preLoginContent}
                        </main>
                        <footer className="absolute bottom-0 text-center py-4">
                            <p className="text-sm text-slate-500">© {new Date().getFullYear()} SATUWARGA.</p>
                        </footer>
                    </div>
                );
            } else {
                // --- TAMPILAN MOBILE LAYOUT UNTUK HALAMAN PRA-LOGIN LAINNYA ---
                pageContent = (
                    <div className="min-h-screen bg-slate-300 sm:p-4 font-sans">
                        {isRtSpecificTestingMode && <TestingModeBadge />}
                        <MobileAppLayout
                            header={<GenericHeader title={rtProfile?.rtTitle || "Verifikasi Akses"} onExit={handleExitRtContext} />}
                            footer={null}
                        >
                            {preLoginContent}
                        </MobileAppLayout>
                    </div>
                );
            }
        }
    }

    // console.log('APP RENDER. Current Page State:', publicPageState, 'Is Logged In:', !!loggedInHouseData);

    // --- BAGIAN 4: RETURN UTAMA ---
    return (
        <>
            <UpdatePrompt registration={updateRegistration} />
            {/* TAMBAHKAN KOMPONEN MODAL INI DI SINI */}
            <ForcedLogoutModal
                isOpen={showForcedLogoutModal}
                onTimeout={handleForcedLogout}
            />
            <InactivityModal isOpen={isIdle} onConfirm={handleStayActive} onTimeout={handleSessionTimeout} />
            <FeatureGateModal isOpen={showFeatureGateModal} onClose={() => setShowFeatureGateModal(false)} featureName={gatedFeatureName} />
            {pageContent}
            {/* Tampilkan tombol instal jika siap */}
            {showInstallButton && <PWAInstallButton onInstallClick={handleInstallClick} />}
        </>
    );
}

// Ganti seluruh komponen PublicDashboardPage Anda dengan versi baru ini
// --- GANTI SELURUH KOMPONEN AdminPageLayout ANDA DENGAN VERSI INI ---

const AdminPageLayout = ({ children, accessibleNavItems, activePage, onNavigate }) => {
    const { logout, appConfig, userRole, rtProfileId, currentUser, updateSpecificRtConfig } = useAuth();
    const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
    const wrapperRef = useRef(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    // State dan handler untuk toggle testing mode (tetap diperlukan di sini)
    const [showTestingModeModal, setShowTestingModeModal] = useState(false);
    const [intendedTestingMode, setIntendedTestingMode] = useState(false);
    const [isSavingMode, setIsSavingMode] = useState(false);

    const currentRtConfig = appConfig?.rtProfiles?.[rtProfileId];

    useEffect(() => {
        // Setiap kali halaman aktif berubah (activePage),
        // paksa window untuk scroll ke paling atas.
        window.scrollTo(0, 0);
    }, [activePage]);

    const handleToggleClick = (newMode) => {
        setIntendedTestingMode(newMode);
        setShowTestingModeModal(true);
    };

    const handleConfirmChange = async () => {
        setIsSavingMode(true);
        try {
            const rtConfigRef = doc(db, getRtSpecificConfigDocPath(rtProfileId));
            const newConfig = { isTestingMode: intendedTestingMode };

            // 1. Update data di Firestore
            await updateDoc(rtConfigRef, newConfig);

            // 2. PANGGIL FUNGSI UPDATE INSTAN DI SINI
            // Ini akan langsung memperbarui state appConfig di seluruh aplikasi
            if (updateSpecificRtConfig) {
                updateSpecificRtConfig(rtProfileId, newConfig);
            }

            // 3. Update data di Realtime Database
            await updateDoc(rtConfigRef, { isTestingMode: intendedTestingMode });
        } catch (error) {
            console.error("Gagal mengubah mode testing:", error);
        } finally {
            setIsSavingMode(false);
            setShowTestingModeModal(false);
        }
    };

    // Logika untuk mengelompokkan menu (tetap diperlukan untuk sidebar)
    const groupedItems = useMemo(() => {
        const groups = {};
        // --- FILTER BARU DI SINI ---
        // Hanya proses item yang memiliki judul untuk ditampilkan di menu
        accessibleNavItems.filter(item => item.title).forEach(item => {
            const groupName = item.group || 'Lainnya';
            if (!groups[groupName]) {
                groups[groupName] = [];
            }
            groups[groupName].push(item);
        });
        return groups;
    }, [accessibleNavItems]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsProfileDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [wrapperRef]);

    // --- FUNGSI-FUNGSI BARU UNTUK AKSI DROPDOWN ---
    const handleChangePassword = async () => {
        if (!currentUser?.email) {
            alert("Tidak bisa mengirim email, data pengguna tidak ditemukan.");
            return;
        }
        if (window.confirm(`Anda akan mengirim link untuk reset password ke email ${currentUser.email}. Lanjutkan?`)) {
            try {
                // Gunakan fungsi bawaan Firebase Auth
                await sendPasswordResetEmail(authGlobal, currentUser.email);
                alert("Email untuk reset password telah berhasil dikirim. Silakan periksa kotak masuk (termasuk folder spam).");
            } catch (error) {
                console.error("Error sending password reset email:", error);
                alert(`Gagal mengirim email: ${error.message}`);
            }
        }
        setIsProfileDropdownOpen(false);
    };

    const handleSendVerification = async () => {
        if (!currentUser || currentUser.emailVerified) {
            alert("Email Anda sudah terverifikasi.");
            return;
        }
        if (window.confirm(`Anda akan mengirim ulang email verifikasi ke ${currentUser.email}. Lanjutkan?`)) {
            try {
                // Gunakan fungsi bawaan Firebase Auth
                await sendEmailVerification(currentUser);
                alert("Email verifikasi telah berhasil dikirim ulang. Silakan periksa kotak masuk Anda.");
            } catch (error) {
                console.error("Error sending verification email:", error);
                alert(`Gagal mengirim email: ${error.message}`);
            }
        }
        setIsProfileDropdownOpen(false);
    };

    // Tentukan nama yang akan ditampilkan di header
    const displayName = userRole === 'superAdmin' ? 'Super Admin' : (currentRtConfig?.rtTitle || 'Admin RT');
    const pageTitle = accessibleNavItems.find(item => item.page === activePage)?.title || 'Dasbor';

    return (
        <>
            <div className="flex min-h-screen bg-slate-100">
                {/* --- Sidebar (Desktop) --- */}
                <aside className="hidden lg:block w-64 bg-white shadow-md flex-shrink-0">
                    <div className="p-4 sticky top-0">
                        <img
                            src={`${process.env.PUBLIC_URL}/icon/logo-satuwarga-text.png`}
                            alt="Logo Satuwarga Admin"
                            className="h-9 w-auto mb-6 cursor-pointer"
                            onClick={() => onNavigate('dashboard')}
                        />
                        <nav className="space-y-4">
                            {Object.keys(groupedItems).map(groupName => (
                                <div key={groupName}>
                                    <h3 className="text-xs font-bold text-slate-400 uppercase mb-2">{groupName}</h3>
                                    {groupedItems[groupName].map(item => (
                                        <button
                                            key={item.page}
                                            onClick={() => onNavigate(item.page)}
                                            className={`w-full text-left flex items-center space-x-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${activePage === item.page ? 'bg-sky-100 text-sky-700' : 'text-slate-600 hover:bg-slate-100'}`}
                                        >
                                            <span className="text-lg">{item.icon}</span>
                                            <span>{item.title}</span>
                                        </button>
                                    ))}
                                </div>
                            ))}
                            <div className="pt-4 border-t">
                                <button onClick={logout} className="w-full text-left flex items-center space-x-3 px-3 py-2 rounded-md text-sm font-medium text-red-600 hover:bg-red-50">
                                    <span>🚪</span>
                                    <span>Logout</span>
                                </button>
                            </div>
                        </nav>
                    </div>
                </aside>

                {/* --- Konten Utama --- */}
                <div className="flex-grow">
                    <header className="sticky top-0 bg-white/80 backdrop-blur-sm p-4 shadow-sm flex justify-between items-center z-20">
                        {/* Tombol Hamburger (Hanya untuk Mobile) */}
                        <button onClick={() => setIsSidebarOpen(true)} className="lg:hidden text-slate-600 p-2 -ml-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
                        </button>

                        {/* Judul Halaman atau elemen lain di kiri (khusus mobile) */}
                        {/* <div className="lg:hidden text-lg font-bold text-sky-700">
                            {accessibleNavItems.find(item => item.page === activePage)?.title || 'Dasbor'}
                        </div> */}

                        {/* --- TOGGLE SWITCH BARU DI SINI --- */}
                        {userRole === 'admin_rt' && currentRtConfig ? (
                            <div className="flex items-center gap-2">
                                <span className={`text-sm font-semibold ${!currentRtConfig.isTestingMode ? 'text-sky-600' : 'text-slate-400'}`}>Live</span>
                                <ToggleSwitch
                                    checked={currentRtConfig.isTestingMode === true}
                                    onChange={handleToggleClick}
                                />
                                <span className={`text-sm font-semibold ${currentRtConfig.isTestingMode ? 'text-orange-500' : 'text-slate-400'}`}>Testing</span>
                            </div>
                        ) : (
                            // Beri div kosong agar justify-between tetap berfungsi
                            <div></div>
                        )}

                        {/* Dropdown Akun */}
                        <div className="relative ml-4" ref={wrapperRef}>
                            <button onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)} className="flex items-center space-x-2 p-2 rounded-lg hover:bg-slate-100">
                                <div className="w-8 h-8 bg-sky-500 rounded-full flex items-center justify-center text-white font-bold">
                                    {displayName.charAt(0).toUpperCase()}
                                </div>
                                <div className="hidden md:block text-left">
                                    <p className="text-sm font-semibold text-slate-800">{displayName}</p>
                                    <p className="text-xs text-slate-500">{currentUser?.email}</p>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-slate-500 hidden md:block" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                            </button>

                            {isProfileDropdownOpen && (
                                <div className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none animate-fade-in-fast">
                                    <div className="py-1" role="menu" aria-orientation="vertical">
                                        <a href="#" onClick={(e) => { e.preventDefault(); onNavigate('accountSettings'); setIsProfileDropdownOpen(false); }} className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-100" role="menuitem">Pengaturan Akun</a>
                                        <a href="#" onClick={(e) => { e.preventDefault(); handleChangePassword(); }} className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-100" role="menuitem">Ganti Password</a>
                                        {!currentUser.emailVerified && (
                                            <a href="#" onClick={(e) => { e.preventDefault(); handleSendVerification(); }} className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-100" role="menuitem">
                                                Kirim Ulang Verifikasi Email
                                            </a>
                                        )}
                                        <hr className="my-1" />
                                        <a href="#" onClick={(e) => { e.preventDefault(); logout(); setIsProfileDropdownOpen(false); }} className="block px-4 py-2 text-sm text-red-600 hover:bg-red-50" role="menuitem">Logout</a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </header>

                    <main className="p-4 sm:p-6 md:p-8">
                        {children}
                    </main>
                </div>

                {/* Sidebar Mobile (Overlay) (tidak berubah) */}
                {isSidebarOpen && (
                    <div className="fixed inset-0 z-40 lg:hidden">
                        {/* Backdrop */}
                        <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setIsSidebarOpen(false)}></div>

                        {/* Konten Sidebar */}
                        <aside className="relative w-72 h-full bg-white shadow-xl flex flex-col">
                            {/* Header Sidebar (tetap di atas) */}
                            <div className="p-4 border-b flex-shrink-0">
                                <div className="flex justify-between items-center">
                                    <img src='/icon/logo-satuwarga-text.png' alt="Logo" className="h-8 w-auto" />
                                    <button onClick={() => setIsSidebarOpen(false)} className="p-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                                    </button>
                                </div>
                            </div>

                            {/* Area Menu yang Bisa di-scroll */}
                            <nav className="flex-grow overflow-y-auto p-4 space-y-4">
                                {Object.keys(groupedItems).map(groupName => (
                                    <div key={groupName}>
                                        <h3 className="px-3 text-xs font-bold text-slate-400 uppercase mb-2">{groupName}</h3>
                                        {groupedItems[groupName].map(item => (
                                            <button
                                                key={item.page}
                                                onClick={() => { onNavigate(item.page); setIsSidebarOpen(false); }}
                                                className={`w-full text-left flex items-center space-x-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${activePage === item.page ? 'bg-sky-100 text-sky-700' : 'text-slate-600 hover:bg-slate-100'}`}
                                            >
                                                <span className="text-lg">{item.icon}</span>
                                                <span>{item.title}</span>
                                            </button>
                                        ))}
                                    </div>
                                ))}
                            </nav>

                            {/* Footer Sidebar (tetap di bawah) */}
                            <div className="p-4 border-t flex-shrink-0">
                                <button onClick={logout} className="w-full text-left flex items-center space-x-3 px-3 py-2 rounded-md text-sm font-medium text-red-600 hover:bg-red-50">
                                    <span>🚪</span>
                                    <span>Logout</span>
                                </button>
                            </div>
                        </aside>
                    </div>
                )}
            </div>

            {/* Modal Konfirmasi Testing Mode (tidak berubah) */}
            <ConfirmationModal
                isOpen={showTestingModeModal}
                onClose={() => setShowTestingModeModal(false)}
                onConfirm={handleConfirmChange}
                title="Konfirmasi Perubahan Mode"
                confirmText="Ya, Ubah Mode"
                isConfirming={isSavingMode}
            >
                <p>Mengubah mode akan mempengaruhi data yang Anda lihat dan kelola di seluruh aplikasi, termasuk di sisi warga. Anda yakin ingin melanjutkan?</p>
                <p className='mt-2 font-semibold'>Ubah ke: <span className={intendedTestingMode ? 'text-orange-600' : 'text-green-600'}>{intendedTestingMode ? 'Mode Testing' : 'Mode Live'}</span></p>
            </ConfirmationModal>
        </>
    );
};

// --- Komponen AccountSettingsPage (FINAL & Fungsional) ---
const AccountSettingsPage = () => {
    const { currentUser } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [isEmailVerified, setIsEmailVerified] = useState(currentUser?.emailVerified || false);

    const handleSendPasswordReset = async () => {
        if (!currentUser?.email) {
            setMessage({ text: "Gagal: Tidak dapat menemukan email pengguna.", type: 'error' });
            return;
        }
        if (!window.confirm(`Anda akan mengirim link reset password ke ${currentUser.email}. Lanjutkan?`)) {
            return;
        }

        setIsLoading(true);
        setMessage({ text: '', type: '' });
        try {
            await sendPasswordResetEmail(authGlobal, currentUser.email);
            setMessage({ text: "Email untuk reset password telah berhasil dikirim. Silakan periksa kotak masuk Anda.", type: 'success' });
        } catch (error) {
            console.error("Error sending password reset:", error);
            setMessage({ text: `Gagal mengirim email: ${error.message}`, type: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    const handleResendVerification = async () => {
        if (!currentUser || currentUser.emailVerified) {
            setMessage({ text: "Email Anda sudah terverifikasi.", type: 'info' });
            return;
        }
        setIsLoading(true);
        setMessage({ text: '', type: '' });
        try {
            await sendEmailVerification(currentUser);
            setMessage({ text: "Email verifikasi telah berhasil dikirim ulang. Silakan periksa kotak masuk Anda.", type: 'success' });
        } catch (error) {
            console.error("Error resending verification email:", error);
            setMessage({ text: `Gagal mengirim email: ${error.message}`, type: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    // --- FUNGSI BARU UNTUK MEMUAT ULANG DATA PENGGUNA ---
    const handleReloadUser = async () => {
        if (!currentUser) return;

        setIsLoading(true);
        setMessage({ text: "Memeriksa status terbaru...", type: "info" });
        try {
            // Perintah ini memaksa Firebase untuk mengambil data pengguna terbaru dari server
            await currentUser.reload();

            // Setelah di-reload, perbarui state lokal kita
            const freshUser = authGlobal.currentUser; // Ambil lagi objek yang sudah di-refresh
            setIsEmailVerified(freshUser.emailVerified);

            if (freshUser.emailVerified) {
                setMessage({ text: "Status verifikasi berhasil diperbarui!", type: "success" });
            } else {
                setMessage({ text: "Status email masih belum terverifikasi.", type: "info" });
            }

        } catch (error) {
            console.error("Gagal memuat ulang data pengguna:", error);
            setMessage({ text: "Gagal memeriksa status terbaru.", type: "error" });
        } finally {
            setIsLoading(false);
        }
    };

    if (!currentUser) {
        return <div className={cardStyle}><LoadingSpinner /></div>
    }

    return (
        <div className={cardStyle}>
            <h2 className="text-2xl font-semibold text-slate-700 mb-2">Pengaturan Akun Saya</h2>
            <p className="text-slate-500 mb-6">Kelola keamanan dan preferensi akun Anda.</p>

            {message.text && <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />}

            <div className="space-y-4 border-t pt-6">
                <div>
                    <label className="text-sm font-medium text-slate-500">Email</label>
                    <p className="font-semibold text-slate-800">{currentUser.email}</p>
                </div>
                <div>
                    <label className="text-sm font-medium text-slate-500">Status Email</label>
                    <div className="flex items-center gap-2">
                        {isEmailVerified ? (
                            <p className="font-semibold text-green-600">Terverifikasi</p>
                        ) : (
                            <>
                                <p className="font-semibold text-orange-600">Belum Terverifikasi</p>
                                <button onClick={handleReloadUser} className="text-xs text-sky-600 hover:underline" disabled={isLoading}>
                                    (Periksa Ulang)
                                </button>
                            </>
                        )}
                    </div>
                </div>

                <hr />

                <div>
                    <h3 className="font-semibold text-slate-700 mb-2">Aksi Keamanan</h3>
                    <div className="flex flex-col sm:flex-row gap-3">
                        <button onClick={handleSendPasswordReset} className={secondaryButtonStyle} disabled={isLoading}>
                            Kirim Link Ganti Password
                        </button>

                        {!isEmailVerified && (
                            <button onClick={handleResendVerification} className={secondaryButtonStyle} disabled={isLoading}>
                                Kirim Ulang Verifikasi Email
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const PublicDashboardPage = ({ loggedInHouseData, onNavigate, rtProfileId }) => {
    // State tetap sama
    const [latestAnnouncement, setLatestAnnouncement] = useState(null);
    const [nextAgenda, setNextAgenda] = useState(null);
    const [loadingInfo, setLoadingInfo] = useState(true);
    const { currentUser } = useAuth();

    // useEffect sekarang bergantung pada 'rtProfileId'
    useEffect(() => {
        // Gunakan rtProfileId yang diterima sebagai prop untuk mengambil data
        if (!rtProfileId || !db || !currentUser) {
            setLoadingInfo(false);
            return;
        }

        setupFCM(app, db, currentUser, rtProfileId, loggedInHouseData);

        const fetchDashboardData = async () => {
            setLoadingInfo(true);
            try {
                // --- Mengambil Pengumuman Terakhir ---
                const announcementsPath = `/artifacts/${appIdForPaths}/public/data/rtProfiles/${rtProfileId}/announcements`;
                const announcementsQuery = query(collection(db, announcementsPath), orderBy("createdAt", "desc"), limit(1));
                const announcementSnap = await getDocs(announcementsQuery);
                if (!announcementSnap.empty) {
                    setLatestAnnouncement({ id: announcementSnap.docs[0].id, ...announcementSnap.docs[0].data() });
                } else {
                    setLatestAnnouncement(null); // Reset jika tidak ada
                }

                // --- Mengambil Agenda Terdekat ---
                const agendasPath = getAgendasCollectionPath(rtProfileId);
                const agendasQuery = query(
                    collection(db, agendasPath),
                    where("activityDate", ">=", Timestamp.now()),
                    orderBy("activityDate", "asc"),
                    limit(1)
                );
                const agendaSnap = await getDocs(agendasQuery);
                if (!agendaSnap.empty) {
                    setNextAgenda({ id: agendaSnap.docs[0].id, ...agendaSnap.docs[0].data() });
                } else {
                    setNextAgenda(null); // Reset jika tidak ada
                }

            } catch (error) {
                console.error("Gagal mengambil data untuk dasbor:", error);
            } finally {
                setLoadingInfo(false);
            }
        };

        fetchDashboardData();

        // setupFCM(app, db, currentUser, rtProfileId);
    }, [rtProfileId]); // <-- Dependensi diubah ke rtProfileId

    // JSX untuk render tetap sama persis seperti sebelumnya
    return (
        <div className="flex flex-col h-full space-y-4">

            {/* --- PERUBAHAN UTAMA: Struktur Banner Baru --- */}
            {/* Tambahkan `relative` dan `overflow-hidden` pada kontainer utama banner */}
            <div className="relative overflow-hidden bg-gradient-to-br from-orange-400 to-orange-500 text-white p-6 rounded-2xl shadow-lg flex flex-col justify-start min-h-[240px]">

                {/* Blok Konten Kiri Atas (Teks & Tombol) */}
                {/* Diberi z-index agar berada di atas gambar */}
                <div className="relative z-10">
                    <h2 className="text-xl font-bold">Selalu Dapatkan Informasi Terkini</h2>
                    <p className="text-white opacity-80 text-sm mt-1">dengan informasi & pengumuman RT. anda akan selalu menerima info terbaru</p>
                    <button
                        onClick={() => onNavigate('announcements_list')}
                        className="mt-4 bg-white text-orange-600 font-semibold py-2 px-5 rounded-lg shadow hover:bg-orange-50 transition-colors"
                    >
                        Lihat Pengumumann
                    </button>
                </div>

                {/* Blok Ilustrasi Kanan Bawah (diposisikan absolut) */}
                <div className="absolute -bottom-4 -right-2 flex items-end">
                    {/* ILUSTRASI BARU: WARGA */}
                    <svg width="120" height="120" viewBox="0 0 150 150" className="opacity-40 -mr-8">
                        <path d="M75 75C95.4249 75 112 58.4249 112 37.5C112 16.5751 95.4249 0 75 0C54.5751 0 38 16.5751 38 37.5C38 58.4249 54.5751 75 75 75Z" fill="white" />
                        <path d="M149.5 150C149.5 124.721 127.353 103.929 101.813 101.913C93.6386 117.729 74.75 125 74.75 125C74.75 125 55.8614 117.729 47.6875 101.913C22.1473 103.929 0 124.721 0 150H149.5Z" fill="white" />
                    </svg>
                    {/* Ilustrasi Rumah yang dipindahkan */}
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-28 w-28 text-white opacity-20" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                    </svg>
                </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div onClick={() => onNavigate('agenda_page')} className="bg-white text-slate-800 p-4 rounded-2xl flex flex-col items-center justify-center cursor-pointer hover:bg-slate-50 transition-colors shadow"><svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-orange-500 mb-2" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" /></svg><span className="font-semibold">Agenda</span></div>
                <div onClick={() => onNavigate('kartu_iuran_dedicated')} className="bg-white text-slate-800 p-4 rounded-2xl flex flex-col items-center justify-center cursor-pointer hover:bg-slate-50 transition-colors shadow"><svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-orange-500 mb-2" viewBox="0 0 20 20" fill="currentColor"><path d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 10a2 2 0 00-2 2v.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V16a2 2 0 00-2-2H4z" /></svg><span className="font-semibold">Kartu Iuran</span></div>
            </div>

            {loadingInfo && <LoadingSpinner />}

            {/* === BAGIAN AGENDA & PETA YANG DIPERBARUI === */}
            {!loadingInfo && nextAgenda ? (
                // 'onClick' dan 'cursor-pointer' sekarang ada di kartu utama ini
                <div
                    className="bg-white p-4 rounded-2xl shadow space-y-2 cursor-pointer hover:bg-slate-50 transition-colors"
                    onClick={() => onNavigate('agenda_page', { date: nextAgenda.activityDate.toDate() })}
                >
                    {/* Detail agenda sekarang menjadi anak langsung, tidak dibungkus div lagi */}
                    <p className="text-xs font-bold text-sky-600 uppercase">AGENDA TERDEKAT</p>
                    <h3 className="text-base font-bold text-slate-800 truncate">{nextAgenda.activityName}</h3>
                    <p className="text-sm text-slate-500">{nextAgenda.activityDate.toDate().toLocaleString('id-ID', { weekday: 'long', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</p>

                    {/* Tampilkan peta HANYA jika agenda punya koordinat */}
                    {nextAgenda.locationCoords && (
                        // Kita beri sedikit margin atas pada kontainer peta
                        <div className="pt-3 mt-3 border-t">
                            {/* Link untuk peta tetap di sini agar hanya peta yang bisa di-klik untuk membuka Google Maps */}
                            <a
                                href={`https://maps.google.com/?q=${nextAgenda.locationCoords.latitude},${nextAgenda.locationCoords.longitude}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => e.stopPropagation()} // Mencegah navigasi halaman saat peta diklik
                            >
                                <MapDisplay location={nextAgenda.locationCoords} />
                            </a>
                        </div>
                    )}
                </div>
            ) : (
                // Jika TIDAK ADA agenda terdekat
                !loadingInfo && (
                    <div className="bg-white p-4 rounded-2xl shadow text-center text-slate-500">
                        <p>Tidak ada agenda terdekat untuk saat ini.</p>
                    </div>
                )
            )}

            {!loadingInfo && latestAnnouncement && (
                <div className="bg-slate-50 p-4 rounded-2xl shadow cursor-pointer hover:bg-slate-100 transition-colors" onClick={() => onNavigate('announcements_list')}>
                    <div className="flex justify-between items-center"><p className="text-xs font-bold text-slate-500 uppercase">PENGUMUMAN TERBARU</p><span className="text-xs text-slate-400">{latestAnnouncement.createdAt?.toDate().toLocaleDateString('id-ID')}</span></div>
                    <h3 className="text-base font-bold mt-1 truncate">{latestAnnouncement.title}</h3>
                </div>
            )}
        </div>
    );
};

const ToggleSwitch = ({ checked, onChange, label }) => {
    return (
        <label htmlFor="toggle-switch" className="flex items-center cursor-pointer">
            <div className="relative">
                <input
                    type="checkbox"
                    id="toggle-switch"
                    className="sr-only" // Sembunyikan checkbox asli
                    checked={checked}
                    onChange={e => onChange(e.target.checked)}
                />
                <div className={`block w-12 h-6 rounded-full transition-colors ${checked ? 'bg-orange-500' : 'bg-green-500'}`}></div>
                <div className={`dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform ${checked ? 'translate-x-6' : ''}`}></div>
            </div>
            <div className="ml-3 text-sm text-slate-600 font-medium">
                {label}
            </div>
        </label>
    );
};

// --- Komponen Navigasi Kantong ---
const KantongNavigation = ({ items, activeKantong, onSelectKantong }) => {
    return (
        <div className="relative">
            <div className="flex space-x-3 overflow-x-auto py-2 -mx-4 px-4 scrollbar-hide">
                {items.map(item => {
                    const isActive = item.id === activeKantong;
                    return (
                        <button
                            key={item.id}
                            onClick={() => onSelectKantong(item.id)}
                            className={`flex-shrink-0 p-3 rounded-xl shadow-md w-40 transition-all transform hover:scale-105 ${isActive ? 'bg-sky-500 text-white' : 'bg-white text-slate-800'
                                }`}
                        >
                            <div className="flex justify-between items-center mb-2">
                                <span className="font-semibold text-sm">{item.title}</span>
                                {item.icon && <div className={`text-lg ${isActive ? 'opacity-80' : 'text-slate-400'}`}>{item.icon}</div>}
                            </div>
                            <div className="text-left">
                                <p className={`text-xl font-bold ${isActive ? 'text-white' : 'text-red-500'}`}>{item.totalAmount}</p>
                                <p className={`text-xs ${isActive ? 'text-sky-100' : 'text-slate-500'}`}>{item.description}</p>
                            </div>
                        </button>
                    )
                })}
            </div>
        </div>
    );
};

const SlidingTabs = ({ tabs, activeTab, onSelectTab }) => {
    return (
        <div className="w-full">
            <div className="flex space-x-5 border-b border-slate-200 overflow-x-auto scrollbar-hide px-4 -mx-4">
                {tabs.map(tab => {
                    const isActive = tab.id === activeTab;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => onSelectTab(tab.id)}
                            className={`py-3 px-1 text-sm font-semibold whitespace-nowrap transition-colors border-b-2 ${isActive
                                ? 'border-sky-500 text-sky-500'
                                : 'border-transparent text-slate-500 hover:text-slate-800'
                                }`}
                        >
                            {tab.title}
                        </button>
                    )
                })}
            </div>
        </div>
    );
};

const BottomNavBar = ({ activePage, onNavigate }) => {
    const navItems = [
        { page: 'public_dashboard', label: 'Beranda', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg> },
        { page: 'payment_form', label: 'Iuran', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg> },
        { page: 'agenda_page', label: 'Agenda', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg> },
        // { page: 'profile', label: 'Profil', icon: ... }, // Bisa ditambahkan nanti
    ];

    return (
        <div className="grid grid-cols-3 items-center justify-around border-t border-slate-200">
            {navItems.map(item => {
                const isActive = activePage === item.page;
                return (
                    <button
                        key={item.page}
                        onClick={() => onNavigate(item.page)}
                        className={`flex flex-col items-center justify-center space-y-1 py-3 px-2 text-xs font-medium transition-colors focus:outline-none ${isActive ? 'text-orange-500' : 'text-slate-500 hover:text-orange-500'}`}
                    >
                        {item.icon}
                        <span>{item.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

// Ganti seluruh komponen PublicUserHeader Anda dengan ini
const PublicUserHeader = ({ userData, onLogout, onNavigate }) => {
    const { currentUser } = useAuth();
    const [unreadCount, setUnreadCount] = useState(0);

    // DENGARKAN NOTIFIKASI YANG BELUM DIBACA SECARA REAL-TIME
    useEffect(() => {
        if (!currentUser) return;

        const notificationsRef = collection(db, getResidentNotificationsCollectionPath(currentUser.uid));
        const q = query(notificationsRef, where('isRead', '==', false));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setUnreadCount(snapshot.size);
        }, (error) => {
            console.error("Error listening to notifications:", error);
            setUnreadCount(0);
        });

        return () => unsubscribe();
    }, [currentUser]);

    // FUNGSI UNTUK MEMBUKA PENGUMUMAN DAN MENANDAI NOTIFIKASI SEBAGAI SUDAH DIBACA
    const handleNavigateAndMarkAsRead = async (page) => {
        if (unreadCount > 0) {
            try {
                console.log("Mencari notifikasi yang belum dibaca...");
                const collectionPath = getResidentNotificationsCollectionPath(currentUser.uid);
                if (!collectionPath) {
                    onNavigate(page);
                    return;
                }

                const notificationsRef = collection(db, collectionPath);
                const q = query(notificationsRef, where('isRead', '==', false));
                const snapshot = await getDocs(q);

                if (snapshot.empty) {
                    console.log("Tidak ada notifikasi yang belum dibaca untuk diperbarui.");
                    setUnreadCount(0);
                    onNavigate(page);
                    return;
                }

                console.log(`Menemukan ${snapshot.size} notifikasi. Memulai operasi batch...`);

                const batch = writeBatch(db);
                snapshot.docs.forEach(docSnapshot => {
                    // PERBAIKAN UTAMA: Menggunakan .set({ merge: true })
                    // Ini mencegah 400 Bad Request jika dokumen telah dihapus secara bersamaan
                    batch.set(docSnapshot.ref, { isRead: true }, { merge: true });
                });

                await batch.commit();

                console.log("Semua notifikasi berhasil ditandai sebagai sudah dibaca.");
                setUnreadCount(0); // Perbarui status hitungan

            } catch (error) {
                console.error("Gagal menandai notifikasi sebagai sudah dibaca:", error);
            }
        }
        // Lanjutkan navigasi setelah operasi selesai, baik berhasil maupun gagal
        onNavigate(page);
    };

    return (
        <div className="w-full max-w-lg mx-auto flex items-center">
            <div className="flex items-center space-x-3 flex-grow">
                <div className="w-12 h-12 bg-orange-200 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" /></svg>
                </div>
                <div>
                    <p className="font-semibold text-lg text-slate-800">Halo, {userData.payerName || 'Warga'}</p>
                    <p className="text-sm text-slate-500">Rumah {userData.houseIdentifier}</p>
                </div>
            </div>
            <div className="flex items-center flex-shrink-0">
                <div className="relative">
                    {/* PASTIKAN onClick PADA TOMBOL INI SUDAH BENAR */}
                    <button
                        onClick={() => handleNavigateAndMarkAsRead('announcements_list')}
                        title="Lihat Pengumuman"
                        className="p-2 rounded-full hover:bg-slate-200 active:bg-slate-300 relative"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" /></svg>
                        {/* BADGE HITUNGAN */}
                        {unreadCount > 0 && (
                            <span className="absolute top-1 right-1 h-5 w-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-bold">{unreadCount}</span>
                        )}
                    </button>
                </div>

                {/* Tombol Logout */}
                <button onClick={onLogout} title="Logout dari Rumah" className="p-2 rounded-full hover:bg-slate-200 active:bg-slate-300">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" /></svg>
                </button>
            </div>
        </div>
    );
};

// VERSI BARU DENGAN PERBAIKAN SAFE AREA
// --- Komponen MobileAppLayout (Dengan Header Dinamis) ---
const MobileAppLayout = ({ header, children, footer }) => {
    // 1. Tambahkan state untuk melacak posisi scroll
    const [isScrolled, setIsScrolled] = useState(false);

    // 2. Gunakan useEffect untuk menambahkan event listener saat scroll
    useEffect(() => {
        const handleScroll = () => {
            // Jika posisi scroll lebih dari 10px dari atas, set isScrolled menjadi true
            if (window.scrollY > 10) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        // Pasang listener saat komponen dimuat
        window.addEventListener('scroll', handleScroll);

        // Cleanup: Hapus listener saat komponen tidak lagi digunakan
        return () => window.removeEventListener('scroll', handleScroll);
    }, []); // Array dependensi kosong agar hanya berjalan sekali

    return (
        <div className="relative mx-auto flex min-h-screen w-full max-w-lg flex-col bg-gradient-to-bl from-orange-100 via-white to-white shadow-2xl">
            {/* --- 3. className header sekarang dinamis berdasarkan state isScrolled --- */}
            <header
                className={`sticky top-0 z-10 px-4 pb-2 transition-all duration-300 ${isScrolled
                    ? 'bg-white/80 backdrop-blur-sm shadow-sm'
                    : 'bg-transparent'
                    }`}
                style={{ paddingTop: `calc(1rem + env(safe-area-inset-top))` }}
            >
                {header}
            </header>

            {/* Konten utama tidak berubah */}
            <main className="flex-grow p-4 pt-2">
                {children}
            </main>

            {/* Footer tidak berubah */}
            <footer className="sticky bottom-0 z-10 bg-white shadow-[0_-2px_5px_rgba(0,0,0,0.05)]">
                {footer}
            </footer>
        </div>
    );
};

const InactivityModal = ({ isOpen, onConfirm, onTimeout }) => {
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        if (!isOpen) {
            setCountdown(5); // Reset countdown saat modal ditutup
            return;
        }

        if (countdown === 0) {
            onTimeout(); // Panggil fungsi timeout jika hitungan habis
            return;
        }

        const intervalId = setInterval(() => {
            setCountdown(c => c - 1);
        }, 1000);

        // Cleanup interval
        return () => clearInterval(intervalId);
    }, [isOpen, countdown, onTimeout]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-xl text-center max-w-sm mx-4">
                <h3 className="text-xl font-bold text-slate-800">Apakah Anda masih di sana?</h3>
                <p className="text-slate-600 my-4">
                    Sesi Anda akan berakhir dalam...
                </p>
                <div className="text-6xl font-bold text-orange-500 my-6">
                    {countdown}
                </div>
                <button
                    onClick={onConfirm}
                    className={`${primaryButtonStyle} w-full`}
                >
                    Ya, Saya Masih di Sini
                </button>
            </div>
        </div>
    );
};

// --- Komponen PublicRtSelectionPage (Baru) ---
const PublicRtSelectionPage = ({ onRtProfileSelected }) => {
    const [rtProfiles, setRtProfiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState({ text: '', type: '' }); // Inisialisasi state message

    useEffect(() => {
        const fetchRtProfiles = async () => {
            setLoading(true);
            try {
                const q = query(collection(db, getRtProfilesCollectionPath()), orderBy("rtTitle"));
                const snapshot = await getDocs(q);
                const profiles = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setRtProfiles(profiles);
                if (profiles.length === 0) {
                    setMessage({ text: "Belum ada Profil RT yang terdaftar.", type: "info" });
                } else if (profiles.length === 1) {
                    // Jika hanya ada 1 RT, otomatis pilih dan lanjutkan
                    onRtProfileSelected(profiles[0].id);
                }
            } catch (error) {
                console.error("Error fetching RT profiles for public selection:", error);
                setMessage({ text: "Gagal memuat daftar RT.", type: "error" });
            } finally {
                setLoading(false);
            }
        };
        fetchRtProfiles();
    }, [onRtProfileSelected]);

    if (loading) return <div className={cardStyle}><LoadingSpinner /><p className="text-center text-slate-500">Memuat daftar RT...</p></div>;
    if (rtProfiles.length === 0 && !loading) return <div className={cardStyle}><MessageBox message={message.text || "Tidak ada RT yang tersedia saat ini."} type={message.type || "info"} /></div>;
    if (rtProfiles.length === 1 && !loading) return null; // Otomatis lanjut jika hanya 1 RT

    return (
        <div className={`${cardStyle} max-w-md mx-auto`}>
            <h2 className="text-2xl font-semibold text-center text-slate-700 mb-6">Pilih RT Anda</h2>
            <MessageBox message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />
            <div className="space-y-3">
                {rtProfiles.map(profile => (
                    <button
                        key={profile.id}
                        onClick={() => onRtProfileSelected(profile.id)}
                        className="w-full text-left p-4 bg-sky-50 hover:bg-sky-100 border border-sky-200 rounded-lg shadow transition-colors"
                    >
                        <h3 className="text-lg font-semibold text-sky-700">{profile.rtTitle}</h3>
                        {profile.rtDescription && <p className="text-sm text-slate-600">{profile.rtDescription}</p>}
                        {profile.rtAddress && <p className="text-xs text-slate-500 mt-1">{profile.rtAddress}</p>}
                    </button>
                ))}
            </div>
        </div>
    );
};

const AppWrapper = () => (
    <AuthProvider>
        <RTProvider>
            {/* 2. Letakkan Toaster di sini, di dalam provider utama */}
            <Toaster
                position="bottom-center" // Posisi toast muncul
                toastOptions={{
                    duration: 3000, // Durasi 3 detik
                }}
            />
            <App />
        </RTProvider>
    </AuthProvider>
);


export default AppWrapper;
